/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7007aae6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7007aae6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"f050aa94-e9cc-4557-bee0-4f86d4aa49b7","title":"了解打印机","link":"finding-information-about-printer-topic.html","desc":"查找有关打印机的信息 有关打印机的出版物及其他信息来源 您在查找什么？ 在此查找 初始设置说明：","descFull":"查找有关打印机的信息 有关打印机的出版物及其他信息来源 您在查找什么？ 在此查找 初始设置说明： 连接打印机 安装打印机软件 设置文档—设置文档随打印机附带，也可以在  http://support.lexmark.com  上获得。 设置文档—设置文档随打印机附带。 使用打印机的其他设置和说明： 选择和保存纸张及特殊介质 加载纸张 配置打印机设置 查看和打印文档及照片 设置和使用打印机软件 在网络上配置打印机 管理和维护打印机 检查和解决问题 用户指南 和 快速参考指南 —指南可以在  http://support.lexmark.com  上获得。 用户指南 和 快速参考指南 —指南可以在 软件和文档  CD 上获得。 如需更多信息，请转到  www.dell.com/support/manuals 。 这些指南也有其他语言版本提供。 有关设置并配置打印机的辅助功能的信息 Lexmark 辅助功能指南 —该指南可以在  http://support.lexmark.com  上获得。 辅助功能指南 —该指南可以在  www.dell.com/printers  上获得。 使用打印机软件的帮助 Windows 或 Mac 帮助—打开打印机软件程序或应用程序，然后单击 帮助 。 单击   来查看上下文敏感的信息。 “帮助”随打印机软件一起自动安装。 根据您的操作系统，打印机软件位于打印机程序文件夹中或桌面上。 最新的补充信息、更新和客户支持： 文档 驱动程序下载 在线聊天支持 电子邮件支持 语音信箱支持 Lexmark 支持网站— http://support.lexmark.com 选择您所在的国家或地区，然后选择您的产品来查看适当的支持网站。 您所在国家或地区的支持电话号码和营业时间可以在支持网站或随打印机附带的印刷的保证上找到。 记录下列信息（在商店收据上和打印机的背后），并在您联系客户支持人员时准备好它，以便他们能更快地为您服务： 机器类型号码 序列号 购买日期 购买商店 最新的补充信息、更新和技术支持： 文档 驱动程序下载 产品升级 服务呼叫和维修信息 订单状态 在线聊天支持 电子邮件支持 语音信箱支持 Dell 支持网站— www.dell.com/support/printers 您所在国家或地区的支持电话号码和营业时间可以在支持网站上找到。 当您联系支持人员时请准备好下列信息，以便他们能更快地为您服务： 服务标签 快速服务代码 服务标签和快速服务代码出现在打印机上的标签上。  软件和驱动程序—用于您的打印机的经验证驱动程序，以及用于 Dell 打印机软件的安装程序 自述文件—为熟练用户或技术人员提供有关技术更改或高级技术参考材料的最近更新版本 软件和文档  CD 用于您的打印机的耗材和附件 替换碳粉盒 Dell 打印机耗材网站– www.dell.com/printers 您可以在线、通过电话或在选定的零售商店购买打印机耗材。 保证信息 用于准备操作您的打印机的安全信息 规格信息 保证信息 保证信息根据国家或地区而异： 在美国 —请参阅随此打印机附带的 Statement of Limited Warranty（有限保证声明），或者转到  http://support.lexmark.com 。 在其他国家和地区 —请参阅随此打印机附带的印刷的保证。 产品信息指南 产品信息指南  可能在您所在的国家或地区没有提供。 出版物 何处查找 打印机信息 何处查找 查找有关打印机的更多信息"},{"UUID":"f350edde-56c2-4d51-a092-f49f47d5f46e","title":"了解打印机","link":"connecting-the-printer-to-outlet-topic.html","desc":"将打印机连接到电源插座 将电源线连接到打印机上，然后连接到正确接地并且便于使用的电源插座上。 电源插座的外观可能会因您所在的国家或地区而异。 打印机 连接到电源插座","descFull":"将打印机连接到电源插座 将电源线连接到打印机上，然后连接到正确接地并且便于使用的电源插座上。 电源插座的外观可能会因您所在的国家或地区而异。 打印机 连接到电源插座 将打印机连接到电源插座"},{"UUID":"9f02ae73-1960-4f3d-a80d-2324e95851f4","title":"了解打印机","link":"selecting-location-printer-m-topic.html","desc":"为打印机选择位置 打印机的重量大于 18 千克（40 磅），因此，需要两个或更多个受过训练的人才能安全地抬起它。","descFull":"为打印机选择位置 打印机的重量大于 18 千克（40 磅），因此，需要两个或更多个受过训练的人才能安全地抬起它。 在为打印机选择位置时，请留出足够的空间以便打开进纸匣、盖板和盖门。如果您准备安装任何选件，也请为它们留出足够的空间。下面是重要事项： 将打印机设置在正确接地并且便于使用的电源插座附近。 确认室内气流符合 ASHRAE 62 标准或 CEN Technical Committee 156 标准的最新版本。 提供一个平坦、牢固和稳定的表面。 让打印机保持： 清洁、干燥、无灰尘。 远离散落的订书钉和回形针。 远离空调、加热器或通风设备的直接气流。 避免直射阳光和湿度极限。 请保持推荐的温度并避免波动： 推荐的温度 环境温度 存储温度 在打印机周围留出下列推荐的空间以保证良好的通风： 打印机周围推荐的空间 1 后部 2 右边 3 前部 4 左边 5 顶部 打印机 选择位置 打印机 最小空间 打印机 移动 移动打印机 为打印机选择位置"},{"UUID":"7cafdc48-d7f5-4026-9528-e1a5a9b11a70","title":"了解打印机","link":"printer-configurations-topic.html","desc":"打印机配置 确认在一个平坦、牢固和稳定的表面上配置打印机。 基本型号 基本打印机型号的部件 1","descFull":"打印机配置 确认在一个平坦、牢固和稳定的表面上配置打印机。 基本型号 基本打印机型号的部件 1 自动文档传送器（ADF） 2 ADF 进纸匣 3 ADF 接纸架 4 控制面板 5 多功能进纸器 6 标准 2 x 500 页进纸匣 7 标准接纸架 已配置型号 落地配置要求有附加设备以确保稳定性。如果您使用多个输入选件，您必须使用打印机工作台或打印机基座。如果您购买了具有扫描、复印和传真功能的多功能数码复合机（MFD），您可能需要附加设备。如需更多信息，请参阅  www.lexmark.com/multifunctionprinters 。 落地配置要求有附加设备以确保稳定性。如果您使用多个输入选件，您必须使用打印机工作台或打印机基座。如果您购买了具有扫描、复印和传真功能的多功能打印机（MFP），您可能需要附加设备。如需更多信息，请与您购买打印机处的销售商联系。 已配置打印机型号的部件 硬件选件 备选硬件选件 1 装订完成器 此项仅在精选的打印机型号中被支持。 无 2 3000 页进纸匣 无 3 2 x 500 页进纸匣 2500 页进纸匣 4 2500 页进纸匣 2 x 500 页进纸匣 5 完成器 装订、打孔完成器 小册子装订完成器 无 当使用进纸匣选件时： 3000 页进纸匣仅在安装了另一个进纸匣选件时被支持。 如果安装了另一个完成器，装订完成器不被支持。  一些选件可能没有供应。如需更多信息，请与您购买打印机处的销售商联系。 打印机配置 打印机 完全配置 打印机 基本型号"},{"UUID":"57e7b08d-3a7c-4037-a706-4b1fcdd24bb5","title":"了解打印机","link":"understanding-basic-functions-scanner-topic.html","desc":"理解扫描仪的基本功能 进行快速复印，或设置打印机执行特定的复印作业。 使用打印机控制面板发送传真。 将传真同时发送到多个传真目标。 扫描文档并将它们发送到计算机、电子邮件地址、闪存驱动器或","descFull":"理解扫描仪的基本功能 进行快速复印，或设置打印机执行特定的复印作业。 使用打印机控制面板发送传真。 将传真同时发送到多个传真目标。 扫描文档并将它们发送到计算机、电子邮件地址、闪存驱动器或 FTP 目标。 扫描文档并将它们发送到另一台打印机（通过 FTP 传送 PDF 文件）。 扫描仪 功能"},{"UUID":"0952e0c4-e602-4dba-ba89-ef1f7a8ebfe3","title":"了解打印机","link":"using-ADF-and-scanner-glass-topic.html","desc":"使用 ADF 和扫描仪玻璃 将纸张加载到 ADF","descFull":"使用 ADF 和扫描仪玻璃 将纸张加载到 ADF 进纸匣中或放在扫描仪玻璃上 自动文档传送器（ADF） 扫描仪玻璃 ADF 用于多页或两面的文档。 面朝上加载原始文档。 扫描仪玻璃用于单页文档、书页、小物品（如明信片或照片）、透明胶片、照片纸或薄介质（如杂志剪报）。 将文档面朝下放在有箭头的角落中。 使用扫描仪玻璃 使用自动文档传送器（ADF） 自动文档传送器（ADF） 使用 扫描仪玻璃 使用"},{"UUID":"53c025a1-b126-461b-a30e-527b289d7f55","title":"理解打印机控制面板","link":"using-printer-control-panel-topic.html","desc":"使用控制面板 控制面板部件及其描述 使用 来 1","descFull":"使用控制面板 控制面板部件及其描述 使用 来 1 显示屏 查看打印机状态和消息。 设置和操作打印机。 2 “主页”按钮 转到主屏幕。 3 “睡眠”按钮 启用“睡眠”模式或“休眠”模式。 下列操作将打印机从“睡眠”模式唤醒： 触摸控制面板主屏幕 打开扫描仪盖板 下列操作将打印机从“休眠”模式唤醒： 按“睡眠”按钮直到打印机醒来 使用主电源开关执行加电复位 4 键盘 输入数字、字母或符号。 5 “开始”按钮 根据选择的模式启动作业。 6 全部清除 / 重置按钮 重置功能的默认设置，如复印、传真或扫描。 7 “停止”或“取消”按钮 停止所有的打印机活动。 8 指示灯 检查打印机的状态。 控制面板 显示屏，控制面板 按钮，控制面板 指示灯"},{"UUID":"8947e9b7-4d53-4ce8-94f6-d5c3c2bc8981","title":"理解打印机控制面板","link":"understanding-colors-sleep-button-indicator-lights-h-topic.html","desc":"理解“睡眠”按钮和指示灯的颜色 打印机控制面板上的“睡眠”按钮和指示灯的颜色表示一定的打印机状态或状况。 指示灯颜色及其相应的打印机状态 指示灯 打印机状态","descFull":"理解“睡眠”按钮和指示灯的颜色 打印机控制面板上的“睡眠”按钮和指示灯的颜色表示一定的打印机状态或状况。 指示灯颜色及其相应的打印机状态 指示灯 打印机状态 关 打印机电源已关闭或处于“休眠”模式。 绿灯闪烁 打印机正在预热、处理数据或打印作业。 绿灯长亮 打印机电源已打开，但是空闲。 红灯闪烁 打印机要求用户干预。 “睡眠”按钮灯颜色及其相应的打印机状态 “睡眠”按钮灯 打印机状态 关 打印机电源关闭，空闲或处于“就绪”状态。 琥珀色灯长亮 打印机处于“睡眠”模式。 琥珀色灯闪烁 打印机正在进入“休眠”模式或者正在从“休眠”模式唤醒。 以缓慢的脉冲模式，琥珀色灯闪烁 0.1 秒，然后完全关闭 1.9 秒 打印机处于“休眠”模式。 控制面板，打印机 “睡眠”按钮灯 打印机控制面板 “睡眠”按钮灯 打印机控制面板 指示灯 控制面板，打印机 指示灯"},{"UUID":"dd26ed92-fed9-43c9-8ae6-567c2a3329d0","title":"理解打印机控制面板","link":"understanding-home-screen-topic.html","desc":"理解主屏幕 当打印机电源打开时，显示屏显示被称为主屏幕的基本屏幕。触摸主屏幕按钮和图标来初始化复印、传真或扫描等操作；打开菜单屏幕；或响应消息。 您的主屏幕可能根据您的主屏幕定制设置、管理设置和活动的嵌入式解决方案而有所变化。 触摸屏按钮及其功能 触摸","descFull":"理解主屏幕 当打印机电源打开时，显示屏显示被称为主屏幕的基本屏幕。触摸主屏幕按钮和图标来初始化复印、传真或扫描等操作；打开菜单屏幕；或响应消息。 您的主屏幕可能根据您的主屏幕定制设置、管理设置和活动的嵌入式解决方案而有所变化。 触摸屏按钮及其功能 触摸 来 1 更改语言 启动“更改语言”弹出窗口，让您更改打印机的第一语言。 2 复印 访问“复印”菜单并制作副本。 3 传真 访问“传真”菜单并发送传真。 4 电子邮件 访问“电子邮件”菜单并发送电子邮件。 5 FTP 访问“文件传输协议（FTP）”菜单，并将文档直接扫描到 FTP 服务器。 6 箭头 向上或向下滚动。 7 表单与收藏夹 快速查找并打印常用的在线表单。 8 “菜单”图标 访问打印机菜单。 菜单仅在打印机处于“就绪”状态时可用。 9 书签 创建、组织和保存一组书签（URL）到文件夹和文件链接的树形视图中。 树形视图仅支持从此功能创建的书签，不支持从任何其他应用程序创建的书签。 10 USB 驱动器 从闪存驱动器查看、选择、打印、扫描或用电子邮件发送照片和文档。 此图标仅在您返回到主屏幕并且内存卡或闪存驱动器连接在打印机上出现。 11 挂起作业 显示所有当前的挂起作业。 12 状态/耗材 无论何时打印机要求干预以继续处理时，显示警告或错误消息。 访问消息屏幕以获取有关消息，以及如何清除消息的更多信息。 13 提示 打开上下文相关的“帮助”对话。 14 搜索挂起作业 搜索下面的一个或多个项目： 挂起或保密打印作业的用户名 挂起作业，不包括保密打印作业的作业名 配置文件名称 书签容器或打印作业名称 用于支持文件类型的 USB 容器或打印作业名称 特性 主屏幕特性及其描述 特性 描述 菜单路线 示例： 菜单 设置 复印设置 复印份数 菜单路线位于每个菜单屏幕的顶部。此特性显示到达当前菜单采用的路径。 触摸任意带下划线的文字将返回到该菜单。 “复印份数”没有加下划线，因为这是当前屏幕。如果您在设置并保存份数之前触摸“复印份数”屏幕上带下划线的文字，那么选择不会被保存，它不会成为默认设置。 维护消息警报 如果维护消息影响到功能，会出现此图标并且红色指示灯闪烁。 警告 如果出现错误情况，会出现此图标。 状态消息栏 显示当前的打印机状态，例如 就绪 或 忙 。 显示打印机状况，例如 碳粉不足 或 碳粉盒不足 。 显示干预消息，以便打印机可以继续处理。 打印机 IP 地址 示例： 123.123.123.123 您网络打印机的 IP 地址位于主屏幕的左上角，并且显示为四组小数点分隔的数字。当访问 Embedded Web Server 时，您可以使用 IP 地址，这样您在即使没有实际靠近打印机的时候也能够查看并远程配置打印机设置。 主屏幕按钮和图标 描述 理解主屏幕按钮和图标"},{"UUID":"0a709696-43f6-4fc3-9e26-7518829817ff","title":"理解打印机控制面板","link":"using-touch-screen-buttons-topic.html","desc":"使用触摸屏按钮 您的主屏幕、图标和按钮可能根据您的主屏幕定制设置、管理设置和活动的嵌入式解决方案而有所变化。 触摸屏按钮及其功能 触摸 来","descFull":"使用触摸屏按钮 您的主屏幕、图标和按钮可能根据您的主屏幕定制设置、管理设置和活动的嵌入式解决方案而有所变化。 触摸屏按钮及其功能 触摸 来 1 箭头 查看选项列表。 2 复印 打印副本。 3 高级选项 选择复印选项。 4 主页 转到主屏幕。 5 增加 选择更高的值。 6 减少 选择更低的值。 7 提示 打开上下文相关的“帮助”对话。 其他触摸屏按钮 其他触摸屏按钮及其功能 触摸 来 接受 保存设置。 取消 取消操作或选择。 退出屏幕并返回到之前的屏幕而不保存更改。 重置 重置屏幕上的值。 触摸屏 按钮 按钮，触摸屏 使用 使用触摸屏按钮"},{"UUID":"c3496cad-329a-42e4-9fbc-3e60fb9a4b7f","title":"设置和使用主屏幕应用程序","link":"finding-ip-address-of-printer-topic.html","desc":"查找打印机的 IP 地址 确认您的打印机连接到网络或打印服务器上。 您可以查找打印机的","descFull":"查找打印机的 IP 地址 确认您的打印机连接到网络或打印服务器上。 您可以查找打印机的 IP 地址： 从打印机主屏幕的左上角。 从“网络/端口”菜单中的 TCP/IP 部分。 通过打印网络设置页或菜单设置页，然后查找 TCP/IP 部分。 IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 打印机 IP 地址 查找 IP 地址，打印机 查找 查找打印机 IP 地址"},{"UUID":"e3e805b0-35d5-44ba-accb-8fef954a0523","title":"设置和使用主屏幕应用程序","link":"finding-ip-address-of-computer-topic.html","desc":"查找计算机的 IP 地址 对于 Windows","descFull":"查找计算机的 IP 地址 对于 Windows 用户 运行命令提示符。 键入  ipconfig ，然后查看 IP 地址。 对于 Macintosh 用户 从 Apple 菜单中的“系统预置”，选择 网络 。 选择连接类型，然后单击 高级 TCP/IP 。 查看 IP 地址。 计算机的 IP 地址 查找 查找计算机的 IP 地址"},{"UUID":"8848e3fb-0ab3-4e9c-9a43-2dd6d256aacb","title":"设置和使用主屏幕应用程序","link":"accessing-embedded-web-server-topic.html","desc":"访问 Embedded Web Server Embedded","descFull":"访问 Embedded Web Server Embedded Web Server 是打印机 Web 页，让您即使没有实际在打印机近旁时也能查看和远程配置打印机设置。 获取打印机 IP 地址： 从打印机控制面板主屏幕 从“网络/端口”菜单中的 TCP/IP 部分 通过打印网络设置页或菜单设置页，然后查找 TCP/IP 部分 IP 地址显示为四组由小数点分隔的数字，例如  123.123.123.123 。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 按  Enter（回车键） 。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 访问 Embedded Web Server Embedded Web Server 访问"},{"UUID":"7811fe7d-6951-41e4-8820-b6440334b25f","title":"设置和使用主屏幕应用程序","link":"customizing-home-screen-topic.html","desc":"定制主屏幕 打开 Web 浏览器，然后在地址字段中键入打印机 IP","descFull":"定制主屏幕 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 请执行下列操作中的一项或多项： 显示或隐藏基本打印机功能的图标。 单击 设置 常规设置 主屏幕定制 。 选择复选框来指定哪些图标出现在主屏幕上。 如果您清除某个图标旁边的复选框，该图标将不会出现在主屏幕上。 单击 提交 。 为应用程序定制图标。如需更多信息，请参阅 ，或者参阅随应用程序附带的文档。 在主屏幕上显示图标 主屏幕 显示图标 在主屏幕上隐藏图标 主屏幕 隐藏图标 主屏幕上的图标 显示 主屏幕上的图标 隐藏 主屏幕 定制"},{"UUID":"ce1c6fca-0e6d-4c07-b232-016b095aefaa","title":"设置和使用主屏幕应用程序","link":"understanding-different-apps-topic.html","desc":"理解不同的应用程序 应用程序及其描述 使用 来 身份证复印","descFull":"理解不同的应用程序 应用程序及其描述 使用 来 身份证复印 将证卡的两个面扫描并打印到单个页面上。如需更多信息，请参阅 。 传真 扫描文档，然后将它发送到传真号码。如需更多信息，请参阅 。 表单与收藏夹 直接从打印机主屏幕快速查找并打印常用的在线表单。如需更多信息，请参阅 。 多目标扫描方案 扫描文档，然后将它发送到多个目的地。如需更多信息，请参阅 。 我的快捷方式 直接在打印机主屏幕上创建快捷方式。如需更多信息，请参阅 。 扫描到电子邮件 扫描文档，然后将它发送到电子邮件地址。如需更多信息，请参阅 。 扫描到计算机 扫描文档，然后将它保存到主计算机上的预定义文件夹中。如需更多信息，请参阅 。 扫描到 FTP 将文档直接扫描到“文件传输协议（FTP）”服务器。如需更多信息，请参阅 。 扫描到网络 扫描文档，然后将它发送到网络共享文件夹。如需更多信息，请参阅 。 应用程序 理解"},{"UUID":"15c6787c-186b-4e3f-8d9a-2d6f0986fb6d","title":"激活主屏幕应用程序","link":"activating-home-screen-apps-group.html","desc":"查找有关主屏幕应用程序的信息 您的打印机在出厂时预安装了主屏幕应用程序。您在能够使用这些应用程序之前，您必须先使用 Embedded Web Server","descFull":"查找有关主屏幕应用程序的信息 您的打印机在出厂时预安装了主屏幕应用程序。您在能够使用这些应用程序之前，您必须先使用 Embedded Web Server 激活并设置这些应用程序。如需有关访问 Embedded Web Server 的更多信息，请参阅 。 如需有关配置和使用主屏幕应用程序的更多信息，请执行下列操作： 转到  http://support.lexmark.com 。 单击 软件解决方案 ，然后选择下面任一选项： 扫描到网络 —这让您查找有关“扫描到网络”应用程序的信息。 其他应用程序 —这让您查找有关其他应用程序的信息。 单击 手册 选项卡，然后选择主屏幕应用程序的文档。 如需有关配置和使用主屏幕应用程序的详细信息，请与您购买打印机处的销售商联系。 如需有关配置和使用主屏幕应用程序的详细信息，请访问 Dell 的支持网站： www.dell.com/support/printers 。 主屏幕应用程序 查找信息 主屏幕应用程序 配置 应用程序 主屏幕"},{"UUID":"c7325018-8029-4e4b-a410-24319f824d9a","title":"激活主屏幕应用程序","link":"activating-home-screen-apps-group.html","desc":"设置“表单与收藏夹” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南","descFull":"设置“表单与收藏夹” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  http://support.lexmark.com 。 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  www.dell.com/support/manuals 。 “表单与收藏夹”描述 使用 来 通过让您直接从打印机主屏幕快速查找并打印常用的在线表单来组织工作流程。 打印机必须有访问保存书签的网络文件夹、FTP 站点或 Web 站点的权限。从保存书签的计算机，使用共享、安全和防火墙设置来允许打印机至少有 读 访问权限。如需帮助，请参阅随操作系统附带的文档。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 单击 设置 应用程序 应用程序管理 表单与收藏夹 。 单击 添加 ，然后定制设置。 查看每个字段旁边的鼠标悬停帮助以获得设置的描述。 要确认书签的位置设置是否正确，请键入书签所在的主计算机的正确 IP 地址。如需有关获取主计算机的 IP 地址的更多信息，请参阅 。 确认打印机有访问书签所在的文件夹的权限。 单击 应用 。 要使用应用程序，请在打印机主屏幕上触摸 表单与收藏夹 ，然后导览表单类别，或基于表单号码、名称或描述搜索表单。 表单与收藏夹 设置"},{"UUID":"a62a4a57-55b6-4121-900d-c2f329b8517c","title":"激活主屏幕应用程序","link":"activating-home-screen-apps-group.html","desc":"设置“身份证复印” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南","descFull":"设置“身份证复印” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  http://support.lexmark.com 。 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  www.dell.com/support/manuals 。 “身份证复印”图标及描述 使用 来 快速并轻松地复印保险卡、身份证和其他钱包大小的卡。 您可以将证卡的两个面扫描并打印在单个页面上，从而节省纸张并以更便利的方式显示证卡上的信息。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 单击 设置 应用程序 应用程序管理 身份证复印 。 如果需要，请更改默认的扫描选项。 默认进纸匣 —选择要用于打印扫描图像的默认进纸匣。 默认份数 —指定在使用应用程序时应该自动打印的副本份数。 默认对比度设置 —指定设置，在打印已扫描证卡的副本时增加或减少对比度水平。如果您希望打印机自动调整对比度，请选择 最适合内容 。 默认缩放设置 —设置打印时已扫描证卡的尺寸。默认设置为 100%（全尺寸）。 分辨率设置 —调整已扫描证卡的质量。 当扫描一个证卡时，确认扫描分辨率对于彩色不超过 200 dpi，对于黑白不超过 400 dpi。 当扫描多个证卡时，确认扫描分辨率对于彩色不超过 150 dpi，对于黑白不超过 300 dpi。 打印边框 —选择复选框来打印扫描图像和它周围的边框。 单击 应用 。 要使用应用程序，请在打印机主屏幕上触摸 身份证复印 ，然后按照说明进行操作。 身份证复印 设置"},{"UUID":"4cf68b2d-434e-4d8a-9f80-330d37efd80a","title":"激活主屏幕应用程序","link":"activating-home-screen-apps-group.html","desc":"使用“我的快捷方式” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南","descFull":"使用“我的快捷方式” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  http://support.lexmark.com 。 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  www.dell.com/support/manuals 。 “我的快捷方式”图标及描述 使用 来 在打印机主屏幕上创建快捷方式，使用用于最多 25 个常用的复印、传真或电子邮件作业的设置。 要使用应用程序，请触摸 我的快捷方式 ，然后按照打印机显示屏上的说明进行操作。 我的快捷方式 关于"},{"UUID":"0ef77517-db3f-48ee-b003-c702114a9244","title":"激活主屏幕应用程序","link":"activating-home-screen-apps-group.html","desc":"设置“多目标扫描方案” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南","descFull":"设置“多目标扫描方案” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  http://support.lexmark.com 。 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  www.dell.com/support/manuals 。 “多目标扫描方案”图标及其描述 使用 来 扫描文档，然后将扫描的文档发送到多个目标。 确认打印机硬盘中有足够的空间。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。打印机 IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 单击 设置 应用程序 应用程序管理 多目标扫描方案 。 从“配置文件”部分，单击 添加 ，然后定制设置。 查看每个字段旁边的鼠标悬停帮助以获得设置的描述。 如果您选择  FTP  或 共享文件夹 作为目标，请确认目标的位置设置是正确的。键入指定目标所在主计算机的正确 IP 地址。如需有关获取主计算机的 IP 地址的更多信息，请参阅 。 单击 应用 。 要使用应用程序，请在打印机主屏幕上触摸 多目标扫描方案 ，然后按照打印机显示屏上的说明进行操作。 多目标扫描方案 设置 多目标扫描方案 添加配置文件"},{"UUID":"f89103fe-b2bf-4802-9707-cf208f49ab09","title":"激活主屏幕应用程序","link":"activating-home-screen-apps-group.html","desc":"设置“扫描到网络” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南","descFull":"设置“扫描到网络” 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  http://support.lexmark.com 。 此 用户指南 的较新版本可能包含到此应用程序的 管理员指南 的直接链接。要检查此 用户指南 的更新，请转到  www.dell.com/support/manuals 。 “扫描到网络”描述 使用 来 扫描文档并将它发送到共享的网络文件夹。您可以定义最多 30 个唯一的文件夹目标。 打印机必须有写入目标的权限。从指定目标的计算机，使用共享、安全和防火墙设置来允许打印机至少有 写 访问权限。如需帮助，请参阅随操作系统附带的文档。 “扫描到网络”图标仅在一个或多个目标已定义时出现。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 请执行下面的任一操作： 单击 设置“扫描到网络” 单击此处 。 单击 设置 应用程序 应用程序管理 扫描到网络 。 指定目标，然后定制设置。 查看一些字段旁边的鼠标悬停帮助以获得该设置的描述。 要确认目标的位置设置是否正确，请键入指定目标所在主计算机的正确 IP 地址。如需有关获取主计算机的 IP 地址的更多信息，请参阅 。 确认打印机有访问指定目标所在的文件夹的权限。 单击 应用 。 要使用应用程序，请在打印机主屏幕上触摸 扫描到网络 ，然后按照打印机显示屏上的说明进行操作。 扫描到网络 设置"},{"UUID":"7be7f568-e25d-46d1-aabb-a1e62433ba5c","title":"设置和使用主屏幕应用程序","link":"setting-up-remote-operator-panel-topic.html","desc":"设置“远程操作面板” 此应用程序让您能够与打印机控制面板互动，即使您实际上没有在网络打印机附近。从您的计算机，您可以查看打印机状态、释放挂起的打印作业、创建书签，以及执行其他打印相关任务。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"设置“远程操作面板” 此应用程序让您能够与打印机控制面板互动，即使您实际上没有在网络打印机附近。从您的计算机，您可以查看打印机状态、释放挂起的打印作业、创建书签，以及执行其他打印相关任务。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 单击 设置 远程操作面板设置 。 选择 启用 复选框，然后定制设置。 单击 提交 。 要使用应用程序，请单击 远程操作面板 启动 VNC Applet 。 远程操作面板 设置"},{"UUID":"ff3357a7-d4a5-43fe-902d-66eee4ba8030","title":"设置和使用主屏幕应用程序","link":"exporting-importing-configuration-using-ews-winners-circle-topic.html","desc":"导出和导入配置 您可以将配置设置导出到文本文件中，然后导入文件来将设置应用于其他打印机。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"导出和导入配置 您可以将配置设置导出到文本文件中，然后导入文件来将设置应用于其他打印机。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 为一个或多个应用程序导出或导入配置文件。 对于一个应用程序 导览至： 设置 应用程序 应用程序管理  选择一个应用程序 配置 导出或导入配置文件。 如果出现  JVM 内存不足 错误，请重复导出过程，直到配置文件被保存。 如果发生超时并出现空白屏幕，请刷新 Web 浏览器，然后单击 应用 。 对于多个应用程序 单击 设置 导入/导出 。 导出或导入配置文件。 当导入配置文件时，请单击 提交 来完成过程。 导出配置 使用 Embedded Web Server 导入配置 使用 Embedded Web Server"},{"UUID":"ace8be57-abda-45c4-9a0f-e8356132f8f1","title":"安装内置式选件","link":"internal-options.html","desc":"可用的内置式选件 一些选件仅在精选的打印机型号中可用。如需更多信息，请与您购买打印机处的销售商联系。 存储卡 DDR2 DIMM","descFull":"可用的内置式选件 一些选件仅在精选的打印机型号中可用。如需更多信息，请与您购买打印机处的销售商联系。 存储卡 DDR2 DIMM 闪存 字体 固件卡 表单和条形码 PRESCRIBE IPDS Lexmark  内置方案端口（ISP） 标准 10/100/1000 以太网 MarkNet  N8350 802.11 b/g/n 无线打印服务器 MarkNet  N8352 802.11 b/g/n 无线打印服务器 内置方案端口（ISP） 可用的内置式选件 内置式选件 固件卡 内存卡 选件 固件卡 选件 内存卡"},{"UUID":"ac730d32-7f8b-4bcf-b890-2b4ebac12329","title":"安装内置式选件","link":"internal-options.html","desc":"访问控制器板 请使用打印机底部前盖门内的螺丝起子。 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 移除连接器盖板。 从控制器板通道盖板上移除螺钉。","descFull":"访问控制器板 请使用打印机底部前盖门内的螺丝起子。 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 移除连接器盖板。 从控制器板通道盖板上移除螺钉。 移除通道盖板。 使用下面的图示来找到适当的连接器： 控制器板电子组件容易被静电损坏。在接触任何控制器电子组件或连接器之前请先触摸一下打印机上的金属表面。 内部选件卡连接器 1 选件卡连接器 2 内存卡连接器 3 Lexmark  内置方案端口或打印机硬盘连接器 3 内置方案端口或打印机硬盘连接器 将通道盖板的基座与打印机对齐。 重新安装通道盖板。 拧紧通道盖板上的螺钉。 重新安装连接器盖板。 控制器板 访问 访问控制器板"},{"UUID":"21ebc87d-e7b6-4941-abeb-a44d2827ec71","title":"安装内置式选件","link":"internal-options.html","desc":"安装内存卡 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 进入控制器板。 如需更多信息，请参阅 。","descFull":"安装内存卡 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 进入控制器板。 如需更多信息，请参阅 。 拆开内存卡的包装。 请勿接触卡边缘的接插脚。否则可能造成损坏。 将内存卡上的槽口（1）与连接器上的凸脊（2）对齐。 将内存卡笔直推入连接器中，然后将卡朝着控制器板墙推，直到它发出 咔嗒 一声，卡入到位。 内存卡 安装 选件 内存卡 安装内存卡"},{"UUID":"d01a4b91-ab87-4ab0-87ba-2d052931f878","title":"安装内置式选件","link":"internal-options.html","desc":"安装选件卡 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 控制器板电子组件容易被静电损坏。在接触任何控制器电子组件或连接器之前请先触摸一下打印机上的金属表面。 进入控制器板。 如需更多信息，请参阅","descFull":"安装选件卡 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 控制器板电子组件容易被静电损坏。在接触任何控制器电子组件或连接器之前请先触摸一下打印机上的金属表面。 进入控制器板。 如需更多信息，请参阅 。 拆开选件卡的包装。 避免接触卡边缘的接插脚。否则可能造成损坏。 拿住卡的两边，将卡上的塑料接插脚（1）与控制器板上的孔（2）对齐。 用力将卡推入到位。 不正确安装卡可能造成卡和控制器板的损坏。 卡上的整个连接器必须完全接触控制器板，并与控制器板齐平。 选件卡 安装 安装选件卡"},{"UUID":"1f2b93ad-aec9-4538-8559-c516c7878505","title":"安装内置式选件","link":"internal-options.html","desc":"安装内置方案端口 控制器板支持一个可选的  Lexmark ","descFull":"安装内置方案端口 控制器板支持一个可选的  Lexmark  内置方案端口（ISP）。请安装 ISP 以获得额外的连通性选项。 请使用打印机底部前盖门内的螺丝起子。 如果您在设置完打印机后访问控制器板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 控制器板电子组件容易被静电损坏。在接触任何控制器电子组件或连接器之前请先触摸一下打印机上的金属表面。 拆开 ISP 组件的包装。 ISP 组件的内容 1 ISP 2 塑料安装支架 3 翼形螺钉 进入控制器板。如需更多信息，请参阅 。 移除打印机硬盘。 必须先移除硬盘才能安装 ISP。 从控制器板拔掉硬盘接口电缆。 移除固定硬盘的螺钉。 移除硬盘。 将 ISP 安装在之前硬盘在控制器板上的相同位置中。 将塑料安装支架的凸柱与控制器板罩上的孔对齐，将支架按压到罩上，直到它发出 咔嗒 一声，卡入到位。 将 ISP 安装在支架上。 使用为 ISP 提供的翼形螺钉将 ISP 安装到支架上。 使用螺钉将 ISP 安装支架安装到控制器板罩上。 移除将硬盘安装支架安装到硬盘上的翼形螺钉，然后移除支架。 将硬盘的螺孔与 ISP 上的孔对齐，然后向下压硬盘，直到螺孔发出 咔嗒 一声，卡入到位。 将硬盘接口电缆的插头插入 ISP 上的连接器中，然后将 ISP 解决方案接口电缆连接到控制器板的插座中。 内置方案端口（ISP） 安装 选件 内置方案端口（ISP）"},{"UUID":"71fbef38-1e56-4366-82df-286515720e60","title":"安装内置式选件","link":"internal-options.html","desc":"移除打印机硬盘 请使用打印机底部前盖门内的螺丝起子。 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 控制器板电子组件容易被静电损坏。在接触任何控制器电子组件或连接器之前请先触摸一下打印机上的金属表面。 进入控制器板。","descFull":"移除打印机硬盘 请使用打印机底部前盖门内的螺丝起子。 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 控制器板电子组件容易被静电损坏。在接触任何控制器电子组件或连接器之前请先触摸一下打印机上的金属表面。 进入控制器板。 如需更多信息，请参阅 。 从控制器板上拔掉硬盘接口电缆，让电缆仍然连接在硬盘上。为拔掉电缆，请在拉出电缆之前捏住接口电缆插头上的销子来释放插销。 取下将硬盘固定到位的螺钉。 移除硬盘。 打印机硬盘 移除 选件 打印机硬盘，移除 移除打印机硬盘"},{"UUID":"e207bf30-4a6d-4f5c-b26d-ad6a5c22afc9","title":"安装硬件选件","link":"order-installation-topic.html","desc":"安装顺序 打印机的重量大于 18 千克（40 磅），因此，需要两个或更多个受过训练的人才能安全地抬起它。","descFull":"安装顺序 打印机的重量大于 18 千克（40 磅），因此，需要两个或更多个受过训练的人才能安全地抬起它。 落地配置要求有附加设备以确保稳定性。如果您使用多个输入选件，您必须使用打印机工作台或打印机基座。如果您购买了具有扫描、复印和传真功能的多功能数码复合机（MFD），您可能需要附加设备。如需更多信息，请参阅  www.lexmark.com/multifunctionprinters 。 落地配置要求有附加设备以确保稳定性。如果您使用多个输入选件，您必须使用打印机工作台或打印机基座。如果您购买了具有扫描、复印和传真功能的多功能打印机（MFP），您可能需要附加设备。如需更多信息，请与您购买打印机处的销售商联系。 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 请按照下列顺序安装打印机和您已购买的任何选件： 2 x 500 或 2500 页进纸匣选件 打印机 装订完成器 此选件仅在精选的打印机型号中被支持。 装订、打孔完成器或小册子完成器 3000 页进纸匣选件 如果安装了另一个完成器，装订完成器不被支持。如需有关安装完成器和进纸匣选件的更多信息，请参阅随选件附带的说明页。 安装硬件选件 安装顺序"},{"UUID":"1f20f8cf-630a-449e-8d2e-7a4770c93620","title":"安装硬件选件","link":"order-installation-topic.html","desc":"安装进纸匣选件 如需有关安装 3000 页进纸匣选件的信息，请参阅随选件附带的说明页。 请使用打印机底部前盖门内的螺丝起子。","descFull":"安装进纸匣选件 如需有关安装 3000 页进纸匣选件的信息，请参阅随选件附带的说明页。 请使用打印机底部前盖门内的螺丝起子。 打印机的重量大于 18 千克（40 磅），因此，需要两个或更多个受过训练的人才能安全地抬起它。 如果您在设置完打印机后访问控制器主板或者安装可选的硬件或内存设备，请在继续操作之前先关闭打印机电源并从电源插座中拔掉电源线。如果您还有其他设备连接在打印机上，也应关闭它们的电源并拔掉所有连接到打印机上的电缆。 落地配置要求有附加设备以确保稳定性。如果您使用多个输入选件，您必须使用打印机工作台或打印机基座。如果您购买了具有扫描、复印和传真功能的多功能数码复合机（MFD），您可能需要附加设备。如需更多信息，请参阅  www.lexmark.com/multifunctionprinters 。 落地配置要求有附加设备以确保稳定性。如果您使用多个输入选件，您必须使用打印机工作台或打印机基座。如果您购买了具有扫描、复印和传真功能的多功能打印机（MFP），您可能需要附加设备。如需更多信息，请与您购买打印机处的销售商联系。 进纸匣选件附带下列附件： 附件列表 附件名称 数量 稳定脚 2 锁定夹 3 金属支架 1 螺钉 5 关闭打印机电源。 从电源插座上拔掉电源线，然后从打印机上拔掉电源线。 拆开进纸匣选件的包装，然后去除所有包装材料。 将稳定脚安装到进纸匣选件上。 确认稳定脚 咔嗒 一声，卡入到位。 从打印机上移除连接器盖板。 使用两边的手柄来抬起打印机。 打印机的重量大于 18 千克（40 磅），因此，需要两个或更多个受过训练的人才能安全地抬起它。 将打印机与进纸匣对齐，然后将打印机向下放到位。 移除连接器上的胶带，然后将连接器插入打印机的插座中。 打开进纸匣 2 和进纸匣 3。 使用锁定夹和金属支架将进纸匣固定到打印机上。 后部 前部 重新安装连接器盖板。 将电源线连接到打印机和电源插座上。 打开打印机电源。 设置打印机软件来识别可选的进纸匣。如需更多信息，请参阅 。 脚 稳定 稳定脚 2 x 500 页进纸匣选件 安装 进纸匣选件 安装 2500 页进纸匣选件 安装 安装进纸匣选件"},{"UUID":"b5c9de10-d559-493f-9cbc-9dccb0abaef3","title":"其他打印机设置","link":"attaching-cables-topic.html","desc":"连接电缆 在雷雨天气时，请不要使用传真功能。也不要在雷雨天气时设置本产品，或者使用传真功能、电源线或电话线进行带电操作或线缆连接。 使用 USB 电缆将打印机连接到计算机上或使用以太网电缆连接到网络上。","descFull":"连接电缆 在雷雨天气时，请不要使用传真功能。也不要在雷雨天气时设置本产品，或者使用传真功能、电源线或电话线进行带电操作或线缆连接。 使用 USB 电缆将打印机连接到计算机上或使用以太网电缆连接到网络上。 请确认下列匹配项： 电缆上的 USB 符号与打印机上的 USB 符号 适当的以太网电缆与以太网端口 打印机电源线插座和端口及其功能 使用 来 1 EXT 端口 连接其他设备（电话或应答机）到打印机和电话线。如果您没有专用于打印机的传真线路，并且如果这种连接方法在您所在的国家或地区被支持，请使用此端口。 移除插头以访问端口。 2 LINE 端口 将打印机通过标准的墙壁插孔（RJ‑11）、DSL 过滤器或 VoIP 适配器，或者任何其他允许您访问电话线以发送和接收传真的适配器连接到活动的电话线路上。 3 打印机电源线插座 将打印机连接到正确接地的电源插座上。 4 内置方案端口（ISP）或打印机硬盘插槽 如果打印机支持无线连接，请将无线天线连接在此处。 连接 ISP 或打印机硬盘。 5 以太网端口 将打印机连接到网络。 6 USB 端口 连接键盘。 7 USB 打印机端口 将打印机连接到计算机。 当正在打印时，请勿触碰所示区域中的 USB 电缆、任何无线网络适配器或打印机。不然，可能会丢失数据或出现故障。 连接电缆 收纳电缆 电缆 USB 电缆 以太网 USB 端口 以太网端口 传真端口 LINE 端口 EXT 端口 电源线插座"},{"UUID":"5959993f-3374-4239-94cf-a399942f5f8d","title":"设置打印机软件","link":"installing-printer-software-topic.html","desc":"安装打印机 获取软件安装程序包的副本。 运行安装程序，然后按照计算机屏幕上的说明进行操作。 对于 Macintosh","descFull":"安装打印机 获取软件安装程序包的副本。 运行安装程序，然后按照计算机屏幕上的说明进行操作。 对于 Macintosh 用户，添加打印机。 从“网络/端口”菜单中的 TCP/IP 部分获得打印机 IP 地址。 安装打印机 打印机"},{"UUID":"27515ea1-1ace-408c-a6ee-5d6e7a84b372","title":"设置打印机软件","link":"installing-printer-software-topic.html","desc":"在打印驱动程序中添加可用选件 对于 Windows 用户 打开打印机文件夹。","descFull":"在打印驱动程序中添加可用选件 对于 Windows 用户 打开打印机文件夹。 选择您要更新的打印机，然后执行下列操作： 对于 Windows 7 或更高的版本，请选择 打印机属性 。 对于早期版本，请选择 属性 。 导览至“配置”选项卡，然后选择 立即更新‑查询打印机 。 应用更改。 对于 Macintosh 用户 从 Apple 菜单中的“系统预置”，导览至您的打印机，然后选择 选件和耗材 。 导览至硬件选件列表，然后添加任何已安装的选件。 应用更改。 添加硬件选件 打印驱动程序 打印驱动程序 硬件选件，添加 添加内置式选件 打印驱动程序 硬件选件，添加 打印驱动程序 内置式选件，添加 打印驱动程序"},{"UUID":"e11a2a59-a535-4239-8d83-429944ffb8b5","title":"网络连接","link":"preparing-set-up-printer-ethernet-network-topic.html","desc":"准备在以太网络上设置打印机 要配置您的打印机连接到以太网络，请在开始之前组织下列信息： 如果您的网络自动分配 IP 地址给计算机和打印机，请继续安装打印机。","descFull":"准备在以太网络上设置打印机 要配置您的打印机连接到以太网络，请在开始之前组织下列信息： 如果您的网络自动分配 IP 地址给计算机和打印机，请继续安装打印机。 供打印机在网络上使用的有效、唯一的 IP 地址 网关 网络掩码 打印机的别名（可选） 打印机别名可以使您更容易在网络上识别您的打印机。您可以选择使用默认的打印机别名，或者分配一个更容易记住的名称。 您将需要以太网电缆来连接打印机到网络和可用的端口，打印机能够从此物理连接到网络。尽可能使用新的网络电缆，以避免由于损坏的电缆而造成的潜在问题。 准备在以太网络上设置打印机 以太网设置 准备 以太网络 准备设置以太网打印"},{"UUID":"05498611-d4d6-4820-8343-b8cd85da2600","title":"网络连接","link":"preparing-set-up-printer-ethernet-network-topic.html","desc":"准备在无线网络上设置打印机 确认无线网络适配器安装在打印机中并且工作正常。如需更多信息，请参阅随无线网络适配器附带的说明页。 确认您的访问点（无线路由器）电源已经打开并且工作正常。 确认您在无线网络上设置打印机之前有下列信息： SSID","descFull":"准备在无线网络上设置打印机 确认无线网络适配器安装在打印机中并且工作正常。如需更多信息，请参阅随无线网络适配器附带的说明页。 确认您的访问点（无线路由器）电源已经打开并且工作正常。 确认您在无线网络上设置打印机之前有下列信息： SSID —SSID 也被称为网络名称。 无线模式（或网络模式） —模式是 Infrastructure 或 Ad hoc。 通道（对于 Ad hoc 网络） —对于 Infrastructure 网络，通道默认为自动。 一些 Ad hoc 网络也将要求自动设置。如果您不确定选择哪个通道，请咨询您的系统支持人员。 安全方法 —安全方法有四个基本选项： WEP 密钥 如果您的网络使用多个 WEP 密钥，请在提供的空间内输入最多四个密钥。通过选择默认的 WEP 传输密钥来选择当前在网络上使用的密钥。 WPA 或 WPA2 预共享密钥 WPA 包括作为额外安全层的加密。选项为 AES 或 TKIP。加密必须在路由器和打印机上被设置为相同类型，否则打印机将不能在网络上通信。 802.1X–RADIUS 如果您在 802.1X 网络上安装打印机，那么您可能需要下列信息： 验证类型 内部验证类型 802.1X 用户名和密码 证书 没有安全性 如果您的无线网络不使用任何类型的安全性，您将没有安全信息。 我们建议不要使用不安全的无线网络。 如果您不知道您的计算机所连网络的 SSID，请启动计算机网络适配器的无线实用程序，然后查找网络名称。如果您无法找到网络的 SSID 或安全信息，请参阅随访问点附带的文档，或与您的系统支持人员联系。 要查找无线网络的 WPA/WPA2 预共享密钥或密码，请参阅随访问点附带的文档，查看与访问点相关的 Embedded Web Server，或咨询您的系统支持人员。 配置信息 无线网络 无线网络 配置信息"},{"UUID":"efd2a265-9fc6-4810-b0c2-3c91f71197bc","title":"网络连接","link":"preparing-set-up-printer-ethernet-network-topic.html","desc":"使用“无线设置向导”来连接打印机 在您开始之前，请确认： 无线网络适配器安装在打印机中并且工作正常。如需更多信息，请参阅随无线网络适配器附带的说明页。 从打印机上断开以太网电缆。 将“活动","descFull":"使用“无线设置向导”来连接打印机 在您开始之前，请确认： 无线网络适配器安装在打印机中并且工作正常。如需更多信息，请参阅随无线网络适配器附带的说明页。 从打印机上断开以太网电缆。 将“活动 NIC”设置为“自动”。要设置此项为“自动”，请导览至： 网络/端口 活动 NIC 自动 提交 确认关闭打印机电源，接着等待至少 5 秒钟，然后重新打开打印机电源。 从打印机控制面板，导览至： 网络/端口 网络 [x] 网络 [x] 设置 无线 无线连接设置 选择一种无线连接设置。 无线连接设置类型及其描述 使用 来 搜索网络 显示可用的无线连接。 此菜单项显示所有广播安全或不安全的 SSID。 输入网络名称 手动键入 SSID。 确认键入正确的 SSID。 Wi‑Fi 保护设置 使用“Wi-Fi 保护设置”将打印机连接到无线网络。 按照打印机显示屏上的指导进行操作。 连接到无线网络 使用无线设置向导 无线设置向导 使用"},{"UUID":"fc7d6ebe-bb91-43f8-932a-1fbb5a13721d","title":"网络连接","link":"preparing-set-up-printer-ethernet-network-topic.html","desc":"使用 Wi‑Fi Protected Setup 将打印机连接到无线网络","descFull":"使用 Wi‑Fi Protected Setup 将打印机连接到无线网络 在您开始之前，请确认： 访问点（无线路由器）是经 Wi‑Fi Protected Setup（WPS）认证或者 WPS 兼容的。如需更多信息，请参阅随访问点附带的文档。 安装在您打印机中的无线网络适配器已连接并且工作正常。如需更多信息，请参阅随无线网络适配器附带的说明页。 使用“按按钮配置”方法 从打印机控制面板，导览至： 网络/端口 网络 [x] 网络 [x] 设置 无线 无线连接设置 Wi‑Fi Protected Setup 启动按按钮方法 按照打印机显示屏上的指导进行操作。 使用“个人身份识别码（PIN）”方法 从打印机控制面板，导览至： 网络/端口 网络 [x] 网络 [x] 设置 无线 无线连接设置 Wi‑Fi Protected Setup 启动 PIN 方法 复制 8 位的 WPS PIN 码。 打开 Web 浏览器，然后在地址字段中键入您的访问点的 IP 地址。 IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 访问 WPS 设置。如需更多信息，请参阅随访问点附带的文档。 输入 8 位 PIN 码，然后保存设置。 连接到无线网络 使用 PIN 码（个人身份识别码）方法 个人身份识别码方法 使用 连接到无线网络 使用“按按钮配置”方法 按按钮配置方法 使用"},{"UUID":"5f9037b0-8e19-46ab-a1bb-d9c58a2e6e83","title":"网络连接","link":"preparing-set-up-printer-ethernet-network-topic.html","desc":"使用 Embedded Web Server 将打印机连接到无线网络","descFull":"使用 Embedded Web Server 将打印机连接到无线网络 在您开始之前，请确认： 您的计算机暂时连接到以太网络。 无线网络适配器安装在您的打印机中并且工作正常。如需更多信息，请参阅随无线网络适配器附带的说明页。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机控制面板上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 网络/端口 无线 。 修改设置以匹配您的访问点（无线路由器）的设置。 确认输入正确的 SSID、安全方法、预共享密钥或密码、网络模式和通道。 单击 提交 。 关闭打印机电源，然后断开以太网电缆。等待至少 5 秒钟，然后重新打开打印机电源。 为检验打印机是否已连接到网络，请打印网络设置页。然后在“网卡 [x]”部分中，查看状态是否为 Connected（已连接）。 连接到无线网络 使用 Embedded Web Server 无线网络设置 使用 Embedded Web Server"},{"UUID":"19a559bd-b05d-483d-b1c8-ae50ab4b1d5b","title":"网络连接","link":"preparing-set-up-printer-ethernet-network-topic.html","desc":"安装内置方案端口之后更改端口设置 如果打印机有静态 IP 地址，请不要更改配置。 如果计算机被配置为使用网络名称，而不是","descFull":"安装内置方案端口之后更改端口设置 如果打印机有静态 IP 地址，请不要更改配置。 如果计算机被配置为使用网络名称，而不是 IP 地址，请不要更改配置。 如果您添加无线内置方案端口（ISP）到之前配置为以太网连接的打印机，请从以太网络上断开打印机连接。 对于 Windows 用户 打开打印机文件夹。 从带有新 ISP 的打印机的快捷方式菜单，打开打印机属性。  从列表中配置端口。 更新 IP 地址。 应用更改。 对于 Macintosh 用户 从 Apple 菜单中的“系统预置”，导览至打印机列表，然后选择  + IP 。 在地址字段中键入 IP 地址。 应用更改。 更改端口设置 内置方案端口 配置端口设置 端口设置 配置"},{"UUID":"891f8838-ade8-4f1d-90ef-d9c2f9c46bc5","title":"网络连接","link":"preparing-set-up-printer-ethernet-network-topic.html","desc":"设置串行打印（仅 Windows） 在打印机中设置参数。 从控制面板，导览至端口设置的菜单。 找到串口设置的菜单，然后根据需要调整设置。","descFull":"设置串行打印（仅 Windows） 在打印机中设置参数。 从控制面板，导览至端口设置的菜单。 找到串口设置的菜单，然后根据需要调整设置。 应用更改。 从您的计算机，打开打印机文件夹，然后选择您的打印机。 打开打印机属性，然后从列表中选择 COM 端口。 在“设备管理器”中设置 COM 端口参数。 串行打印会降低打印速度。 确认串行电缆被连接到打印机上的串口。 设置串行打印 串行打印 设置"},{"UUID":"f157aa97-4845-4aaf-8157-52e52fa6d2a5","title":"检验打印机设置","link":"printing-menu-settings-page-h2-topic.html","desc":"打印菜单设置页 从主屏幕，导览至： >  报告","descFull":"打印菜单设置页 从主屏幕，导览至： >  报告 >  菜单设置页 打印 菜单设置页 打印菜单设置页 菜单设置页 打印"},{"UUID":"81853072-3e8a-4eeb-af22-5f0657006be8","title":"检验打印机设置","link":"printing-menu-settings-page-h2-topic.html","desc":"打印网络设置页 如果打印机连接在网络上，请打印一份网络设置页来检验网络连接。此页也提供帮助网络打印配置的重要信息。 从主屏幕，导览至： > ","descFull":"打印网络设置页 如果打印机连接在网络上，请打印一份网络设置页来检验网络连接。此页也提供帮助网络打印配置的重要信息。 从主屏幕，导览至： >  报告 >  网络设置页 检查网络设置页上的第一部分，并确认状态为  Connected（已连接） 。 如果状态为  Not Connected（未连接） 表示 LAN 分接器可能不活动或网络电缆可能出现功能故障。请咨询系统支持人员以找到解决办法，然后再打印一份网络设置页。 打印 网络设置页 打印网络设置页 网络设置页 打印"},{"UUID":"244c6f40-4fb6-4b7f-ba9c-84caebb8c138","title":"加载纸张和特殊介质","link":"setting-paper-size-and-type-topic.html","desc":"设置纸张尺寸和类型 从主屏幕，导览至： 纸张菜单 纸张尺寸/类型 ","descFull":"设置纸张尺寸和类型 从主屏幕，导览至： 纸张菜单 纸张尺寸/类型  选择一个进纸匣  选择纸张尺寸或类型 提交 设置 纸张尺寸 设置 纸张类型 纸张尺寸 设置 纸张类型 设置"},{"UUID":"8a650538-2556-4ddf-8832-9b7227b78668","title":"加载纸张和特殊介质","link":"configuring-universal-paper-settings-topic.html","desc":"配置 Universal 纸张设置 Universal 纸张尺寸设置是用户定义的设置，让您使用没有在打印机菜单中预先设置的纸张尺寸进行打印。","descFull":"配置 Universal 纸张设置 Universal 纸张尺寸设置是用户定义的设置，让您使用没有在打印机菜单中预先设置的纸张尺寸进行打印。 从主屏幕，导览至： 纸张菜单 Universal 设置 选择度量单位，然后设置纵向宽度和高度。 应用更改。 设置 Universal 纸张尺寸 Universal 纸张尺寸 设置"},{"UUID":"99abf6ea-279e-4ccc-8b3a-2c3203274470","title":"加载纸张和特殊介质","link":"loading-trays-topic.html","desc":"加载进纸匣 为了减少设备不稳定的风险，请分别加载每一个进纸匣。在需要加载之前，保持所有其他的进纸匣为关闭状态。 拉出进纸匣。 当正在打印作业，或者打印机显示屏上出现 忙","descFull":"加载进纸匣 为了减少设备不稳定的风险，请分别加载每一个进纸匣。在需要加载之前，保持所有其他的进纸匣为关闭状态。 拉出进纸匣。 当正在打印作业，或者打印机显示屏上出现 忙 时，请勿移除进纸匣。否则可能造成卡纸。 压住纸张导片，并将导片滑动到与加载的纸张尺寸相符的正确位置上。 请使用进纸匣底部的指示线来放置导片。 前后弯曲纸张，使它们松散，然后将它们扇形展开。不要折叠或弄皱纸张。对齐纸张的边缘。 加载纸张，让可打印面朝上。 对于双面打印，让可打印面朝下。 加载预打孔的纸张时，让孔朝着进纸匣的前部或左边。 加载信签时，让页眉在进纸匣的左边。 确认纸张低于进纸匣边缘上的最大加载线。过量加载可能造成卡纸。 插入进纸匣。 从控制面板，在“纸张”菜单中设置纸张尺寸和纸张类型以匹配进纸匣中加载的纸张。 进纸匣 加载 加载进纸匣"},{"UUID":"5a2d6cac-0e75-4e36-a2e1-42f2a6957b27","title":"加载纸张和特殊介质","link":"loading-multipurpose-feeder-h-topic.html","desc":"加载多功能进纸器 打开多功能进纸器。 调整导片以匹配加载的纸张尺寸。 前后弯曲纸张，使它们松散，然后将它们扇形展开。不要折叠或弄皱纸张。对齐纸张的边缘。 加载纸张。","descFull":"加载多功能进纸器 打开多功能进纸器。 调整导片以匹配加载的纸张尺寸。 前后弯曲纸张，使它们松散，然后将它们扇形展开。不要折叠或弄皱纸张。对齐纸张的边缘。 加载纸张。 只加载一种尺寸和类型的纸张。 加载信签 未安装完成器选件 已安装完成器选件 一面打印 对于长边方向，加载信签时，使打印面朝下，并且页眉在进纸器的左边。 一面打印 对于长边方向，加载信签时，使打印面朝下，并且页眉在进纸器的右边。 两面打印 对于长边方向，加载信签时，使打印面朝上，并且页眉在进纸器的右边。 两面打印 对于长边方向，加载信签时，使打印面朝上，并且页眉在进纸器的左边。 加载预打孔的纸张 一面打印 两面打印 加载信封时，让封舌面朝上。 永远不要使用带有邮票、卡扣、摁扣、窗口、涂层或自动粘胶的信封。这些信封可能会严重损坏打印机。 确认纸张低于最大加载线。过量加载可能造成卡纸。 从控制面板，在“纸张”菜单中设置纸张尺寸和纸张类型以匹配进纸器中加载的纸张。 多功能进纸器 加载 加载多功能进纸器"},{"UUID":"a2508678-271f-4a70-8eb4-4eb94ecdd371","title":"进纸匣连接和解除连接","link":"linking-and-unlinking-trays-h2-topic.html","desc":"进纸匣连接和解除连接 打开 Web 浏览器，然后在地址字段中键入打印机 IP","descFull":"进纸匣连接和解除连接 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 纸张菜单 。 更改您正在连接的进纸匣的纸张尺寸和类型设置。 要连接进纸匣，请确认进纸匣的纸张尺寸和类型与其他进纸匣的相匹配。 要解除进纸匣连接，请确认进纸匣的纸张尺寸或类型与其他进纸匣的 不 匹配。 单击 提交 。 您也可以使用打印机控制面板更改纸张尺寸和类型设置。如需更多信息，请参阅 。 进纸匣中加载的纸张应该符合打印机中分配的纸张类型名称。定影器的温度根据指定的纸张类型而变化。如果设置没有正确配置，可能出现打印问题。 进纸匣 解除连接 进纸匣 连接 解除进纸匣连接 连接进纸匣"},{"UUID":"f66b1ade-085a-4411-bee0-9c8077e038c3","title":"进纸匣连接和解除连接","link":"linking-and-unlinking-trays-h2-topic.html","desc":"为纸张类型创建自定义名称 从主屏幕，导览至： 纸张菜单 自定义名称 键入自定义的纸张类型名称，然后应用更改。","descFull":"为纸张类型创建自定义名称 从主屏幕，导览至： 纸张菜单 自定义名称 键入自定义的纸张类型名称，然后应用更改。 触摸 自定义类型 ，然后检验新的自定义纸张类型名称是否已替换自定义名称。 自定义纸张类型名称 创建"},{"UUID":"53096d6e-61d1-4864-97c1-58c6e0b728c4","title":"进纸匣连接和解除连接","link":"linking-and-unlinking-trays-h2-topic.html","desc":"分配自定义纸张类型 使用 Embedded Web Server","descFull":"分配自定义纸张类型 使用 Embedded Web Server 当连接进纸匣或解除进纸匣连接时分配自定义纸张类型名称给进纸匣。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 纸张菜单 自定义类型 。 选择自定义纸张类型名称，然后选择纸张类型。 “纸张”是所有用户定义的自定义名称的出厂默认纸张类型。 单击 提交 。 使用打印机控制面板 从主屏幕，导览至： 纸张菜单 自定义类型 选择自定义纸张类型名称，然后选择纸张类型。 “纸张”是所有用户定义的自定义名称的出厂默认纸张类型。 触摸 提交 。 进纸匣 连接 进纸匣 解除连接 连接进纸匣 解除进纸匣连接 自定义纸张类型 分配"},{"UUID":"abbd171b-5502-4b39-8399-62b3b6f093be","title":"使用特殊介质","link":"using-specialty-media.html","desc":"使用卡片纸的提示 卡片纸是较重的单层特殊介质。它的许多可变特性，例如水分含量、厚度和纹理会严重影响打印质量。 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的卡片纸。 在大量购买准备使用的卡片纸之前应先试用一些样张。 从进纸匣设置指定纸张纹理和重量以匹配进纸匣中加载的纸张。","descFull":"使用卡片纸的提示 卡片纸是较重的单层特殊介质。它的许多可变特性，例如水分含量、厚度和纹理会严重影响打印质量。 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的卡片纸。 在大量购买准备使用的卡片纸之前应先试用一些样张。 从进纸匣设置指定纸张纹理和重量以匹配进纸匣中加载的纸张。 预打印、穿孔以及折皱会严重影响打印质量并造成卡纸或其他进纸问题。 在进纸匣中加载卡片纸之前，请弯曲并扇形展开卡片纸，使它们松散。对齐纸张的边缘。 卡片纸 提示 提示 卡片纸"},{"UUID":"eddd3a15-7ac5-44db-b2bd-517297256645","title":"使用特殊介质","link":"using-specialty-media.html","desc":"使用信封的提示 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的信封。 在大量购买准备使用的信封之前应先试用一些样张。 使用专为激光打印机设计的信封。 要充分发挥打印机性能，请使用以","descFull":"使用信封的提示 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的信封。 在大量购买准备使用的信封之前应先试用一些样张。 使用专为激光打印机设计的信封。 要充分发挥打印机性能，请使用以 90 克/平方米（24 磅）的纸张或 25% 含棉量的纸张制造的信封。 只使用无破损包装中的新信封。 要使性能最优化并使卡纸最少，请不要使用下列信封： 过度卷曲或扭曲。 粘在一起或有任何损坏。 有窗口、镂孔、穿孔、挖剪图案或压纹。 有金属扣、线扣或折叠杆。 带联锁设计。 贴有邮票。 当封舌处于封住或关闭位置时有暴露的粘胶。 有弯曲的边角。 粗糙、褶皱或有涂层。 调整宽度导片，使它适合信封的宽度。 在进纸匣中加载信封之前，请前后弯曲信封，使它们松散，然后将它们扇形展开。对齐信封的边缘。 高湿度（超过 60%）和高打印温度结合可能使信封变皱或使信封口封住。 提示 有关使用信封 信封 使用提示 使用信封的提示"},{"UUID":"e77f89b5-b062-47cd-a7eb-666986bec884","title":"使用特殊介质","link":"using-specialty-media.html","desc":"使用标签的提示 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的标签。 在大量购买准备使用的标签之前应先试用一些样张。 如需有关标签打印、特性和设计的更多信息，请参阅 Lexmark","descFull":"使用标签的提示 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的标签。 在大量购买准备使用的标签之前应先试用一些样张。 如需有关标签打印、特性和设计的更多信息，请参阅 Lexmark 网站： http://support.lexmark.com  上的  Card Stock & Label Guide（卡片纸和标签使用指南） 。 使用专为激光打印机设计的标签。 不要使用底衬光滑的标签。 不要使用有暴露粘胶的标签。 使用完整的标签页。不完整的标签页会导致标签在打印时脱落，从而造成卡纸。不完整标签页上的粘胶还会污染打印机和碳粉盒，这样造成的打印机和碳粉盒的损坏不在保修范围内。 在进纸匣中加载标签之前，请弯曲并扇形展开标签，使它们松散。对齐标签的边缘。 标签，纸张 提示 提示 标签，纸张"},{"UUID":"c3977108-e462-4cc9-8c25-0f4a1461247b","title":"使用特殊介质","link":"using-specialty-media.html","desc":"使用信签的提示 使用激光打印机专用的信签。 在大量购买之前打印样张。 在加载信签之前，弯曲并扇形展开页面。 使用信签打印时，注意页面方向。","descFull":"使用信签的提示 使用激光打印机专用的信签。 在大量购买之前打印样张。 在加载信签之前，弯曲并扇形展开页面。 使用信签打印时，注意页面方向。 加载信签 来源 打印 信签打印面 纸张方向 进纸匣 一面 打印面朝上 加载纸张时，让顶边朝着进纸匣的后部。 两面 打印面朝下 加载纸张时，让顶边朝着进纸匣的前部。 多功能进纸器 一面 打印面朝下 加载纸张时，让顶边在左边。 两面 打印面朝上 加载纸张时，让顶边在右边。 使用信签的提示 信签 加载，进纸匣 信签 加载，多功能进纸器 加载信签 纸张方向"},{"UUID":"5eac04aa-f3f7-4948-80fe-034ebfdbc94d","title":"使用特殊介质","link":"using-specialty-media.html","desc":"使用透明胶片的提示 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的透明胶片。 在大量购买准备使用的透明胶片之前应先打印测试页。 使用专为激光打印机设计的透明胶片。 避免在透明胶片上留下指印，以防止出现打印质量问题。","descFull":"使用透明胶片的提示 从打印机控制面板，在“纸张”菜单中设置纸张尺寸、类型、纹理和重量以匹配进纸匣中加载的透明胶片。 在大量购买准备使用的透明胶片之前应先打印测试页。 使用专为激光打印机设计的透明胶片。 避免在透明胶片上留下指印，以防止出现打印质量问题。 在加载透明胶片之前，弯曲并扇形展开透明胶片以防止它们粘连在一起。 当打印大量的透明胶片时，请确认按每批次最多 20 张进行打印，并且在每个批次之间至少间隔 3 分钟，以防止透明胶片在接纸架中粘连。您也可以按 20 张一个批次取走透明胶片。 透明胶片 提示 提示 透明胶片"},{"UUID":"426022e7-fe17-417e-bf2a-8f0aef910e93","title":"纸张使用指南","link":"paper-guidelines-group-title.html","desc":"纸张特性 下列纸张特性影响打印质量和可靠性。在使用它们打印之前，请考虑下列因素： 重量 打印机进纸匣能够送入重量为 60–256","descFull":"纸张特性 下列纸张特性影响打印质量和可靠性。在使用它们打印之前，请考虑下列因素： 重量 打印机进纸匣能够送入重量为 60–256 克/平方米（16-68 磅）的纵向纹理纸张。多功能进纸器能够送入重量为 60–256 克/平方米（16-68 磅）的纵向纹理纸张。轻于 60 克/平方米（16 磅）的纸张可能硬度不够而不能正确进纸，从而可能造成卡纸。 双面打印支持 60–169 克/平方米（16–45 磅）的纸张。 卷曲度 卷曲是纸张在其边缘有弯曲的趋势。过度卷曲会造成进纸问题。当纸张通过打印机，经受高温后会出现卷曲。将打开包装的纸张保存在炎热、潮湿、寒冷或干燥的环境中，即使是在进纸匣中，也可能使纸张在打印之前卷曲，从而造成进纸问题。 平滑度 纸张的平滑度直接影响打印质量。如果纸张太粗糙，碳粉将不能正确地熔印到纸张上。如果纸张太光滑，可能造成进纸或打印质量问题。请始终使用 100–200 Sheffield 点之间的纸张。 水分含量 纸张中的水分含量影响打印质量和打印机正确进纸的能力。在使用之前请一直将纸张存放在原包装中。这将限制纸张暴露而改变水分含量，水分含量的改变会降低纸张的性能。 在打印前 24 至 48 小时将存放在原包装中的纸张放在与打印机相同的环境中。如果存储或运输环境与打印机环境相差很大，可将时间延长几天。厚纸也可能需要更长的调整期。 纹理方向 纹理是指纸张中的纸纤维排列方向。纹理可以是 纵向 ，沿着纸张的长度，或者 横向 ，沿着纸张的宽度。 对于 60–256 克/平方米（16-68 磅）的纸张，建议使用纵向纹理的纸张。 纤维含量 大多数高质量静电复印纸张是用 100% 化学制浆木材制成的。这样的含量提供给纸张高度稳定性，从而降低进纸问题，并提高打印质量。包含棉类纤维的纸张对纸张处理能力有负面影响。 纸张 特性 纸张特性 纸张 保存"},{"UUID":"b3309786-47cb-4e8a-a7d1-7b8a4d578c91","title":"纸张使用指南","link":"paper-guidelines-group-title.html","desc":"选择纸张 使用适当的纸张可防止卡纸并有助于确保无故障打印。 要帮助避免卡纸和很差的打印质量： 总是 使用新的、未被损坏的纸张。","descFull":"选择纸张 使用适当的纸张可防止卡纸并有助于确保无故障打印。 要帮助避免卡纸和很差的打印质量： 总是 使用新的、未被损坏的纸张。 在加载纸张之前，了解纸张的推荐可打印面。此信息通常在纸张包装上指出。 不要 使用经手工切割或裁剪的纸张。 不要 在同一个进纸匣中混合纸张尺寸、类型或重量；混合使用会造成卡纸。 不要 使用涂层纸，除非它们是专为电子照排印刷设计的。 纸张 选择 选择纸张"},{"UUID":"96706a55-101c-4c5f-97a3-e594385596f5","title":"纸张使用指南","link":"paper-guidelines-group-title.html","desc":"选择预印表单和信签 对于 60–256 克/平方米（16–68 磅）的纸张，请使用纵向纹理。","descFull":"选择预印表单和信签 对于 60–256 克/平方米（16–68 磅）的纸张，请使用纵向纹理。 仅使用以胶版或雕版印刷的表单和信签。 避免使用粗糙或重纹理表面的纸张。 使用不受碳粉中的树脂影响的墨水。氧化墨水和油墨通常可以满足这些要求；乳胶墨水可能不满足。 在大量购买准备使用的预印表单和信签之前应先试用一些样张。这样可以确定预印表单或信签中的墨水是否会影响打印质量。 若有疑问，请与您的纸张供应商联系。 纸张 预印表单 纸张 信签"},{"UUID":"070520b2-ded0-4c28-878c-2cae6a5bbfab","title":"纸张使用指南","link":"paper-guidelines-group-title.html","desc":"使用再生纸和其他办公用纸 作为具有环保意识的公司，Lexmark 支持使用专为激光（电子照排）打印机用途而生产的再生纸。 虽然不能完全说所有再生纸都将很好地进纸，但 Lexmark","descFull":"使用再生纸和其他办公用纸 作为具有环保意识的公司，Lexmark 支持使用专为激光（电子照排）打印机用途而生产的再生纸。 虽然不能完全说所有再生纸都将很好地进纸，但 Lexmark 还是一贯对代表全球市场上供应的再生定度复印纸的纸张进行测试。此科学测试是严谨和守纪地进行的。许多因素被单独和整体考虑，包括下列各项： 专为激光（电子照排）打印机用途而生产的再生办公用纸可以在您的打印机中使用。然而，不能就此断言所有再生纸都将很好地进纸。 下列特性指南通常适用于再生纸。 消费后废物的数量（Lexmark 测试最高达 100% 的消费后废物含量。） 消费后废物的数量（我们测试最高达 100% 的消费后废物含量。） 温度和湿度条件（测试场所模拟世界各地的气候。） 水分含量（商业纸张应含有较低的水分含量：4–5%。） 抗弯曲性和适当的硬度意味着最适合通过打印机。 厚度（影响能被加载到进纸匣中的纸张数量） 表面粗糙度（以 Sheffield 单位度量，影响打印清晰度和碳粉熔印到纸张上的好坏程度） 表面摩擦力（决定纸张分离的难易程度） 纹理和构成（影响卷曲度，它也影响纸张在通过打印机时如何表现的方法） 明亮度和纹理（外观和感觉） 再生纸好过以往；但是，纸张中的再生物含量影响对杂质的控制度。虽然再生纸是一个很好的环保打印途径，但是它们并不完美。脱墨和处理添加剂（例如着色剂和“胶水”）所需的能源经常产生比正常的纸张生产更多的碳排放。但是，使用再生纸总体上能够实现更好的资源管理。 通常，Lexmark 关心基于其产品的使用寿命周期评估的纸张的合理使用。为了更好地理解打印机对环境的影响，公司已委托进行了大量的使用寿命周期评估，并发现纸张被确定为是在设备的整个使用寿命期间（从设计到寿命终止）内产生碳排放的主要贡献者（高达 80%）。这是因为纸张生产要求能源密集的制造工艺。 因此，Lexmark 努力培养客户及合作伙伴将纸张的影响最小化。使用再生纸是一个途径。消除过度和不必要的纸张消耗是另一个途径。 Lexmark 作好充分准备帮助客户将打印和复印废物减到最少。此外，公司鼓励从实行持续林业经营的供应商处购买纸张。 虽然保留了供特殊应用的加工者的产品列表，但 Lexmark 不认可特定的供应商。无论如何，下列纸张选择指导将帮助减轻打印对环境的影响： 最少化纸张消耗。 对木质纤维的来源有所选择。请从那些拥有证书（例如森林管理委员会（FSC）或森林认证体系认可计划（PEFC））的供应商处购买。这些证书保证纸张制造商使用的木质纸浆来自具有环保和社会责任心的从事森林管理和重建活动的林业经营者。 根据打印需要选择最适当的纸张：正常的 75 或 80 克/平方米经认证纸张，较轻重量的纸张或再生纸。 不可接受的纸张实例 测试结果表明下列纸张类型在用于激光打印机时存在风险： 用于免复写纸复印、经过化学处理的纸张，也称为 无碳纸 含有可能污染打印机的化学物质的预印纸 可能受打印机定影器温度影响的预印纸 要求定位精度（在页面上精确设定打印位置）高于 ± 2.3 毫米（± 0.9 英寸）的预印纸，例如光学字符识别（OCR）表格。有些情况下，可以使用软件应用程序调整定位，以在这些表格上成功打印。 涂层纸（可擦写的铜版纸）、合成纸、热敏纸 边缘粗糙、表面粗糙或纹理密集的纸张，或者卷曲的纸张 不符合 EN12281:2002（欧洲测试）的再生纸 重量小于 60 克/平方米（16 磅）的纸张 几个部分组成的表单或文档 如需有关 Lexmark 的更多信息，请访问  www.lexmark.com 。通过  Environmental Sustainability（环境保护） 链接可以找到与可持续发展相关的常规信息。 再生纸 使用 纸张 再生 纸张 不可接受"},{"UUID":"819d3424-bbd1-42ec-8569-d2c6b8feca0a","title":"纸张使用指南","link":"paper-guidelines-group-title.html","desc":"保存纸张 请使用下列纸张存储指南来帮助避免卡纸和打印质量不稳定： 要获得最佳效果，请将纸张保存在温度为 21°C（70°F），相对湿度为 40%","descFull":"保存纸张 请使用下列纸张存储指南来帮助避免卡纸和打印质量不稳定： 要获得最佳效果，请将纸张保存在温度为 21°C（70°F），相对湿度为 40% 的环境中。大多数标签制造商建议在温度为 18–24°C（65–75°F），相对湿度在 40 至 60% 之间的环境中打印。 将纸张放在纸箱中，并放在平板或支架上保存，不要直接放在地面上。 存储时，将单独包装的纸张放在平面上。 不要在单独包装的纸张上放置任何物品。 只有当您准备将纸张加载到打印机中时，才将纸张从纸箱或包装中取出。纸箱和包装有助于保持纸张清洁、干燥和平整。 保存 纸张 纸张 保存 避免卡纸"},{"UUID":"c5f7678c-d695-4f9a-b8dd-548cae93c963","title":"支持的纸张尺寸、类型和重量","link":"paper-media-sizes-types-weights-supported.html","desc":"打印机支持的纸张尺寸 进纸匣和多功能进纸器支持的纸张尺寸 纸张尺寸 大小 标准","descFull":"打印机支持的纸张尺寸 进纸匣和多功能进纸器支持的纸张尺寸 纸张尺寸 大小 标准 500 页进纸匣（进纸匣 1） 标准 500 页进纸匣（进纸匣 2） 2 x 500 页进纸匣 2500 页进纸匣 3000 页进纸匣 多功能进纸器 3 两面打印 1  仅在短边方向时被支持。 2  仅在长边方向时被支持。 3  支持不带 尺寸检测 的纸张尺寸。 4  仅当纸张宽度在 139.7 毫米（5.5 英寸）至 320 毫米（12.6 英寸）之间，长度在 148 毫米（5.83 英寸）至 458 毫米（18 英寸）之间时被支持。 仅当纸张宽度最多为 296.9 毫米（11.69 英寸），长度最多为 1219.2 毫米（48 英寸）时，横幅纸在多功能进纸器中被支持。将纸张尺寸设置为 Universal。 A4 210 x 297 毫米（8.3 x 11.7 英寸） 2 2 2 A5 148 x 210 毫米（5.8 x 8.3 英寸） 1 1 1 X X A6 105 x 148 毫米（4.1 x 5.8 英寸） X X X X X 1 JIS B5 182 x 257 毫米（7.2 x 10.1 英寸） X X Letter 216 x 279 毫米（8.5 x 11 英寸） 2 2 Legal 216 x 356 毫米（8.5 x 14 英寸） X X Executive 184 x 267 毫米（7.3 x 10.5 英寸） X X JIS B4 257 x 364 毫米（10.12 x 14.33 英寸） X X SRA3 320 x 450 毫米（12.6 x 17.7 英寸） X 1 X X X 1 A3 297 x 420 毫米（11.69 x 16.54 英寸） X X 12 x 18 305 x 457 毫米（12 x 18 英寸） X 1 X X X 1 11 x 17 279.4 x 431.8 毫米（11 x 17 英寸） X X Oficio 216 x 340 毫米（8.5 x 13.4 英寸） X X Folio 216 x 330 毫米（8.5 x 13 英寸） X X Statement 140 x 216 毫米（5.5 x 8.5 英寸） 1 1 1 X X Universal 76.2 x 76.2 毫米（3 x 3 英寸）至 320 x 1219.2 毫米（12.6 x 48 英寸） X X 4 7  3/4 Envelope 98 x 191 毫米（3.9 x 7.5 英寸） X X X X X X 9 Envelope 98 x 225 毫米（3.9 x 8.9 英寸） X X X X X X 10 Envelope 105 x 241 毫米（4.1 x 9.5 英寸） X X X X X X DL Envelope 110 x 220 毫米（4.3 x 8.7 英寸） X X X X X X C5 Envelope 162 x 229 毫米（6.4 x 9 英寸） X X X X X X B5 Envelope 176 x 250 毫米（6.9 x 9.8 英寸） X X X X X X 其他信封 98 x 162 毫米（3.9 x 6.3 英寸）至 176 x 250 毫米（6.9 x 9.8 英寸） X X X X X X ADF 和扫描仪玻璃支持的纸张尺寸 纸张尺寸 大小 ADF 扫描仪玻璃 1  仅在短边方向时被支持。 2  支持不带 尺寸检测 的纸张尺寸。 名片 X 1,2 3 x 5 76.2 x 127 毫米（3 x 5 英寸） X 1,2 4 x 6 101.6 x 152.4 毫米（4 x 6 英寸） 2 1,2 A4 210 x 297 毫米（8.3 x 11.7 英寸） A5 148 x 210 毫米（5.8 x 8.3 英寸） 2 A6 105 x 148 毫米（4.1 x 5.8 英寸） 1,2 1,2 JIS B5 182 x 257 毫米（7.2 x 10.1 英寸） Letter 216 x 279 毫米（8.5 x 11 英寸） Legal 216 x 356 毫米（8.5 x 14 英寸） Executive 184 x 267 毫米（7.3 x 10.5 英寸） JIS B4 257 x 364 毫米（10.12 x 14.33 英寸） SRA3 320 x 450 毫米（12.6 x 17.7 英寸） X X A3 297 x 420 毫米（11.69 x 16.54 英寸） 12 x 18 305 x 457 毫米（12 x 18 英寸） X X 11 x 17 279.4 x 431.8 毫米（11 x 17 英寸） Oficio 216 x 340 毫米（8.5 x 13.4 英寸） 2 2 Folio 216 x 330 毫米（8.5 x 13 英寸） Statement 140 x 216 毫米（5.5 x 8.5 英寸） Universal 89 x 98.4 毫米（3.50 x 3.87 英寸）至 297 x 431.8 毫米（11.69 x 17.00 英寸） 2 2 7  3/4 Envelope 98 x 191 毫米（3.9 x 7.5 英寸） X X 9 Envelope 98 x 225 毫米（3.9 x 8.9 英寸） X X 10 Envelope 105 x 241 毫米（4.1 x 9.5 英寸） X X DL Envelope 110 x 220 毫米（4.3 x 8.7 英寸） X X C5 Envelope 162 x 229 毫米（6.4 x 9 英寸） X X B5 Envelope 176 x 250 毫米（6.9 x 9.8 英寸） X X 其他信封 98 x 162 毫米（3.9 x 6.3 英寸）至 176 x 250 毫米（6.9 x 9.8 英寸） X X 自定义扫描尺寸 [x] 2 2 纸张尺寸 支持的 支持的纸张尺寸"},{"UUID":"27d25860-5b6a-4d3d-b3fb-df36a4ca803a","title":"支持的纸张尺寸、类型和重量","link":"paper-media-sizes-types-weights-supported.html","desc":"打印机支持的纸张类型和重量 打印机引擎支持 60–256 克/平方米（16–68 磅）的纸张重量。","descFull":"打印机支持的纸张类型和重量 打印机引擎支持 60–256 克/平方米（16–68 磅）的纸张重量。 标签、透明胶片、信封和卡片纸总是以降速打印。 打印机支持的纸张类型和重量 纸张类型 标准 500 页进纸匣（进纸匣 1） 标准 500 页进纸匣（进纸匣 2） 2 x 500 页进纸匣 2500 页进纸匣 3000 页进纸匣 多功能进纸器 ADF 扫描仪 1  纸张被支持用于两面打印。 2  每批次只能打印最多 20 张透明胶片，以防止它们粘在一起。如需更多信息，请参阅 。 普通纸张 1 卡片纸 1 透明胶片 2 X X X X X 再生纸 1 光面纸 1 重磅光面纸 1 标签 X X X X X 乙烯基标签 X X X X X X 铜版纸 1 信封 X X X X X 粗糙信封 X X X X X 信签 1 预印纸 1 彩色纸 1 轻磅纸张 1 重磅纸张 1 粗糙棉纸 1 自定义类型 1 纸张类型 打印机支持 纸张重量 打印机支持 支持的纸张类型 支持的纸张重量"},{"UUID":"73bd4d9e-75d9-41f8-8303-0f0171f417f3","title":"支持的纸张尺寸、类型和重量","link":"paper-media-sizes-types-weights-supported.html","desc":"完成器支持的纸张尺寸、类型和重量 打印机引擎支持 60–256 克/平方米（16–68 磅）的纸张重量。","descFull":"完成器支持的纸张尺寸、类型和重量 打印机引擎支持 60–256 克/平方米（16–68 磅）的纸张重量。 当完成器已安装时，标准完成器接纸架成为默认接纸架，即使打印作业不要求输出处理。 支持的纸张尺寸 纸张尺寸 装订完成器 装订、打孔完成器接纸架 1 装订、打孔完成器接纸架 2 小册子完成器 1  仅当完成器堆放纸张但不装订或打孔时，纸张被支持。 2  仅当完成器堆放或装订纸张但不打孔时，纸张被支持。 3  纸张被支持，但完成器不堆放、装订或打孔纸张。 4  纸张仅被支持打 2 个孔。 5  仅当纸张尺寸在 210 x 279.4 毫米（8.27 x 11 英寸）至 320 x 457.2 毫米（12.6 x 18 英寸）之间时，纸张被支持。 A6 3 3 X X A5 3 3 2 X JIS B5 X JIS B4 Executive X Letter A4 Legal 4 12 x 18 1 3 1 11 x 17 SRA3 1 3 1 A3 Oficio 1 3 3 X Folio 1 3 3 X Statement 1 3 3 X Universal 3 1 5 支持的纸张类型 纸张类型 装订完成器 装订、打孔完成器 小册子完成器 1  每次只能打印最多 20 张透明胶片，以防止它们粘在一起。如需更多信息，请参阅 。 2  仅当完成器堆放纸张但不装订时，纸张被支持。 3  仅当完成器堆放纸张但不装订或打孔时，纸张被支持。 4  仅当完成器打孔或堆放纸张但不装订时，纸张被支持。 5  仅当完成器装订或折叠纸张时，纸张被支持。 普通纸张 5 卡片纸 2 X 透明胶片 1 2 3 X 再生纸 2 5 光面纸 2 5 重磅光面纸 2 4 X 标签 2 3 X 铜版纸 5 信封 2 3 X 粗糙信封 2 3 X 信签 5 预印纸 5 彩色纸 5 轻磅纸张 5 重磅纸张 2 4 X 粗糙棉纸 2 X 自定义类型 5 完成器 支持的纸张尺寸 完成器 支持的纸张类型 完成器 支持的纸张重量 支持的纸张类型 完成器 支持的纸张重量 完成器 支持的纸张尺寸 完成器"},{"UUID":"953ae0d7-3f91-49bf-bdb6-0b1e3d048167","title":"打印表单和文档","link":"printing-forms-topic.html","desc":"打印表单 使用“表单与收藏夹”来快速方便地访问常用的表单或经常打印的其他信息。在您能够使用此应用程序之前，请首先在打印机上设置它。如需更多信息，请参阅 。 从主屏幕，导览至： 表单与收藏夹","descFull":"打印表单 使用“表单与收藏夹”来快速方便地访问常用的表单或经常打印的其他信息。在您能够使用此应用程序之前，请首先在打印机上设置它。如需更多信息，请参阅 。 从主屏幕，导览至： 表单与收藏夹  从列表中选择表单  输入份数 调整其他设置 应用更改。 使用“表单与收藏夹” 打印 表单 打印表单"},{"UUID":"3247e519-98e5-41a4-9378-7da057bfdb94","title":"打印表单和文档","link":"printing-forms-topic.html","desc":"从计算机打印 对于如标签、卡片纸和信封等特殊介质，请在发送打印作业之前在打印机中设置纸张尺寸和类型。 打开文档后，单击 文件 打印","descFull":"从计算机打印 对于如标签、卡片纸和信封等特殊介质，请在发送打印作业之前在打印机中设置纸张尺寸和类型。 打开文档后，单击 文件 打印 。 如果需要，请调整设置。 发送打印作业。 打印 从计算机 文档，打印 从计算机"},{"UUID":"1c577504-c1e9-4327-80ee-13dc6b7dfb06","title":"打印表单和文档","link":"printing-forms-topic.html","desc":"调整碳粉浓度 从主屏幕，导览至： 设置 打印设置 质量菜单","descFull":"调整碳粉浓度 从主屏幕，导览至： 设置 打印设置 质量菜单 调整碳粉浓度设置，然后保存更改。 碳粉浓度 调整 调整碳粉浓度"},{"UUID":"0489e459-ac0f-4135-b929-5de5777028a8","title":"从闪存驱动器或移动设备打印","link":"printing-from-flash-drive-h2-topic.html","desc":"从闪存驱动器打印 在打印加密的 PDF 文件之前，您会得到提示，从控制面板键入文件密码。 您不能打印未取得打印许可的文件。","descFull":"从闪存驱动器打印 在打印加密的 PDF 文件之前，您会得到提示，从控制面板键入文件密码。 您不能打印未取得打印许可的文件。 将闪存驱动器插入 USB 端口中。 当插入闪存驱动器时，一个闪存驱动器图标出现在打印机主屏幕上。 如果您在打印机要求关注（如发生卡纸）时插入闪存驱动器，打印机将忽略闪存驱动器。 如果您在打印机正在处理其他打印作业时插入闪存驱动器，打印机显示屏上会出现 忙 。在处理完这些打印作业后，您可能需要查看挂起作业列表来从闪存驱动器打印文档。 当正在从内存设备打印、读取或写入时，不要触摸所示区域内的打印机或闪存驱动器。不然，可能会丢失数据或出现故障。 从控制面板，触摸您要打印的文档。 指定要打印的份数，然后发送作业打印。 在文档结束打印之前请不要从 USB 端口中移除闪存驱动器。 如果您在离开最初的 USB 菜单屏幕后将闪存驱动器留在打印机上，请在主屏幕上触摸 挂起作业 来从闪存驱动器打印文件。 打印 从闪存驱动器 从闪存驱动器打印 闪存驱动器 打印，从"},{"UUID":"fe687f0a-f5a1-40ca-ab42-b42a6a7cb8fe","title":"从闪存驱动器或移动设备打印","link":"printing-from-flash-drive-h2-topic.html","desc":"支持的闪存驱动器和文件类型 高速 USB 闪存驱动器必须支持全速标准。不支持低速 USB","descFull":"支持的闪存驱动器和文件类型 高速 USB 闪存驱动器必须支持全速标准。不支持低速 USB 设备。 USB 闪存驱动器必须支持文件分配表（FAT）系统。不支持使用“新技术文件系统（NTFS）”或任何其他文件系统格式化的设备。 推荐的闪存驱动器和文件类型 推荐的闪存驱动器 文件类型 Lexar FireFly（512MB 和 1GB） SanDisk Cruzer Micro（512MB 和 1GB） Sony（512MB 和 1GB） 许多闪存驱动器已经过测试认证可用于该打印机。如需更多信息，请与您购买打印机处的销售商联系。 许多闪存驱动器已经过测试认证可用于该打印机。如需更多信息，请转到  www.dell.com/support/printers 。 文档： .pdf .xps 图像： .dcx .gif .jpeg 或 .jpg .bmp .pcx .tiff 或 .tif .png 闪存驱动器 支持的文件类型 支持的闪存驱动器"},{"UUID":"b32af1e4-af4a-4d96-bbe9-87526681909f","title":"从闪存驱动器或移动设备打印","link":"printing-from-flash-drive-h2-topic.html","desc":"从移动设备打印 如需下载兼容的移动打印应用程序，请访问  www.lexmark.com/mobile 。","descFull":"从移动设备打印 如需下载兼容的移动打印应用程序，请访问  www.lexmark.com/mobile 。 如需下载兼容的移动打印应用程序，请访问我们的网站或者与您购买打印机处的销售商联系。 移动打印应用程序也可以从您的移动设备制造商处获得。 从移动设备打印 移动设备 打印，从 打印 从移动设备"},{"UUID":"a7c70f79-7934-4eda-8e56-968dbbbe137c","title":"打印保密和其他挂起作业","link":"holding-confidential-other-jobs.html","desc":"在打印机中保存打印作业 从打印机控制面板，导览至： 安全 保密打印 ","descFull":"在打印机中保存打印作业 从打印机控制面板，导览至： 安全 保密打印  选择打印作业类型 打印作业类型及描述 使用 来 最多无效 PIN 码 限制能够输入无效 PIN 码的次数。 当达到限制时，对应于该用户名和 PIN 码的打印作业将被删除。 保密打印有效期 将打印作业挂起在计算机中，直到您从打印机控制面板输入 PIN 码。 PIN 码从计算机设置。它必须是使用数字 1–9 的四位数。 重复作业有效期 打印并将打印作业保存在打印机内存中。 校验作业有效期 打印一份打印作业的副本，并挂起剩余的副本。它允许您检查第一份副本是否令人满意。当打印出所有副本时，打印作业自动从打印机内存中被删除。 保留作业有效期 保存打印作业以便稍后打印。 打印作业被挂起，直到从“挂起作业”菜单中被删除。 如果打印机需要额外内存来处理其他挂起作业，“保密”、“校验”、“保留”和“重复”打印作业可能被删除。 您可以设置打印机将打印作业保存在打印机内存中，直到您从打印机控制面板启动打印作业。 所有能够由用户在打印机上启动的打印作业被称为 挂起作业 。 触摸 提交 。 保密打印作业 挂起作业 保存打印作业 保留打印作业 重复打印作业 校验打印作业"},{"UUID":"e3051ef8-25e4-4979-bc49-0b6801a93cbb","title":"打印保密和其他挂起作业","link":"holding-confidential-other-jobs.html","desc":"打印挂起作业 打开文档后，选择 文件 打印 。","descFull":"打印挂起作业 打开文档后，选择 文件 打印 。 选择打印机，然后执行下列操作： 对于 Windows 用户，单击 属性 或 首选项 ，然后单击 打印并挂起 。 对于 Macintosh 用户，选择 打印并挂起 。 选择打印作业类型。 如果需要，分配用户名。 发送打印作业。 从打印机主屏幕，触摸 挂起作业 。 发送打印作业。 打印挂起作业 从 Windows 挂起打印作业 从 Windows 打印 重复打印作业 从 Windows 打印 保留打印作业 从 Windows 打印 校验打印作业 从 Windows 打印 挂起作业 从 Windows 打印 打印挂起作业 从 Macintosh 计算机 挂起打印作业 从 Macintosh 计算机打印 重复打印作业 从 Macintosh 计算机打印 保留打印作业 从 Macintosh 计算机打印 校验打印作业 从 Macintosh 计算机打印 挂起作业 从 Macintosh 计算机打印"},{"UUID":"230a1b61-cfef-462f-a9d8-b7eb994e1274","title":"打印保密和其他挂起作业","link":"holding-confidential-other-jobs.html","desc":"修改保密打印设置 此特性仅在网络打印机或连接到打印服务器的打印机中可用。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"修改保密打印设置 此特性仅在网络打印机或连接到打印服务器的打印机中可用。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在“网络/端口”菜单的 TCP/IP 部分中查看打印机的 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置  选项卡 安全 保密打印设置 。 修改设置： 设置尝试输入 PIN 码的最多次数。当用户超过了 PIN 码输入次数的指定值时，该用户的所有作业将被删除。 为保密打印作业设置一个到期时间。当用户在指定的时间内没有打印作业，该用户的所有作业将被删除。 保存修改的设置。 Embedded Web Server 修改保密打印设置 安全 修改保密打印设置 保密作业 修改打印设置"},{"UUID":"52bc448e-5ed4-47a1-a865-40485c96a974","title":"打印信息页","link":"printing-font-sample-list-h2-topic.html","desc":"打印字体样本列表 从主屏幕，导览至： >  ","descFull":"打印字体样本列表 从主屏幕，导览至： >   报告 >  打印字体 触摸  PCL 字体 或  PostScript 字体 。 打印 字体样本列表 打印字体样本列表 字体样本列表 打印"},{"UUID":"ebf61171-7f01-412d-88c5-9fd205167af6","title":"打印信息页","link":"printing-font-sample-list-h2-topic.html","desc":"打印目录列表 目录列表显示保存在闪存或打印机硬盘中的资源。 从主屏幕，导览至： > ","descFull":"打印目录列表 目录列表显示保存在闪存或打印机硬盘中的资源。 从主屏幕，导览至： >  报告 >  打印目录 打印 目录列表 打印目录列表 目录列表 打印"},{"UUID":"d4c255bc-5bc8-4e83-8595-49c808c74f66","title":"取消打印作业","link":"canceling-print-job-from-printer-control-panel-h2-topic.html","desc":"从打印机控制面板取消打印作业 从打印机控制面板，触摸 取消作业 或在键盘上按 ","descFull":"从打印机控制面板取消打印作业 从打印机控制面板，触摸 取消作业 或在键盘上按  。 触摸您要取消的打印作业，然后触摸 删除选定作业 。 如果您在键盘上按  ，请触摸 恢复 来返回到主屏幕。 取消打印作业 从打印机控制面板 打印 取消，从打印机控制面板"},{"UUID":"ff0ccdf2-74c6-40fe-ab7a-539dbc8e2670","title":"取消打印作业","link":"canceling-print-job-from-printer-control-panel-h2-topic.html","desc":"从计算机取消打印作业。 根据操作系统，请执行下面任一操作： 打开打印机文件夹，然后选择您的打印机。 从 Apple","descFull":"从计算机取消打印作业。 根据操作系统，请执行下面任一操作： 打开打印机文件夹，然后选择您的打印机。 从 Apple 菜单中的“系统预置”，导览至您的打印机。 选择要取消的打印作业。 打印作业 从计算机取消 取消打印作业 从计算机"},{"UUID":"f7fa6729-53ec-4e51-a214-7aace58e5835","title":"制作副本","link":"copying-using-adf-or-scanner-glass-topic.html","desc":"使用 ADF 或扫描仪玻璃复印 将原始文档放入 ADF","descFull":"使用 ADF 或扫描仪玻璃复印 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 为避免剪裁图像，请确认原始文档的尺寸与复印纸张的尺寸相同。 从主屏幕，导览至： 复印  指定复印设置 复印 要进行快速复印，请从控制面板按  。 使用 ADF 复印 使用扫描仪玻璃 复印"},{"UUID":"e6aad0ff-04d2-4839-aa94-72ab69e5445b","title":"制作副本","link":"copying-using-adf-or-scanner-glass-topic.html","desc":"复印照片 将照片放在扫描仪玻璃上。 从主屏幕，导览至： 复印 内容","descFull":"复印照片 将照片放在扫描仪玻璃上。 从主屏幕，导览至： 复印 内容 照片 从“内容来源”菜单，选择最匹配原始照片的设置。 触摸  复印 。 复印照片 照片 复印"},{"UUID":"671a1b12-7bd2-46cf-bec6-d6e033289919","title":"制作副本","link":"copying-using-adf-or-scanner-glass-topic.html","desc":"使用透明胶片或信签复印 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"使用透明胶片或信签复印 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 复印来源  选择原始文档的尺寸 触摸 复印到 ，然后选择装有特殊介质的进纸匣。 如果您将特殊介质加载到多功能进纸器中，请导览至： 多功能进纸器  选择特殊介质的尺寸 透明胶片 或 信签 触摸  复印 。 透明胶片 复印，使用 使用透明胶片复印 信签 复印，使用 使用信签复印"},{"UUID":"c694dc39-3218-4264-bc04-f59e5fc02216","title":"创建复印快捷方式","link":"creating-copy-shortcut-using-printer-control-panel-topic.html","desc":"使用打印机控制面板创建复印快捷方式 从主屏幕，触摸 复印 。 调整复印设置，然后触摸","descFull":"使用打印机控制面板创建复印快捷方式 从主屏幕，触摸 复印 。 调整复印设置，然后触摸 另存为快捷方式 。 如果您在创建复印快捷方式之后更改设置，设置不会被保存。 为快捷方式键入唯一的名称，然后触摸 完成 。 检验快捷方式名称是否正确，然后触摸 确定 。 如果快捷方式名称不正确，请触摸 取消 ，然后重新输入信息。 快捷方式名称出现在打印机主屏幕上的“复印快捷方式”图标中。 当使用相同设置复印其他文档时，您可以使用快捷方式。 复印 使用打印机控制面板创建快捷方式 快捷方式，创建 复印屏幕"},{"UUID":"64774509-8288-449a-8ef1-cbf126b4f84f","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"复印到不同的尺寸 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"复印到不同的尺寸 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 复印来源  选择原始文档的尺寸 触摸 复印到 ，然后选择用于复印的新尺寸。 触摸  复印 。 复印到不同的尺寸 不同尺寸 复印到"},{"UUID":"9909f556-65dc-4696-ad91-d1781eb97a3d","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"使用选定进纸匣中的纸张进行复印 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"使用选定进纸匣中的纸张进行复印 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 复印来源  选择原始文档的尺寸 触摸 复印到 ，然后选择装有您要使用的纸张类型的进纸匣。 触摸  复印 。 复印来源 选定进纸匣 使用选定进纸匣中的纸张进行复印"},{"UUID":"21652dc4-3c7d-4c33-a839-ba4379e73924","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"复印不同的纸张尺寸 复印到混合的纸张尺寸上 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。","descFull":"复印不同的纸张尺寸 复印到混合的纸张尺寸上 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 复印来源 混合尺寸 触摸 复印到 自动尺寸匹配 复印 。 复印到单一的纸张尺寸上 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 复印来源 混合尺寸 触摸 复印到 Letter 复印 。 扫描仪将在扫描时识别不同的纸张尺寸，然后将混合的纸张尺寸缩放到适合选定的纸张尺寸。 复印不同的纸张尺寸 纸张 不同的尺寸，复印 不同的纸张尺寸，复印"},{"UUID":"1776ff3f-71cb-4f74-b752-f24c922e4608","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"在纸张的两个面上复印（两面） 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"在纸张的两个面上复印（两面） 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 面数（双面打印）  选择首选的双面打印方法 对于首选的方法，第一个数字代表原始文档的面数；第二个数字代表副本的面数。例如，如果您有 2 面的原始文档并且希望获得 2 面的副本，那么请选择“2 面到 2 面”。 触摸  复印 。 复印 在纸张的两个面上（两面） 两面复印 在纸张的两个面上复印（两面）"},{"UUID":"c1a6c0c0-2c38-48e5-8188-7dc6e59672d2","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"缩小或放大副本 副本可以缩放为原始文档尺寸的 25% 到 400%。","descFull":"缩小或放大副本 副本可以缩放为原始文档尺寸的 25% 到 400%。 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，触摸 复印 。 从“缩放”区域，触摸   或   来以 1% 的量减小或增大值。 在手动设置“缩放”之后触摸“复印到”或“复印来源”会将缩放值更改回“自动”。 “自动”是出厂默认设置。此设置自动调整原始文档的扫描图像以适合您正在用于复印的纸张尺寸。  触摸 复印 。 缩小副本 放大副本"},{"UUID":"3fbfc652-0fb4-4e50-8cfa-368f47822349","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"调整复印质量 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"调整复印质量 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 内容  指定文档的内容类型  指定文档的内容来源，然后触摸  复印 。 复印质量 调整 调整复印质量"},{"UUID":"6eee79f1-8e55-4623-94a6-a247c336cb4b","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"逐份打印副本 如果您打印文档的多份副本，您可以选择按批次打印副本（逐份打印）或按页组打印副本（非逐份打印）。 逐份打印的选项 逐份打印 非逐份打印","descFull":"逐份打印副本 如果您打印文档的多份副本，您可以选择按批次打印副本（逐份打印）或按页组打印副本（非逐份打印）。 逐份打印的选项 逐份打印 非逐份打印 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印  输入份数 逐份打印  选择首选的页序 复印 逐份打印副本 复印"},{"UUID":"483937bb-ca96-4f47-89fa-7a2601634d07","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"在副本之间放置分隔页 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"在副本之间放置分隔页 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 高级选项 分隔页  选择您要放置分隔页的位置 设置“逐份打印”为 (1,2,3) (1,2,3) 来在份数之间放置分隔页。如果“逐份打印”设置为 (1,1,1) (2,2,2)，分隔页将被添加到复印作业的结尾。如需更多信息，请参阅 。 触摸  复印 。 在副本之间放置分隔页 复印"},{"UUID":"9129550e-0058-403c-ba65-b422fd91a330","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"将多个页面复印到一张纸上 为了节省纸张，您可以将多页文档的两个或四个连续页面复印到一张纸上。 确认将纸张尺寸设置为 Letter、Legal、A4 或","descFull":"将多个页面复印到一张纸上 为了节省纸张，您可以将多页文档的两个或四个连续页面复印到一张纸上。 确认将纸张尺寸设置为 Letter、Legal、A4 或 JIS B5。 确认将副本尺寸设置为 100%。 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 高级选项 纸张节省  选择您需要的输出 复印 如果“纸张节省”设置为“关”，“打印页面边框”选项不可用。 将多个页面复印在一张纸上 节省纸张 纸张 节省"},{"UUID":"01696c14-356d-4d14-886c-b34b98bd663a","title":"定制复印设置","link":"copying-to-different-size-topic.html","desc":"创建自定义复印作业 自定义复印作业用于将一组或多组原始文档组合为一个单一的复印作业。 组的定义由扫描来源决定： 如果您在扫描仪玻璃上扫描文档，那么一组包含一页。 如果您使用","descFull":"创建自定义复印作业 自定义复印作业用于将一组或多组原始文档组合为一个单一的复印作业。 组的定义由扫描来源决定： 如果您在扫描仪玻璃上扫描文档，那么一组包含一页。 如果您使用 ADF 扫描多页，那么一组包含在 ADF 进纸匣变为空之前所有被扫描的页面。 如果您使用 ADF 扫描一页，那么一组包含一页。 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 高级选项 自定义作业 开 复印 当到达一组结尾时，出现扫描屏幕。 将下一个文档放入 ADF 进纸匣中或放在扫描仪玻璃上，然后触摸 从自动文档传送器扫描 或 从平板扫描 。 如果需要，请更改扫描作业设置。 如果您要扫描另一个文档，请重复之前的步骤。否则，请触摸 完成作业 。 自定义作业 复印"},{"UUID":"0bd22863-a949-44b4-8bec-d2af720844f6","title":"复印","link":"placing-header-or-footer-on-pages-topic.html","desc":"在页面上放置页眉或页脚 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"在页面上放置页眉或页脚 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 复印 高级选项 页眉/页脚  选择您要放置页眉或页脚的位置  选择您需要的页眉或页脚类型  根据您选定的页眉或页脚输入必需的信息，然后触摸 完成 。 触摸  ，然后按  。 插入页眉或页脚 复印"},{"UUID":"49634659-699d-4a16-8327-e5e13a0b66e6","title":"复印","link":"canceling-copy-job-while-pages-are-being-printed-topic.html","desc":"当正在打印页面时取消复印作业 从打印机控制面板，触摸 取消作业 或在键盘上按 ","descFull":"当正在打印页面时取消复印作业 从打印机控制面板，触摸 取消作业 或在键盘上按  。 触摸您要取消的作业，然后触摸  删除选定作业 。 如果您在键盘上按  ，请触摸 恢复 来返回到主屏幕。 复印 取消复印作业"},{"UUID":"050abfad-e1d7-4f0b-b0ce-c352e39c0caf","title":"理解复印选项","link":"copy-from-topic.html","desc":"复印来源 此选项打开一个屏幕，您可以在此选择原始文档的纸张尺寸。 触摸与原始文档相匹配的纸张尺寸。 要复印包含具有相同宽度的混合纸张尺寸的原始文档，请触摸 混合尺寸","descFull":"复印来源 此选项打开一个屏幕，您可以在此选择原始文档的纸张尺寸。 触摸与原始文档相匹配的纸张尺寸。 要复印包含具有相同宽度的混合纸张尺寸的原始文档，请触摸 混合尺寸 。 要设置打印机自动检测原始文档的尺寸，请触摸 自动尺寸检测 。 复印屏幕 选项 选项，复印屏幕 复印来源"},{"UUID":"93c627fd-57dd-4cde-8975-26ea0ae8efec","title":"理解复印选项","link":"copy-from-topic.html","desc":"复印到 此选项打开一个屏幕，您可以在此输入您将用于打印副本的纸张尺寸和类型。 触摸与加载的纸张相符的纸张尺寸和类型。 如果“复印来源”和“复印到”的纸张尺寸设置不同，打印机将自动调整“缩放”设置来适应差异。 复印屏幕","descFull":"复印到 此选项打开一个屏幕，您可以在此输入您将用于打印副本的纸张尺寸和类型。 触摸与加载的纸张相符的纸张尺寸和类型。 如果“复印来源”和“复印到”的纸张尺寸设置不同，打印机将自动调整“缩放”设置来适应差异。 复印屏幕 选项 选项，触摸屏 复印"},{"UUID":"95438bb5-e6b8-404d-babe-0c609456293d","title":"理解复印选项","link":"copy-from-topic.html","desc":"缩放 此选项让您将文档缩放为原始文档尺寸的 25% 到 400%。您也可以设置自动缩放。","descFull":"缩放 此选项让您将文档缩放为原始文档尺寸的 25% 到 400%。您也可以设置自动缩放。 当复印到不同的纸张尺寸，如从 legal 尺寸到 letter 尺寸的纸张时，设置“复印来源”和“复印到”纸张尺寸自动缩放扫描图像以适合您用于复印的纸张尺寸。 要以 1% 的量减小或增大值，请在打印机控制面板上触摸   或  。要持续减小或增大值，请按住按钮 2 秒或更多的时间。 复印屏幕 选项 选项，复印屏幕 缩放"},{"UUID":"4e97f998-56b9-40b8-8288-c55ef9987797","title":"理解复印选项","link":"copy-from-topic.html","desc":"浓度 此选项让您调整副本相对于原始文档的深浅程度。 复印选项 浓度 浓度","descFull":"浓度 此选项让您调整副本相对于原始文档的深浅程度。 复印选项 浓度 浓度 复印选项"},{"UUID":"ed41db12-6bf8-4923-b71f-f956433d6339","title":"理解复印选项","link":"copy-from-topic.html","desc":"面数（双面打印） 此选项让您从一面或两面的原始文档制作一面或两面的副本。 复印选项 面数（双面打印） 面数（双面打印）","descFull":"面数（双面打印） 此选项让您从一面或两面的原始文档制作一面或两面的副本。 复印选项 面数（双面打印） 面数（双面打印） 复印选项"},{"UUID":"ce60743b-a64a-4a19-a2f1-c899223061ab","title":"理解复印选项","link":"copy-from-topic.html","desc":"逐份打印 此选项当打印文档的多份副本时，按顺序堆放打印作业的页面。 复印选项 逐份打印 逐份打印","descFull":"逐份打印 此选项当打印文档的多份副本时，按顺序堆放打印作业的页面。 复印选项 逐份打印 逐份打印 复印选项"},{"UUID":"d4be9b39-a4b4-40f6-a59b-44174f3a5a60","title":"理解复印选项","link":"copy-from-topic.html","desc":"份数 此选项让您设置要打印的份数。 复印选项 份数 份数","descFull":"份数 此选项让您设置要打印的份数。 复印选项 份数 份数 复印选项"},{"UUID":"aec4cd6b-72bd-4d61-ac0d-3c656048ed80","title":"理解复印选项","link":"copy-from-topic.html","desc":"内容 此选项让您指定原始文档的内容类型和来源。 复印屏幕 内容类型 复印屏幕","descFull":"内容 此选项让您指定原始文档的内容类型和来源。 复印屏幕 内容类型 复印屏幕 内容来源"},{"UUID":"ee9a8d48-21d8-4214-82c2-9398a02cbbe7","title":"理解复印选项","link":"copy-from-topic.html","desc":"另存为快捷方式 此选项让您通过分配一个快捷方式名称来保存当前设置。 选择此选项自动分配下一个可用的快捷方式号码。 复印选项 另存为快捷方式","descFull":"另存为快捷方式 此选项让您通过分配一个快捷方式名称来保存当前设置。 选择此选项自动分配下一个可用的快捷方式号码。 复印选项 另存为快捷方式 另存为快捷方式 复印选项"},{"UUID":"206e43da-c455-41a2-b491-70f31edd43b9","title":"理解复印选项","link":"copy-from-topic.html","desc":"","descFull":"打孔 此设置指定是否在复印作业上打孔。 打孔"},{"UUID":"67b0bb2d-19ff-4158-9b21-b8fde0403ffd","title":"理解复印选项","link":"copy-from-topic.html","desc":"","descFull":"装订 此设置指定是否装订包含多页的复印作业。 装订"},{"UUID":"85c382be-2b26-4b81-87e2-a0371fb30b1a","title":"理解复印选项","link":"copy-from-topic.html","desc":"使用高级选项 高级双面打印 —此设置指定文档方向，单面或双面打印，以及装订类型。 高级图像 —","descFull":"使用高级选项 高级双面打印 —此设置指定文档方向，单面或双面打印，以及装订类型。 高级图像 — 此设置在您复印文档之前，调整“自动居中”、“背景消除”、“色彩平衡”、“颜色漏失”、“对比度”、“镜像图像”、“反白图像”、“边对边扫描”、“阴影细节”和“清晰度”设置。 创建小册子 —此设置创建单面或双面的小册子。 此选项仅在打印机硬盘已安装时出现。 封面页设置 —此项设置副本和小册子的封面页。 自定义作业 — 此设置将多个扫描作业组合为一个单一的作业。 此选项仅在打印机硬盘已安装时出现。 边缘消除 — 此设置消除文档边缘周围的污迹或标记。您可以选择消除围绕纸张四边的相等区域，或是挑选特定的一边。“边缘消除”会清除选定区域内的所有内容。 折叠 —此设置将纸张对折或三折。 此选项仅在小册子完成器已安装时出现。 页眉/页脚 —此设置在指定的页眉或页脚位置上插入“日期/时间”、“页码”、“贝茨编号”或“自定义文本”。 边距改变 —此设置通过移动扫描图像增加或减少页边距。触摸   或   来设置您需要的页边距。如果附加的边距太大，副本会被剪裁。 偏移页 —此设置在份数之间或者在作业之间偏移页面。 背景画面 —此设置创建覆盖副本每一页的水印或消息。您可以从预设消息选择或输入自定义消息。 纸张节省 — 此设置将原始文档的两页或更多页打印在同一页上。“纸张节省”也被称为  N 页 打印，其中  N  代表页数。例如：“2 页”将两页打印在单个页面上，“4 页”将四页打印在单个页面上。 分隔页 —此设置将一张空白纸放在副本、页面或打印作业之间。分隔页可以从装有与您用于打印副本的纸张不同类型或颜色的纸张的进纸匣送入。 复印屏幕 高级选项 高级选项，触摸屏 复印"},{"UUID":"05316516-8813-4dbc-abf5-d980e5726853","title":"设置打印机发送电子邮件","link":"configuring-email-settings-topic.html","desc":"配置电子邮件设置 打开 Web 浏览器，然后在地址字段中键入打印机 IP","descFull":"配置电子邮件设置 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 电子邮件/FTP 设置 电子邮件设置 。 输入适当的信息，然后单击 提交 。 发送电子邮件 配置电子邮件设置 配置电子邮件设置"},{"UUID":"923abfbb-0907-494f-bbf4-d94184ecf398","title":"创建电子邮件快捷方式","link":"creating-email-shortcut-using-ews-topic.html","desc":"使用 Embedded Web Server 创建电子邮件快捷方式","descFull":"使用 Embedded Web Server 创建电子邮件快捷方式 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 。 从“其他设置”列，单击 管理快捷方式 电子邮件快捷方式设置 。 为电子邮件收件人键入唯一的名称，然后键入电子邮件地址。如果您输入多个地址，请用逗号分隔每一个地址。 单击 添加 。 发送电子邮件 使用 Embedded Web Server 创建快捷方式 快捷方式，创建 电子邮件 Embedded Web Server 创建电子邮件快捷方式 电子邮件快捷方式，创建 使用 Embedded Web Server"},{"UUID":"2330461a-1f9a-47f1-bbc2-336377710914","title":"创建电子邮件快捷方式","link":"creating-email-shortcut-using-ews-topic.html","desc":"使用控制面板创建电子邮件快捷方式 从主屏幕，导览至： 我的快捷方式 创建 电子邮件","descFull":"使用控制面板创建电子邮件快捷方式 从主屏幕，导览至： 我的快捷方式 创建 电子邮件 键入唯一的快捷方式名称，然后触摸 完成 。 配置电子邮件设置，然后触摸 完成 。  在主屏幕上触摸 电子邮件快捷方式 以检验快捷方式。 创建电子邮件快捷方式 使用控制面板 电子邮件快捷方式，创建 使用控制面板"},{"UUID":"1b1752c9-badf-47c3-9478-d25e2a497445","title":"用电子邮件发送文档","link":"sending-email-using-control-panel-topic.html","desc":"使用控制面板发送电子邮件 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，触摸","descFull":"使用控制面板发送电子邮件 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，触摸 电子邮件 ，然后输入需要的信息。 配置，然后保存输出文件类型设置。 触摸 发送 。 使用电子邮件发送文档 使用控制面板 使用控制面板发送电子邮件"},{"UUID":"c9e21880-dfc8-4b1e-88b5-f0a439160393","title":"用电子邮件发送文档","link":"sending-email-using-control-panel-topic.html","desc":"使用快捷方式号码发送电子邮件 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 按","descFull":"使用快捷方式号码发送电子邮件 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 按  # ，然后使用键盘输入快捷方式号码。 触摸 发送 。 发送电子邮件 使用快捷方式号码 电子邮件，发送 使用快捷方式号码"},{"UUID":"07e195dc-f01d-4b77-bbad-3fffb46bbd30","title":"用电子邮件发送文档","link":"sending-email-using-control-panel-topic.html","desc":"使用地址簿发送电子邮件 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"使用地址簿发送电子邮件 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 电子邮件 收件人 键入收件人的名称 搜索 选择收件人的名称，然后触摸 完成 。 发送电子邮件 使用地址簿 使用地址簿 发送电子邮件"},{"UUID":"3fc19bbd-34b1-427d-ad27-8b72ff12b2ed","title":"定制电子邮件设置","link":"email-changing-output-file-type-topic.html","desc":"更改输出文件类型 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至：","descFull":"更改输出文件类型 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： 电子邮件 收件人  键入电子邮件地址 完成 发送为 选择您要发送的文件类型。 如果您选择“安全 PDF”，那么您将被提示输入两次密码。 触摸  发送 。 更改输出文件类型 发送电子邮件 输出文件类型 更改"},{"UUID":"ded498e6-16f0-437f-b73a-fd13a321cbf0","title":"电子邮件","link":"canceling-an-email-topic.html","desc":"取消电子邮件 如果使用 ADF，请在出现 正在扫描 时触摸","descFull":"取消电子邮件 如果使用 ADF，请在出现 正在扫描 时触摸 取消作业 。 如果使用扫描仪玻璃，请在出现 正在扫描 或者出现 扫描下一页  /  完成作业 时触摸 取消作业 。 电子邮件 取消 取消电子邮件"},{"UUID":"f0974a83-47d3-4c0f-9f03-c50a2bf17798","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"收件人 此选项让您输入您的电子邮件的收件人。您可以输入多个电子邮件地址。 电子邮件选项 收件人 收件人","descFull":"收件人 此选项让您输入您的电子邮件的收件人。您可以输入多个电子邮件地址。 电子邮件选项 收件人 收件人 电子邮件选项"},{"UUID":"7fe29b8f-0853-46f5-8f2a-87f2da7ea17a","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"主题 此选项让您键入电子邮件的主题。 电子邮件选项 主题 电子邮件选项","descFull":"主题 此选项让您键入电子邮件的主题。 电子邮件选项 主题 电子邮件选项 主题"},{"UUID":"542be583-887c-46bf-af3f-02a8e4307b9b","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"消息 此选项让您键入将与扫描附件一起发送的消息。 电子邮件选项 消息 消息","descFull":"消息 此选项让您键入将与扫描附件一起发送的消息。 电子邮件选项 消息 消息 电子邮件选项"},{"UUID":"507b3af7-f9ed-43d3-bab9-72d21fbc67c6","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"文件名 此选项让您定制附件的文件名。 电子邮件屏幕 选项 选项，触摸屏","descFull":"文件名 此选项让您定制附件的文件名。 电子邮件屏幕 选项 选项，触摸屏 电子邮件"},{"UUID":"d0ba63ac-fec6-4499-8b4f-500b050c3f42","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"原始尺寸 此选项让您设置您要用电子邮件发送的文档的纸张尺寸。当“原始尺寸”被设置为“混合尺寸”时，您可以扫描包含混合纸张尺寸（letter 和 legal 尺寸页面）的原始文档。","descFull":"原始尺寸 此选项让您设置您要用电子邮件发送的文档的纸张尺寸。当“原始尺寸”被设置为“混合尺寸”时，您可以扫描包含混合纸张尺寸（letter 和 legal 尺寸页面）的原始文档。 电子邮件选项 原始尺寸 原始尺寸 电子邮件选项"},{"UUID":"7b99993d-993d-49ce-a281-7f3d0beede01","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"分辨率 此选项让您调整电子邮件的输出质量。增加图像分辨率会增加电子邮件文件大小和扫描原始文档所需要的时间。降低图像分辨率会减小文件大小。 电子邮件选项 分辨率 分辨率","descFull":"分辨率 此选项让您调整电子邮件的输出质量。增加图像分辨率会增加电子邮件文件大小和扫描原始文档所需要的时间。降低图像分辨率会减小文件大小。 电子邮件选项 分辨率 分辨率 电子邮件选项"},{"UUID":"0cba0586-2dd5-4faa-92cc-7597af4bad79","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"内容 此选项让您指定原始文档的内容类型和来源。 内容 电子邮件设置 内容类型","descFull":"内容 此选项让您指定原始文档的内容类型和来源。 内容 电子邮件设置 内容类型 电子邮件设置 内容来源 电子邮件设置"},{"UUID":"5d78ae33-6b55-4dac-b1c2-8038cfd2f2a9","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"另存为快捷方式 此选项让您通过分配一个快捷方式名称来将当前设置保存为快捷方式。 选择此选项自动分配下一个可用的快捷方式号码。 电子邮件选项 另存为快捷方式","descFull":"另存为快捷方式 此选项让您通过分配一个快捷方式名称来将当前设置保存为快捷方式。 选择此选项自动分配下一个可用的快捷方式号码。 电子邮件选项 另存为快捷方式 另存为快捷方式 电子邮件选项"},{"UUID":"3a0c1adb-2d5c-4fb9-9688-4eab35615bd0","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"浓度 此选项让您调整扫描的文档相对于原始文档的深浅程度。 电子邮件选项 浓度 浓度","descFull":"浓度 此选项让您调整扫描的文档相对于原始文档的深浅程度。 电子邮件选项 浓度 浓度 电子邮件选项"},{"UUID":"a7095744-72ab-40c4-9e89-1ad94696ee68","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"发送为 此选项让您为扫描图像设置输出类型。 请选择下列选项之一： PDF —使用此项创建具有多页的单个文件。这可以发送为安全或压缩的文件。","descFull":"发送为 此选项让您为扫描图像设置输出类型。 请选择下列选项之一： PDF —使用此项创建具有多页的单个文件。这可以发送为安全或压缩的文件。 TIFF —使用此项创建多个文件或单个文件。如果在 Embedded Web Server 的“设置”菜单中关闭“多页 TIFF”，则 TIFF 在每个文件中保存一页。文件大小通常比同等的 JPEG 文件大。 JPEG —使用此项为您的原始文档的每一页创建并附加一个单独的文件。 XPS —使用此项创建具有多页的单个 XPS 文件。 电子邮件选项 发送为 发送为 电子邮件选项"},{"UUID":"74b12c15-d3f1-4369-9987-e430c15f17bc","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"页面设置 此选项让您更改下列设置： 面数（双面打印） —这指定原始文档是只打印在纸张的一个面上还是两个面上。这也确定需要扫描哪些内容以包括在电子邮件中。 方向","descFull":"页面设置 此选项让您更改下列设置： 面数（双面打印） —这指定原始文档是只打印在纸张的一个面上还是两个面上。这也确定需要扫描哪些内容以包括在电子邮件中。 方向 — 这指定原始文档的方向，然后更改“面数（双面打印）”和“装订”设置以匹配方向。 装订 — 这指定原始文档是在长边装订还是短边装订。 电子邮件选项 页面设置 页面设置 电子邮件选项"},{"UUID":"3b0dc4c2-342f-453e-aa75-6e056baaa1fb","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"扫描预览 此选项让您在图像被包括到电子邮件中之前查看图像的第一页。当第一页被扫描后，扫描暂停并出现预览图像。 此选项仅在工作的打印机硬盘已安装时出现。 电子邮件屏幕 选项","descFull":"扫描预览 此选项让您在图像被包括到电子邮件中之前查看图像的第一页。当第一页被扫描后，扫描暂停并出现预览图像。 此选项仅在工作的打印机硬盘已安装时出现。 电子邮件屏幕 选项 选项，触摸屏 电子邮件"},{"UUID":"ce9ef65b-5c01-4156-a5c4-201808cbc1ca","title":"理解电子邮件选项","link":"email-recipients-topic.html","desc":"使用高级选项 请从下列设置中选择： 高级图像 — 此设置在您使用电子邮件发送文档之前调整“背景消除”、“色彩平衡”、“颜色漏失”、“对比度”、“JPEG","descFull":"使用高级选项 请从下列设置中选择： 高级图像 — 此设置在您使用电子邮件发送文档之前调整“背景消除”、“色彩平衡”、“颜色漏失”、“对比度”、“JPEG 质量”、“镜像图像”、“反白图像”、“边对边扫描”、“阴影细节”、“清晰度”和“温度”设置。 自定义作业 — 此设置将多个扫描作业组合为一个单一的作业。 此选项仅在已格式化并工作的打印机硬盘已安装时出现。 边缘消除 — 此设置消除文档边缘周围的污迹或标记。您可以选择消除围绕纸张四边的相等区域，或是挑选特定的一边。“边缘消除”将清除选定区域内的所有内容，使该部分扫描上无任何内容。 传输日志 — 此设置打印传输日志或传输错误日志。 电子邮件屏幕 高级选项 高级选项，触摸屏 电子邮件"},{"UUID":"18561b6e-a317-4939-b9bb-0067660233d6","title":"设置打印机发送传真","link":"initial-fax-setup-topic.html","desc":"初始传真设置 许多国家和地区要求外发的传真在每个传输页面的顶部或底部的空白处，或者在传输的第一页上包含下列信息：传真名称（发送消息的商业机构、其他实体或个人的标识）和传真号码（发送传真的机器、商业机构、其他实体或个人的电话号码）。如需更多信息，请参阅 。 许多国家和地区要求外发的传真在每个传输页面的顶部或底部的空白处，或者在传输的第一页上包含下列信息：传真名称（发送消息的商业机构、其他实体或个人的标识）和传真号码（发送传真的机器、商业机构、其他实体或个人的电话号码）。 要输入您的传真设置信息，请使用打印机控制面板，或者使用您的浏览器访问","descFull":"初始传真设置 许多国家和地区要求外发的传真在每个传输页面的顶部或底部的空白处，或者在传输的第一页上包含下列信息：传真名称（发送消息的商业机构、其他实体或个人的标识）和传真号码（发送传真的机器、商业机构、其他实体或个人的电话号码）。如需更多信息，请参阅 。 许多国家和地区要求外发的传真在每个传输页面的顶部或底部的空白处，或者在传输的第一页上包含下列信息：传真名称（发送消息的商业机构、其他实体或个人的标识）和传真号码（发送传真的机器、商业机构、其他实体或个人的电话号码）。 要输入您的传真设置信息，请使用打印机控制面板，或者使用您的浏览器访问 Embedded Web Server，然后进入“设置”菜单。 如果您没有 TCP/IP 环境，那么您必须使用打印机控制面板来输入您的传真设置信息。 使用打印机控制面板进行传真设置 当打印机第一次打开时，会出现一系列启动屏幕。如果打印机有传真功能，那么会出现“传真名称”和“传真号码”屏幕。 当出现“传真名称”屏幕时，请执行下列操作： 输入将要被打印在所有外发传真上的名称。 输入传真名称，然后触摸 提交 。 当出现“传真号码”屏幕时，请输入传真号码，然后触摸 提交 。 使用 Embedded Web Server 进行传真设置 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 传真设置 模拟传真设置 。 “在传真名称”字段中，键入要被打印在所有外发传真上的名称。 在“传真号码”字段中，输入打印机传真号码。 单击 提交 。 发送传真 传真设置 初始传真设置 Embedded Web Server 初始传真设置 初始传真设置 使用 Embedded Web Server"},{"UUID":"95a64f52-d268-4d50-be77-ce5bb22577e0","title":"选择传真连接","link":"initial-fax-setup-topic.html","desc":"使用标准电话线路设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26","descFull":"使用标准电话线路设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26 AWG 或更大的通信线 (RJ-11)。澳大利亚用户的通信线必须获得 Australian Communications and Media Authority 的批准。 设置 1：打印机连接到专用传真线路 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到活动的模拟墙壁插孔中。 您可以设置打印机自动接收传真（自动应答开）或手动接收传真（自动应答关）。 如果您想要自动接收传真，请设置打印机在指定的振铃次数后接听。 设置 2：打印机与应答机共享线路 如果您订购了特色振铃服务，请确认您为打印机设置了正确的振铃模式。否则，即使您已经设置打印机自动接收传真，打印机也不接收传真。 连接到相同的电话墙壁插孔 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到活动的模拟墙壁插孔中。 将应答机连接到打印机的电话端口。 连接到不同的墙壁插孔 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到活动的模拟墙壁插孔中。 如果您的线路上只有一个电话号码，请设置打印机自动接收传真。 设置打印机在应答机之后两次振铃时接听呼叫。例如，如果应答机在四次振铃之后接听呼叫，请设置打印机的应答振铃设置为 6。 设置 3：打印机与已订购语音信箱服务的电话共享线路 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到活动的模拟墙壁插孔中。 将电话连接到打印机的电话端口。 如果您使用语音信箱比传真更经常，并且您订购了特色振铃服务，此设置效果最佳。 当您接听电话并听到传真音时，请按  *9*  或电话上的手动应答代码来接收传真。 您也可以设置打印机自动接收传真，但请在等待传真时关闭语音信箱服务。 设置传真 标准电话线连接 传真设置 标准电话线连接 应答机 设置 语音信箱 设置"},{"UUID":"4811bec5-0c57-48d5-adca-653190110a00","title":"选择传真连接","link":"initial-fax-setup-topic.html","desc":"使用数字用户线设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26","descFull":"使用数字用户线设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26 AWG 或更大的通信线 (RJ-11)。澳大利亚用户的通信线必须获得 Australian Communications and Media Authority 的批准。 数字用户线 (DSL) 将您的常规电话线路分为两个通道：语音和 Internet。电话和传真信号通过语音通道传输，而 Internet 信号通过另一个通道传输。 为了最大限度地减少两个通道之间的干扰，请向您的 DSL 提供商索取一个 DSL 过滤器。 将 DSL 过滤器的线路端口连接到墙壁插孔。 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到 DSL 过滤器上的电话端口。 要将电话连接到打印机上，请从打印机的电话端口移除任何已安装的适配器插头，然后连接电话。 数字用户线 (DSL) 传真设置 设置传真 DSL 连接 DSL 过滤器 线路过滤器 传真设置 DSL 连接"},{"UUID":"745977c5-41d1-4755-8d65-ab8ca14364fc","title":"选择传真连接","link":"initial-fax-setup-topic.html","desc":"使用 VoIP 电话服务设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。","descFull":"使用 VoIP 电话服务设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26 AWG 或更大的通信线 (RJ-11)。澳大利亚用户的通信线必须获得 Australian Communications and Media Authority 的批准。 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到 VoIP 适配器上标注为 电话线 1  或 电话端口 的端口。 标注为 电话线 2  或 传真端口 的端口并不总是活动的。VoIP 提供商可能为激活第二个电话端口收取额外的费用。 将电话连接到打印机的电话端口。 要检查 VoIP 适配器上的电话端口是否活动，请将模拟电话插入端口中，然后聆听拨号音。 如果您需要两个电话端口用于您的设备，但是不希望支付额外的费用，请使用电话分线器。将电话分线器插入标注为 电话线 1  或 电话端口 的端口中，然后将打印机和电话插入分线器中。 要检查分线器，请将模拟电话插入分线器中，然后聆听拨号音。 传真设置 VoIP 互联网语音协议 (VoIP) 传真设置 设置传真 VoIP 连接 电话分线器 VoIP 适配器"},{"UUID":"e9d4c2c6-4c80-474b-8fe3-aaafebfd472a","title":"选择传真连接","link":"initial-fax-setup-topic.html","desc":"使用电缆调制解调器连接设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26","descFull":"使用电缆调制解调器连接设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26 AWG 或更大的通信线 (RJ-11)。澳大利亚用户的通信线必须获得 Australian Communications and Media Authority 的批准。 设置 1：打印机直接连接到电缆调制解调器 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到电缆调制解调器上标注为 电话线 1  或 电话端口 的端口。 将模拟电话连接到打印机的电话端口。 要检查电缆调制解调器上的电话端口是否活动，请连接模拟电话，然后聆听拨号音。 设置 2：打印机连接到墙壁插孔；电缆调制解调器安装在设施中其他地方 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到活动的模拟电话墙壁插孔中。 将模拟电话连接到打印机的电话端口。 传真设置 数字电话服务 数字电话服务 传真设置 设置传真 数字电话服务"},{"UUID":"a5ecff77-3f2f-42c3-8e2b-205a2f4a115d","title":"选择传真连接","link":"initial-fax-setup-topic.html","desc":"在使用不同电话墙壁插孔和插头的国家或地区设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26","descFull":"在使用不同电话墙壁插孔和插头的国家或地区设置传真 为避免电击危险，请不要在雷雨天气时设置本产品，或者使用电源线、传真特性或电话线进行带电操作或线缆连接。 为避免电击危险，在雷雨天气时，请不要使用传真功能。 为了降低发生火灾的风险，当连接此产品到公共交换电话网络时，请只使用 26 AWG 或更大的通信线 (RJ-11)。澳大利亚用户的通信线必须获得 Australian Communications and Media Authority 的批准。 大多数国家或地区采用的标准墙壁插孔是 RJ11。如果您设施内的墙壁插孔或装置与此类连接不兼容，请使用电话适配器。适用于您所在国家或地区的适配器可能没有随打印机附带，您可能需要另外购买。 可能有适配器插头安装在打印机的电话端口中。如果您连接到串行或级联的电话系统，请不要从打印机的电话端口移除适配器插头。 适配器插头部件号 部件名称 部件号 Lexmark 适配器插头 40X8519 将打印机连接到非 RJ11 的墙壁插孔 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到 RJ11 适配器，然后将适配器连接到墙壁插孔中。 如果您要将带有非 RJ11 连接器的另一个设备连接到同一个墙壁插孔，请将它直接连接电话适配器上。 在德国将打印机连接到墙壁插孔 德国的墙壁插孔有两种端口。N 端口用于传真机、调制解调器和应答机。F 端口用于电话。将打印机连接到任意 N 端口。 将电话线的一端连接到打印机的线路端口。  将电话线的另一端连接到 RJ11 适配器，然后将适配器连接到一个 N 端口。 如果您要将电话和应答机连接到同一个墙壁插孔，请如图所示连接设备。 传真设置 特定国家或地区 设置传真 特定国家或地区 RJ11 适配器 适配器插头"},{"UUID":"c1b80e88-4a62-4a62-a722-8651fa6e9823","title":"设置打印机发送传真","link":"initial-fax-setup-topic.html","desc":"连接到特色振铃服务 特色振铃服务可以从您的电话公司获得。此服务让您在一条电话线路上有多个电话号码，并且每个电话号码使用不同的振铃模式。在区分传真和语音呼叫时这可能很有用。如果您订购了特色振铃服务，请按照下列步骤来连接装置： 将随打印机附带的电话线的一端连接到打印机的 LINE 端口","descFull":"连接到特色振铃服务 特色振铃服务可以从您的电话公司获得。此服务让您在一条电话线路上有多个电话号码，并且每个电话号码使用不同的振铃模式。在区分传真和语音呼叫时这可能很有用。如果您订购了特色振铃服务，请按照下列步骤来连接装置： 将随打印机附带的电话线的一端连接到打印机的 LINE 端口  。 将电话线的另一端连接到活动的模拟电话墙壁插孔中。 更改特色振铃设置，使之与您希望打印机应答的设置相符。 特色振铃的出厂默认设置是“开”。这设置打印机使用一次、两次和三次振铃模式应答。 从主屏幕，导览至： 设置 传真设置 模拟传真设置 应答开 选择您要更改的模式设置，然后触摸 提交 。 发送传真 特色振铃服务 特色振铃服务，传真 连接到 将打印机连接到特色振铃服务"},{"UUID":"42d73961-9d72-49c6-bbdb-062f7c58a3ab","title":"设置打印机发送传真","link":"initial-fax-setup-topic.html","desc":"设置外发传真的名称和号码 打开 Web 浏览器，然后在地址字段中键入打印机 IP","descFull":"设置外发传真的名称和号码 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 传真设置 模拟传真设置 。 “在传真名称”字段中，键入要被打印在所有外发传真上的名称。 在“传真号码”字段中，输入打印机传真号码。 单击 提交 。 发送传真 设置外发传真的名称 传真号码，设置 传真名称，设置 发送传真 设置传真号码 设置外发传真的名称 设置传真号码"},{"UUID":"032378cb-75c0-41af-98c2-b2a1f753e7e5","title":"设置打印机发送传真","link":"initial-fax-setup-topic.html","desc":"设置日期和时间 您可以设置日期和时间以便将它们打印在您发送的每一份传真上。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"设置日期和时间 您可以设置日期和时间以便将它们打印在您发送的每一份传真上。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在主屏幕上查看 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 安全 设置日期和时间 。 在“手动设置日期和时间”字段中，输入当前日期和时间。 建议使用网络时间。 单击 提交 。 发送传真 设置日期和时间 日期和时间，传真 设置"},{"UUID":"94eda083-f27e-411d-b5fe-56f45e8a1459","title":"设置打印机发送传真","link":"initial-fax-setup-topic.html","desc":"配置打印机以遵循夏令时 打印机能被设置为自动调整夏令时时间。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"配置打印机以遵循夏令时 打印机能被设置为自动调整夏令时时间。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 安全 设置日期和时间 。 单击 自动遵守 DST  复选框。 在“自定义时区设置”部分中，设置 DST 的起止日期。 单击 提交 。 发送传真 配置打印机以遵循夏令时 夏令时，传真"},{"UUID":"3856e289-5446-4d99-b1a9-bc414cda4a5d","title":"传真","link":"sending-fax-topic.html","desc":"发送传真 发送传真 使用控制面板 将原始文档放入 ADF","descFull":"发送传真 发送传真 使用控制面板 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，触摸 传真 ，然后输入需要的信息。 如果需要，请配置其他传真设置。 发送传真作业。 使用计算机 对于 Windows 用户 打开文档后，单击 文件 打印 。 选择打印机，然后单击 属性 、 首选项 、 选项 或 设置 。 单击 传真 启用传真 ，然后输入收件人号码。 如果需要，请配置其他传真设置。 发送传真作业。 对于 Macintosh 用户 打开文档后，选择 文件 打印 。 选择打印机，然后输入收件人号码。 如果需要，请配置其他传真设置。 发送传真作业。 发送传真 使用控制面板 发送传真 使用计算机"},{"UUID":"6892358e-7403-4a52-9d44-179e591ba16f","title":"传真","link":"sending-fax-at-scheduled-time-topic.html","desc":"在预定时间发送传真 将原始文档面朝上放入 ADF 进纸匣中，让短边先进入，或面朝下放在扫描仪玻璃上。 请勿将明信片、照片、小物品、透明胶片、照片纸或薄介质（例如杂志剪报）放入","descFull":"在预定时间发送传真 将原始文档面朝上放入 ADF 进纸匣中，让短边先进入，或面朝下放在扫描仪玻璃上。 请勿将明信片、照片、小物品、透明胶片、照片纸或薄介质（例如杂志剪报）放入 ADF 进纸匣中。请将这些物品放在扫描仪玻璃上。 当纸张正确加载时，ADF 指示灯会变亮。 如果您将文档放入 ADF 进纸匣中，请调整纸张导片。 从主屏幕，导览至： 传真  输入传真号码 选项 延迟发送 如果“传真模式”被设置为“传真服务器”，“延迟发送”按钮不会出现。等待传送的传真被列在传真队列中。 指定传真将被传送的时间，然后触摸  。 触摸 发送传真 。 扫描文档，然后在预定的时间发送传真。 发送传真 在预定时间发送传真 在预定时间发送传真 传真 在预定时间发送"},{"UUID":"042b8cfe-7cd0-4250-8408-640a3caca6bf","title":"创建快捷方式","link":"creating-fax-destination-shortcut-using-embedded-web-server-topic.html","desc":"使用 Embedded Web Server 创建传真目标快捷方式","descFull":"使用 Embedded Web Server 创建传真目标快捷方式 快捷方式号码可以分配给单个传真号码或一组传真号码。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置  管理快捷方式  传真快捷方式设置 。 可能需要密码。如果您没有 ID 和密码，请与您的系统支持人员联系。 为快捷方式键入名称，然后输入传真号码。 要创建多号码的快捷方式，请输入成组的传真号码。 用分号（;）来分隔组中的每一个传真号码。 分配快捷方式号码。 如果您输入的号码已被使用，您会得到选择其他号码的提示。 单击 添加 。 发送传真 使用 Embedded Web Server 创建快捷方式 快捷方式，创建 传真目标 Embedded Web Server 创建传真目标快捷方式 创建传真目标快捷方式 使用 Embedded Web Server"},{"UUID":"81ea80a6-bde9-4484-83da-6255409ce5e6","title":"创建快捷方式","link":"creating-fax-destination-shortcut-using-embedded-web-server-topic.html","desc":"使用打印机控制面板创建传真目标快捷方式 从主屏幕，触摸 传真 ，然后输入传真号码。 要创建一组传真号码，请触摸","descFull":"使用打印机控制面板创建传真目标快捷方式 从主屏幕，触摸 传真 ，然后输入传真号码。 要创建一组传真号码，请触摸 下一个号码 ，然后输入下一个传真号码。 触摸  。 为快捷方式键入唯一的名称，然后触摸 完成 。 检验快捷方式名称和号码是否正确，然后触摸 确定 。 如果名称或号码不正确，请触摸 取消 ，然后重新输入信息。 发送传真 使用打印机控制面板创建快捷方式 快捷方式，创建 传真目标"},{"UUID":"a5c29826-c7a2-4cb3-a2e3-77310e993d38","title":"定制传真设置","link":"changing-fax-resolution-topic.html","desc":"更改传真分辨率 将原始文档面朝上放入 ADF 进纸匣中，让短边先进入，或面朝下放在扫描仪玻璃上。 请勿将明信片、照片、小物品、透明胶片、照片纸或薄介质（例如杂志剪报）放入","descFull":"更改传真分辨率 将原始文档面朝上放入 ADF 进纸匣中，让短边先进入，或面朝下放在扫描仪玻璃上。 请勿将明信片、照片、小物品、透明胶片、照片纸或薄介质（例如杂志剪报）放入 ADF 进纸匣中。请将这些物品放在扫描仪玻璃上。 当纸张正确加载时，ADF 指示灯会变亮。 如果您将文档放入 ADF 进纸匣中，请调整纸张导片。 从主屏幕，导览至： 传真  输入传真号码 选项 从“分辨率”区域，触摸箭头来选择您需要的分辨率。 从“标准”（最快速度）到“极精细”（最佳质量并减速）选择一个分辨率。 触摸 发送传真 。 发送传真 更改分辨率 分辨率，传真 更改"},{"UUID":"4dce546b-c0c3-4fc1-a927-911d8a4722d6","title":"定制传真设置","link":"changing-fax-resolution-topic.html","desc":"减淡或加深传真 将原始文档面朝上放入 ADF 进纸匣中，让短边先进入，或面朝下放在扫描仪玻璃上。 请勿将明信片、照片、小物品、透明胶片、照片纸或薄介质（例如杂志剪报）放入","descFull":"减淡或加深传真 将原始文档面朝上放入 ADF 进纸匣中，让短边先进入，或面朝下放在扫描仪玻璃上。 请勿将明信片、照片、小物品、透明胶片、照片纸或薄介质（例如杂志剪报）放入 ADF 进纸匣中。请将这些物品放在扫描仪玻璃上。 当纸张正确加载时，ADF 指示灯会变亮。 如果您将文档放入 ADF 进纸匣中，请调整纸张导片。 从主屏幕，导览至： 传真  输入传真号码 选项 调整传真浓度，然后触摸 发送传真 。 发送传真 减淡或加深传真"},{"UUID":"5f66e412-7757-4df0-bd9c-515d8bf806a6","title":"定制传真设置","link":"changing-fax-resolution-topic.html","desc":"查看传真日志 在 Web 浏览器的地址字段中键入打印机 IP","descFull":"查看传真日志 在 Web 浏览器的地址字段中键入打印机 IP 地址。 如果您不知道打印机的 IP 地址，请打印网络设置页并在 TCP/IP 部分中找到 IP 地址。 单击 报告 。 单击 传真作业日志 或 传真呼叫日志 。 发送传真 查看传真日志"},{"UUID":"c836f938-ad04-4400-a7cc-b464d78bca62","title":"定制传真设置","link":"changing-fax-resolution-topic.html","desc":"阻止垃圾传真 打开 Web 浏览器，然后在地址字段中键入打印机 IP","descFull":"阻止垃圾传真 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 传真设置 模拟传真设置 阻止无名称传真 。 此选项阻止所有使用私人呼叫者  ID 或没有传真名称的发来的传真。 在“禁止的传真列表”字段中，输入电话号码或键入您要阻止的特定传真呼叫者的传真名称。 发送传真 阻止垃圾传真 阻止垃圾传真"},{"UUID":"3cef9040-2762-4c29-a68b-88642a6bc822","title":"传真","link":"canceling-fax-job-topic.html","desc":"取消传真作业 从控制面板，触摸 取消作业 或在键盘上按 ","descFull":"取消传真作业 从控制面板，触摸 取消作业 或在键盘上按  。 触摸您要取消的作业，然后触摸 删除选定作业 。 如果您在键盘上按  ，请触摸 恢复 来返回到主屏幕。 取消传真作业 传真作业 取消"},{"UUID":"f656b22b-c590-4b1a-b3c2-595e0df537d1","title":"挂起和转发传真","link":"holding-faxes-topic.html","desc":"挂起传真 此选项让您保留收到的传真不打印，直到它们被释放。挂起的传真可以被手动释放或在预定的日期或时间释放。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"挂起传真 此选项让您保留收到的传真不打印，直到它们被释放。挂起的传真可以被手动释放或在预定的日期或时间释放。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 传真设置 模拟传真设置 挂起传真 。 从“挂起传真模式”菜单，选择下列选项之一： 关 始终为开 手动 预定 如果您选择“预定”，请继续执行下面的步骤： 单击 传真挂起时间表 。 从“操作”菜单，选择 挂起传真 。 从“时间”菜单，选择您要释放挂起传真的时间。 从“日”菜单，选择您要释放挂起传真的日期。 单击 添加 。 发送传真 挂起传真 挂起传真"},{"UUID":"fd1f924d-0854-4772-9925-33fb76877c31","title":"挂起和转发传真","link":"holding-faxes-topic.html","desc":"转发传真 此选项让您打印并转发收到的传真到传真号码、电子邮件地址、FTP 站点或 LDSS。 打开","descFull":"转发传真 此选项让您打印并转发收到的传真到传真号码、电子邮件地址、FTP 站点或 LDSS。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 传真设置 。 从“传真转发”菜单，选择 打印 、 打印并转发 或 转发 。 从“转发到”菜单，选择 传真 、 电子邮件 、 FTP 、 LDSS  或  eSF 。 在“转发到快捷方式”字段内，输入您要将传真转发到的目标的快捷方式号码。 快捷方式号码必须对在“转发到”菜单中选择的设置有效。 单击 提交 。 发送传真 转发传真 转发传真"},{"UUID":"ddbdf573-a72c-4453-81fc-f562be9828f6","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"分辨率 此选项让您调整传真输出的质量。增加图像分辨率会增加文件大小和扫描原始文档所需要的时间。降低图像分辨率会减小文件大小。 请选择下列选项之一： 标准 —当传真大多数文档时使用此项。","descFull":"分辨率 此选项让您调整传真输出的质量。增加图像分辨率会增加文件大小和扫描原始文档所需要的时间。降低图像分辨率会减小文件大小。 请选择下列选项之一： 标准 —当传真大多数文档时使用此项。 精细 200 dpi —当传真带有小字体的文档时使用此项。 超精细 300 dpi —当传真带有精细细节的文档时使用此项。 极精细 600 dpi —当传真带有图片或照片的文档时使用此项。 传真选项 分辨率 分辨率 传真选项"},{"UUID":"8a583bd2-931c-44c1-93cb-e596f3af5e5c","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"浓度 此选项让您调整传真相对于原始文档的深浅程度。 传真选项 浓度 浓度","descFull":"浓度 此选项让您调整传真相对于原始文档的深浅程度。 传真选项 浓度 浓度 传真选项"},{"UUID":"6f904b9c-1223-4a88-a65b-f00ec4af25b9","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"页面设置 此选项让您更改下列设置： 面数（双面打印） —这指定原始文档是打印在纸张的一个面上还是两个面上（双面）。这也确定需要扫描哪些内容以包括在传真中。 方向","descFull":"页面设置 此选项让您更改下列设置： 面数（双面打印） —这指定原始文档是打印在纸张的一个面上还是两个面上（双面）。这也确定需要扫描哪些内容以包括在传真中。 方向 — 这指定原始文档的方向，然后更改“面数（双面打印）”和“装订”设置以匹配方向。 装订 — 这指定原始文档是在长边装订还是短边装订。 传真选项 页面设置 页面设置 传真选项"},{"UUID":"352f5ee7-39fa-4a85-9dbc-517b16da3c66","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"内容 此选项让您指定原始文档的内容类型和来源。 传真选项 内容类型 传真选项","descFull":"内容 此选项让您指定原始文档的内容类型和来源。 传真选项 内容类型 传真选项 内容来源 内容类型 传真选项 内容来源 传真选项"},{"UUID":"b0efee5a-2aa8-402c-a16f-1c04ee49666d","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"延迟发送 此选项让您在稍后时间或日期发送传真。 传真选项 延迟发送 延迟发送","descFull":"延迟发送 此选项让您在稍后时间或日期发送传真。 传真选项 延迟发送 延迟发送 传真选项"},{"UUID":"e06451ae-1db6-4b94-b34e-63e34e5a5af5","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"颜色 此选项让您将扫描图像的输出设置为彩色或单色。 传真屏幕 选项 选项，触摸屏","descFull":"颜色 此选项让您将扫描图像的输出设置为彩色或单色。 传真屏幕 选项 选项，触摸屏 传真"},{"UUID":"7a75ccfd-d3e2-4148-a77b-4b7129536857","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"扫描预览 此选项让您在图像被包括到传真中之前查看图像的第一页。当第一页被扫描后，扫描暂停并出现预览图像。 此选项仅在工作的打印机硬盘已安装时出现。 传真选项 扫描预览","descFull":"扫描预览 此选项让您在图像被包括到传真中之前查看图像的第一页。当第一页被扫描后，扫描暂停并出现预览图像。 此选项仅在工作的打印机硬盘已安装时出现。 传真选项 扫描预览 扫描预览 传真选项"},{"UUID":"5130e31e-8f93-48d0-8293-8f824c6ace4e","title":"理解传真选项","link":"faxing-resolution-topic.html","desc":"使用高级选项 请从下列设置中选择： 高级图像 — 此设置在传真文档之前调整“背景消除”、“色彩平衡”、“颜色漏失”、“对比度”、“镜像图像”、“反白图像”、“边对边扫描”、“阴影细节”、“清晰度”和“温度”设置。","descFull":"使用高级选项 请从下列设置中选择： 高级图像 — 此设置在传真文档之前调整“背景消除”、“色彩平衡”、“颜色漏失”、“对比度”、“镜像图像”、“反白图像”、“边对边扫描”、“阴影细节”、“清晰度”和“温度”设置。 自定义作业 — 此设置将多个扫描作业组合为一个单一的作业。 此选项仅在已格式化并工作的打印机硬盘已安装时出现。 边缘消除 — 此设置消除文档边缘周围的污迹或标记。您可以选择消除围绕纸张四边的相等区域，或是挑选特定的一边。“边缘消除”将清除选定区域内的所有内容，使该部分扫描上无任何内容。 传输日志 — 此设置打印传输日志或传输错误日志。 传真屏幕 高级选项 高级选项，触摸屏 传真"},{"UUID":"a0435f4a-7b6f-428c-90d6-aa76e3590f98","title":"扫描","link":"using-scan-to-network-topic.html","desc":"使用“扫描到网络” “扫描到网络”让您将您的文档扫描到由您的系统支持人员指定的网络目标。当目标（共享的网络文件夹）已在网络上被建立后，应用程序的设置过程包括使用其 Embedded Web Server","descFull":"使用“扫描到网络” “扫描到网络”让您将您的文档扫描到由您的系统支持人员指定的网络目标。当目标（共享的网络文件夹）已在网络上被建立后，应用程序的设置过程包括使用其 Embedded Web Server 在适当的打印机上安装和配置应用程序。如需更多信息，请参阅 。 扫描到网络 使用 扫描到网络目标"},{"UUID":"a8ca9a93-59f8-4c0b-a138-6e5f8270a61f","title":"创建快捷方式","link":"creating-ftp-shortcuts-using-ews-topic.html","desc":"使用 Embedded Web Server 创建","descFull":"使用 Embedded Web Server 创建 FTP 快捷方式 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 导览至： 设置  “其他设置”区域 管理快捷方式 FTP 快捷方式设置 输入适当的信息。 可能需要密码。如果您没有 ID 和密码，请与您的系统支持人员联系。 输入快捷方式号码。 如果您输入的号码已被使用，您会得到选择其他号码的提示。 单击 添加 。 扫描到 FTP 地址 使用计算机创建快捷方式 快捷方式，创建 FTP 目标 Embedded Web Server 创建 FTP 快捷方式 创建 FTP 快捷方式 使用 Embedded Web Server"},{"UUID":"0105be45-3b0c-4a20-9f63-2082d76cf0b3","title":"创建快捷方式","link":"creating-ftp-shortcuts-using-ews-topic.html","desc":"使用打印机控制面板创建 FTP 快捷方式 从主屏幕，导览至： FTP","descFull":"使用打印机控制面板创建 FTP 快捷方式 从主屏幕，导览至： FTP FTP  键入 FTP 地址  键入快捷方式的名称 完成 检验快捷方式名称和号码是否正确，然后触摸 确定 。 如果名称或号码不正确，请触摸 取消 ，然后重新输入信息。 如果您输入的号码已被使用，您会得到选择其他号码的提示。 FTP 地址 使用打印机控制面板创建快捷方式 快捷方式，创建 FTP 地址"},{"UUID":"23b95690-ebc6-4ac3-8a03-923d2a5ec338","title":"扫描到 FTP 地址","link":"creating-ftp-shortcuts-using-ews-topic.html","desc":"使用控制面板扫描到 FTP 地址 将原始文档放入 ADF","descFull":"使用控制面板扫描到 FTP 地址 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 从主屏幕，导览至： FTP FTP  键入 FTP 地址 完成 发送 您也可以使用快捷方式号码或地址簿输入收件人。 要添加收件人，请触摸 下一个号码 。 扫描到 FTP 地址 使用控制面板 FTP 地址，扫描到 使用控制面板 扫描 到 FTP 地址"},{"UUID":"b765609e-5b2b-4657-9975-783ce82b990e","title":"扫描到计算机或闪存驱动器","link":"setting-up-scan-to-computer-topic.html","desc":"设置“扫描到计算机” 此特性仅在 Windows Vista 或更高版本的操作系统中被支持。","descFull":"设置“扫描到计算机” 此特性仅在 Windows Vista 或更高版本的操作系统中被支持。 确认您的计算机和打印机都被连接到相同的网络上。 打开打印机文件夹，然后选择您的打印机。 如果您的打印机没有在列表中，请添加您的打印机。 打开打印机属性，然后根据需要调整设置。 从控制面板，触摸 扫描到计算机  选择适当的扫描设置 发送 。 扫描到计算机 设置 扫描到计算机"},{"UUID":"3facfc38-0c85-42de-be9f-0a8ae4dcf018","title":"扫描到计算机或闪存驱动器","link":"setting-up-scan-to-computer-topic.html","desc":"扫描到闪存驱动器 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 将闪存驱动器插入","descFull":"扫描到闪存驱动器 将原始文档放入 ADF 进纸匣中，或放在扫描仪玻璃上。 将闪存驱动器插入 USB 端口中。 选择目标文件夹，然后触摸 扫描到 USB 驱动器 。 调整扫描设置，然后触摸 扫描 。 扫描到闪存驱动器 闪存驱动器 扫描"},{"UUID":"c84c8088-9269-42d5-bba1-e96ec2361e65","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"FTP 此选项让您为 FTP 目标输入 IP","descFull":"FTP 此选项让您为 FTP 目标输入 IP 地址。 IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 FTP 选项 FTP FTP FTP 选项"},{"UUID":"e920de73-9c99-49b6-acda-4b781cd57343","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"文件名 此选项让您为扫描图像键入文件名。 扫描选项 文件名 文件名","descFull":"文件名 此选项让您为扫描图像键入文件名。 扫描选项 文件名 文件名 扫描选项"},{"UUID":"be2da34a-9d91-4f7b-8154-2223d98ae1c0","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"另存为快捷方式 此选项让您通过分配一个快捷方式名称来将当前设置保存为快捷方式。 选择此选项自动分配下一个可用的快捷方式号码。 扫描选项 另存为快捷方式","descFull":"另存为快捷方式 此选项让您通过分配一个快捷方式名称来将当前设置保存为快捷方式。 选择此选项自动分配下一个可用的快捷方式号码。 扫描选项 另存为快捷方式 另存为快捷方式 扫描选项"},{"UUID":"e87a0fec-d059-4d44-981f-784d8307dac1","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"原始尺寸 此选项让您设置您要扫描的文档的纸张尺寸。当“原始尺寸”被设置为“混合尺寸”时，您可以扫描包含混合纸张尺寸（letter 和 legal 尺寸页面）的原始文档。","descFull":"原始尺寸 此选项让您设置您要扫描的文档的纸张尺寸。当“原始尺寸”被设置为“混合尺寸”时，您可以扫描包含混合纸张尺寸（letter 和 legal 尺寸页面）的原始文档。 扫描选项 原始尺寸 原始尺寸 扫描选项"},{"UUID":"b7049c04-4af4-43db-ab29-1355c10bb191","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"浓度 此选项让您调整扫描的文档相对于原始文档的深浅程度。 扫描选项 浓度 浓度","descFull":"浓度 此选项让您调整扫描的文档相对于原始文档的深浅程度。 扫描选项 浓度 浓度 扫描选项"},{"UUID":"bd060cfd-7763-4b2b-948b-6f6ed5fb4db7","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"分辨率 此选项让您调整文件的输出质量。增加图像分辨率会增加文件大小和扫描原始文档所需要的时间。降低图像分辨率会减小文件大小。 扫描选项 分辨率 分辨率","descFull":"分辨率 此选项让您调整文件的输出质量。增加图像分辨率会增加文件大小和扫描原始文档所需要的时间。降低图像分辨率会减小文件大小。 扫描选项 分辨率 分辨率 扫描选项"},{"UUID":"0e833028-23ce-467d-b789-bc910465554f","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"发送为 此选项让您为扫描图像设置输出类型。 请选择下列选项之一： PDF —用于创建具有多页的单个文件。PDF","descFull":"发送为 此选项让您为扫描图像设置输出类型。 请选择下列选项之一： PDF —用于创建具有多页的单个文件。PDF 可以发送为安全或压缩的文件。 TIFF —用于创建多个文件或单个文件。如果在“设置”菜单中关闭“多页 TIFF”，则 TIFF 在每个文件中保存一页。文件大小通常比同等的 JPEG 文件大。 JPEG —用于为原始文档的每一页创建并附加一个单独的文件。 XPS —用于创建具有多页的单个 XPS 文件。 扫描选项 发送为 发送为 扫描选项 输出文件类型 扫描图像 扫描图像 输出文件类型"},{"UUID":"cf9c26aa-3d6e-4772-91f5-ebdae9f5cd1f","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"内容 此选项让您指定原始文档的内容类型和来源。 扫描屏幕 内容类型 扫描屏幕","descFull":"内容 此选项让您指定原始文档的内容类型和来源。 扫描屏幕 内容类型 扫描屏幕 内容来源"},{"UUID":"684890a7-4c49-4cb6-a544-225e4a33c7d0","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"页面设置 此选项让您更改下列设置： 面数（双面打印） —这指定原始文档是只打印在纸张的一个面上还是两个面上。 方向","descFull":"页面设置 此选项让您更改下列设置： 面数（双面打印） —这指定原始文档是只打印在纸张的一个面上还是两个面上。 方向 — 这指定原始文档的方向，然后更改“面数（双面打印）”和“装订”设置以匹配方向。 装订 — 这指定原始文档是在长边装订还是短边装订。 扫描选项 页面设置 页面设置 扫描选项"},{"UUID":"5de081f2-90ae-4665-84a2-65e1f5c83d57","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"扫描预览 此选项让您在图像被包括到文件中之前查看图像的第一页。当第一页被扫描后，扫描暂停并出现预览图像。 此选项仅在已格式化并工作的打印机硬盘已安装时出现。 扫描选项 扫描预览","descFull":"扫描预览 此选项让您在图像被包括到文件中之前查看图像的第一页。当第一页被扫描后，扫描暂停并出现预览图像。 此选项仅在已格式化并工作的打印机硬盘已安装时出现。 扫描选项 扫描预览 扫描预览 扫描选项"},{"UUID":"3b27f5f8-7aea-47e2-aab3-359ec1489774","title":"理解扫描选项","link":"ftp-destination-topic.html","desc":"使用高级选项 请从下列设置中选择： 高级图像 — 此设置在扫描文档之前调整“背景消除”、“色彩平衡”、“颜色漏失”、“对比度”、“JPEG","descFull":"使用高级选项 请从下列设置中选择： 高级图像 — 此设置在扫描文档之前调整“背景消除”、“色彩平衡”、“颜色漏失”、“对比度”、“JPEG 质量”、“镜像图像”、“反白图像”、“边对边扫描”、“阴影细节”、“清晰度”和“温度”设置。 自定义作业 — 此设置将多个扫描作业组合为一个单一的作业。 此选项仅在已格式化并工作的打印机硬盘已安装时出现。 边缘消除 — 此设置消除文档边缘周围的污迹或标记。您可以选择消除围绕纸张四边的相等区域，或是挑选特定的一边。“边缘消除”将清除选定区域内的所有内容，使该部分扫描上无任何内容。 传输日志 — 此设置打印传输日志或传输错误日志。 FTP 屏幕 高级选项 高级选项，触摸屏 FTP"},{"UUID":"9ff2c375-fcdc-4a36-95a6-9b8a20529f9c","title":"理解打印机菜单","link":"menus-list-topic.html","desc":"菜单列表 菜单列表 纸张菜单 报告 网络/端口","descFull":"菜单列表 菜单列表 纸张菜单 报告 网络/端口 安全 1  根据打印机设置，此菜单显示为“标准网络”或“网络 [x]”。 2  此菜单仅在一个或多个 DLE 已安装时出现。 默认纸张来源 纸张尺寸/类型 配置多功能进纸器 替换尺寸 纸张纹理 加载纸张 自定义类型 自定义名称 自定义扫描尺寸 自定义接纸架名称 Universal 设置 接纸架设置 菜单设置页 设备统计 装订器测试 网络设置页 网络 [x] 设置页 快捷方式列表 传真作业日志 传真呼叫日志 复印快捷方式 电子邮件快捷方式 传真快捷方式 FTP 快捷方式 配置文件列表 打印字体 打印目录 打印演示 资产报告 事件日志摘要 活动 NIC 标准网络 1 标准 USB 并口 [x] 串口 [x] SMTP 设置 编辑安全设置 混合安全设置 保密打印 清除临时数据文件 安全审核日志 设置日期和时间 设置 帮助 管理快捷方式 选件卡菜单 2 常规设置 复印设置 传真设置 电子邮件设置 FTP 设置 闪存驱动器菜单 打印设置 打印所有指南 复印指南 电子邮件指南 传真指南 FTP 指南 打印缺陷指南 信息指南 耗材指南 传真快捷方式 电子邮件快捷方式 FTP 快捷方式 复印快捷方式 配置文件快捷方式 出现已安装的 DLE（下载仿真器）列表。 菜单图表 菜单 图表"},{"UUID":"780e3130-9ff8-448e-9251-386f1f6c3d17","title":"纸张菜单","link":"paper-menu-group.html","desc":"“默认纸张来源”菜单 “默认纸张来源”菜单项及描述 使用 来 默认纸张来源","descFull":"“默认纸张来源”菜单 “默认纸张来源”菜单项及描述 使用 来 默认纸张来源 进纸匣 [x] 多功能进纸器 手动纸张 手动信封 为所有打印作业设置默认的纸张来源。 “进纸匣 1”（标准进纸匣）是出厂默认设置。 从“纸张”菜单将“配置多功能进纸器”设置为“盒子”，以使“多功能进纸器”作为菜单设置出现。 如果两个进纸匣装有相同尺寸和类型的纸张，并且进纸匣具有相同设置，那么进纸匣被自动连接。当一个进纸匣变空时，打印作业继续使用连接的进纸匣。 默认纸张来源菜单 菜单 默认纸张来源"},{"UUID":"bc49db52-0263-410c-99c0-e64cc2cbfd74","title":"纸张菜单","link":"paper-menu-group.html","desc":"“纸张尺寸/类型”菜单 “纸张尺寸/类型”菜单项及描述 使用 来 此菜单中只列出已安装的进纸匣和进纸器。","descFull":"“纸张尺寸/类型”菜单 “纸张尺寸/类型”菜单项及描述 使用 来 此菜单中只列出已安装的进纸匣和进纸器。 进纸匣 [x] 尺寸 A4 A5 A6 JIS‑B5 JIS‑B4 Letter Legal 12 x 18 11 x 17 SRA3 A3 Executive Oficio（墨西哥） Folio Statement Universal 指定每个进纸匣中加载的纸张尺寸。 Letter 是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 如果两个进纸匣装有相同尺寸和类型的纸张，并且进纸匣具有相同设置，那么进纸匣被自动连接。多功能进纸器也可以连接。当一个进纸匣变空时，打印作业继续使用连接的进纸匣。 进纸匣 [x] 类型 普通纸张 卡片纸 透明胶片 再生纸 光面纸 重磅光面纸 标签 铜版纸 信封 粗糙信封 信签 预印纸 彩色纸 轻磅纸张 重磅纸张 粗糙/棉纸 自定义类型 [x] 指定每个进纸匣中加载的纸张类型。 “普通纸张”是进纸匣 1 的出厂默认设置。“自定义 类型 [x]”是所有其他进纸匣的出厂默认设置。 如果可用，用户定义的名称将代替“自定义类型 [x]”出现。 使用此菜单来配置自动进纸匣连接。 多功能进纸器尺寸 A4 A5 A6 JIS‑B5 JIS‑B4 Letter Legal 12 x 18 11 x 17 SRA3 A3 Executive Oficio（墨西哥） Folio Statement Universal 指定多功能进纸器中加载的纸张尺寸。 Letter 是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 从“纸张”菜单将“配置多功能进纸器”设置为“盒子”，以使“多功能进纸器尺寸”作为菜单出现。 多功能进纸器不会自动检测纸张尺寸。必须设置纸张尺寸值。 多功能进纸器类型 普通纸张 卡片纸 透明胶片 再生纸 光面纸 重磅光面纸 标签 铜版纸 信封 粗糙信封 信签 预印纸 彩色纸 轻磅纸张 重磅纸张 粗糙/棉纸 自定义类型 [x] 指定多功能进纸器中加载的纸张类型。 “普通纸张”是出厂默认设置。 从“纸张”菜单将“配置多功能进纸器”设置为“盒子”，以使“多功能进纸器类型”作为菜单出现。 手动纸张尺寸 A4 A5 A6 JIS B5 Letter Legal Executive Oficio（墨西哥） JIS B4 A3 11 x 17 Folio Statement Universal SRA3 12 x 18 指定被手动加载的纸张尺寸。 Letter 是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 手动纸张类型 普通纸张 卡片纸 透明胶片 再生纸 标签 铜版纸 信签 预印纸 彩色纸 轻磅纸张 重磅纸张 粗糙/棉纸 自定义类型 [x] 指定手动加载的纸张类型。 “普通纸张”是出厂默认设置。 从“纸张”菜单将“配置多功能进纸器”设置为“手动”，以使“手动纸张类型”作为菜单出现。 手动信封尺寸 7 3/4 Envelope 9 Envelope 10 Envelope DL Envelope C5 Envelope B5 Envelope 其他信封 指定手动加载的信封尺寸。 10 Envelope 是美国的出厂默认设置。DL Envelope 是国际通用的出厂默认设置。 手动信封类型 信封 粗糙信封 自定义类型 [x] 指定手动加载的信封类型。 “信封”是出厂默认设置。 纸张尺寸/类型菜单 菜单 纸张尺寸/类型"},{"UUID":"4f01be7e-573a-450a-a3aa-298881b8d3b4","title":"纸张菜单","link":"paper-menu-group.html","desc":"“配置多功能进纸器”菜单 “配置多功能进纸器”菜单项及描述 使用 来 配置多功能进纸器","descFull":"“配置多功能进纸器”菜单 “配置多功能进纸器”菜单项及描述 使用 来 配置多功能进纸器 盒子 手动 首选 确定打印机何时选择多功能进纸器中的纸张。 “盒子”是出厂默认设置。“盒子”将多功能进纸器配置为自动纸张来源。 “手动”设置多功能进纸器仅用于手动进纸打印作业。 “首选”将多功能进纸器配置为第一个纸张来源。 配置多功能进纸器菜单 菜单 配置多功能进纸器"},{"UUID":"e72dbe5d-5624-41bf-bef0-d54e4ce8a42f","title":"纸张菜单","link":"paper-menu-group.html","desc":"“替换尺寸”菜单 “替换尺寸”菜单项及其描述 使用 来 替换尺寸","descFull":"“替换尺寸”菜单 “替换尺寸”菜单项及其描述 使用 来 替换尺寸 关 Statement/A5 Letter/A4 11 x 17/A3 所有列出的尺寸 如果请求的纸张尺寸不可用，用指定的纸张尺寸替换。 “所有列出的尺寸”是出厂默认设置。允许所有可用的替换。 设置尺寸替换让打印作业继续进行，而不会出现 更改纸张 。 替换尺寸菜单 菜单 替换尺寸"},{"UUID":"a2c7ef35-7a2f-4628-85bf-09f67a0c9e71","title":"纸张菜单","link":"paper-menu-group.html","desc":"“纸张纹理”菜单 “纸张纹理”菜单项及描述 使用 来 普通纸张纹理","descFull":"“纸张纹理”菜单 “纸张纹理”菜单项及描述 使用 来 普通纸张纹理 平滑 正常 粗糙 指定被加载的普通纸张的相对纹理。 “正常”是出厂默认设置。 卡片纸纹理 平滑 正常 粗糙 指定被加载的卡片纸的相对纹理。 “正常”是出厂默认设置。 此选项仅在卡片纸被支持时出现。 透明胶片纹理 平滑 正常 粗糙 指定被加载的透明胶片的相对纹理。 “正常”是出厂默认设置。 再生纸纹理 平滑 正常 粗糙 指定被加载的再生纸的相对纹理。 “正常”是出厂默认设置。 标签纹理 平滑 正常 粗糙 指定被加载的标签的相对纹理。 “正常”是出厂默认设置。 铜版纸纹理 平滑 正常 粗糙 指定被加载的铜版纸的相对纹理。 “粗糙”是出厂默认设置。 信封纹理 平滑 正常 粗糙 指定被加载的信封的相对纹理。 “正常”是出厂默认设置。 粗糙信封纹理 粗糙 指定被加载的粗糙信封的相对纹理。 信签纹理 平滑 正常 粗糙 指定被加载的信签的相对纹理。 “正常”是出厂默认设置。 预印纸纹理 平滑 正常 粗糙 指定被加载的预印纸的相对纹理。 “正常”是出厂默认设置。 彩色纸纹理 平滑 正常 粗糙 指定被加载的彩色纸的相对纹理。 “正常”是出厂默认设置。 轻磅纸张纹理 平滑 正常 粗糙 指定被加载的纸张的相对纹理。 “正常”是出厂默认设置。 重磅纸张纹理 平滑 正常 粗糙 指定被加载的纸张的相对纹理。 “正常”是出厂默认设置。 粗糙/棉纸纹理 粗糙 指定被加载的棉纸的相对纹理。 自定义 [x] 纹理 平滑 正常 粗糙 指定被加载的自定义纸张的相对纹理。 “正常”是出厂默认设置。 此选项仅在自定义类型被支持时出现。 纸张纹理菜单 菜单 纸张纹理"},{"UUID":"e1b38104-9c12-4d03-b1c6-dc7d2e4c6ac0","title":"纸张菜单","link":"paper-menu-group.html","desc":"“加载纸张”菜单 “加载纸张”菜单项及其描述 使用 来 “关”是所有“纸张加载”菜单选项的出厂默认设置。","descFull":"“加载纸张”菜单 “加载纸张”菜单项及其描述 使用 来 “关”是所有“纸张加载”菜单选项的出厂默认设置。 根据您的操作系统，“双面打印”将每一个打印作业的打印机默认值设置为两面打印，除非从“打印属性”或“打印”对话选择了一面打印。 加载卡片纸 双面打印 关 为所有使用“卡片纸”作为纸张类型的打印作业确定并设置双面打印。 加载再生纸 双面打印 关 为所有使用“再生纸”作为纸张类型的打印作业确定并设置双面打印。 加载光面纸 双面打印 关 为所有使用“光面纸”作为纸张类型的打印作业确定并设置双面打印。 加载重磅光面纸 双面打印 关 为所有使用“重磅光面纸”作为纸张类型的打印作业确定并设置双面打印。 加载标签 双面打印 关 为所有使用“标签”作为纸张类型的打印作业确定并设置双面打印。 加载铜版纸 双面打印 关 为所有使用“铜版纸”作为纸张类型的打印作业确定并设置双面打印。 加载信签 双面打印 关 为所有使用“信签”作为纸张类型的打印作业确定并设置双面打印。 加载预印纸 双面打印 关 为所有使用“预印纸”作为纸张类型的打印作业确定并设置双面打印。 加载彩色纸 双面打印 关 为所有使用“彩色纸”作为纸张类型的打印作业确定并设置双面打印。 加载轻磅纸张 双面打印 关 为所有使用“轻磅纸张”作为纸张类型的打印作业确定并设置双面打印。 加载重磅纸张 双面打印 关 为所有使用“重磅纸张”作为纸张类型的打印作业确定并设置双面打印。 加载粗糙/棉纸 双面打印 关 为所有使用“粗糙纸张”或“棉纸”作为纸张类型的打印作业确定并设置双面打印。 加载自定义 [x] 双面打印 关 为所有使用“自定义 [x]”作为纸张类型的打印作业确定并设置双面打印。 “加载自定义 [x]”仅在自定义类型被支持时可用。 加载纸张菜单 菜单 加载纸张"},{"UUID":"9dcad0d7-13fd-4325-bf7f-0d111ea24497","title":"纸张菜单","link":"paper-menu-group.html","desc":"“自定义类型”菜单 “自定义类型”菜单项及描述 使用 来 自定义类型","descFull":"“自定义类型”菜单 “自定义类型”菜单项及描述 使用 来 自定义类型 [x] 纸张 卡片纸 透明胶片 粗糙/棉纸 标签 信封 将纸张或特殊介质类型关联到出厂默认的自定义类型名称或者从 Embedded Web Server 或  MarkVision  Professional 中创建的用户定义的自定义名称。 将纸张或特殊介质类型关联到出厂默认的自定义类型名称或者从 Embedded Web Server 创建的用户定义的自定义名称。 “纸张”是出厂默认设置。 自定义介质类型必须被选定的进纸匣或多功能进纸器支持才能从该来源打印。 再生纸 纸张 卡片纸 透明胶片 粗糙/棉纸 标签 信封 当在其他菜单中选择“再生纸”时，指定纸张类型。 “纸张”是出厂默认设置。 自定义介质类型必须被选定的进纸匣或多功能进纸器支持才能从该来源打印。 自定义类型菜单 菜单 自定义类型"},{"UUID":"1af9c120-55b1-4ea1-9f31-99fbd7e25ae2","title":"纸张菜单","link":"paper-menu-group.html","desc":"“自定义名称”菜单 “自定义名称”菜单项及描述 使用 来 自定义名称","descFull":"“自定义名称”菜单 “自定义名称”菜单项及描述 使用 来 自定义名称 [x] 为纸张类型指定自定义名称。此名称在打印机菜单中替换“自定义类型 [x]”。 自定义名称菜单 菜单 自定义名称"},{"UUID":"c9a51a96-dae9-4ba9-b2d9-4e2bb476dae6","title":"纸张菜单","link":"paper-menu-group.html","desc":"“自定义扫描尺寸”菜单 “自定义扫描尺寸”菜单项和描述 使用 来 自定义扫描尺寸","descFull":"“自定义扫描尺寸”菜单 “自定义扫描尺寸”菜单项和描述 使用 来 自定义扫描尺寸 [x] 扫描尺寸名称 宽度 1–11.69 英寸（25–297 毫米） 高度 1–17 英寸（22–432 毫米） 方向 纵向 横向 每面两次扫描 关 开 指定自定义扫描尺寸名称、扫描尺寸和选项。在打印机菜单中，自定义扫描尺寸名称代替“自定义扫描尺寸 [x]”。 自定义扫描尺寸菜单 菜单 自定义扫描尺寸"},{"UUID":"84433c7b-516e-4430-8b49-cb59220dbb9f","title":"纸张菜单","link":"paper-menu-group.html","desc":"“自定义接纸架名称”菜单 “自定义接纸架名称”菜单项及描述 使用 来 标准接纸架","descFull":"“自定义接纸架名称”菜单 “自定义接纸架名称”菜单项及描述 使用 来 标准接纸架 为标准接纸架指定自定义名称。 接纸架 [x] 为“接纸架 [x]”指定自定义名称。 “自定义接纸架名称”菜单 菜单 自定义接纸架名称"},{"UUID":"afe7076e-7af9-4ef1-94b2-d0e658e7b9d8","title":"纸张菜单","link":"paper-menu-group.html","desc":"“Universal 设置”菜单 “Universal 设置”菜单项及其描述 使用","descFull":"“Universal 设置”菜单 “Universal 设置”菜单项及其描述 使用 来 度量单位 英寸 毫米 指定度量单位。 “英寸”是美国的出厂默认设置。 “毫米”是国际通用的出厂默认设置。 纵向宽度 3.54–48 英寸 89.9–1219 毫米 设置纵向宽度。 如果宽度超过最大值，打印机将使用允许的最大宽度。 12 英寸是美国的出厂默认设置。您可以以 0.01 英寸为增量增加宽度。 305 毫米是国际通用的出厂默认设置。您可以以 1 毫米为增量增加宽度。 纵向高度 5.5–48 英寸 139.7–1219 毫米 设置纵向高度。 如果高度超过最大值，打印机将使用允许的最大高度。 17 英寸是美国的出厂默认设置。您可以以 0.01 英寸为增量增加高度。 432 毫米是国际通用的出厂默认设置。您可以以 1 毫米为增量增加高度。 进纸方向 短边 长边 如果可以按任一方向加载纸张，则指定进纸方向。 “短边”是出厂默认设置。 “长边”仅在最长边小于进纸匣中支持的最大宽度时出现。 Universal 设置菜单 菜单 Universal 设置"},{"UUID":"4f6e47a5-3a5e-4be6-ae2b-d192b91a8ed7","title":"纸张菜单","link":"paper-menu-group.html","desc":"“接纸架设置”菜单 “接纸架设置”菜单项及其描述 使用 来 *","descFull":"“接纸架设置”菜单 “接纸架设置”菜单项及其描述 使用 来 * 如果安装了适当的接纸架选件，[x] 可以是从 1 到 4 的任何数字。如果多个接纸架被分配了相同的名称，该名称在接纸架列表中只出现一次。 接纸架 标准接纸架 接纸架 [x]* 指定默认的接纸架。 “标准接纸架”是出厂默认设置。 配置接纸架 邮箱 连接 连接选件 类型分配 指定接纸架的配置选项。 “邮箱”是出厂默认设置。这将每一个接纸架视为单独的邮箱。 “连接”将所有可用的接纸架配置为一个大的接纸架。 “连接选件”将除标准接纸架之外的所有可用接纸架连接在一起，并且此设置仅在至少安装了两个接纸架选件时才出现。 “类型分配”将每一种纸张类型分配给一个接纸架或已连接的接纸架组。 溢出接纸架 标准接纸架 接纸架 [x]* 指定当指定接纸架装满时的备用接纸架。 此菜单仅在接纸架选件已安装时出现。 “标准接纸架”是出厂默认设置。 分配类型/接纸架 普通纸张接纸架 卡片纸接纸架 透明胶片接纸架 再生纸接纸架 光面纸接纸架 重磅光面纸接纸架 标签接纸架 铜版纸接纸架 信封接纸架 粗糙信封接纸架 信签接纸架 预印纸接纸架 彩色纸接纸架 轻磅纸张接纸架 重磅纸张接纸架 粗糙/棉纸接纸架 自定义 [x] 接纸架 为每一种支持的纸张类型选择接纸架。 对于每一种类型，请从下列选项中选择： 禁用 标准接纸架 接纸架 [x]* “禁用”是出厂默认设置。 “接纸架设置”菜单 菜单 接纸架设置"},{"UUID":"f951e748-4813-4dd4-a25a-e1a91229878c","title":"报告菜单","link":"reports-group.html","desc":"“报告”菜单 “报告”菜单项及其描述 使用 来 菜单设置页","descFull":"“报告”菜单 “报告”菜单项及其描述 使用 来 菜单设置页 打印包含有关进纸匣中加载的纸张、已安装内存、总页数、警报设置、超时、控制面板语言、TCP/IP 地址、耗材状态、网络连接状态的信息以及其他信息的报告。 设备统计 打印包含打印机统计信息，例如耗材信息和已打印页数的报告。 装订器测试 打印报告，确认装订完成器工作正常。 此菜单项仅在支持的装订完成器已安装时出现。 网络设置页 打印包含有关网络打印机设置信息，例如 TCP/IP 地址信息的报告。 此菜单项仅在网络打印机或连接到打印服务器的打印机中出现。 网络 [x] 设置页 打印包含有关网络打印机设置信息，例如 TCP/IP 地址信息的报告。 此菜单项仅在网络打印机或连接到打印服务器的打印机中，并且安装了多个网络选件时出现。 快捷方式列表 打印包含有关已配置的快捷方式信息的报告。 传真作业日志 打印包含有关最近 200 个已完成传真的信息的报告。 此菜单项仅在“传真设置”菜单中的“启用作业日志”被设置为“开”时出现。 传真呼叫日志 打印包含有关最近 100 个已尝试、已接收和已阻止呼叫的信息的报告。 此菜单项仅在“传真设置”菜单中的“启用作业日志”被设置为“开”时出现。 复印快捷方式 打印包含有关复印快捷方式信息的报告。 电子邮件快捷方式 打印包含有关电子邮件快捷方式信息的报告。 传真快捷方式 打印包含有关传真快捷方式信息的报告。 FTP 快捷方式 打印包含有关 FTP 快捷方式信息的报告。 配置文件列表 打印存储在打印机中的配置文件列表。 打印字体 打印可用于打印机中当前设置的打印机语言的所有字体的报告。 打印目录 打印存储在闪存卡选件或打印机硬盘上的所有资源列表。 “作业缓冲区大小”必须设置为 100%。 请确认闪存或硬盘正在工作，并且安装正确。 资产报告 打印包含资产信息，包括打印机序列号和型号名称的报告。 报告菜单 菜单 报告"},{"UUID":"d91b8043-1969-49e7-9dce-c3ca2e036644","title":"网络/端口菜单","link":"network-ports-group.html","desc":"“活动 NIC”菜单 “活动 NIC”菜单项及描述 使用","descFull":"“活动 NIC”菜单 “活动 NIC”菜单项及描述 使用 来 活动 NIC 自动 [可用网卡的列表] 允许打印机连接到网络。 “自动”是出厂默认设置。 此菜单项仅在网络适配器选件已安装时出现。 活动 NIC 菜单 菜单 活动 NIC"},{"UUID":"6ddfe622-dcba-44ef-aab1-b644d235f6a5","title":"网络/端口菜单","link":"network-ports-group.html","desc":"标准网络或网络 [x] 菜单 只有活动端口出现在此菜单中。 “标准网络”或“网络","descFull":"标准网络或网络 [x] 菜单 只有活动端口出现在此菜单中。 “标准网络”或“网络 [x]”菜单项及其描述 使用 来 能效以太网 启用 禁用 当打印机没有从以太网络接收数据时降低功耗。 “启用”是出厂默认设置。 PCL 智能切换 开 关 设置打印机在打印作业需要 PCL 仿真时自动切换到 PCL 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 如果“PCL 智能切换”被禁用，打印机不检查发来的数据，它将使用在“设置”菜单中指定的默认打印机语言。 PS 智能切换 开 关 设置打印机在打印作业需要 PS 仿真时自动切换到 PS 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 如果“PS 智能切换”被禁用，打印机不检查发来的数据，它将使用在“设置”菜单中指定的默认打印机语言。 NPA 模式 关 自动 设置打印机按照 NPA 协议定义的惯例执行双向通信所要求的特殊处理。 “自动”是出厂默认设置。 当从控制面板更改设置时，打印机自动重新启动。 网络缓冲区 自动 3KB 至 [允许的最大值] 设置网络输入缓冲区的大小。 “自动”是出厂默认设置。 允许的最大值由打印机中的内存数量，其他连接缓冲区的大小，以及“资源保存”是设置为“开”还是“关”决定。 要增加网络缓冲区的最大值，可禁用并口、串口和 USB 缓冲区或减小它们的大小设置值。 当从控制面板更改设置时，打印机自动重新启动。 作业缓存 关 开 自动 在打印前将打印作业暂时保存在打印机硬盘上。此菜单仅在已格式化的硬盘已安装时出现。 “关”是出厂默认设置。 当从控制面板更改设置时，打印机自动重新启动。而且菜单选择被更新。 Mac 二进制 PS 开 关 自动 设置打印机处理 Macintosh 二进制 PostScript 打印作业。 “自动”是出厂默认设置。 标准网络设置或网络 [x] 设置 报告 网卡 TCP/IP IPv6 无线 AppleTalk 显示和设置打印机网络设置。 “无线”菜单仅在打印机连接到无线网络时出现。 标准网络菜单 网络 [x] 菜单 菜单 标准网络 菜单 网络 [x]"},{"UUID":"0d35ffd1-7603-48fb-b43f-e4d984cac011","title":"网络/端口菜单","link":"network-ports-group.html","desc":"“报告”菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络 标准网络设置","descFull":"“报告”菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络 标准网络设置 报告 网络/端口 网络 [x] 网络 [x] 设置 报告 “报告”菜单项及其描述 使用 来 打印设置页 打印包含有关网络打印机设置信息，例如 TCP/IP 地址的报告。 网络报告菜单 菜单 网络报告"},{"UUID":"f3529a91-8e44-4ac4-b5dc-f01804b7eea5","title":"网络/端口菜单","link":"network-ports-group.html","desc":"“网卡”菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络 标准网络设置","descFull":"“网卡”菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络 标准网络设置 网卡 网络/端口 网络 [x] 网络 [x] 设置 网卡 “网卡”菜单项及其描述 使用 来 查看网卡状态 已连接 未连接 查看无线网络适配器的连接状态。 查看网卡速度 查看活动的无线网络适配器的速度。 网络地址 UAA LAA 查看网络地址。 作业超时 0，10–225 秒 设置取消网络打印作业所需的时间。 “90 秒”是出厂默认设置。 设置值为 0 将禁用超时。 如果选择 1 至 9 之间的值，显示屏上会出现 无效 ，并且不保存该值。 标题页 关 开 允许打印机打印标题页。 “关”是出厂默认设置。 网卡菜单 菜单 网卡"},{"UUID":"833163e9-36ce-4345-a1c5-0c041b36c725","title":"网络/端口菜单","link":"network-ports-group.html","desc":"TCP/IP 菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络","descFull":"TCP/IP 菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络 标准网络设置 TCP/IP 网络/端口 网络 [x] 网络 [x] 设置 TCP/IP 此菜单仅在网络打印机或连接到打印服务器的打印机中可用。 TCP/IP 菜单项及描述 使用 来 设置主机名 设置当前的 TCP/IP 主机名。 这只能从 Embedded Web Server 进行更改。 IP 地址 查看或更改当前的 TCP/IP 地址。 手动设置 IP 地址将“启用 DHCP”和“启用自动 IP”设置为“关”。它在支持 BOOTP 和 RARP 的系统上也将“启用 BOOTP”和“启用 RARP”设置为“关”。 掩码 查看或更改当前的 TCP/IP 网络掩码。 网关 查看或更改当前的 TCP/IP 网关。 启用 DHCP 开 关 指定 DHCP 地址和参数分配。 “开”是出厂默认设置。 启用 RARP 开 关 指定 RARP 地址分配设置。 “关”是出厂默认设置。 启用 BOOTP 开 关 指定 BOOTP 地址分配设置。 “开”是出厂默认设置。 启用 AutoIP 是 否 指定“零配置网络连接”设置。 “是”为出厂默认设置。 启用 FTP/TFTP 是 否 启用内置的 FTP 服务器，让您使用文件传输协议将文件发送给打印机。 “是”为出厂默认设置。 启用 HTTP 服务器 是 否 启用内置的 Web 服务器（Embedded Web Server）。当启用后，能够使用 Web 浏览器来远程监视和管理打印机。 “是”为出厂默认设置。 WINS 服务器地址 查看或更改当前的 WINS 服务器地址。 启用 DDNS 是 否 查看或更改当前的 DDNS 设置。 “是”为出厂默认设置。 启用 mDNS 是 否 查看或更改当前的 mDNS 设置。 “是”为出厂默认设置。 DNS 服务器地址 查看或更改当前的 DNS 服务器地址。 备份 DNS 服务器地址 查看或更改备份的 DNS 服务器地址。 备份 DNS 服务器地址 2 备份 DNS 服务器地址 3 启用 HTTPS 是 否 查看或更改当前的 HTTPS 设置。 “是”为出厂默认设置。 设置 TCP/IP 地址 TCP/IP 菜单 菜单 TCP/IP"},{"UUID":"444eafe3-b90a-4c73-a47a-8af6e64d2d3e","title":"网络/端口菜单","link":"network-ports-group.html","desc":"IPv6 菜单 要访问此菜单，请导览至下面任意项： “网络/端口”菜单 标准网络","descFull":"IPv6 菜单 要访问此菜单，请导览至下面任意项： “网络/端口”菜单 标准网络 标准网络设置 IPv6 “网络/端口”菜单 网络 [x] 网络 [x] 设置 IPv6 此菜单仅在网络打印机或连接到打印服务器的打印机中可用。 IPV6 菜单项及描述 使用 来 启用 IPv6 开 关 在打印机中启用 IPv6。 “开”是出厂默认设置。 自动配置 开 关 指定网络适配器是否接受由路由器提供的自动 IPv6 地址配置输入项。 “开”是出厂默认设置。 设置主机名 设置主机名。 这些设置只能从 Embedded Web Server 更改。 查看地址 查看路由器地址 启用 DHCPv6 开 关 在打印机中启用 DHCPv6。 “开”是出厂默认设置。 IPv6 菜单 菜单 IPv6"},{"UUID":"57d12fdc-e2d1-4f5d-a50d-50016008a836","title":"网络/端口菜单","link":"network-ports-group.html","desc":"“无线”菜单  此菜单仅在连接到无线网络的打印机或者有无线网络适配器的打印机型号中可用。 要访问菜单，请导览至： 网络/端口 网络","descFull":"“无线”菜单  此菜单仅在连接到无线网络的打印机或者有无线网络适配器的打印机型号中可用。 要访问菜单，请导览至： 网络/端口 网络 [x] 网络 [x] 设置 无线 “无线”菜单项及其描述 使用 来 Wi‑Fi 保护设置 启动按按钮方法 启动 PIN 方法 建立无线网络并启用网络安全。 “启动按按钮方法”在给定时间段内按打印机和访问点（无线路由器）上的按钮来将打印机连接到无线网络。 “启动 PIN 方法”在将打印机上的 PIN 码输入到访问点的无线设置中时将打印机连接到无线网络。 启用/禁用 WPS 自动检测 启用 禁用 自动检测带 WPS 的访问点使用的连接方法—“启动按按钮方法”或“启动 PIN 方法”。 “禁用”是出厂默认设置。 网络模式 BSS 类型 Infrastructure Ad hoc 指定网络模式。 Infrastructure 是出厂默认设置。它让打印机使用访问点来访问网络。 Ad hoc 直接配置打印机和计算机之间的无线连接。 兼容性 802.11b/g 802.11b/g/n 指定无线网络的无线标准。 802.11b/g/n 是出厂默认设置。 选择网络 选择打印机可使用的网络。 查看信号质量 查看无线连接的质量。 查看安全模式 查看无线网络的加密方法。 无线菜单 菜单 无线"},{"UUID":"1d78cf46-38fa-47e2-94f8-cf8161ed6e3e","title":"网络/端口菜单","link":"network-ports-group.html","desc":"AppleTalk 菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络","descFull":"AppleTalk 菜单 要访问此菜单，请导览至下面任一项： 网络/端口 标准网络 标准网络设置 AppleTalk 网络/端口 网络 [x] 网络 [x] 设置 AppleTalk AppleTalk 菜单项及其描述 使用 来 激活 是 否 启用或禁用 AppleTalk 支持。 “否”是出厂默认设置。 查看名称 显示已分配的 AppleTalk 名称。 AppleTalk 名称只能从 Embedded Web Server 进行更改。 查看地址 显示已分配的 AppleTalk 地址。 AppleTalk 地址只能从 Embedded Web Server 进行更改。 设置域 [网络上可用的域列表] 提供一份网络上可用的 AppleTalk 域列表。 网络的默认域是出厂默认设置。 AppleTalk 菜单 菜单 AppleTalk"},{"UUID":"6f1520a0-00aa-4460-ba87-84305a27eee5","title":"网络/端口菜单","link":"network-ports-group.html","desc":"“标准 USB”菜单 “标准 USB”菜单项及描述 使用","descFull":"“标准 USB”菜单 “标准 USB”菜单项及描述 使用 来 PCL 智能切换 开 关 设置打印机在一项通过 USB 端口接收的打印作业需要 PCL 仿真时自动切换到 PCL 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 当设置为“关”时，打印机不检查接收的数据。如果“PS 智能切换”设置为“开”，打印机将使用 PostScript 仿真。如果“PS 智能切换”设置为“关”，打印机将使用“设置”菜单中指定的默认打印机语言。 PS 智能切换 开 关 设置打印机在一项通过 USB 端口接收的打印作业需要 PS 仿真时自动切换到 PS 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 当设置为“关”时，打印机不检查接收的数据。如果“PCL 智能切换”设置为“开”，打印机将使用 PCL 仿真。如果“PCL 智能切换”设置为“关”，打印机将使用“设置”菜单中指定的默认打印机语言。 NPA 模式 开 关 自动 设置打印机按照 NPA 协议定义的惯例执行双向通信所要求的特殊处理。 “自动”是出厂默认设置。“自动”设置打印机检查数据，确定格式，然后适当地处理它。 当从打印机控制面板更改设置时，打印机自动重新启动。而且菜单选择被更新。 USB 缓冲区 禁用 自动 3K 至 [允许的最大值] 设置 USB 输入缓冲区的大小。 “自动”是出厂默认设置。 “禁用”关闭作业缓存。在恢复正常的处理之前，任何已经缓存到打印机硬盘上的作业被打印出来。 USB 缓冲区大小的值可以以 1K 为单位进行调整。 允许的最大值由打印机中的内存数量，其他连接缓冲区的大小，以及“资源保存”是设置为“开”还是“关”决定。 要增加 USB 缓冲区的最大值，可禁用并口、串口和网络缓冲区或减小它们的大小设置值。 当从打印机控制面板更改设置时，打印机自动重新启动。而且菜单选择被更新。 作业缓存 关 开 自动 在打印前将打印作业暂时保存在打印机硬盘上。 “关”是出厂默认设置。 “开”将作业缓存到打印机硬盘上。 “自动”仅在打印机忙于处理从其他输入端口接收的数据时，才缓存打印作业。 从打印机控制面板更改此设置，然后退出菜单会使打印机重新启动。而且菜单选择被更新。 Mac 二进制 PS 开 关 自动 设置打印机处理 Macintosh 二进制 PostScript 打印作业。 “自动”是出厂默认设置。 “开”处理原始的二进制 PostScript 打印作业。 “关”使用标准协议来过滤打印作业。 ENA 地址 yyy.yyy.yyy.yyy 设置外置式打印服务器的网络地址信息。 此菜单仅在打印机通过 USB 端口连接到外置式打印服务器时可用。 ENA 掩码 yyy.yyy.yyy.yyy 设置外置式打印服务器的网络掩码信息。 此菜单仅在打印机通过 USB 端口连接到外置式打印服务器时可用。 ENA 网关 yyy.yyy.yyy.yyy 设置外置式打印服务器的网关信息。 此菜单仅在打印机通过 USB 端口连接到外置式打印服务器时可用。 标准 USB 菜单 菜单 标准 USB"},{"UUID":"aac53293-b849-4569-ad00-e8008f3eddc5","title":"网络/端口菜单","link":"network-ports-group.html","desc":"“并口 [x]”菜单 此菜单仅在并口卡选件已安装时出现。 “并口 [x]”菜单项及描述","descFull":"“并口 [x]”菜单 此菜单仅在并口卡选件已安装时出现。 “并口 [x]”菜单项及描述 使用 来 PCL 智能切换 开 关 设置打印机在一项通过并口接收的打印作业需要 PCL 仿真时自动切换到 PCL 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 当设置为“关”时，打印机不检查接收的数据。如果“PS 智能切换”设置为“开”，打印机将使用 PostScript 仿真。如果“PS 智能切换”设置为“关”，打印机将使用“设置”菜单中指定的默认打印机语言。 PS 智能切换 开 关 设置打印机在一项通过并口接收的打印作业需要 PS 仿真时自动切换到 PS 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 当设置为“关”时，打印机不检查接收的数据。如果“PCL 智能切换”设置为“开”，打印机将使用 PCL 仿真。如果“PCL 智能切换”设置为“关”，打印机将使用“设置”菜单中指定的默认打印机语言。 NPA 模式 开 关 自动 设置打印机按照 NPA 协议定义的惯例执行双向通信所要求的特殊处理。 “自动”是出厂默认设置。 从打印机控制面板更改此设置，然后退出菜单会使打印机重新启动。而且菜单选择被更新。 并口缓冲区 禁用 自动 3K 至 [允许的最大值] 设置并口输入缓冲区的大小。 “自动”是出厂默认设置。 “禁用”关闭作业缓存。在恢复正常的处理之前，任何已经缓存到打印机硬盘上的打印作业被打印出来。 并口缓冲区大小设置可以以 1KB 为单位进行调整。 允许的最大值由打印机中的内存数量，其他连接缓冲区的大小，以及“资源保存”是设置为“开”还是“关”决定。 要增加并口缓冲区的最大值，可禁用 USB、串口和网络缓冲区或减小它们的大小设置值。 从打印机控制面板更改此设置，然后退出菜单会使打印机重新启动。而且菜单选择被更新。 作业缓存 关 开 自动 在打印前将打印作业暂时保存在打印机硬盘上。 “关”是出厂默认设置。 “开”将打印作业缓存到打印机硬盘上。 “自动”仅在打印机忙于处理从其他输入端口接收的数据时，才缓存打印作业。 从打印机控制面板更改此设置，然后退出菜单会使打印机重新启动。而且菜单选择被更新。 高级状态 开 关 启用通过并口的双向通信。 “开”是出厂默认设置。 “关”禁用并口数据流通。 协议 标准 快速字节 指定并口协议。 “快速字节”是出厂默认设置。它提供与大多数现有并口的兼容性并且是推荐设置。 “标准”尝试解决并口通信问题。 承认初始化 开 关 确定打印机是否承认来自计算机的打印机硬件初始化请求。 “关”是出厂默认设置。 计算机通过从并口激活初始化信号来请求初始化。许多个人计算机每次开机时都激活初始化信号。 并行模式 2 开 关 确定并口数据是在脉冲波形的上升沿还是下降沿被采样。 “开”是出厂默认设置。 Mac 二进制 PS 开 关 自动 设置打印机处理 Macintosh 二进制 PostScript 打印作业。 “自动”是出厂默认设置。 “关”使用标准协议来过滤打印作业。 “开”处理原始的二进制 PostScript 打印作业。 ENA 地址 yyy.yyy.yyy.yyy 设置外置式打印服务器的网络地址信息。 此菜单项仅在打印机通过 USB 端口连接到外置式打印服务器时可用。 ENA 掩码 yyy.yyy.yyy.yyy 设置外置式打印服务器的网络掩码信息。 此菜单项仅在打印机通过 USB 端口连接到外置式打印服务器时可用。 ENA 网关 yyy.yyy.yyy.yyy 设置外置式打印服务器的网关信息。 此菜单项仅在打印机通过 USB 端口连接到外置式打印服务器时可用。 并口 [x] 菜单 菜单 并口 [x]"},{"UUID":"51c44fa7-b583-4b86-85c8-858c7489d177","title":"网络/端口菜单","link":"network-ports-group.html","desc":"串口 [x] 菜单 此菜单仅在串口卡选件已安装时出现。 “串口","descFull":"串口 [x] 菜单 此菜单仅在串口卡选件已安装时出现。 “串口 [x]”菜单项及描述 使用 来 PCL 智能切换 开 关 设置打印机在一项通过串口接收的打印作业需要 PCL 仿真时自动切换到 PCL 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 当设置为“关”时，打印机不检查接收的数据。如果“PS 智能切换”设置为“开”，打印机将使用 PostScript 仿真。如果“PS 智能切换”设置为“关”，打印机将使用“设置”菜单中指定的默认打印机语言。 PS 智能切换 开 关 设置打印机在一项通过串口接收的打印作业需要 PS 仿真时自动切换到 PS 仿真，而不管默认的打印机语言是什么。 “开”是出厂默认设置。 当设置为“关”时，打印机不检查接收的数据。如果“PCL 智能切换”设置为“开”，打印机将使用 PCL 仿真。如果“PCL 智能切换”设置为“关”，打印机将使用“设置”菜单中指定的默认打印机语言。 NPA 模式 开 关 自动 设置打印机按照 NPA 协议定义的惯例执行双向通信所要求的特殊处理。 “自动”是出厂默认设置。“自动”设置打印机检查数据，确定格式，然后适当地处理它。 当设置为“开”时，打印机执行 NPA 处理。如果数据不是 NPA 格式，它将被当作坏数据拒绝。 当设置为“关”时，打印机不执行 NPA 处理。 从打印机控制面板更改此设置，然后退出菜单会使打印机重新启动。而且菜单选择被更新。 串口缓冲区 禁用 自动 3K 至 [允许的最大值] 设置串口输入缓冲区的大小。 “自动”是出厂默认设置。 “禁用”关闭作业缓存。在恢复正常的处理之前，任何已经缓存到磁盘上的作业都被打印出来。 串口缓冲区大小设置可以以 1KB 为单位进行调整。 允许的最大值由打印机中的内存数量，其他连接缓冲区的大小，以及“资源保存”是设置为“开”还是“关”决定。 要增加串口缓冲区的最大值，可禁用并口、USB 和网络缓冲区或减小它们的大小设置值。 从打印机控制面板更改此设置，然后退出菜单会使打印机重新启动。而且菜单选择被更新。 作业缓存 关 开 自动 在打印前将打印作业暂时保存在打印机硬盘上。 “关”是出厂默认设置。打印机不将打印作业缓存到打印机硬盘上。 “开”将打印作业缓存到打印机硬盘上。 “自动”仅在打印机忙于处理从其他输入端口接收的数据时，才缓存打印作业。 从打印机控制面板更改此设置，然后退出菜单会使打印机重新启动。而且菜单选择被更新。 协议 DTR DTR/DSR XON/XOFF XON/XOFF/DTR XONXOFF/DTRDSR 为串口选择硬件和软件信号交换设置。 DTR 是出厂默认设置。 DTR/DSR 是硬件信号交换设置。 XON/XOFF 是软件信号交换设置。 XON/XOFF/DTR 和 XON/XOFF/DTR/DSR 是组合的硬件和软件信号交换设置。 鲁棒性 XON 开 关 确定打印机是否向计算机传达有效性。 “关”是出厂默认设置。 如果“串口协议”设置为 XON/XOFF，此菜单项只适用于串行端口。 波特率 1200 2400 4800 9600 19200 38400 57600 115200 138200 172800 230400 345600 指定能够通过串口接收数据的速率。 9600 是出厂默认设置。 波特率 138200、172800、230400 和 345600 只在“标准串口”菜单中显示。这些设置不在“串口选件 1”、“串口选件 2”或“串口选件 3”菜单中出现。 数据位数 7 8 指定在每一个传输帧中传送的数据位数。 8 是出厂默认设置。 奇偶校验 偶校验 奇校验 无 忽略 为串行输入和输出的数据帧设置奇偶校验。 “无”是出厂默认设置。 承认 DSR 开 关 确定打印机是否使用 DSR 信号。 “关”是出厂默认设置。 DSR 是一个握手信号，用于大多数串口电缆。串口使用 DSR 来区分数据是计算机发送的，还是串口电缆上的电流噪声引起的。这种电流噪声会导致打印杂散字符。将此项设置为“开”来防止打印杂散字符。 串口 [x] 菜单 菜单 串口 [x]"},{"UUID":"54eb6aa6-a717-49ee-b1cb-4e43750a8e20","title":"网络/端口菜单","link":"network-ports-group.html","desc":"“SMTP 设置”菜单 “SMTP 设置”菜单项及其描述 使用","descFull":"“SMTP 设置”菜单 “SMTP 设置”菜单项及其描述 使用 来 主要 SMTP 网关 指定 SMTP 服务器网关和端口信息。 25 是默认的 SMTP 网关端口。 主要 SMTP 网关端口 次要 SMTP 网关 次要 SMTP 网关端口 SMTP 超时 5–30 以秒为单位指定在服务器停止尝试发送电子邮件之前的时间。 30 秒是出厂默认设置。 答复地址 指定在打印机发送的电子邮件中最多 128 个字符的答复地址。 使用 SSL 禁用 协商 必需 设置打印机在连接到 SMTP 服务器时使用 SSL 来增加安全性。 “禁用”是出厂默认设置。 当使用“协商”设置时，SMTP 服务器决定是否将使用 SSL。 SMTP 服务器验证 不要求验证 注册/简单 CRAM‑MD5 Digest‑MD5 NTLM Kerberos 5 指定扫描到电子邮件权限所要求的用户验证类型。 “不要求验证”是出厂默认设置。 设备启动的电子邮件 无 使用设备 SMTP 凭证 指定当与 SMTP 服务器通信时，将使用哪些凭证。一些 SMTP 服务器要求凭证才能发送电子邮件。 “无”是“设备启动的电子邮件”和“用户启动的电子邮件”的出厂默认设置。 当“使用设备 SMTP 凭证”被选定时，“设备用户 ID”和“设备密码”被用于注册到 SMTP 服务器。 用户启动的电子邮件 * 无 使用设备 SMTP 凭证 使用会话用户 ID 和密码 使用会话电子邮件地址和密码 提示用户 设备用户 ID 设备密码 Kerberos 5 域 NTLM 域 SMTP 设置菜单 菜单 SMTP 设置"},{"UUID":"d25cedb3-0476-40d8-becb-ad8d930242a1","title":"安全菜单","link":"security-menus-group.html","desc":"“编辑安全设置”菜单 “编辑安全设置”菜单项及其描述 使用 来 编辑备份密码","descFull":"“编辑安全设置”菜单 “编辑安全设置”菜单项及其描述 使用 来 编辑备份密码 使用备份密码 关 开 密码 创建备份密码。 “关”是“使用备份密码”的出厂默认设置。 此菜单项仅在存在备份密码时出现。 编辑组件模块 内部帐户 NTLM 简单 Kerberos 设置 Kerberos 设置 Active Directory LDAP LDAP+GSSAPI 密码 PIN 码 编辑“内部帐户”、NTLM、“简单 Kerberos 设置”、“Kerberos 设置”、Active Directory、LDAP、“密码”和“PIN 码”的设置。 编辑安全模板 [可用模板列表] 添加或编辑安全模板。 编辑访问控制 管理菜单 功能访问 应用程序配置 管理 解决方案 在设备上取消作业 控制对打印机菜单、固件更新、挂起作业和其他访问点的访问。 编辑安全设置菜单 菜单 编辑安全设置"},{"UUID":"0eaf361f-aa3f-458a-bebc-91082b5afb93","title":"安全菜单","link":"security-menus-group.html","desc":"“混合安全设置”菜单 “混合安全设置”菜单项及其描述 使用 来 登录限制","descFull":"“混合安全设置”菜单 “混合安全设置”菜单项及其描述 使用 来 登录限制 登录失败 失败时间期限  锁定时间 面板登录超时 远程登录超时 限制在 所有 用户被锁定之前，尝试在打印机控制面板上登录的失败次数和时间期限。 “登录失败”指定在用户被锁定之前尝试登录失败的次数。设置范围从 1 到 10 次尝试。“3 次尝试”是出厂默认设置。 “失败时间期限”指定在此期间内，当用户被锁定之前能够尝试登录失败的时间期限。设置范围从 1 到 60 分钟。“5 分钟”是出厂默认设置。 “锁定时间”指定用户在超过登录失败的限制后被锁定的持续时间。设置范围从 1 到 60 分钟。“5 分钟”是出厂默认设置。1 表示打印机不实行锁定。 “面板登录超时”指定在自动注销用户之前打印机在主屏幕上保持空闲的持续时间。设置范围从 1 到 900 秒。“30 秒”是出厂默认设置。 “远程登录超时”指定在自动注销用户之前远程接口保持空闲的持续时间。设置范围从 1 到 120 分钟。“10 分钟”是出厂默认设置。 安全复位跳线 无影响 访问控制 = “无安全性” 重置出厂安全默认值 调整安全设置。 “无影响”表示重置对打印机的安全配置没有影响。 “访问控制 = ‘无安全性’”保留所有用户已经定义的安全信息。“无安全性”是出厂默认设置。 “重置出厂安全默认值”删除所有用户已定义的安全信息，并还原“混合安全”菜单中的出厂默认设置。 LDAP 证书检验 要求 尝试 允许 从不 允许用户请求服务器证书。 “要求”是出厂默认设置。这表示服务器证书被请求。如果提供坏证书或无证书提供，会话将被立即终止。 “尝试”表示服务器证书被请求。如果无证书提供，会话继续正常进行。如果提供坏证书，会话将被立即终止。 “允许”表示服务器证书被请求。如果无证书提供，会话继续正常进行。如果提供坏证书，它将被忽略并且会话继续正常进行。 “从不”表示没有服务器证书被请求。 最小 PIN 码长度 1–16 限制个人身份识别码（PIN）的位数。 4 是出厂默认设置。 混合安全设置菜单 菜单 混合安全设置"},{"UUID":"8f2b2d6f-dbfb-4aa5-b6ba-d3c52cc52ba5","title":"安全菜单","link":"security-menus-group.html","desc":"“保密打印”菜单 “保密打印”菜单项及其描述 使用 来 “关”是出厂默认设置。","descFull":"“保密打印”菜单 “保密打印”菜单项及其描述 使用 来 “关”是出厂默认设置。 最多无效 PIN 码 关 2–10 设置能够输入无效 PIN 码的次数限制。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 当达到限制时，对应于该用户名和 PIN 码的打印作业将被删除。 保密打印有效期 关 1 小时 4 小时 24 小时 1 周 设置打印机保存保密打印作业的时间限制。 如果在保密打印作业驻留在打印机内存或打印机硬盘中时更改“保密作业有效期”设置，那些打印作业的有效期时间不会更改为新的默认值。 如果关闭打印机电源，保留在打印机内存中的所有保密作业会被删除。 重复作业有效期 关  1 小时 4 小时 24 小时 1 周 设置打印机保存打印作业的时间限制。 校验作业有效期 关 1 小时 4 小时 24 小时 1 周 设置打印机保存需要校验的打印作业的时间限制。 保留作业有效期 关 1 小时 4 小时 24 小时 1 周 设置打印机保存打印作业用于稍后打印的时间限制。 保密打印菜单 菜单 保密打印"},{"UUID":"fca6468d-d877-4405-838f-791c54c3f467","title":"安全菜单","link":"security-menus-group.html","desc":"清除临时数据文件菜单 清除临时数据文件 仅 删除打印机硬盘上当前 未","descFull":"清除临时数据文件菜单 清除临时数据文件 仅 删除打印机硬盘上当前 未 被文件系统使用的打印作业数据。打印机硬盘上的所有永久数据都被保留，例如下载字体、宏和挂起作业。 此菜单仅在已格式化并工作的打印机硬盘已安装时出现。 “清除临时数据文件”菜单项及其描述 使用 来 擦除模式 自动 指定清除临时数据文件的模式。 自动方法 单通道 多通道 标记被之前的打印作业使用的所有磁盘空间。这种方法不允许文件系统在此空间被清除之前重用它。 “单通道”是出厂默认设置。 只有“自动擦除”让用户可以清除临时数据文件，而无需让打印机长时间关机。 高度保密信息应该 仅 使用“多通道”方法来清除。 清除临时数据文件菜单 菜单 清除临时数据文件"},{"UUID":"09f6c007-1aec-444e-a7b3-ae6b332886a2","title":"安全菜单","link":"security-menus-group.html","desc":"“安全审核日志”菜单 “安全审核日志”菜单项及其描述 使用 来 导出日志","descFull":"“安全审核日志”菜单 “安全审核日志”菜单项及其描述 使用 来 导出日志 让授权用户能够导出安全日志。 要从打印机控制面板导出日志，请在打印机上安装闪存驱动器。 要从 Embedded Web Server 导出日志，请将日志下载到计算机。 删除日志 是 否 指定是否删除审核日志。 配置日志 启用审核 是 否 启用远程 Syslog 否 是 远程 Syslog 服务器 [256 个字符的字符串] 远程 Syslog 端口 1–65535 远程 Syslog 方法 正常 UDP Stunnel 远程 Syslog 工具 0–23 日志已满行为 打包最旧的输入项 电邮日志，然后删除所有输入项 指定如何配置审核日志。 “启用审核”确定是否将事件记录在安全审核日志和远程 syslog 中。“否”是出厂默认设置。 “启用远程 Syslog”确定是否将日志发送到远程服务器。“否”是出厂默认设置。 “远程 Syslog 服务器”确定用于发送日志到远程 syslog 服务器的值。 “远程 Syslog 端口”识别打印机将已记录事件发送到远程服务器所在的端口。 “远程 Syslog 方法”识别打印机将已记录事件发送给远程服务器所使用的协议。“正常 UDP”是出厂默认设置。 “远程 Syslog 工具”确定打印机在发送事件给远程 syslog 服务器时使用的“工具”值。4 是出厂默认设置。 “日志已满行为”决定打印机在日志完全填满其分配的内存时如何解决。“打包最旧的输入项”是出厂默认设置。 “安全审核日志”菜单项及其描述 使用 来 配置日志（续） 管理员的电子邮件地址 [256 个字符的字符串] 数字签名导出 关 开 记录事件严重性 0–7 远程 Syslog 非记录事件 否 是 电邮日志清除警报 否 是 电邮日志打包警报 否 是 电邮 % 已满警报 否 是 % 已满警报级别 1–99 电邮日志导出警报 否 是 电邮日志设置更改警报 否 是 日志行结尾 LF (\\n) CR (\\r) CRLF (\\r\\n) 指定如何配置审核日志。 “管理员的电子邮件地址”决定管理员是否被自动通知某些日志事件。此设置可以有一个或多个电子邮件地址（以逗号分隔）。 “数字签名导出”决定打印机是否自动签署每一份导出的安全日志。“关”是出厂默认设置。 “记录事件严重性”记录每一个事件的严重性值。4 是出厂默认设置。 “远程 Syslog 未记录事件”决定打印机是否将事件发送给具有比“记录事件严重性”设置值更高的安全级别的远程服务器。“否”是出厂默认设置。 “电邮日志清除警报”决定打印机是否在每次日志通过打印机控制面板或 EWS 被删除时发送电子邮件给管理员。“否”是出厂默认设置。 “电邮日志打包警报”决定打印机是否在日志输入项被打包时发送电子邮件给管理员。“否”是出厂默认设置。 “电邮 % 已满警报”决定打印机是否在日志填充了其一定量的分配空间时发送电子邮件给管理员。“否”是出厂默认设置。 “% 已满警报级别”决定日志所占的空间是等于还是大于已满警报级别的值。90 是出厂默认设置。 “电邮日志导出警报”决定打印机是否在有日志被导出时发送电子邮件给管理员。“否”是出厂默认设置。 “电邮日志设置更改警报”决定打印机是否在“启用审核日志”设置的值被触发时发送电子邮件给管理员。“否”是出厂默认设置。 根据文件将在其中被解析或查看的操作系统，“日志行结尾”指定将如何在日志文件中处理行结尾。“LF (\\n)”是出厂默认设置。 安全审核日志菜单 菜单 安全审核日志"},{"UUID":"c621f2ac-9f0e-45d0-a291-b66807932eeb","title":"安全菜单","link":"security-menus-group.html","desc":"“设置日期和时间”菜单 “设置日期和时间”菜单项及其描述 使用 来 当前日期和时间","descFull":"“设置日期和时间”菜单 “设置日期和时间”菜单项及其描述 使用 来 当前日期和时间 查看扫描仪的当前日期和时间设置。 手动设置日期和时间 输入日期和时间。 以 YYYY-MM-DD HH:MM:SS 格式设置日期/时间。 时区 选择时区。 GMT 是出厂默认设置。 自动遵守 DST 开 关 设置扫描仪使用与扫描仪“时区”设置相关联的适用夏时制（DST）的起止时间。 “开”是出厂默认设置并使用与“时区”设置相关联的适用的“夏令时”。 自定义时区设置 DST 开始周 DST 开始日 DST 开始月 DST 开始时间 DST 结束周 DST 结束日 DST 结束月 DST 结束时间 DST 时差 让用户能够设置时区。 启用 NTP 开 关 启用“网络时间协议”，它与网络上的设备时钟同步。 “开”是出厂默认设置。 NTP 服务器 查看 NTP 服务器地址。 启用验证 开 关 启用验证设置。 “关”是出厂默认设置。 设置日期和时间菜单 菜单 设置日期和时间"},{"UUID":"99da3f86-c61b-4b47-84c9-5deefc33f0cc","title":"设置菜单","link":"settings-group.html","desc":"“常规设置”菜单 “常规设置”菜单项及描述 使用 来 显示语言","descFull":"“常规设置”菜单 “常规设置”菜单项及描述 使用 来 显示语言 English Francais Deutsch Italiano Espanol Dansk Norsk Nederlands Svenska Portuguese Suomi Russian Polski Greek Magyar Turkce Cesky 简体中文 繁体中文 Korean Japanese 设置出现在打印机显示屏上的文本语言。 不是所有语言可用于所有打印机，您可能需要安装特殊的硬件才能让这些语言出现。 Eco 模式 关 能源 能源/纸张 纸张 最小化能源、纸张或特殊介质的使用。 “关”是出厂默认设置。此设置将打印机复位到它的出厂默认设置。 “能源”最小化打印机使用的能源。可能会影响性能，但不会影响打印质量。 “能源/纸张”最小化能源、纸张和特殊介质的用量。 “纸张”设置最小化打印作业所需要的纸张和特殊介质的数量。可能会影响性能，但不会影响打印质量。 ADF 已加载蜂鸣声 启用 禁用 指定当加载纸张时，ADF 是否发出蜂鸣声。 “启用”是出厂默认设置。 静音模式 关 开 减少打印机产生的噪音。 “关”是出厂默认设置。此设置支持本打印机的性能规格。 “开”设置配置打印机来尽可能少产生噪音。此设置最适合打印文本和线条图案。 对于色彩丰富的文档，如需最佳打印效果，请将“静音模式”设置为“关”。 从打印驱动程序选择“照片”可以禁用“静音模式”并提供较好的打印质量和全速打印。 运行初始设置 是 否 设置打印机运行设置向导。 “是”为出厂默认设置。当完成设置向导后，默认值变为“否”。 键盘 键盘类型 English Francais Francais Canadien Deutsch Italiano Espanol Greek Dansk Norsk Nederlands Svenska Suomi Portuguese Russian Polski Swiss German Swiss French Korean Magyar Turkce Cesky 简体中文 繁体中文 Japanese 自定义按键 [x] 为打印机键盘指定语言和自定义键信息。其他选项卡启用从键盘到重音符号和符号的访问。 纸张尺寸 美制 公制 指定默认的纸张度量。 “美制”是出厂默认设置。 初始设置由您在初始化设置向导中的国家或地区选择决定。 更改此设置也改变“纸张尺寸/类型”菜单中的每一个输入来源的默认设置。 扫描到 PC 端口范围 [端口范围] 为端口阻止防火墙后面的打印机指定有效的端口范围。 9751:12000 是出厂默认设置。 显示的信息 左边 右边 自定义文本 [x] 指定显示在主屏幕的左上角和右上角的内容。 对于“左边”和“右边”菜单，请从下列选项中选择： 无 IP 地址 主机名 联系人名称 位置 日期/时间 mDNS/DDNS 服务名称 零配置名称 自定义文本 [x] 型号名称 “IP 地址”是“左边”的出厂默认设置。 “日期/时间”是“右边”的出厂默认设置。 显示的信息（续） 黑色碳粉 为“黑色碳粉”定制显示的信息。 请从下列选项中选择： 显示时间 不显示 显示 显示消息 默认 交互 默认 [文本输入项] 交互 [文本输入项] “不显示”是“显示时间”的出厂默认设置。 “默认”是“显示消息”的出厂默认设置。 显示的信息（续） 废碳粉瓶 卡纸 加载纸张 服务错误 为“废碳粉瓶”、“卡纸”、“加载纸张”和“服务错误”定制显示的信息。 请从下列选项中选择： 显示 是 否 显示消息 默认 交互 默认 [文本输入项] 交互 [文本输入项] “否”是“显示”的出厂默认设置。 “默认”是“显示消息”的出厂默认设置。 主屏幕定制 更改语言 复印 复印快捷方式 传真 传真快捷方式 电子邮件 电子邮件快捷方式 FTP FTP 快捷方式 搜索挂起作业 挂起作业 USB 驱动器 配置文件和应用程序 书签 基于用户的作业数 表单与收藏夹 身份证复印 扫描到网络 我的快捷方式 多目标扫描方案 更改出现在主屏幕上的图标。 对于每一个图标，请从下列选项中选择： 显示 不显示 “显示”是“复印”、“传真”、“电子邮件”、FTP、“搜索挂起作业”、“挂起作业”、“USB 驱动器”、“表单与收藏夹”、“身份证复印”、“扫描到网络”、“我的快捷方式”和“多目标扫描方案”的出厂默认设置。 “不显示”是“更改语言”、“复印快捷方式”、“传真快捷方式”、“电子邮件快捷方式”、“FTP 快捷方式”、“配置文件和应用程序”、“书签”及“按用户的作业数”的出厂默认设置。 日期格式 MM‑DD‑YYYY DD‑MM‑YYYY YYYY‑MM‑DD 格式化打印机日期。 MM‑DD‑YYYY 是美国的出厂默认设置。 DD-MM-YYYY 是国际通用的出厂默认设置。 时间格式 12 小时 A.M./P.M. 24 小时制 格式化打印机时间。 12 小时 A.M./P.M. 是出厂默认设置。 屏幕明亮度 20–100 指定控制面板屏幕的明亮度。 100 是出厂默认设置。 一页复印 关 开 设置从扫描仪玻璃每次一页进行复印。 “关”是出厂默认设置。 输出照明 正常/待机模式 关 暗淡 明亮 设置来自标准接纸架的灯亮度。 如果“Eco 模式”被设置为“能源”或“能源/纸张”，“暗淡”是出厂默认设置。 如果“Eco 模式”被设置为“纸张”或“关”，“明亮”是出厂默认设置。 音频反馈 按钮反馈 开 关 音量 1–10 设置按钮的音量。 “开”是“按钮反馈”的出厂默认设置。 5 是“音量”的出厂默认设置。 显示书签 是 否 指定书签是否从“挂起作业”区域显示。 “是”为出厂默认设置。 允许背景消除 开 关 指定是否允许消除复印、传真、电子邮件、FTP 或扫描到 USB 作业中的图像背景。 “开”是出厂默认设置。图像的背景会被消除。 允许自定义作业扫描 开 关 将多个作业扫描到一个文件中。 “开”是出厂默认设置。如果选择“开”，可以为特定作业启用“允许自定义作业扫描”设置。 扫描仪卡纸恢复 作业级别 页面级别 指定在 ADF 中发生卡纸时应该如何重新加载扫描作业。 “作业级别”是出厂默认设置。如果选定，当任何页面卡住时，整个作业都必须重新扫描。 如果选择“页面级别”，从被卡页面之前重新扫描。 Web 页面刷新率 30–300 指定 Embedded Web Server 每次刷新之间的秒数。 120 是出厂默认设置。 联系人名称 为打印机指定联系人名称。 联系人名称被保存在 Embedded Web Server 上。 位置 指定打印机的位置。 位置被保存在 Embedded Web Server 上。 警报 警报控制 碳粉盒警报 订书钉警报 打孔警报 设置当打印机要求用户干预时的警报。 对于每一种警报类型，请从下列选项中选择： 关 一次 连续 “一次”是“警报控制”的出厂默认设置。“一次”发出三声短促的蜂鸣声。 “关”是“碳粉盒警报”、“订书钉警报”和“打孔警报”的出厂默认设置。 “连续”每隔 10 秒钟重复三声蜂鸣声。 超时 待机模式 禁用 1–240 指定打印机在进入低耗电状态之前不活动的分钟数。 15 是出厂默认设置。 超时 睡眠模式 禁用 1–120 以分钟为单位设置打印机从作业打印完毕到进入低耗状态之前的等待时间。 20 是出厂默认设置。 “禁用”仅在“能源节省”设置为“关”时出现。 较低设置能节省较多能源，但是可能需要较长的预热时间。 如果打印机处于持续使用状态，请选择高设置。在大多数情况下，这使打印机以最少的预热时间准备打印。 超时 打印并关闭显示 允许打印并关闭显示 打印时打开显示 即使显示关闭，仍允许打印机打印。 “允许打印并关闭显示”是出厂默认设置。 超时 休眠超时 禁用 1 小时 2 小时 3 小时 6 小时 1 天 2 天 3 天 1 周 2 周 1 个月 设置打印机在进入“休眠”模式之前的时间。 “3 天”是出厂默认设置。 超时 连接时休眠超时 不休眠 休眠 即使存在活动的以太网连接，也将打印机设置为“休眠超时”。 “休眠”是出厂默认设置。 超时 屏幕超时 15–300 以秒为单位设置打印机在返回到“就绪”状态之前等待的时间。 30 是出厂默认设置。 超时 延长屏幕超时 开 关 设置打印机在屏幕超时计时器到期时继续处理指定的作业，而不返回到主屏幕。 “关”是出厂默认设置。 超时 打印超时 禁用 1–255 以秒为单位设置打印机在取消打印作业的剩余部分之前等待接收作业结束消息的时间。 90 是出厂默认设置。 当计时器到时后，打印机将打印仍留在其中的任何已部分打印的页面，然后查看是否有新的打印作业在等待。 “打印超时”仅在使用 PCL 仿真时可用。它对 PostScript 仿真打印作业没有影响。 超时 等待超时 禁用 15–65535 以秒为单位设置打印机在取消打印作业之前等待其他数据的时间。 40 是出厂默认设置。 “等待超时”仅在打印机使用 PostScript 仿真时可用。它对 PCL 仿真打印作业没有影响。 超时 作业挂起超时 5–255 设置打印机在挂起要求不可用资源的作业并继续打印打印队列中的其他作业之前等待用户干预的时间。 30 是出厂默认设置。 此菜单仅在已格式化的打印机硬盘已安装时出现。 错误恢复 自动重启 当空闲时重启 总是重启 从不重启 设置打印机在遇到错误时重新启动。 “总是重启”是出厂默认设置。 错误恢复 最多自动重启次数 1–20 确定打印机可以执行的自动重启次数。 2 是出厂默认设置。 打印恢复 自动继续 禁用 5–255 如果在指定时间内问题未解决，让打印机自动从某个脱机状态继续打印。 “禁用”是出厂默认设置。 打印恢复 卡纸恢复 开 关 自动 指定打印机是否重新打印被卡的页面。 “自动”是出厂默认设置。打印机重新打印被卡的页面，除非用来保存该页面的内存要用于其他打印机任务。 “开”设置打印机总是重新打印被卡的页面。 “关”设置打印机从不重新打印被卡的页面。 打印恢复 卡纸协助 开 关 设置打印机自动检查被卡的纸张。 “开”是出厂默认设置。 打印恢复 页面保护 关 开 让打印机成功打印在其他情况下可能不打印的页面。 “关”是出厂默认设置。当内存不足以打印整页时，此设置打印部分页面。 “开”设置打印机处理整页以便打印整个页面。 按睡眠按钮 无操作 睡眠 休眠 确定当打印机处于空闲时按下“睡眠”按钮打印机如何响应。 “睡眠”是出厂默认设置。 “睡眠”或“休眠”将打印机设置为在低功耗配置下运行。 如果打印机处于“睡眠”模式，显示屏显示为关并且“睡眠”按钮变为琥珀色。触摸显示屏上的任意位置或按控制面板上的按钮将打印机从“睡眠”模式唤醒。 如果打印机处于“休眠”模式，显示屏完全为关并且“睡眠”按钮变为琥珀色并闪烁。 按住睡眠按钮 无操作 睡眠 休眠 确定当打印机处于空闲时按下“睡眠”按钮 3 秒或更长时间打印机如何响应。 “无操作”是出厂默认设置。 “睡眠”或“休眠”将打印机设置为在低功耗配置下运行。 如果打印机处于“睡眠”模式，显示屏显示为关并且“睡眠”按钮变为琥珀色。触摸显示屏上的任意位置或按控制面板上的按钮将打印机从“睡眠”模式唤醒。 出厂默认设置 不还原 立即还原 将打印机设置还原为出厂默认设置。 “不还原”是出厂默认设置。它保留用户定义的设置。 “立即还原”使所有打印机设置返回到出厂默认设置，除了“网络/端口”菜单中的设置。保存在 RAM 中的所有下载资源都被删除。保存在闪存或打印机硬盘上的下载资源不受影响。 导出配置软件包 导出 将打印机配置文件导出到闪存驱动器。 常规设置菜单 菜单 常规设置"},{"UUID":"ca852d3c-d0af-4e43-8a52-34c35c533a25","title":"设置菜单","link":"settings-group.html","desc":"“复印设置”菜单 “复印设置”菜单项及其描述 使用 来 内容类型","descFull":"“复印设置”菜单 “复印设置”菜单项及其描述 使用 来 内容类型 文本 图形 文本/照片 照片 指定原始文档的内容。 “文本/照片”是出厂默认设置。 内容来源 黑白激光 彩色激光 喷墨 照片/底片 杂志 报纸 印刷品 其他 指定原始文档是如何产生的。 “黑白激光”是出厂默认设置。 面数（双面打印） 1 面到 1 面 1 面到 2 面 2 面到 1 面 2 面到 2 面 指定原始文档是两面还是一面，然后指定副本应该是两面还是一面。 1 面到 1 面 —原始文档打印在一个面上，并且副本也将打印在一个面上。 1 面到 2 面 —原始文档打印在一个面上，而副本将打印在两个面上。 2 面到 1 面 —原始文档打印在两个面上，而副本将只打印在一个面上。 2 面到 2 面 —原始文档打印在两个面上，并且副本也将打印在两个面上。 纸张节省 关 2 页纵向 2 页横向 4 页纵向 4 页横向 在一个页面上复印文档的两页或四页。 “关”是出厂默认设置。 打印页面边框 开 关 指定是否打印边框。 “关”是出厂默认设置。 逐份打印 (1,1,1) (2,2,2) (1,2,3) (1,2,3) 打印多份副本时，保持打印作业的页面按顺序堆放。 “(1,2,3) (1,2,3)”是出厂默认设置。 打孔 关 2 个孔 3 个孔 4 个孔 指定要在打印或复印作业中使用的打孔完成类型。 “关”是出厂默认设置。 此菜单项仅在装订、打孔完成器已安装时出现。 装订 关 1 个订书钉 2 个订书钉 启用或禁用装订完成器。 “关”是出厂默认设置。 此菜单项仅在装订完成器已安装时出现。 原始尺寸 Letter Legal Executive Tabloid Folio Statement Oficio（墨西哥） Universal 自动尺寸检测 混合尺寸 A3 A4 A5 A6 JIS B4 JIS B5 自定义扫描尺寸 [x] 书本原件 名片 3 x 5 英寸 4 x 6 英寸 ID 卡 指定原始文档的纸张尺寸。 Letter 是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 复印目标纸张来源 进纸匣 [x] 自动尺寸匹配 多功能进纸器 为复印作业指定纸张来源。 “进纸匣 1”是出厂默认设置。 透明胶片分隔页 开 关 将一张纸放在透明胶片之间。 “开”是出厂默认设置。 当设置为“开”时，将一张空白页放在透明胶片之间。 分隔页 关 份数之间 作业之间 页面之间 将一张纸放在页面、副本或作业之间。 “关”是出厂默认设置。 分隔页纸张来源 进纸匣 [x] 多功能进纸器 指定分隔页的纸张来源。 “进纸匣 1”是出厂默认设置。 浓度 1–9 为复印作业减淡或加深打印效果。 5 是出厂默认设置。 接纸架 标准接纸架 接纸架 [x] 指定要用于复印作业的接纸架。 “标准接纸架”是出厂默认设置。 “接纸架 [x]”仅在至少一个接纸架选件已安装时出现。 份数 1–9999 为复印作业指定份数。 1 是出厂默认设置。 页眉/页脚 [位置] 关 日期/时间 页码 自定义文本 打印到 所有页 仅第一页 除第一页外的所有页 自定义文本 指定页眉和页脚信息及其在页面上的位置。 对于位置，请从下列选项中进行选择： 顶部左边 顶部中间 顶部右边 底部左边 底部中间 底部右边 “关”是位置的出厂默认设置。 “所有页”是“打印到”的出厂默认设置。 背景画面 密件 副本 草稿 急件 自定义 关 指定打印在复印作业每一页上的背景画面文本。 “关”是出厂默认设置。 自定义背景画面 指定自定义背景画面文本。 允许最多 64 个字符。 允许优先副本 开 关 允许中断打印作业来复印一页或一个文档。 “开”是出厂默认设置。 自定义作业扫描 开 关 将包含混合纸张尺寸的文档复制到一个复印作业中。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 允许另存为快捷方式 开 关 将自定义复印设置另存为快捷方式。 “开”是出厂默认设置。 背景消除 ‑4 至 4 调整可在副本上看到的背景数量。 0 是出厂默认设置。 自动居中 关 开 在页面上自动居中内容。 “关”是出厂默认设置。 颜色漏失 颜色漏失 无 红色 绿色 蓝色 默认红色阈值 0–255 默认绿色阈值 0–255 默认蓝色阈值 0–255 指定在扫描期间停止使用哪种颜色，以及如何调整每一种颜色阈值的漏失设置。 “无”是“颜色漏失”的出厂默认设置。 128 是每种颜色阈值的出厂默认设置。 对比度 0–5 最适合内容 指定用于复印作业的对比度。 “最适合内容”是出厂默认设置。 镜像图像 关 开 创建原始文档的镜像图像。 “关”是出厂默认设置。 反白图像 关 开 创建原始文档的反白图像。 “关”是出厂默认设置。 阴影细节 ‑4 至 4 调整可在副本上看到的阴影细节数量。 0 是出厂默认设置。 边对边扫描 关 开 允许原始文档的边对边扫描。 “关”是出厂默认设置。 清晰度 1–5 调整副本的清晰度。 3 是出厂默认设置。 校样复印 关 开 创建原始文档的一份样本。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 菜单 复印设置 复印设置菜单"},{"UUID":"08902b5b-44d4-499d-a191-a81685868276","title":"传真设置菜单","link":"settings-group.html","desc":"“传真模式（模拟传真设置）”菜单 “模拟传真设置”模式通过电话线发送传真作业。 常规传真设置 使用 来","descFull":"“传真模式（模拟传真设置）”菜单 “模拟传真设置”模式通过电话线发送传真作业。 常规传真设置 使用 来 传真名称 在打印机中指定传真的名称。 传真号码 指定分配给传真的号码。 传真 ID 传真名称 传真号码 指定如何识别传真。 “传真号码”是出厂默认设置。 启用手动传真 开 关 将打印机设置为手动发送传真，这需要分线器和手持送受话器。 使用普通电话来应答发来的传真作业并拨打传真号码。 触摸数字键盘上的  # 0  来直接进入“手动传真”功能。 “关”是出厂默认设置。 内存使用 全部接收 大部分接收 相等 大部分发送 全部发送 定义在发送和接收传真作业之间的非易失性内存的分配。 “相等”是出厂默认设置。“相等”将内存分成大小相等的两部分，用来发送和接收传真作业。 “大部分发送”指定大部分内存被设置为发送传真作业。 “全部发送”指定所有内存都被设置为发送传真作业。 “全部接收”指定所有内存都被设置为接收传真作业。 “大部分接收”指定大部分内存被设置为接收传真作业。 取消传真 允许 不允许 指定打印机是否取消传真作业。 “允许”是出厂默认设置。 来电显示 关 一级 交互 指定正被使用的来电显示的类型。 传真号码屏蔽 关 从左起 从右起 指定在外发传真号码中从哪个数字开始屏蔽的方向。 被屏蔽的字符数由“需屏蔽数字”设置决定。 “关”是出厂默认设置。 需屏蔽数字 0–58 指定在外发传真号码中要屏蔽的数字个数。 0 是出厂默认设置。 传真封面页 传真封面页 默认为关 默认为开 从不使用 总是使用 包括收件人字段 开 关 包括发件人字段 开 关 发件人 包括消息字段 开 关 消息 包括徽标 开 关 包括页脚 [x] 开 关 页脚 [x] 配置传真封面页。 “默认为关”是“传真封面页”的出厂默认设置。 “关”是所有其他菜单项的出厂默认设置。 传真发送设置 使用 来 分辨率 标准 精细 200 dpi 超精细 300 dpi 极精细 600 dpi 用每英寸点数（dpi）指定质量。越高的分辨率提供越好的打印质量，但是会增加外发传真的传输时间。 “标准”是出厂默认设置。 原始尺寸 Letter Legal Executive Tabloid Folio Statement Oficio（墨西哥） Universal 自动尺寸检测 混合尺寸 A3 A4 A5 A6 JIS B4 JIS B5 自定义扫描尺寸 [x] 书本原件 名片 3 x 5 英寸 4 x 6 英寸 指定原始文档的尺寸。 “混合尺寸”是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 面数（双面打印） 关 长边 短边 指定文本和图形在页面上的打印方向。 “关”是出厂默认设置。 “长边”假设沿着页面的长边进行装订（纵向打印为左边，横向打印为顶边）。 “短边”假设沿着页面的短边进行装订（纵向打印为顶边，横向打印为左边）。 内容类型 文本 图形 文本/照片 照片 指定原始文档的内容。 “文本”是出厂默认设置。 内容来源 黑白激光 彩色激光 喷墨 照片/底片 杂志 报纸 印刷品 其他 指定原始文档是如何产生的。 “黑白激光”是出厂默认设置。 浓度 1–9 减淡或加深输出。 5 是出厂默认设置。 拨号前缀 输入拨号前缀，例如 99。提供了数字输入项字段。 拨号前缀规则 前缀规则 [x] 建立拨号前缀规则。 自动重拨 0–9 指定打印机尝试将传真发送到指定号码的次数。 5 是出厂默认设置。 重拨频率 1–200 指定重拨之间的分钟数。 3 是出厂默认设置。 在 PABX 后面 是 否 启用或禁用不带拨号音的电话交换机盲拨。 “否”是出厂默认设置。 启用 ECM 是 否 为传真作业启用或禁用错误修正模式。 “是”为出厂默认设置。 启用传真扫描 开 关 传真在打印机上扫描的文件。 “开”是出厂默认设置。 驱动程序到传真 是 否 允许打印驱动程序发送传真作业。 “是”为出厂默认设置。 允许另存为快捷方式 开 关 将传真号码作为快捷方式保存到打印机中。 “开”是出厂默认设置。 拨号模式 音频 脉冲 指定拨号音。 “音频”是出厂默认设置。 最快速度 2400 4800 9600 14400 33600 以波特为单位指定发送传真的最快速度。 33600 是出厂默认设置。 自定义作业扫描 开 关 将包含混合纸张尺寸的文档扫描到一个文件中。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 扫描预览 开 关 指定是否在显示屏上出现扫描作业的预览。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 背景消除 ‑4 至 4 调整可在扫描图像上看到的背景数量。 0 是出厂默认设置。 色彩平衡 青色 - 红色 品红色 - 绿色 黄色 - 蓝色 启用在扫描图像中的颜色均等平衡。 颜色漏失 颜色漏失 无 红色 绿色 蓝色 默认红色阈值 0–255 默认绿色阈值 0–255 默认蓝色阈值 0–255 指定在扫描期间停止使用哪种颜色，以及如何调整每一种颜色阈值的漏失设置。 “无”是“颜色漏失”的出厂默认设置。 128 是每种颜色阈值的出厂默认设置。 对比度 0–5 最适合内容 指定扫描图像中的对比度。 “最适合内容”是出厂默认设置。 镜像图像 关 开 创建原始文档的镜像图像。 “关”是出厂默认设置。 反白图像 关 开 创建原始文档的反白图像。 “关”是出厂默认设置。 阴影细节 ‑4 至 4 调整可见的阴影细节数量。 0 是出厂默认设置。 边对边扫描 关 开 在传真之前指定是否边对边扫描原始文档。 “关”是出厂默认设置。 清晰度 1–5 调整传真的清晰度。 3 是出厂默认设置。 温度 ‑4 至 4 指定热或凉输出。凉值生成比默认值更蓝的输出，而热值生成比默认值更红的输出。 0 是出厂默认设置。 启用彩色传真扫描 默认为关 默认为开 从不使用 总是使用 启用彩色传真。 “默认为关”是出厂默认设置。 将彩色传真自动转换为单色传真 开 关 将所有外发的传真转换为黑白色。 “开”是出厂默认设置。 传真接收设置 使用 来 启用传真接收 开 关 允许打印机接收传真作业。 “开”是出厂默认设置。 传真作业等待 无 碳粉 碳粉和耗材 当作业要求特定不可用的资源时，从打印队列移除传真作业。 “无”是出厂默认设置。 应答振铃 1–25 指定在应答发来的传真作业之前振铃的次数。 3 是出厂默认设置。 自动应答 是 否 允许打印机应答发来的传真作业。 “是”为出厂默认设置。 手动应答代码 0–9 在电话数字键盘上输入一个代码以开始接收传真。 *9* 是出厂默认设置。 当打印机与电话共享一条线路时使用此菜单项。 自动缩小 开 关 缩放发来的传真作业以使它适合装在指定的传真纸张来源中的纸张尺寸。 “开”是出厂默认设置。 纸张来源 自动 进纸匣 [x] 多功能进纸器 指定用于打印发来的传真作业的纸张来源。 “自动”是出厂默认设置。 面数（双面打印） 关 开 为发来的传真作业启用两面打印。 “关”是出厂默认设置。 分隔页 关 作业之前 作业之后 启用打印机为发来的传真作业包括分隔页。 “关”是出厂默认设置。 分隔页纸张来源 进纸匣 [x] 多功能进纸器 指定分隔页的纸张来源。 “进纸匣 1”是出厂默认设置。 接纸架 标准接纸架 接纸架 [x] 指定用于已接收传真的接纸架。 “标准接纸架”是出厂默认设置。 传真页脚 开 关 在接收到的传真的每一页底部打印传输信息。 “关”是出厂默认设置。 最快速度 2400 4800 9600 14400 33600 以波特为单位指定接收传真的最快速度。 33600 是出厂默认设置。 传真转发 打印 打印并转发 转发 启用将已接收传真转发到其他收件人。 “打印”是出厂默认设置。 转发到 传真 电子邮件 FTP LDSS eSF 指定传真被转发到的收件人类型。 “传真”是出厂默认设置。 此菜单只能从打印机 Embedded Web Server 使用。 转发到快捷方式 输入与收件人类型（传真、电子邮件、FTP、LDSS 或 eSF）相匹配的快捷方式号码。 阻止无名称传真 关 开 启用对发自没有指定工作站 ID 或传真 ID 的设备的传真的阻止。 “关”是出厂默认设置。 禁止的传真列表 启用保存在打印机上的被阻止传真号码的列表。 挂起传真 挂起传真模式 关 始终为开 手动 预定 传真挂起时间表 启用在所有时间或根据设定的时间表挂起传真。 “关”是出厂默认设置。 打孔 关 开 指定是否打孔打印页面。 “关”是出厂默认设置。 此菜单项仅在装订、打孔完成器已安装时出现。 装订 关 1 个订书钉 2 个订书钉 4 个订书钉 指定是否装订打印页面。 “关”是出厂默认设置。 此菜单项仅在装订完成器已安装时出现。 启用彩色传真接收 开 关 让打印机能够接收彩色传真并以灰度打印。 “开”是出厂默认设置。 传真日志设置 使用 来 传输日志 打印日志 不打印日志 仅出错时打印 启用在每一个传真作业之后打印传输日志。 “打印日志”是出厂默认设置。 接收错误日志 从不打印 出错时打印 启用在出现接收错误后打印接收错误日志。 “从不打印”是出厂默认设置。 自动打印日志 开 关 启用自动打印传真日志。 “开”是出厂默认设置。 每到 200 个传真作业后打印日志。 日志纸张来源 进纸匣 [x] 多功能进纸器 指定用于打印日志的纸张来源。 “进纸匣 1”是出厂默认设置。 日志显示 远程工作站名称 已拨号码 指定打印的日志是否显示已拨号码或者回复的工作站名称或传真名称。 “远程工作站名称”是出厂默认设置。 启用作业日志 开 关 启用对传真作业日志的访问。 “开”是出厂默认设置。 启用呼叫日志 开 关 启用对传真呼叫日志的访问。 “开”是出厂默认设置。 日志接纸架 标准接纸架 接纸架 [x] 指定用于打印传真日志的接纸架。 “标准接纸架”是出厂默认设置。 扬声器设置 使用 来 扬声器模式 始终为关 在连接前为开 始终为开 指定扬声器的模式。 “在连接前为开”是出厂默认设置。在传真连接建立之前发出声音。 扬声器音量 高 低 控制音量设置。 “高”是出厂默认设置。 振铃音量 关 开 控制传真扬声器的振铃音量。 “开”是出厂默认设置。 应答开 使用 来 所有振铃 仅一次振铃 仅两次振铃 仅三次振铃 仅一次或两次振铃 仅一次或三次振铃 仅两次或三次振铃 指定当打印机应答呼叫时的振铃模式。 “所有振铃”是出厂默认设置。 菜单 传真模式（模拟传真设置） 传真模式（模拟传真设置）菜单"},{"UUID":"610b9f4a-a0e0-46ff-89fe-8e382abcc2ae","title":"设置菜单","link":"settings-group.html","desc":"“电子邮件设置”菜单 “电子邮件设置”菜单项及其描述 使用 来 电子邮件服务器设置","descFull":"“电子邮件设置”菜单 “电子邮件设置”菜单项及其描述 使用 来 电子邮件服务器设置 主题 消息 文件名 发送一份副本给我 最大电子邮件大小 大小错误消息 限制目标 Web 链接设置 指定电子邮件服务器的信息。 格式 PDF（.pdf） 安全 PDF TIFF（.tif） JPEG（.jpg） XPS（.xps） 指定扫描文件的格式。 “PDF（.pdf）”是出厂默认设置。 PDF 版本 1.2–1.7 A–1a 设置被扫描以发送电子邮件的 PDF 文件的版本。 1.5 是出厂默认设置。 内容类型 文本 图形 文本/照片 照片 指定原始文档的内容。 “文本/照片”是出厂默认设置。 内容来源 黑白激光 彩色激光 喷墨 照片/底片 杂志 报纸 印刷品 其他 指定原始文档是如何产生的。 “黑白激光”是出厂默认设置。 颜色 关 开 指定打印机是以彩色还是黑白色捕获并传输内容。 “开”是出厂默认设置。 分辨率 75 dpi 150 dpi 200 dpi 300 dpi 400 dpi 600 dpi 以每英寸点数指定扫描的分辨率。 150 dpi 是出厂默认设置。 浓度 1–9 减淡或加深输出。 5 是出厂默认设置。 方向 纵向 横向 指定扫描图像的方向。 “纵向”是出厂默认设置。 原始尺寸 Letter Legal Executive Tabloid Folio Statement Oficio（墨西哥） Universal 自动尺寸检测 混合尺寸 A3 A4 A5 A6 JIS B4 JIS B5 自定义扫描尺寸 [x] 书本原件 名片 3 x 5 英寸 4 x 6 英寸 指定被扫描文档的尺寸。 Letter 是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 面数（双面打印） 关 长边 短边 指定文本和图形在页面上的打印方向。 “关”是出厂默认设置。 “长边”假设沿着页面的长边进行装订（纵向打印为左边，横向打印为顶边）。 “短边”假设沿着页面的短边进行装订（纵向打印为顶边，横向打印为左边）。 JPEG 质量 最适合内容 5–90 设置相对于图像的文件大小和质量的 JPEG 照片图像的质量。 “最适合内容”是出厂默认设置。 5 减小图像的文件大小并降低质量。 设置为 90 将提供最佳的图像质量，但文件大小会非常大。 此菜单设置应用于所有扫描功能。 文本默认值 5–90 设置相对于图像的文件大小和质量的文本图像的质量。 75 是出厂默认设置。 文本/照片默认值 5–90 设置相对于图像的文件大小和质量的文本或照片图像的质量。 75 是出厂默认设置。 照片默认值 5–90 设置相对于图像的文件大小和质量的照片图像的质量。 50 是出厂默认设置。 发送电子邮件图像为 附件 Web 链接 指定如何发送图像。 “附件”是出厂默认设置。 使用多页 TIFF 开 关 在单页 TIFF 文件和多页 TIFF 文件之间进行选择。对于多页的扫描到电子邮件作业，可以创建包含所有页面的一个 TIFF 文件，也可以创建一个文件包含作业一个页面的多个 TIFF 文件。 “开”是出厂默认设置。 此菜单设置应用于所有扫描功能。 传输日志 打印日志 不打印日志 仅出错时打印 指定是否打印传输日志。 “打印日志”是出厂默认设置。 日志纸张来源 进纸匣 [x] 多功能进纸器 指定用于打印电子邮件日志的纸张来源。 “进纸匣 1”是出厂默认设置。 日志接纸架 标准接纸架 接纸架 [x] 指定用于 FTP 日志的接纸架。 “标准接纸架”是出厂默认设置。 “接纸架 [x]”仅在至少一个接纸架选件已安装时出现。 电子邮件位深度 1 位 8 位 当“颜色”设置为“关”时，让“文本/照片”模式能够通过使用 1 位图像来产生较小的文件大小。 “8 位”是出厂默认设置。 自定义作业扫描 开 关 复印包含混合纸张尺寸的文档。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 扫描预览 开 关 指定是否在显示屏上出现扫描作业的预览。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 允许另存为快捷方式 开 关 将电子邮件地址另存为快捷方式。 “开”是出厂默认设置。 当设置为“关”时，“另存为快捷方式”按钮不会出现在“电子邮件目标”屏幕上。 背景消除 ‑4 至 4 调整可在扫描图像上看到的背景数量。 0 是出厂默认设置。 色彩平衡 青色 - 红色 品红色 - 绿色 黄色 - 蓝色 启用在扫描图像中的颜色均等平衡。 颜色漏失 颜色漏失 无 红色 绿色 蓝色 默认红色阈值 0–255 默认绿色阈值 0–255 默认蓝色阈值 0–255 指定在扫描期间停止使用哪种颜色，以及如何调整每一种颜色阈值的漏失设置。 “无”是“颜色漏失”的出厂默认设置。 128 是每种颜色阈值的出厂默认设置。 对比度 0–5 最适合内容 指定输出的对比度。 “最适合内容”是出厂默认设置。 镜像图像 关 开 创建原始文档的镜像图像。 “关”是出厂默认设置。 反白图像 关 开 创建原始文档的反白图像。 “关”是出厂默认设置。 阴影细节 ‑4 至 4 调整可在扫描图像上看到的阴影细节数量。 0 是出厂默认设置。 边对边扫描 关 开 指定是否边对边扫描原始文档。 “关”是出厂默认设置。 清晰度 1–5 调整扫描图像的清晰度。 3 是出厂默认设置。 温度 ‑4 至 4 指定热或凉输出。凉值生成比默认值更蓝的输出，而热值生成比默认值更红的输出。 0 是出厂默认设置。 使用抄送/密送 关 开 启用“抄送：”和“密送：”字段的使用。 “关”是出厂默认设置。 菜单 电子邮件设置 电子邮件设置菜单"},{"UUID":"bc2d9ee3-6f80-4952-b220-d3b8b7bfbc4c","title":"设置菜单","link":"settings-group.html","desc":"“FTP 设置”菜单 “FTP 设置”菜单项及其描述 使用","descFull":"“FTP 设置”菜单 “FTP 设置”菜单项及其描述 使用 来 格式 PDF（.pdf） 安全 PDF（.pdf） TIFF（.tif） JPEG（.jpg） XPS（.xps） 指定用于 FTP 发送的文件格式。 “PDF（.pdf）”是出厂默认设置。 PDF 版本 1.2–1.7 A–1a 为 FTP 发送设置 PDF 文件的版本。 1.5 是出厂默认设置。 内容类型 文本 图形 文本/照片 照片 指定原始文档的内容。 “文本/照片”是出厂默认设置。 内容来源 黑白激光 彩色激光 喷墨 照片/底片 杂志 报纸 印刷品 其他 指定原始文档是如何产生的。 “黑白激光”是出厂默认设置。 颜色 关 开 指定打印机是以彩色还是黑白色捕获并传输内容。 “开”是出厂默认设置。 分辨率 75 dpi 150 dpi 200 dpi 300 dpi 400 dpi 600 dpi 以每英寸点数（dpi）指定扫描的质量。 150 dpi 是出厂默认设置。 浓度 1–9 减淡或加深输出。 5 是出厂默认设置。 方向 纵向 横向 指定扫描图像的页面方向。 “纵向”是出厂默认设置。 原始尺寸 Letter Legal Executive Folio Statement Oficio（墨西哥） Universal 自动尺寸检测 混合尺寸 A3 A4 A5 A6 JIS B4 JIS B5 自定义扫描尺寸 [x] 书本原件 名片 3 x 5 英寸 4 x 6 英寸 指定原始文档的尺寸。 Letter 是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 面数（双面打印） 关 长边 短边 指定文本和图形的页面方向。 “关”是出厂默认设置。 “长边”假设沿着页面的长边进行装订（纵向打印为左边，横向打印为顶边）。 “短边”假设沿着页面的短边进行装订（纵向打印为顶边，横向打印为左边）。 JPEG 质量 最适合内容 5–90 设置相对于图像的文件大小和质量的 JPEG 照片图像的质量。 “最适合内容”是出厂默认设置。 设置为 5 将缩小文件大小，但也降低图像质量。 设置为 90 将提供最佳的图像质量，但文件大小会非常大。 此菜单设置应用于所有扫描功能。 文本默认值 5–90 设置相对于图像的文件大小和质量的文本的质量。 75 是出厂默认设置。 文本/照片默认值 5–90 设置相对于图像的文件大小和质量的文本/照片图像的质量。 75 是出厂默认设置。 照片默认值 5–90 设置相对于图像的文件大小和质量的照片图像的质量。 50 是出厂默认设置。 使用多页 TIFF 开 关 提供单页 TIFF 文件和多页 TIFF 文件之间的选择。对于多页的扫描到 FTP 作业，可以创建包含所有页面的一个 TIFF 文件，也可以创建一个文件包含作业一个页面的多个 TIFF 文件。 “开”是出厂默认设置。 此菜单设置应用于所有扫描功能。 传输日志 打印日志 不打印日志 仅出错时打印 指定是否打印传输日志。 “打印日志”是出厂默认设置。 日志纸张来源 进纸匣 [x] 多功能进纸器 指定当打印 FTP 日志时的纸张来源。 “进纸匣 1”是出厂默认设置。 日志接纸架 标准接纸架 接纸架 [x] 指定用于 FTP 日志的接纸架。 “标准接纸架”是出厂默认设置。 “接纸架 [x]”仅在一个接纸架选件已安装时出现。 FTP 位深度 1 位 8 位 当“颜色”设置为“关”时，让“文本/照片”模式能够通过使用 1 位图像来具有较小的文件大小。 “8 位”是出厂默认设置。 文件名 输入基本文件名。 自定义作业扫描 开 关 将包含混合纸张尺寸的文档复印到一个扫描作业中。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 扫描预览 开 关 指定是否在显示屏上出现扫描作业的预览。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 允许另存为快捷方式 开 关 为 FTP 地址启用快捷方式创建。 “开”是出厂默认设置。 背景消除 ‑4 至 4 调整可在副本上看到的背景数量。 0 是出厂默认设置。 色彩平衡 青色 - 红色 品红色 - 绿色 黄色 - 蓝色 启用在扫描图像中的颜色均等平衡。 颜色漏失 颜色漏失 无 红色 绿色 蓝色 默认红色阈值 0–255 默认绿色阈值 0–255 默认蓝色阈值 0–255 指定在扫描期间停止使用哪种颜色，以及如何调整每一种颜色阈值的漏失设置。 “无”是“颜色漏失”的出厂默认设置。 128 是每种颜色阈值的出厂默认设置。 对比度 0–5 最适合内容 指定输出的对比度。 “最适合内容”是出厂默认设置。 镜像图像 关 开 创建原始文档的镜像图像。 “关”是出厂默认设置。 反白图像 关 开 创建原始文档的反白图像。 “关”是出厂默认设置。 阴影细节 ‑4 至 4 调整可在扫描图像上看到的阴影细节数量。 0 是出厂默认设置。 边对边扫描 关 开 指定是否边对边扫描原始文档。 “关”是出厂默认设置。 清晰度 1–5 调整扫描图像的清晰度。 3 是出厂默认设置。 温度 ‑4 至 4 指定热或凉输出。凉值生成比默认值更蓝的输出，而热值生成比默认值更红的输出。 0 是出厂默认设置。 菜单 FTP 设置 FTP 设置菜单"},{"UUID":"4ac0e9ee-574d-4185-a27c-64d0bdb9d059","title":"设置菜单","link":"settings-group.html","desc":"“闪存驱动器”菜单 扫描设置 “扫描设置”菜单项及其描述 使用 来","descFull":"“闪存驱动器”菜单 扫描设置 “扫描设置”菜单项及其描述 使用 来 格式 PDF（.pdf） 安全 PDF TIFF（.tif） JPEG（.jpg） XPS（.xps） 指定要通过 FTP 发送的文件的格式。 “PDF（.pdf）”是出厂默认设置。 PDF 版本 1.2–1.7 A–1a 设置要通过 FTP 发送的 PDF 文件的版本。 1.5 是出厂默认设置。 内容类型 文本 图形 文本/照片 照片 指定原始文档的内容。 “文本/照片”是出厂默认设置。  内容来源 黑白激光 彩色激光 喷墨 照片/底片 杂志 报纸 印刷品 其他 指定原始文档是如何产生的。 “黑白激光”是出厂默认设置。 颜色 开 关 指定打印机是以彩色还是黑白色捕获并传输内容。 “开”是出厂默认设置。 分辨率 75 dpi 150 dpi 200 dpi 300 dpi 400 dpi 600 dpi 以每英寸点数（dpi）指定扫描的分辨率。 150 dpi 是出厂默认设置。 浓度 1–9 减淡或加深输出。 5 是出厂默认设置。 方向 纵向 横向 指定扫描图像的方向。 “纵向”是出厂默认设置。 原始尺寸 Letter Legal Executive Folio Statement Oficio（墨西哥） Universal 自动尺寸检测 混合尺寸 A3 A4 A5 A6 JIS B4 JIS B5 自定义扫描尺寸 [x] 书本原件 名片 3 x 5 英寸 4 x 6 英寸 指定原始文档的尺寸。 Letter 是美国的出厂默认设置。A4 是国际通用的出厂默认设置。 面数（双面打印） 关 长边 短边 指定文本和图形的页面方向。 “关”是出厂默认设置。 “长边”假设沿着页面的长边进行装订（纵向打印为左边，横向打印为顶边）。 “短边”假设沿着页面的短边进行装订（纵向打印为顶边，横向打印为左边）。 JPEG 质量 最适合内容 5–90 设置相对于文件大小和质量的 JPEG 照片图像的质量。 “最适合内容”是出厂默认设置。 设置为 5 将缩小文件大小，但也降低图像质量。 设置为 90 将提供最佳的图像质量，但文件大小会非常大。 此菜单应用于所有扫描功能。 文本默认值 5–90 设置相对于图像的文件大小和质量的文本的质量。 75 是出厂默认设置。 文本/照片默认值 5–90 设置相对于文件大小和质量的文本/照片图像的质量。 75 是出厂默认设置。 照片默认值 5–90 设置相对于文件大小和质量的照片图像的质量。 50 是出厂默认设置。 使用多页 TIFF 开 关 提供单页 TIFF 文件和多页 TIFF 文件之间的选择。对于多页的扫描到 FTP 作业，可以创建包含所有页面的一个 TIFF 文件，也可以创建一个文件包含一个页面的多个 TIFF 文件。 “开”是出厂默认设置。 此菜单应用于所有扫描功能。 扫描位深度 1 位 8 位 当“颜色”设置为“关”时，让“文本/照片”模式能够通过使用 1 位图像来具有较小的文件大小。 “8 位”是出厂默认设置。 文件名 输入基本文件名。 允许最多 53 个字符。 自定义作业扫描 开 关 将包含混合纸张尺寸的文档复印到一个复印作业中。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 扫描预览 开 关 指定是否在显示屏上出现扫描作业的预览。 “关”是出厂默认设置。 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 背景消除 ‑4 至 4 调整可在副本上看到的背景数量。 0 是出厂默认设置。 色彩平衡 青色 - 红色 品红色 - 绿色 黄色 - 蓝色 启用在扫描图像中的颜色均等平衡。 颜色漏失 颜色漏失 无 红色 绿色 蓝色 默认红色阈值 0–255 默认绿色阈值 0–255 默认蓝色阈值 0–255 指定在扫描期间停止使用哪种颜色，以及如何调整每一种颜色阈值的漏失设置。 “无”是“颜色漏失”的出厂默认设置。 128 是每种颜色阈值的出厂默认设置。 对比度 0–5 最适合内容 指定扫描图像的对比度。 “最适合内容”是出厂默认设置。 镜像图像 关 开 创建原始文档的镜像图像。 “关”是出厂默认设置。 反白图像 关 开 创建原始文档的反白图像。 “关”是出厂默认设置。 阴影细节 ‑4 至 4 调整可在扫描图像上看到的阴影细节数量。 0 是出厂默认设置。 边对边扫描 关 开 指定是否边对边扫描原始文档。 “关”是出厂默认设置。 清晰度 1–5 调整扫描图像的清晰度。 3 是出厂默认设置。 温度 ‑4 至 4 指定热或凉输出。凉值生成比默认值更蓝的输出，而热值生成比默认值更红的输出。 0 是出厂默认设置。 打印设置 “打印设置”菜单项及其描述 份数 1–999 为每一个打印作业指定默认的份数。 1 是出厂默认设置。 纸张来源 进纸匣 [x] 多功能进纸器 手动纸张 手动信封 为所有打印作业设置默认的纸张来源。 “进纸匣 1”是出厂默认设置。 逐份打印 (1,1,1) (2,2,2) (1,2,3) (1,2,3) 打印多份副本时，使打印作业的页面按顺序堆放。 “(1,2,3) (1,2,3)”是出厂默认设置。 面数（双面打印） 1 面 2 面 指定在纸张的一个面还是两个面上打印。 “1 面”是出厂默认设置。 装订 关 开 指定是否装订打印页面。 “关”是出厂默认设置。 此菜单项仅在装订完成器已安装时出现。 打孔 关 开 指定是否打孔打印页面。 “关”是出厂默认设置。 此菜单项仅在支持的装订、打孔完成器已安装时出现。 打孔模式 2 个孔 3 个孔 4 个孔 指定在打印页面上打孔的个数。 “3 个孔”是美国的出厂默认设置。“4 个孔”是国际通用的出厂默认设置。 此菜单项仅在支持的装订、打孔完成器已安装时出现。 双面打印装订 长边 短边 定义相对于打印文档的页面方向的两面打印页面的装订。 “长边”假设沿着页面的长边进行装订（纵向打印为左边，横向打印为顶边）。 “短边”假设沿着页面的短边进行装订（纵向打印为顶边，横向打印为左边）。 纸张节省方向 自动 横向 纵向 指定合并打印文档的打印方向。 “自动”是出厂默认设置。打印机在纵向和横向之间进行选择。 纸张节省 关 2 页 3 页 4 页 6 页 9 页 12 页 16 页 指定在一张纸的一个面上打印多个页面图像。 “关”是出厂默认设置。 选定的数值是在每一个面上打印的页面图像数。 纸张节省边框 无 实线 在每一个页面图像上打印一个边框。 “无”是出厂默认设置。 纸张节省顺序 水平 水平反转 垂直反转 垂直 指定多页图像的放置位置。 “水平”是出厂默认设置。 位置根据页面图像数以及它们是纵向打印还是横向打印而定。 分隔页 关 份数之间 作业之间 页面之间 指定是否插入空白的分隔页。 “关”是出厂默认设置。 选择“份数之间”时，如果“逐份打印”被设置为 (1,2,3) (1,2,3)，则在打印作业的每个副本之间插入空白页。如果“逐份打印”被设置为 (1,1,1) (2,2,2)，则在每组打印页之间插入空白页，例如在所有第 1 页的后面，所有第 2 页的后面。 选择“作业之间”时，在打印作业之间插入空白页。 选择“页面之间”时，在打印作业的每个页面之间插入空白页。此设置在打印透明胶片或在文档中插入空白页时有用。 分隔页纸张来源 进纸匣 [x] 多功能进纸器 指定分隔页的纸张来源。 “进纸匣 1”是出厂默认设置。 空白页 不打印 打印 指定是否在打印作业中插入空白页。 “不打印”是出厂默认设置。 闪存驱动器菜单 菜单 闪存驱动器"},{"UUID":"a7bba553-59e5-485f-a6f6-937e0ffea4f5","title":"打印设置","link":"settings-group.html","desc":"“设置”菜单 “设置”菜单项及其描述 使用 来 打印机语言","descFull":"“设置”菜单 “设置”菜单项及其描述 使用 来 打印机语言 PCL 仿真 PS 仿真 设置默认的打印机语言。 “PCL 仿真”是出厂默认设置。 PostScript 仿真使用 PostScript 解释程序来处理打印作业。 “PCL 仿真”使用 PCL 解释程序来处理打印作业。 将一种打印机语言设置为默认语言不会阻止软件程序发送使用其他打印机语言的打印作业。 作业等待 开 关 确定当打印作业要求不可用的打印机选件或自定义设置时是否将它们从打印队列中删除。这些打印作业被存储在单独的打印队列中，以便其他作业能够正常打印。当获得缺少的信息或选件，或两者后，打印存储的作业。 “关”是出厂默认设置。 此菜单仅在安装了非只读的打印机硬盘时出现。此要求确保打印机掉电时存储的作业不会被删除。 打印区域 正常 整页 设置逻辑和物理的可打印区域。 “正常”是出厂默认设置。当试图打印由“正常”设置定义的不可打印区域内的数据时，打印机在边界上裁剪图像。 “整页”允许图像移动到由“正常”设置定义的不可打印区域内，但打印机在“正常”设置的边界上裁剪图像。此设置只影响使用 PCL 5e 解释程序打印的页面，对使用 PCL  XL 解释程序或 PostScript 解释程序打印的页面没有影响。 下载目标 RAM 闪存 硬盘 设置下载资源的存储位置。 RAM 是出厂默认设置。将下载资源保存在 RAM 中是暂时的存储方法。 将下载资源保存在闪存或打印机硬盘中是永久的存储方法。即使打印机电源被关闭，下载的资源仍保存在闪存或打印机硬盘中。 此菜单项仅在可选的闪存或打印机硬盘已安装时出现。 资源保存 开 关 指定打印机在接收所需内存比可用内存多的打印作业时，如何处理临时的下载资源，如存储在 RAM 中的字体和宏。 “关”是出厂默认设置。“关”设置打印机只将下载资源保留到内存被需要时为止。删除下载资源以便处理打印作业。 “开”设置打印机在语言改变和打印机复位期间保留下载资源。如果打印机内存用完，打印机显示屏上会出现 内存已满 [38] ，但下载资源不会被删除。 全部打印顺序 按字母顺序 先打印最旧作业 先打印最新作业 指定当选择“全部打印”时，挂起和保密作业的打印顺序。 “按字母顺序”是出厂默认设置。 设置菜单 菜单 设置"},{"UUID":"23e4a43d-a8fd-4472-be51-05eb8fae39e1","title":"打印设置","link":"settings-group.html","desc":"“输出”菜单 “输出”菜单项及其描述 使用 来 面数（双面打印）","descFull":"“输出”菜单 “输出”菜单项及其描述 使用 来 面数（双面打印） 1 面 2 面 指定是否将两面打印设置为所有打印作业的默认设置。 “1 面”是出厂默认设置。 您可以从打印机软件设置两面打印。 双面打印装订 长边 短边 定义双面打印页面被装订和打印的方式。 “长边”是出厂默认设置。这假设沿着页面的长边进行装订（纵向打印为左边，横向打印为顶边）。 “短边”假设沿着页面的短边进行装订（纵向打印为顶边，横向打印为左边）。 份数 1–999 为每一个打印作业指定默认的份数。 1 是出厂默认设置。 空白页 不打印 打印 指定是否在打印作业中插入空白页。 “不打印”是出厂默认设置。 逐份打印 (1,1,1) (2,2,2) (1,2,3) (1,2,3) 打印多份副本时，使打印作业的页面按顺序堆放。 “(1,2,3) (1,2,3)”是出厂默认设置。 分隔页 关 份数之间 作业之间 页面之间 指定是否插入空白的分隔页。 “关”是出厂默认设置。 选择“份数之间”时，如果“逐份打印”被设置为 (1,2,3) (1,2,3)，则在打印作业的每个副本之间插入空白页。如果“逐份打印”被设置为 (1,1,1) (2,2,2)，则在每组打印页之间插入空白页，例如在所有第 1 页的后面，所有第 2 页的后面。 选择“作业之间”时，在打印作业之间插入空白页。 选择“页面之间”时，在打印作业的每个页面之间插入空白页。此设置在打印透明胶片或在文档中插入空白页时有用。 分隔页纸张来源 进纸匣 [x] 多功能进纸器 指定分隔页的纸张来源。 “进纸匣 1”（标准进纸匣）是出厂默认设置。 从“纸张”菜单将“配置多功能进纸器”设置为“盒子”，以使“多功能进纸器”作为菜单设置出现。 纸张节省 关 2 页 3 页 4 页 6 页 9 页 12 页 16 页 在一张纸的一个面上打印多个页面图像。 “关”是出厂默认设置。 选定的数值是在每一个面上打印的页面图像数。 纸张节省顺序 水平 水平反转 垂直反转 垂直 指定在使用“纸张节省”时，多个页面图像的位置。 “水平”是出厂默认设置。 位置根据页面图像数以及它们是纵向打印还是横向打印而定。 纸张节省方向 自动 横向 纵向 指定合并打印文档的打印方向。 “自动”是出厂默认设置。打印机在纵向和横向之间进行选择。 纸张节省边框 无 实线 当使用“纸张节省”时打印边框。 “无”是出厂默认设置。 装订作业 自动 返回 双订 正面 关 指定是否装订打印输出。 “关”是出厂默认设置。 此菜单仅在支持的装订完成器已安装时出现。 运行装订器测试 打印报告，确认装订完成器工作正常。 此菜单仅在支持的装订完成器已安装时出现。 打孔 开 关 指定是否为整理活页夹或文件夹中的单页而在打印输出上打孔。 “关”是出厂默认设置。 此菜单仅在支持的装订、打孔完成器已安装时出现。 打孔模式 2 个孔 3 个孔 4 个孔 指定为整理活页夹或文件夹中的单页而在打印输出上打孔的个数。 “3 个孔”是美国的出厂默认设置。“4 个孔”是国际通用的出厂默认设置。 此菜单仅在支持的装订、打孔完成器已安装时出现。 偏移页 无 份数之间 作业之间 在某些情况下偏移页面。 “无”是出厂默认设置。 如果“逐份打印”设置为 (1,2,3) (1,2,3)，“份数之间”偏移打印作业的每一份副本。如果“逐份打印”设置为 (1,1,1) (2,2,2)，每一组打印页被偏移，如所有第一页和所有第二页。 “作业之间”为整个打印作业设置相同的偏移位置，而不管打印的份数。 此菜单仅在支持的装订完成器已安装时出现。 输出菜单 菜单 输出"},{"UUID":"2288c2df-e441-4f8e-b0d4-03348315c835","title":"打印设置","link":"settings-group.html","desc":"“质量”菜单 “质量”菜单项及其描述 使用 来 打印分辨率","descFull":"“质量”菜单 “质量”菜单项及其描述 使用 来 打印分辨率 300 dpi 600 dpi 1200 dpi 1200 图像质量 2400 图像质量 以每英寸点数（dpi）或图像质量指定打印输出分辨率。 600 dpi 是出厂默认设置。 像素增强 关 字体 水平 垂直 两个方向 启用更多的像素以明确和增强图像或文本。 “关”是出厂默认设置。 碳粉浓度 1–10 确定打印输出的浓度。 8 是出厂默认设置。 选择较小的数值可以节省碳粉。 增强细线 开 关 增强打印输出以具有更清晰边缘的更光滑线条。 “关”是出厂默认设置。 您可以从打印机软件设置这个选项。对于 Windows 用户，单击 文件 打印 ，然后单击 属性 或 首选项 。对于 Macintosh 用户，选择 文件 打印 ，然后从“打印”对话和上下文菜单调整设置。 要使用嵌入式网页服务器设置这个选项，请在 Web 浏览器的地址字段中键入网络打印机的 IP 地址。 灰度修正 自动 关 调整应用于图像的对比度增强。 “自动”是出厂默认设置。 明亮度 ‑6 至 6 减淡或加深打印输出。 0 是出厂默认设置。 对比度 0–5 调整打印对象的对比度。 0 是出厂默认设置。 质量菜单 菜单 质量"},{"UUID":"cf01e3f8-8091-4da6-b80a-df3944743232","title":"打印设置","link":"settings-group.html","desc":"“作业统计”菜单 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 “作业统计”菜单项及其描述 使用 来","descFull":"“作业统计”菜单 此菜单项仅在安装了已格式化并且工作的打印机硬盘时出现。 “作业统计”菜单项及其描述 使用 来 作业统计日志 关 开 确定并设置打印机是否创建它接收的打印作业的日志。 “关”是出厂默认设置。 作业统计实用程序 打印和删除日志文件或将它们导出到闪存驱动器。 统计日志频率 每天 每周 每月 确定并设置创建日志文件的频率。 “每月”为出厂默认设置。 频率结束时的日志操作 无 电邮当前日志 电邮并删除当前日志 发布当前日志 发布并删除当前日志 确定并设置当频率阈值到期时打印机如何响应。 “无”是出厂默认设置。 日志接近满水平 关 1–99 在打印机执行“接近满时的日志操作”之前，指定日志文件的最大大小。 5 是出厂默认设置。 接近满时的日志操作 无 电邮当前日志 电邮并删除当前日志 电邮并删除最旧的日志 发布当前日志 发布并删除当前日志 发布并删除最旧的日志 删除当前日志 删除最旧的日志 删除所有日志 删除除当前外的所有日志 确定当硬盘即将满时打印机如何响应。 “无”是出厂默认设置。 在“日志接近满水平”中定义的值决定此操作何时被触发。 已满时的日志操作 无 电邮并删除当前日志 电邮并删除最旧的日志 发布并删除当前日志 发布并删除最旧的日志 删除当前日志 删除最旧的日志 删除所有日志 删除除当前外的所有日志 确定并设置当磁盘使用达到最大限量（100MB）时，打印机如何响应。 “无”是出厂默认设置。 发布日志的 URL 确定并设置打印机发布作业统计日志的位置。 发送日志的电子邮件地址 指定打印机向其发送作业统计日志的电子邮件地址。 日志文件前缀 指定您要用于日志文件名中的前缀。 在 TCP/IP 菜单中定义的当前主机名被用作为默认的日志文件前缀。 作业统计菜单 菜单 作业统计"},{"UUID":"7f77f426-0d67-456d-a25d-de58448a23ad","title":"打印设置","link":"settings-group.html","desc":"“实用程序”菜单 “实用程序”菜单项及其描述 使用 来 删除挂起作业","descFull":"“实用程序”菜单 “实用程序”菜单项及其描述 使用 来 删除挂起作业 保密 挂起 未还原 全部 从打印机硬盘上删除保密和挂起作业。 选择一个设置只影响常驻在打印机中的打印作业。书签、闪存驱动器上的打印作业和其他类型的挂起作业不受影响。 “未还原”将删除所有 没有 从打印机硬盘或内存还原的“打印并挂起”作业。 格式化闪存 是 否 格式化闪存。 当正在格式化闪存时，不要关闭打印机电源。 选择“是”将删除保存在闪存中的所有数据。 选择“否”将取消格式化请求。 闪存是指通过在打印机内安装闪存卡而增加的内存。 闪存选件卡一定不能被读/写或写保护。 此菜单项仅在无故障的闪存卡已安装时出现。 删除磁盘上的下载资源 立即删除 不删除 从打印机硬盘上删除下载资源，包括所有挂起作业、已缓存的作业和暂存的作业。 “立即删除”设置打印机删除下载资源并允许在删除后显示屏返回到原始屏幕。 “不删除”设置打印机在删除后显示屏返回到原始屏幕。 激活十六进制打印 帮助隔离打印作业问题的来源。 当激活时，所有发送到打印机的数据以十六进制和字符方式进行打印，并且不执行控制代码。 要退出或停用“十六进制打印”，请关闭打印机电源或复位打印机。 覆盖率估算 关 开 提供页面上碳粉覆盖率的百分比估算值。估算值被打印在每个打印作业末尾的单独页面上。 “关”是出厂默认设置。 实用程序菜单 菜单 实用程序"},{"UUID":"4ab2c94c-f023-4eba-9578-c66255a2d045","title":"打印设置","link":"settings-group.html","desc":"XPS 菜单 XPS 菜单项及描述 使用","descFull":"XPS 菜单 XPS 菜单项及描述 使用 来 打印错误页 关 开 打印包含有关错误信息的页面，包括 XML 标记错误。 “关”是出厂默认设置。 XPS 菜单 菜单 XPS"},{"UUID":"88bc2d40-0e28-4d31-becc-bc1da18a44c5","title":"打印设置","link":"settings-group.html","desc":"PDF 菜单 PDF 菜单项及描述 使用","descFull":"PDF 菜单 PDF 菜单项及描述 使用 来 缩放以适合 是 否 缩放页面内容以适合选定的纸张尺寸。 “否”是出厂默认设置。 注释 不打印 打印 打印 PDF 中的注释。 “不打印”是出厂默认设置。 PDF 菜单 菜单 PDF"},{"UUID":"fb1cb14b-2303-48d3-962b-cedd1942507d","title":"打印设置","link":"settings-group.html","desc":"PostScript 菜单 PostScript 菜单项及描述 使用","descFull":"PostScript 菜单 PostScript 菜单项及描述 使用 来 打印 PS 错误 开 关 打印包含 PostScript 错误的页面。 “关”是出厂默认设置。 锁定 PS 启动模式 开 关 禁用 SysStart 文件。 “关”是出厂默认设置。 字体优先级 常驻 闪存/硬盘 建立字体搜索的顺序。 “常驻”是出厂默认设置。 此菜单项仅在已格式化的闪存选件卡或打印机硬盘已安装并操作正确时可用。 确认闪存选件或打印机硬盘没有被读/写、写或密码保护。 “作业缓冲区大小”一定不能设置为 100%。 PostScript 菜单 菜单 PostScript"},{"UUID":"8cf8fb58-2121-45e4-acc8-c1a3193d417b","title":"打印设置","link":"settings-group.html","desc":"“PCL 仿真”菜单 “PCL 仿真”菜单项及其描述 使用","descFull":"“PCL 仿真”菜单 “PCL 仿真”菜单项及其描述 使用 来 字体来源 常驻 硬盘 下载 闪存 全部 指定“字体名称”菜单使用的字体集。 “常驻”是出厂默认设置。“常驻”显示下载到 RAM 中的出厂默认字体集。 “闪存”和“硬盘”设置显示常驻在该选件中的所有字体。 闪存选件必须被正确格式化，并且不能被读/写，写或者密码保护。 “下载”显示所有下载到 RAM 中的字体。 “全部”显示对任何选件都可用的所有字体。 字体名称 Courier 10 识别特定字体和保存它的选件。 Courier 10 是出厂默认设置。Courier 10 显示字体名称、字体 ID 和打印机中的存储位置。字体来源缩写 R 表示“常驻”，F 表示“闪存”，K 表示“硬盘”，D 表示“下载”。 符号集 10U PC‑8 12U PC‑850 指定用于每一个字体名称的符号集。 10U PC‑8 是美国的出厂默认设置。12U PC‑850 是国际通用的出厂默认设置。 符号集是字母和数字字符、标点符号以及特殊符号的集合。符号集支持不同的语言或特定程序，例如用于科学文本的数学符号。只显示支持的符号集。 PCL 仿真设置 磅值 1.00–1008.00 更改可缩放印刷字体的磅值。 12 是出厂默认设置。 “磅值”指字体中字符的高度。一磅约等于 0.014 英寸。 磅值可以以 0.25 磅为单位递增或递减。 PCL 仿真设置 水平字距 0.08–100 指定可缩放单一宽度字体的水平字距。 10 是出厂默认设置。 “水平字距”指每英寸固定空间字符的个数（cpi）。 水平字距可以以 0.01 cpi 为单位递增或递减。 对于不可缩放的单一宽度字体，水平字距会出现在显示屏上，但不能被更改。 PCL 仿真设置 方向 纵向 横向 指定文本和图形在页面上的打印方向。 “纵向”是出厂默认设置。“纵向”沿着与页面短边平行的方向打印文本和图形。 “横向”沿着与页面长边平行的方向打印文本和图形。 PCL 仿真设置 每页行数 1–255 指定打印在每一页上的行数。 60 是美国的出厂默认设置。64 是国际通用的默认设置。 打印机根据“每页行数”、“纸张尺寸”和“打印方向”设置来设置每一行之间的距离。在设置“每页行数”之前，请先选择您需要的“纸张尺寸”和“打印方向”。 PCL 仿真设置 A4 宽度 198 毫米 203 毫米 设置打印机在 A4 尺寸的纸张上打印。 “198 毫米”是出厂默认设置。 203 毫米设置值将页面的宽度设置为允许打印 80 个水平字距为 10 的字符。 PCL 仿真设置 换行后自动回车 开 关 指定打印机是否在换行（LF）控制命令之后自动执行回车（CR）。 “关”是出厂默认设置。 PCL 仿真设置 回车后自动换行 开 关 指定打印机是否在回车（CR）控制命令之后自动执行换行（LF）。 “关”是出厂默认设置。 重编进纸匣号码 分配多功能进纸器 关 无 0–199 分配进纸匣 [x] 关 无 0–199 分配手动纸张 关 无 0–199 分配手动信封 关 无 0–199 配置打印机来与将不同来源分配用于进纸匣和进纸器的打印机软件或程序一起工作。 “关”是出厂默认设置。 “无”忽略“选择进纸”命令。此选项仅在它被 PCL 5 解释程序选定时出现。 “0–199”允许分配自定义设置。 重编进纸匣号码 查看出厂默认设置 MPF Default = 8 T1 Default = 1 T1 Default = 4 T1 Default = 5 T1 Default = 20 T1 Default = 21 Env Default = 6 MPaper Default = 2 MEnv Default = 3 显示分配给每一个进纸匣或进纸器的出厂默认设置。 重编进纸匣号码 还原默认设置 是 否 使所有进纸匣和进纸器分配返回到出厂默认设置。 PCL 仿真菜单 菜单 PCL 仿真"},{"UUID":"e8ecb084-81e7-4dd0-9482-a33d9b5c15a2","title":"打印设置","link":"settings-group.html","desc":"HTML 菜单 HTML 菜单项及描述 使用","descFull":"HTML 菜单 HTML 菜单项及描述 使用 来 字体名称 Albertus MT Antique Olive Apple Chancery Arial MT Avant Garde Bodoni Bookman Chicago Clarendon Cooper Black Copperplate Coronet Courier Eurostile Garamond Geneva Gill Sans Goudy Helvetica Hoefler Text Intl CG Times Intl Courier Intl Univers Joanna MT Letter Gothic Lubalin Graph Marigold MonaLisa Recut Monaco New CenturySbk New York Optima Oxford Palatino StempelGaramond Taffy Times TimesNewRoman Univers Zapf Chancery NewSansMTJA NewSansMTCS NewSansMTCT NewSansMTKO 为 HTML 文档设置默认字体。 在没有指定字体的 HTML 文档中使用 Times 字体。 HTML 菜单项及描述 使用 来 字体大小 1–255 磅 为 HTML 文档设置默认的字体大小。 “12 磅”是出厂默认设置。 字体大小可以以 1 磅为单位递增。 缩放 1–400% 为 HTML 文档缩放默认字体。 100% 是出厂默认设置。 “缩放”可以以 1% 为单位递增。 方向 纵向 横向 为 HTML 文档设置页面方向。 “纵向”是出厂默认设置。 页边距尺寸 8–255 毫米 为 HTML 文档设置页边距。 “19 毫米”是出厂默认设置。 页边距尺寸可以以 1 毫米为单位递增。 背景 不打印 打印 指定是否在 HTML 文档上打印背景。 “打印”是出厂默认设置。 HTML 菜单 菜单 HTML"},{"UUID":"7a69a556-9b42-40d3-a97a-a35eb809ebf2","title":"打印设置","link":"settings-group.html","desc":"“图像”菜单 “图像”菜单项及描述 使用 来 自动适合","descFull":"“图像”菜单 “图像”菜单项及描述 使用 来 自动适合 开 关 选择最佳的纸张尺寸、缩放比例和方向。 “开”是出厂默认设置。它覆盖某些图像的缩放比例和方向设置。 反转 开 关 反转黑白单色图像。 “关”是出厂默认设置。 此设置不能应用于 GIF 或 JPEG 图像。 缩放 左上角定位 最适合 中心定位 适合高度/ 宽度 适合高度 适合宽度 缩放图像以适合选定的纸张尺寸。 “最适合”是出厂默认设置。 当“自动适合”设置为“开”时，“缩放”被自动设置为“最适合”。 方向 纵向 横向 纵向反转 横向反转 设置图像方向。 “纵向”是出厂默认设置。 图像菜单 菜单 图像"},{"UUID":"04947f25-ffbb-4c17-bafd-96525e8899e8","title":"设置菜单","link":"settings-group.html","desc":"帮助菜单 “帮助”菜单项及其描述 菜单项 描述 打印所有指南","descFull":"帮助菜单 “帮助”菜单项及其描述 菜单项 描述 打印所有指南 打印所有指南 复印指南 提供有关制作副本和配置设置的信息 电子邮件指南 提供有关发送电子邮件和配置设置的信息 传真指南 提供有关发送传真和配置设置的信息 FTP 指南 提供有关扫描文档和配置设置的信息 打印缺陷指南 提供模板，用于确定重复打印质量缺陷的原因，并列出可被用于调整打印质量的设置 信息指南 提供找到其他信息的帮助 耗材指南 提供有关订购耗材的信息 菜单 帮助 帮助菜单"},{"UUID":"5b098ff8-39ef-4ab4-bfec-147bf30f3255","title":"节省费用和环境资源","link":"conserving-printer-energy-materials.html","desc":"Lexmark 一直致力于环境的可持续发展，并且不断地改善其打印机产品以减少它们对环境的影响。我们在产品设计中包含环保理念，设计生产的包装尽可能减少材料，并且提供收集和循环再生的计划。如需更多信息，请参阅： “注意事项”章节 Lexmark 网站上有关环境可持续发展的部分：","descFull":"Lexmark 一直致力于环境的可持续发展，并且不断地改善其打印机产品以减少它们对环境的影响。我们在产品设计中包含环保理念，设计生产的包装尽可能减少材料，并且提供收集和循环再生的计划。如需更多信息，请参阅： “注意事项”章节 Lexmark 网站上有关环境可持续发展的部分： www.lexmark.com/environment Lexmark 循环再生计划： www.lexmark.com/recycle 通过选择某些打印机设置或任务，您或许能够进一步减少打印机的影响。本章节概述可以获得更大环境效益的设置和任务。 我们一直致力于环境的可持续发展，并且不断地改善其打印机产品以减少它们对环境的影响。"},{"UUID":"72370a04-be13-4120-b8fb-b29ca8ef45e9","title":"节省纸张和碳粉","link":"conserving-printer-energy-materials.html","desc":"使用再生纸 作为具有环保意识的公司，Lexmark 支持使用专为激光打印机用途而生产的再生办公用纸。如需有关适用于您的打印机的再生纸的更多信息，请参阅 。 作为具有环保意识的公司，我们支持使用专为激光打印机用途而生产的再生办公用纸。如需有关适用于您的打印机的再生纸的更多信息，请参阅","descFull":"使用再生纸 作为具有环保意识的公司，Lexmark 支持使用专为激光打印机用途而生产的再生办公用纸。如需有关适用于您的打印机的再生纸的更多信息，请参阅 。 作为具有环保意识的公司，我们支持使用专为激光打印机用途而生产的再生办公用纸。如需有关适用于您的打印机的再生纸的更多信息，请参阅 。 纸张 使用再生纸 耗材 使用再生纸 再生纸 使用 使用再生纸"},{"UUID":"61befca2-b690-44c6-9923-f42f7e57f523","title":"节省纸张和碳粉","link":"conserving-printer-energy-materials.html","desc":"节省耗材 使用纸张的两个面 如果您的打印机型号支持两面打印，您可以控制打印在纸张的一个面还是两个面上。 两面打印是打印驱动程序中的默认设置。 如需支持的产品和国家/地区的完整列表，请转到","descFull":"节省耗材 使用纸张的两个面 如果您的打印机型号支持两面打印，您可以控制打印在纸张的一个面还是两个面上。 两面打印是打印驱动程序中的默认设置。 如需支持的产品和国家/地区的完整列表，请转到  http://support.lexmark.com www.dell.com/support 。 将多个页面放在一张纸上 您可以通过为打印作业设置“缩排并印（N 页）”来将多页文档中的最多 16 个连续页面打印在一张纸的一个面上。 检查第一份草稿的正确性 在打印或制作文档的多份副本之前： 使用预览特性来在您打印之前查看文档的外观。 使用预览特性来在您打印之前查看文档的外观。 打印文档的一份副本来检查其内容和格式的正确性。 避免卡纸 正确设置纸张类型和尺寸以避免卡纸。如需更多信息，请参阅 。 节省耗材 耗材 节省 环保设置 节省耗材 节省设置 节省耗材"},{"UUID":"efe9d709-4558-4929-b815-f42bb59bae00","title":"节省能源","link":"conserving-printer-energy-materials.html","desc":"使用“休眠”模式 “休眠”是一种超低功耗运行模式。 “3 天”是打印机在进入“休眠”模式之前的默认时间。 确认在发送打印作业之前，将打印机从“休眠”模式唤醒。硬件复位或者长按“睡眠”按钮将打印机从“休眠”模式唤醒。","descFull":"使用“休眠”模式 “休眠”是一种超低功耗运行模式。 “3 天”是打印机在进入“休眠”模式之前的默认时间。 确认在发送打印作业之前，将打印机从“休眠”模式唤醒。硬件复位或者长按“睡眠”按钮将打印机从“休眠”模式唤醒。 如果打印机处于“休眠”模式，那么 Embedded Web Server 被禁用。 从主屏幕，导览至： 设置 常规设置 从“按睡眠按钮”或“按住睡眠按钮”菜单，选择 休眠 ，然后触摸 提交 。 休眠模式 使用 使用“休眠”模式 环保设置 休眠模式 节省设置 休眠模式 绿色设置 休眠模式"},{"UUID":"5f3da503-4dca-432e-a5f0-b79745027c23","title":"节省能源","link":"conserving-printer-energy-materials.html","desc":"使用 Eco 模式 打开 Web","descFull":"使用 Eco 模式 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 常规设置 Eco 模式  选择一个设置 Eco 模式设置及描述 使用 来 关 将出厂默认设置用于所有与 Eco 模式相关联的设置。“关”设置支持本打印机的性能规格。 能源 减少能源使用，尤其在打印机空闲的时候。 在准备好打印之前，打印机引擎马达不启动。您可能注意到在打印第一页之前有短暂的延迟。 打印机在不活动一分钟之后进入睡眠模式。 能源/纸张 使用所有与“能源”和“纸张”模式相关联的设置。 普通纸张 启用自动两面（双面）打印功能。 关闭打印日志功能。 单击 提交 。 Eco 模式设置 环保设置 Eco 模式 节省设置 Eco 模式 绿色设置 Eco 模式"},{"UUID":"92ffe4fd-2de8-4300-857c-65f7b7d99b8e","title":"节省能源","link":"conserving-printer-energy-materials.html","desc":"调整“睡眠模式” 从主屏幕，导览至： 设置 常规设置 超时","descFull":"调整“睡眠模式” 从主屏幕，导览至： 设置 常规设置 超时 睡眠模式 在“睡眠模式”字段中，选择打印机在进入“睡眠”模式之前空闲的分钟数。 应用更改。 睡眠模式 调整 调整“睡眠”模式 环保设置 睡眠模式 节省设置 睡眠模式"},{"UUID":"94a32674-ad4c-4e0b-9ab9-54b38891b0a4","title":"节省能源","link":"conserving-printer-energy-materials.html","desc":"调整打印机显示屏的明亮度 为节省能源，或者如果您阅读显示屏有困难，请调整它的明亮度设置。 使用 Embedded Web","descFull":"调整打印机显示屏的明亮度 为节省能源，或者如果您阅读显示屏有困难，请调整它的明亮度设置。 使用 Embedded Web Server 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在“网络/端口”菜单的 TCP/IP 部分中查看打印机的 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 常规设置 。 在“屏幕明亮度”字段中，输入您希望用于显示屏的明亮度百分比。 单击 提交 。 显示屏，打印机控制面板 调整明亮度 打印机控制面板 调整明亮度 Embedded Web Server 调整明亮度 环保设置 打印机显示屏明亮度，调整 节省设置 明亮度，调整 调整打印机显示屏明亮度"},{"UUID":"5ea8ea76-6608-44bb-a49e-5556695af475","title":"循环再生","link":"conserving-printer-energy-materials.html","desc":"Lexmark 提供收集计划及合乎环境要求的逐步循环再生办法。如需更多信息，请参阅： “注意事项”章节 Lexmark 网站上有关环境可持续发展的部分：","descFull":"Lexmark 提供收集计划及合乎环境要求的逐步循环再生办法。如需更多信息，请参阅： “注意事项”章节 Lexmark 网站上有关环境可持续发展的部分： www.lexmark.com/environment Lexmark 循环再生计划： www.lexmark.com/recycle"},{"UUID":"b5de9e11-60ed-4bc6-85cb-3d21c5097c5a","title":"循环再生","link":"conserving-printer-energy-materials.html","desc":"循环再生 Lexmark 产品 要返回 Lexmark","descFull":"循环再生 Lexmark 产品 要返回 Lexmark 产品以循环再生： 转到  www.lexmark.com/recycle 。 查找您要循环再生的产品类型，然后从列表中选择您所在的国家或地区。 按照计算机屏幕上的指导进行操作。 Lexmark 收集计划中未列出的打印机耗材和硬件可以通过您当地的回收中心回收。请与您当地的回收中心联系来确定他们接受的项目。 循环再生 Lexmark 产品"},{"UUID":"602c88e3-97fd-4a75-8b6d-812438d7623b","title":"循环再生","link":"conserving-printer-energy-materials.html","desc":"循环再生 Lexmark 包装 Lexmark 一直致力于尽量减少包装。较少的包装有助于确保","descFull":"循环再生 Lexmark 包装 Lexmark 一直致力于尽量减少包装。较少的包装有助于确保 Lexmark 打印机以最有效和环保的方式进行运输，而且只有较少的包装材料需要处理。这些努力可减少温室气体排放，节约能源并节省自然资源。 Lexmark 纸板箱在存在瓦楞纸回收设施的地区是 100% 可回收的。这些设施在您所在区域内可能不存在。 Lexmark 包装中使用的泡沫塑料在存在泡沫塑料回收设施的地区是可回收的。这些设施在您所在区域内可能不存在。  当您返回碳粉盒给 Lexmark 时，您可以重新使用碳粉盒的包装箱。Lexmark 将循环再生包装箱。 循环再生 Lexmark 包装"},{"UUID":"cde24a30-db52-48d4-a23d-65ca6f8f06b1","title":"循环再生","link":"conserving-printer-energy-materials.html","desc":"返回 Lexmark 碳粉盒以再使用或循环再生 “Lexmark 碳粉盒收集计划”通过让","descFull":"返回 Lexmark 碳粉盒以再使用或循环再生 “Lexmark 碳粉盒收集计划”通过让 Lexmark 客户简单容易并免费地返回旧碳粉盒给 Lexmark 以再使用或循环再生，每年使上百万个 Lexmark 碳粉盒不被运到垃圾填埋场去处理。返回给 Lexmark 的空碳粉盒百分之百被再使用或被拆解以循环再生。用于返回碳粉盒的包装箱也被回收利用。 要返回 Lexmark 碳粉盒以再使用或循环再生，请按照随您的打印机或碳粉盒附带的说明进行操作并使用预付费的运输标签。您也可以执行下列操作： 转到  www.lexmark.com/recycle 。 从“碳粉盒”部分，选择您所在的国家或地区。 按照计算机屏幕上的指导进行操作。 碳粉盒 循环再生 循环再生 碳粉盒"},{"UUID":"2398c895-e49e-46d0-8a4c-6b33c476b402","title":"保护打印机","link":"using-security-lock-feature-m-topic.html","desc":"","descFull":"使用安全锁特性 打印机配置了安全锁特性。当连接了与大多数笔记本电脑兼容的锁时，打印机被锁定。当锁定时，控制器板挡板和控制器板不能被移除。在如图所示的位置将安全锁连接到打印机。 锁，安全 安全锁"},{"UUID":"1f0f197d-bc40-43ff-b768-c767ca130851","title":"保护打印机","link":"statement-of-volatility-h-topic.html","desc":"易失性声明 您的打印机包含各种内存，可以存储设备和网络设置，以及用户数据。 内存类型及其描述 内存类型 描述","descFull":"易失性声明 您的打印机包含各种内存，可以存储设备和网络设置，以及用户数据。 内存类型及其描述 内存类型 描述 易失性内存 您的打印机使用标准 随机存取内存 （RAM）在简单打印作业期间临时缓存用户数据。 非易失性内存 您的打印机可以使用两种形式的非易失性内存：EEPROM 和 NAND（闪烁存储器）。两种类型都用来保存操作系统、设备设置、网络信息、书签设置和嵌入式解决方案。 硬盘内存 一些打印机已经安装硬盘驱动器。打印机硬盘专为设备特定功能设计。这让设备可以保留从复杂的打印作业缓存的用户数据，以及表单数据和字体数据。 在下列情况下清除任何已安装的打印机内存中的内容： 打印机正要停止工作。 正在更换打印机硬盘。 打印机正被移动到另一个部门或位置。 打印机正在由您组织以外的人员维修。 为了维修将打印机从您的处所移出。 打印机被出售给另一个组织。 打印机硬盘的处置 一些打印机型号可能没有安装打印机硬盘。 在高度安全环境中，可能有必要执行额外的步骤来确保当打印机—或它的硬盘—从您的处所被移出时打印机硬盘上保存的机密数据不会被访问。 消磁 —用清除存储数据的磁场刷新硬盘 压碎 —物理上将硬盘压成破碎的部件并使它们不可读 粉碎 —物理上将硬盘粉碎成小的金属块 大多数数据可被电子清除，但只有每个存储数据的硬盘被物理破坏才能保证所有的数据被完全清除。 易失性声明 易失性 声明 内存 安装在打印机上的类型 易失性内存 非易失性内存 打印机硬盘的处置 打印机硬盘 处置"},{"UUID":"a7c850a8-03dc-4b29-bbe2-334e39106868","title":"保护打印机","link":"erasing-volatile-memory-h-topic.html","desc":"","descFull":"清除易失性内存 安装在您打印机内的易失性内存（RAM）需要电源来保留信息。要清除已缓存的数据，只需关闭打印机电源。 易失性内存 清除 清除易失性内存"},{"UUID":"1128b326-e952-41b1-ab3c-ee06881949c7","title":"保护打印机","link":"erasing-non-volatile-memory-h-topic.html","desc":"清除非易失性内存 通过下列步骤，清除单独设置、设备和网络设置、安全设置，以及嵌入式解决方案： 关闭打印机电源。 从控制面板，按下 ","descFull":"清除非易失性内存 通过下列步骤，清除单独设置、设备和网络设置、安全设置，以及嵌入式解决方案： 关闭打印机电源。 从控制面板，按下  2  和  6 ，并同时打开打印机电源。当屏幕上出现进程条时松开两个按钮。 从“配置”菜单，导览至： 还原出厂默认设置 清除打印机内存 是 在此过程中打印机将重启几次。 触摸 返回 ，然后退出“配置”菜单。 打印机执行加电复位，然后返回到正常的操作模式。 非易失性内存 清除 单独设置信息 清除 设备和网络设置信息 清除 安全设置信息 清除 嵌入式解决方案信息 清除 清除非易失性内存"},{"UUID":"09e5bb1d-c69d-488e-91a1-2f2ee3a27c7d","title":"保护打印机","link":"erasing-printer-hard-disk-memory-h1-topic.html","desc":"清除打印机硬盘内存 关闭打印机电源。 从控制面板，按下  2","descFull":"清除打印机硬盘内存 关闭打印机电源。 从控制面板，按下  2  和  6 ，并同时打开打印机电源。当屏幕上出现进程条时松开两个按钮。 从“配置”菜单，导览至： 还原出厂默认设置 清除硬盘  选择清除硬盘内存的方法 是 此过程可能需要花费几分钟到一个多小时，在此期间打印机不能用于其他用户任务。 触摸 返回 ，然后退出“配置”菜单。 打印机执行加电复位，然后返回到正常的操作模式。 打印机硬盘内存 清除 清除硬盘内存"},{"UUID":"c3764934-249c-499e-85b3-686bbf2b68f0","title":"保护打印机","link":"configuring-printer-hard-disk-encryption-topic.html","desc":"配置打印机硬盘加密 启用硬盘加密来防止在打印机或其硬盘被盗时丢失敏感数据。 一些打印机型号可能没有安装硬盘。 关闭打印机电源。 从控制面板，按下","descFull":"配置打印机硬盘加密 启用硬盘加密来防止在打印机或其硬盘被盗时丢失敏感数据。 一些打印机型号可能没有安装硬盘。 关闭打印机电源。 从控制面板，按下  2  和  6 ，并同时打开打印机电源。只有当屏幕上出现进程条时才能松开两个按钮。 触摸 磁盘加密 启用 。 启用磁盘加密会清除硬盘的内容。 触摸 是 来执行磁盘擦除。 在加密过程中不要关闭打印机电源。这样做可能会丢失数据。 磁盘加密可能需要花费几分钟到一个多小时，在此期间打印机不能用于其他用户任务。 状态栏指出磁盘擦除任务的进度。当磁盘被加密后，打印机返回到“启用/禁用”屏幕。 触摸 返回 ，然后退出“配置”菜单。 打印机执行加电复位，然后返回到正常的操作模式。 打印机硬盘加密 加密打印机硬盘 打印机硬盘 加密"},{"UUID":"e2e97c6b-52ba-4ff0-8064-3baa1a79fce3","title":"保护打印机","link":"finding-printer-security-information-b-topic.html","desc":"查找打印机安全信息 在高安全性环境中，可能有必要采取额外的步骤，以确保存储在打印机内的保密数据不会被未经授权的人员访问。如需更多信息，请转到  Lexmark security","descFull":"查找打印机安全信息 在高安全性环境中，可能有必要采取额外的步骤，以确保存储在打印机内的保密数据不会被未经授权的人员访问。如需更多信息，请转到  Lexmark security Web page  或参阅  http://support.lexmark.com  上的  Embedded Web Server — Security: Administrator’s Guide（Embedded Web Server — 安全：管理员指南） 。 在高安全性环境中，您可能需要采取额外的步骤，以确保存储在打印机内的保密数据不会被未经授权的人员访问。如需更多信息，请从打印机 CD 或者我们的网站查看  Embedded Web Server — Security: Administrator’s Guide（Embedded Web Server — 安全：管理员指南） ，或者与您购买打印机处的销售商联系。 安全 Web 页 打印机安全信息 Embedded Web Server — Security: Administrator’s Guide（Embedded Web Server — 安全：管理员指南） 何处查找 打印机安全性 有关信息 保密数据 有关安全的信息"},{"UUID":"60cf7689-1afd-4e1c-af39-0f9babbb717a","title":"清洁打印机部件","link":"cleaning-printer-topic.html","desc":"清洁打印机 您可能需要每隔几个月执行此任务一次。 因不当处理造成的打印机损坏不在打印机保修范围内。 确认您已经关闭打印机电源，并且从电源插座中拔掉电源线。 为避免在清洁打印机的外部时发生电击危险，请在操作之前从电源插座中拔掉电源线并断开打印机上连接的所有电缆。","descFull":"清洁打印机 您可能需要每隔几个月执行此任务一次。 因不当处理造成的打印机损坏不在打印机保修范围内。 确认您已经关闭打印机电源，并且从电源插座中拔掉电源线。 为避免在清洁打印机的外部时发生电击危险，请在操作之前从电源插座中拔掉电源线并断开打印机上连接的所有电缆。 从标准接纸架和多功能进纸器中取出纸张。 使用软毛刷或真空吸尘器清除打印机周围的所有灰尘、绒毛和纸片。 用水润湿一块干净、不起毛的布，并用它擦拭打印机的外部。 不要使用家庭用的清洁剂或洗涤剂，以防止损坏打印机的外部。 确认在发送新的打印作业之前，打印机的所有区域都是干燥的。 打印机外部 清洁 清洁 打印机外部 清洁打印机"},{"UUID":"21e722a7-6263-4970-91e6-b165dff3f1f4","title":"清洁打印机部件","link":"cleaning-printer-topic.html","desc":"清洁扫描仪玻璃 如果您遇到打印质量问题，如复印或扫描的图像上有条纹，请清洁扫描仪玻璃。 打开扫描仪盖板。 使用柔软或不起毛的布擦拭所示区域。 扫描仪玻璃的各部分","descFull":"清洁扫描仪玻璃 如果您遇到打印质量问题，如复印或扫描的图像上有条纹，请清洁扫描仪玻璃。 打开扫描仪盖板。 使用柔软或不起毛的布擦拭所示区域。 扫描仪玻璃的各部分 1 扫描仪盖板的白色内面 2 扫描仪玻璃 3 ADF 玻璃 4 ADF 盖板的白色内面 关闭扫描仪盖板。 扫描仪玻璃 清洁 打印质量 清洁扫描仪玻璃 清洁 扫描仪玻璃"},{"UUID":"0f29f349-7b41-4a79-a148-91d3e341a653","title":"清洁打印机部件","link":"cleaning-printer-topic.html","desc":"清洁充电辊和打印头镜片 打开底部前盖门。 移除废碳粉瓶。 找到白色凸片。 轻轻地拉出凸片直到它停止，然后缓慢地将它滑回原位。重复三次。","descFull":"清洁充电辊和打印头镜片 打开底部前盖门。 移除废碳粉瓶。 找到白色凸片。 轻轻地拉出凸片直到它停止，然后缓慢地将它滑回原位。重复三次。 移除打印头刷片。 将刷片插入孔中直到它停止，然后将它滑出。重复三次。 将刷片放入其固定器中。 重新安装废碳粉瓶。 关闭底部前盖门。 充电辊 清洁 打印质量，疑难解答 清洁充电辊 清洁充电辊 打印头镜片 清洁 打印质量，疑难解答 清洁打印头镜片 清洁打印头镜片"},{"UUID":"bcc545fc-3fc8-426b-a2ab-e545f71252b3","title":"清洁打印机部件","link":"cleaning-printer-topic.html","desc":"清空打孔箱 打开盖门 H。 移除并清空打孔箱。 重新安装打孔箱。","descFull":"清空打孔箱 打开盖门 H。 移除并清空打孔箱。 重新安装打孔箱。 关闭盖门 H。 打孔箱 清空 清空打孔箱"},{"UUID":"768c9d44-46b7-42b0-bdcc-7337fb82410a","title":"检查部件和耗材的状态","link":"checking-status-of-parts-and-supplies-on-printer-control-panel-topic.html","desc":"在打印机控制面板上检查部件和耗材状态 从主屏幕，触摸 状态/耗材 > ","descFull":"在打印机控制面板上检查部件和耗材状态 从主屏幕，触摸 状态/耗材 >  查看耗材 。 检查部件和耗材的状态 耗材状态 检查 部件状态 检查 耗材 检查，从打印机控制面板 部件 检查，从打印机控制面板"},{"UUID":"109e3a25-090e-43c1-95db-4f05b2a37435","title":"检查部件和耗材的状态","link":"checking-status-of-parts-and-supplies-on-printer-control-panel-topic.html","desc":"从 Embedded Web Server 检查部件和耗材的状态","descFull":"从 Embedded Web Server 检查部件和耗材的状态 确认计算机和打印机都被连接到相同的网络上。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。  如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设备状态 更多详细信息 。 耗材 检查状态 部件 检查状态 检查部件和耗材的状态 耗材 检查，使用 Embedded Web Server 部件 检查，使用 Embedded Web Server Embedded Web Server 检查耗材状态 Embedded Web Server 检查部件状态"},{"UUID":"5511a654-f95c-4509-a69a-a8eb18f184b4","title":"维护打印机","link":"estimated-number-remaining-pages-topic.html","desc":"估算的剩余页数 估算的剩余页数基于打印机的最近打印历史确定。其准确性可能会有明显的不同，并且取决于许多因素，如实际的文档内容、打印质量设置，以及其他打印机设置。 当实际的打印消耗与历史的打印消耗不同时，估算剩余页数的准确性可能会降低。在根据估算值购买或更换耗材之前，请考虑准确性的变化程度。在打印机上获得足够的打印历史记录之前，初步估算假设未来的耗材消耗基于国际标准化组织*的测试方法和页面内容而定。 *平均连续黑色 CMY","descFull":"估算的剩余页数 估算的剩余页数基于打印机的最近打印历史确定。其准确性可能会有明显的不同，并且取决于许多因素，如实际的文档内容、打印质量设置，以及其他打印机设置。 当实际的打印消耗与历史的打印消耗不同时，估算剩余页数的准确性可能会降低。在根据估算值购买或更换耗材之前，请考虑准确性的变化程度。在打印机上获得足够的打印历史记录之前，初步估算假设未来的耗材消耗基于国际标准化组织*的测试方法和页面内容而定。 *平均连续黑色 CMY 的标称碳粉盒打印量符合 ISO/IEC 19752 标准。 剩余页数 估算"},{"UUID":"07b141d2-a59f-44c4-b1c2-f0397f7090af","title":"订购耗材","link":"ordering-supplies.html","desc":"使用正品 Lexmark 部件和耗材 您的 Lexmark","descFull":"使用正品 Lexmark 部件和耗材 您的 Lexmark 打印机设计为使用正品 Lexmark 耗材和部件时运行性能最佳。使用第三方耗材或部件可能影响打印机及其成像组件的性能、可靠性或使用寿命。使用第三方耗材或部件会影响保修范围。由于使用第三方耗材或部件而造成的损坏不在保修范围内。所有使用寿命指示器都是围绕 Lexmark 耗材和部件而设计，如果使用第三方耗材或部件可能出现不可预知的结果。超出预期使用寿命使用成像组件可能损坏您的 Lexmark 打印机或其相关组件。 部件 使用正品 Lexmark 耗材 使用正品 Lexmark"},{"UUID":"156e6ef2-3f66-495c-8c17-fc1985915c8e","title":"订购耗材","link":"ordering-supplies.html","desc":"订购碳粉盒 如需订购碳粉盒，请与您购买打印机处的销售商联系。 碳粉盒容量基于 ISO/IEC 19752","descFull":"订购碳粉盒 如需订购碳粉盒，请与您购买打印机处的销售商联系。 碳粉盒容量基于 ISO/IEC 19752 标准估算。 长时间的极低打印覆盖率可能对实际打印量有负面影响。 Lexmark 碳粉盒及部件号 部件名称 部件号 高容量碳粉盒 64G0H00 订购耗材 碳粉盒 耗材，订购 碳粉盒 碳粉盒 订购"},{"UUID":"12de73d1-94a5-493d-85a4-4278de208aa0","title":"订购耗材","link":"ordering-supplies.html","desc":"订购感光鼓 长时间的极低打印覆盖率可能造成感光鼓在碳粉耗尽之前部分失效。 如需订购感光鼓，请与您购买打印机处的销售商联系。 打印机耗材及其部件号 项目","descFull":"订购感光鼓 长时间的极低打印覆盖率可能造成感光鼓在碳粉耗尽之前部分失效。 如需订购感光鼓，请与您购买打印机处的销售商联系。 打印机耗材及其部件号 项目 部件号 感光鼓 54G0P00 订购 感光鼓 耗材，订购 感光鼓 感光鼓 订购"},{"UUID":"22f7a8ab-bc36-4619-84c3-c5796ef85e0a","title":"订购耗材","link":"ordering-supplies.html","desc":"订购废碳粉瓶 如需订购废碳粉瓶，请与您购买打印机处的销售商联系。 废碳粉瓶及其部件号 项目 部件号","descFull":"订购废碳粉瓶 如需订购废碳粉瓶，请与您购买打印机处的销售商联系。 废碳粉瓶及其部件号 项目 部件号 废碳粉瓶 54G0W00 订购耗材 废碳粉瓶 耗材，订购 废碳粉瓶 废碳粉瓶 订购"},{"UUID":"7de93bf6-3ef2-4d57-8bd2-61cefef25ee7","title":"订购耗材","link":"ordering-supplies.html","desc":"订购订书钉盒 如需订购订书钉盒，请与您购买打印机处的销售商联系。 打印机耗材及部件号 项目 部件号","descFull":"订购订书钉盒 如需订购订书钉盒，请与您购买打印机处的销售商联系。 打印机耗材及部件号 项目 部件号 订书钉盒 25A0013 订购 订书钉盒 耗材，订购 订书钉盒 订书钉盒 订购"},{"UUID":"002dc58e-99e7-462c-84a9-81d8e9ff4af2","title":"维护打印机","link":"ordering-maintenance-kit-topic.html","desc":"订购 300K 维护组件 如需订购维护组件，请与您购买打印机处的销售商联系。 如需更换维护组件中包含的部件，请参阅随每个部件附带的说明页。","descFull":"订购 300K 维护组件 如需订购维护组件，请与您购买打印机处的销售商联系。 如需更换维护组件中包含的部件，请参阅随每个部件附带的说明页。 Lexmark 维护组件类型 项目 部件号 维护组件 40X9669 订购 300K 维护组件 部件，订购 300K 维护组件 300K 维护组件 订购"},{"UUID":"42fb12a9-89f7-44ed-91be-dc10c9eb8e96","title":"存储部件和耗材","link":"storing-supplies-topic.html","desc":"保存耗材 为打印机耗材选择一个阴凉、干净的地方保存。将耗材正面朝上并保存在原来的包装内，直到您准备使用它们。 不要将耗材暴露在： 直射的阳光下 温度高于","descFull":"保存耗材 为打印机耗材选择一个阴凉、干净的地方保存。将耗材正面朝上并保存在原来的包装内，直到您准备使用它们。 不要将耗材暴露在： 直射的阳光下 温度高于 35°C（95°F）的环境中 高湿度（高于 80%）的环境中 含盐分的空气中 腐蚀性气体中 浓重的粉尘中 保存 耗材 耗材 保存"},{"UUID":"040251fc-0adf-4d75-bd81-1209806c0ce2","title":"存储部件和耗材","link":"storing-supplies-topic.html","desc":"存储辊 打印机配有存储在标准进纸匣内部隔间内的替换辊。当您购买新的辊之后，请确认将它们存储在进纸匣内部的隔间内。 如需正确处置部件和耗材，请参阅 。 保存","descFull":"存储辊 打印机配有存储在标准进纸匣内部隔间内的替换辊。当您购买新的辊之后，请确认将它们存储在进纸匣内部的隔间内。 如需正确处置部件和耗材，请参阅 。 保存 部件 部件 保存"},{"UUID":"9ae850ad-12e3-474b-9c5b-ab368c3a8510","title":"更换耗材","link":"replacing-supplies.html","desc":"更换感光鼓 打开底部前盖门。 移除废碳粉瓶。 解锁感光鼓。 移除感光鼓。","descFull":"更换感光鼓 打开底部前盖门。 移除废碳粉瓶。 解锁感光鼓。 移除感光鼓。 拆开新感光鼓的包装。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 请勿触摸感光鼓。否则会影响以后打印作业的打印质量。 安装感光鼓。 锁定感光鼓。 重新安装废碳粉瓶。 关闭底部前盖门。 打印质量 更换感光鼓 感光鼓 更换"},{"UUID":"3591a3ae-c005-4d08-9472-f48118cb5c1a","title":"更换订书钉盒","link":"replacing-supplies.html","desc":"更换装订完成器中的订书钉盒 装订完成器仅在精选的打印机型号中被支持。 按装订完成器上的插销，然后将完成器滑到左边。 移除订书钉盒支架。 从订书钉盒支架上移除空的订书钉盒。","descFull":"更换装订完成器中的订书钉盒 装订完成器仅在精选的打印机型号中被支持。 按装订完成器上的插销，然后将完成器滑到左边。 移除订书钉盒支架。 从订书钉盒支架上移除空的订书钉盒。 将新的订书钉盒插入订书钉盒支架中。 将订书钉盒支架推入完成器中，直到支架发出 咔嗒 一声，卡入到位。 将完成器滑回原位。 更换耗材 装订完成器中的订书钉盒 更换装订完成器中的订书钉盒 装订完成器中的订书钉盒 更换"},{"UUID":"c37d7e04-f20b-4408-9301-061424f44601","title":"更换订书钉盒","link":"replacing-supplies.html","desc":"更换小册子完成器中的订书钉盒 打开盖门 H，然后拉出小册子制作器。 移除订书钉盒支架。 从订书钉盒支架上移除空的订书钉盒。","descFull":"更换小册子完成器中的订书钉盒 打开盖门 H，然后拉出小册子制作器。 移除订书钉盒支架。 从订书钉盒支架上移除空的订书钉盒。 将新的订书钉盒插入订书钉盒支架中。 将订书钉盒支架推入小册子制作器中，直到支架发出 咔嗒 一声，卡入到位。 将小册子制作器推回原位，然后关闭盖门。 更换耗材 小册子完成器中的订书钉盒 更换小册子完成器中的订书钉盒 小册子完成器中的订书钉盒 更换"},{"UUID":"20adf3ac-661d-4e1b-9156-747bb2e3257e","title":"更换订书钉盒","link":"replacing-supplies.html","desc":"更换装订、打孔完成器中的订书钉盒 打开盖门 H。 移除订书钉盒支架。 从订书钉盒支架上移除空的订书钉盒。","descFull":"更换装订、打孔完成器中的订书钉盒 打开盖门 H。 移除订书钉盒支架。 从订书钉盒支架上移除空的订书钉盒。 将新的订书钉盒插入订书钉盒支架中。 将订书钉盒支架推入完成器中，直到支架发出 咔嗒 一声，卡入到位。 关闭盖门 H。 更换耗材 装订、打孔完成器中的订书钉盒 更换装订、打孔完成器中的订书钉盒 装订、打孔完成器中的订书钉盒 更换"},{"UUID":"b453ecdc-bf26-4a1a-a0c6-d49733bae81d","title":"更换耗材","link":"replacing-supplies.html","desc":"更换碳粉盒 打开顶部前盖门。 逆时针转动碳粉盒，然后将它拉出。 拆开新碳粉盒的包装，移除包装材料，然后摇晃碳粉盒使碳粉重新分布。 将碳粉盒插入打印机中。","descFull":"更换碳粉盒 打开顶部前盖门。 逆时针转动碳粉盒，然后将它拉出。 拆开新碳粉盒的包装，移除包装材料，然后摇晃碳粉盒使碳粉重新分布。 将碳粉盒插入打印机中。 顺时针转动碳粉盒以将它锁定到位。 关闭顶部前盖门。 清洁充电辊和打印头镜片。如需更多信息，请参阅 。 碳粉盒 更换 更换碳粉盒 更换耗材 碳粉盒"},{"UUID":"2c0601be-a97e-4876-999f-569bbbd274b3","title":"更换耗材","link":"replacing-supplies.html","desc":"更换废碳粉瓶 打开底部前盖门。 移除废碳粉瓶。 清洁充电辊和打印头镜片。如需更多信息，请参阅 的第","descFull":"更换废碳粉瓶 打开底部前盖门。 移除废碳粉瓶。 清洁充电辊和打印头镜片。如需更多信息，请参阅 的第 3-7 步。 拆开新的废碳粉瓶的包装。 将新的废碳粉瓶插入打印机中，直到它发出 咔嗒 一声，卡入到位。 关闭底部前盖门。 更换耗材 废碳粉瓶 更换废碳粉瓶 废碳粉瓶 更换"},{"UUID":"a70880c9-f119-40c0-90db-157c0293d491","title":"更换 300K 维护组件","link":"replacing-exhaust-ozone-filters-topic.html","desc":"更换排气和臭氧过滤器 过滤器的位置 1 排气过滤器 2","descFull":"更换排气和臭氧过滤器 过滤器的位置 1 排气过滤器 2 臭氧过滤器 更换排气过滤器 拉出排气过滤器。 拆开新排气过滤器的包装。 插入新的过滤器。 更换臭氧过滤器 拉出臭氧过滤器。 拆开新臭氧过滤器的包装。 插入新的过滤器。 排气过滤器 更换 更换排气过滤器 臭氧过滤器 更换 更换臭氧过滤器"},{"UUID":"29b0fc91-e8c1-410b-8d27-d6dfc213fe6d","title":"更换 300K 维护组件","link":"replacing-exhaust-ozone-filters-topic.html","desc":"更换拾纸、进纸和分离辊 打印机辊 1 拾纸辊 2","descFull":"更换拾纸、进纸和分离辊 打印机辊 1 拾纸辊 2 进纸辊 3 分离辊 您可以使用存储在标准进纸匣内部隔间内的辊。如需更多信息，请参阅 。 关闭打印机电源。 移除所有进纸匣。 标准进纸匣 2 x 500 或 2500 页进纸匣选件 要移除 2 x 500 页进纸匣选件，请按照移除标准进纸匣的步骤进行操作。 打开盖门 C。确保它不触及任何连接到打印机的电缆。 如果 3000 页进纸匣已安装，请滑动进纸匣以打开盖门。 打开盖门 D。 如果 2 x 500 页或 2500 页进纸匣选件已安装，您只能打开盖门 D。 如果 3000 页进纸匣已安装，请滑动进纸匣以打开盖门。 找到辊。 移除辊。 插入新的辊，直到发出 咔嗒 一声，卡入到位。 确认将辊插入其正确的位置中。 关闭盖门 C 和 D。 插入进纸匣。 更换部件 拾纸、进纸、分离辊 更换拾纸、进纸和分离辊 辊 更换"},{"UUID":"fc3c852e-0a1a-44b2-9d42-26c3e5cee503","title":"更换 300K 维护组件","link":"replacing-exhaust-ozone-filters-topic.html","desc":"更换转印模块 请使用打印机底部前盖门内的螺丝起子。 关闭打印机电源。 打开盖门 C。确保它不触及任何连接到打印机的电缆。","descFull":"更换转印模块 请使用打印机底部前盖门内的螺丝起子。 关闭打印机电源。 打开盖门 C。确保它不触及任何连接到打印机的电缆。 打印机内部可能很烫。为避免被发热组件烫伤的危险，在接触组件之前，请等待表面冷却。 如果 3000 页进纸匣已安装，请将进纸匣滑到右边以打开盖门。 移除盖门挡板。 松开转印模块锁的螺钉。 移除纸张导片。 使用手柄抬起转印模块，然后将它完全拉出。 拆开新转印模块的包装。 不要让转印带暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 请勿触摸转印带。否则会影响以后打印作业的打印质量。 插入新的转印模块，直到发出 咔嗒 一声，卡入到位。 将纸张导片放回原位。 拧紧转印模块锁的螺钉。 重新安装盖门挡板。 关闭盖门 C。 转印模块 更换 更换转印模块 更换部件 转印模块"},{"UUID":"32740ee8-8bb5-421c-818e-262be33a3b29","title":"更换 300K 维护组件","link":"replacing-exhaust-ozone-filters-topic.html","desc":"更换转印辊 打开盖门 C。确保它不触及任何连接到打印机的电缆。 如果 3000","descFull":"更换转印辊 打开盖门 C。确保它不触及任何连接到打印机的电缆。 如果 3000 页进纸匣已安装，请将进纸匣滑到右边以打开盖门。 拉出转印辊。 拆开新转印辊的包装。 插入新的转印辊，直到发出 咔嗒 一声，卡入到位。 关闭盖门 C。 更换部件 转印辊 更换转印辊 转印辊 更换"},{"UUID":"45041a05-66e1-4a5a-b9bd-6d450d4bef50","title":"更换 300K 维护组件","link":"replacing-exhaust-ozone-filters-topic.html","desc":"重置维护计数器 关闭打印机电源。 从控制面板，按下  2","descFull":"重置维护计数器 关闭打印机电源。 从控制面板，按下  2  和  6 ，并同时打开打印机电源。当屏幕上出现进程条时松开两个按钮。 从“配置”菜单，导览至： 重置维护计数器 重置 300K 维护组件 触摸 返回 ，然后退出“配置”菜单。 打印机执行加电复位，然后返回到正常的操作模式。 重置维护计数器 维护计数器，重置"},{"UUID":"8026b859-4ad7-4017-a85a-75474c68f2e9","title":"维护打印机","link":"replacing-adf-scan-pad-topic.html","desc":"更换 ADF 扫描垫 打开扫描仪盖板。 移除","descFull":"更换 ADF 扫描垫 打开扫描仪盖板。 移除 ADF 扫描垫。 拆开新的 ADF 扫描垫的包装，然后移除包装材料。 将 ADF 扫描垫平放在扫描仪玻璃上，白色区域面朝下。 关闭扫描仪盖板以使 ADF 扫描垫粘到盖板上，然后打开盖板。 推 ADF 扫描垫的各个角，将它固定到位。 关闭扫描仪盖板。 ADF 扫描垫 更换 更换 ADF 扫描垫"},{"UUID":"5a57b7d4-9a81-4a4a-9b2e-660ada55c569","title":"移动打印机","link":"moving-the-printer.html","desc":"在移动打印机之前 在移动打印机之前，请按照下列指南来避免人身伤害或打印机损坏： 关闭打印机电源，然后从电源插座上拔掉电源线。 断开打印机上的所有电源线和电缆。 如果打印机没有带脚轮基座，但配置了进纸匣选件，请移除进纸匣。","descFull":"在移动打印机之前 在移动打印机之前，请按照下列指南来避免人身伤害或打印机损坏： 关闭打印机电源，然后从电源插座上拔掉电源线。 断开打印机上的所有电源线和电缆。 如果打印机没有带脚轮基座，但配置了进纸匣选件，请移除进纸匣。 使用打印机两边的把手来抬起它。 确认在放下打印机时您的手指不在打印机的下面。 确认打印机周围有足够的空间。 请只使用随本产品提供的电源线或经制造商许可的替代品。 因不当移动造成的打印机损坏不在打印机保修范围内。 移动打印机 打印机 移动"},{"UUID":"41ffe4d1-91a2-4752-bb98-d2d3cfd9d4f7","title":"移动打印机","link":"moving-the-printer.html","desc":"将打印机移动到其他位置 使用平头螺丝起子重新安装螺钉以锁定扫描仪平板到位。 在另一位置设置打印机之后，请移除螺钉。 如果需要，请使用有足够大表面能支持整个打印机尺寸的平板车。 使打印机保持直立状态。","descFull":"将打印机移动到其他位置 使用平头螺丝起子重新安装螺钉以锁定扫描仪平板到位。 在另一位置设置打印机之后，请移除螺钉。 如果需要，请使用有足够大表面能支持整个打印机尺寸的平板车。 使打印机保持直立状态。 请避免震动。 打印机 移动 移动打印机"},{"UUID":"abe297fa-90ab-4ca8-b930-2b7805ff2bd8","title":"移动打印机","link":"moving-the-printer.html","desc":"","descFull":"运输打印机 当运输打印机时，请使用原包装。 打印机 运输 运输打印机"},{"UUID":"36584bec-45b3-4b89-8013-a5937e9d221c","title":"管理打印机","link":"checking-virtual-display-h-topic.html","desc":"检查虚拟显示屏 打开 Web 浏览器，然后在地址字段中键入打印机 IP","descFull":"检查虚拟显示屏 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 检查出现在屏幕左上角的虚拟显示屏。 虚拟显示屏的功能象打印机控制面板上的实际显示屏一样。 检查虚拟显示屏 使用 Embedded Web Server 虚拟显示屏 检查，使用 Embedded Web Server 检查虚拟显示屏 使用 Embedded Web Server"},{"UUID":"ca05f018-53ce-4621-9581-4274c92bb7cd","title":"管理打印机","link":"setting-up-e-mail-alert-topic.html","desc":"设置电子邮件警报 配置打印机在耗材变得不足或纸张需要更换或添加，或者发生卡纸时发送电子邮件警报给您。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"设置电子邮件警报 配置打印机在耗材变得不足或纸张需要更换或添加，或者发生卡纸时发送电子邮件警报给您。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 。 从“其他设置”菜单，单击 电子邮件警报设置 。 选择您希望收到通知的项目，然后键入电子邮件地址。 单击 提交 。 如需有关设置电子邮件服务器的信息，请与您的系统支持人员联系。 Embedded Web Server 设置电子邮件警报 电子邮件警报 低耗材水平 电子邮件警报 纸张卡住 电子邮件警报 设置 设置电子邮件警报"},{"UUID":"bc3d2d73-da72-47e7-8d14-9bf456a57803","title":"管理打印机","link":"viewing-reports-topic.html","desc":"查看报告 您可以从 Embedded Web Server","descFull":"查看报告 您可以从 Embedded Web Server 查看一些报告。这些报告可用于评估打印机、网络和耗材的状态。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 报告 ，然后单击您要查看的报告类型。 查看 报告 报告 查看"},{"UUID":"956c66ed-7f96-4d16-849d-02e30b482d7b","title":"管理打印机","link":"copying-printer-settings-to-other-printers-topic.html","desc":"将打印机设置复制到其他打印机 此特性仅在网络打印机上可用。 打开 Web 浏览器，然后在地址字段中键入打印机","descFull":"将打印机设置复制到其他打印机 此特性仅在网络打印机上可用。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在“网络/端口”菜单的 TCP/IP 部分中查看打印机的 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 复制打印机设置 。 如需更改语言，请从下拉菜单中选择语言，然后单击 单击此处来提交语言 。 单击 打印机设置 。 在其适当的字段中键入源打印机和目标打印机的 IP 地址。 如果您要添加或移除目标打印机，请单击 添加目标 IP  或 移除目标 IP 。  单击 复制打印机设置 。 Embedded Web Server 将设置复制到其他打印机 菜单设置 加载到多台打印机上 配置 多台打印机"},{"UUID":"4e37cb46-0503-44fb-bb87-ffc836e65212","title":"管理打印机","link":"configuring-supply-notifications-h2-topic.html","desc":"从 Embedded Web Server 配置耗材通知","descFull":"从 Embedded Web Server 配置耗材通知 您可以通过设置可选的警报来确定您想要在耗材变得即将不足、不足、接近使用寿命期限或达到其使用寿命期限时如何获得通知。 可以为某些耗材的某些耗材状况设置提示警报的估算剩余耗材百分比。 打开 Web 浏览器，然后键入打印机 IP 地址。 单击 设置 打印设置 耗材通知 。 从下拉菜单，选择下列通知选项之一： 通知选项及其描述 通知 描述 1  当耗材通知启用时，打印机生成一个有关耗材状态的电子邮件。 2  当一些耗材变空时，打印机停止工作以防止损坏。 关 发生所有耗材的正常打印机行为。 仅 SNMP 当出现耗材状况时，打印机生成一个“简单网络管理协议（SNMP）”警报。耗材的状态出现在菜单页和状态页上。 电子邮件 当出现耗材状况时，打印机生成一个电子邮件。耗材的状态出现在菜单页和状态页上。 警告 打印机显示警告消息并生成一个有关耗材状态的电子邮件。当出现耗材状况时，打印机不停止工作。 可继续停止 1 当出现耗材状况时打印机停止处理作业，并且用户需要按按钮才能继续打印。 不可继续停止 1,2 当出现耗材状况时，打印机停止处理作业。必须更换耗材才能继续打印。 单击 提交 。 耗材通知 配置 配置耗材通知"},{"UUID":"08f69c75-ddf2-4ad2-9635-9fa30725fc14","title":"管理打印机","link":"restoring-factory-default-settings-h-topic.html","desc":"还原出厂默认设置 如果您想要保留当前菜单设置列表作为参考，请在还原出厂默认设置之前打印菜单设置页。如需更多信息，请参阅 。 如需更全面的方法还原打印机的出厂默认设置，请参阅 。","descFull":"还原出厂默认设置 如果您想要保留当前菜单设置列表作为参考，请在还原出厂默认设置之前打印菜单设置页。如需更多信息，请参阅 。 如需更全面的方法还原打印机的出厂默认设置，请参阅 。 还原出厂默认设置将使大多数打印机设置返回到最初的出厂默认设置。例外情况包括显示语言、自定义尺寸和消息，以及“网络/端口”菜单设置。保存在 RAM 中的所有下载资源都被删除。保存在闪存或打印机硬盘上的下载资源不受影响。 从主屏幕，导览至： 设置 常规设置 出厂默认设置 立即还原 应用更改。 控制面板 出厂默认设置，还原 出厂默认设置 还原 还原出厂默认设置"},{"UUID":"1dedf134-5aeb-4f7a-899c-d22decbca740","title":"清除卡纸","link":"avoiding-jams-topic.html","desc":"避免卡纸 正确加载纸张 确认纸张平整地放在进纸匣中。 正确和不正确的纸张加载 正确的纸张加载","descFull":"避免卡纸 正确加载纸张 确认纸张平整地放在进纸匣中。 正确和不正确的纸张加载 正确的纸张加载 不正确的纸张加载 当打印机正在打印时不要取出进纸匣。 当打印机正在打印时不要加载进纸匣。请在打印之前加载它，或等待提示出现后再加载。 不要加载过多纸张。确认纸堆高度低于最大纸张加载指示线。 不要将纸张滑入进纸匣中。如图所示加载纸张。 确认进纸匣或多功能进纸器中的导片都被正确放置，并且没有与纸张或信封靠得太紧。 加载纸张后用力将进纸匣推入打印机中。 使用推荐的纸张 仅使用推荐的纸张或特殊介质。 不要加载有褶皱、有折痕、潮湿、弯曲或卷曲的纸张。 在加载之前，弯曲、成扇形展开纸张并对齐纸张的边缘。 不要使用经手工切割或裁剪的纸张。 不要在同一个进纸匣中混合不同尺寸、重量或类型的纸张。 确认在计算机或打印机控制面板上正确设置纸张尺寸和类型。 请按照制造商的建议存储纸张。 卡纸 避免 纸张卡住 避免 避免卡纸"},{"UUID":"9366df19-e777-4e54-98fd-765c2d0689b2","title":"清除卡纸","link":"understanding-jam-messages-topic.html","desc":"理解卡纸消息和位置 当发生卡纸时，打印机显示屏上会出现指示卡纸位置和信息以清除卡纸的消息。打开显示屏上指示的盖门、盖板和进纸匣来移除卡纸。 当“卡纸协助”设置为“开”时，打印机在清除被卡的页面后送出空白页或部分打印的页面。检查您的打印输出是否有空白页。 当“卡纸恢复”设置为“开”或“自动”时，打印机重新打印被卡的页面。然而，“自动”设置仅在有足够的打印机内存可用时才会重新打印被卡的页面。 卡纸位置和解决方案","descFull":"理解卡纸消息和位置 当发生卡纸时，打印机显示屏上会出现指示卡纸位置和信息以清除卡纸的消息。打开显示屏上指示的盖门、盖板和进纸匣来移除卡纸。 当“卡纸协助”设置为“开”时，打印机在清除被卡的页面后送出空白页或部分打印的页面。检查您的打印输出是否有空白页。 当“卡纸恢复”设置为“开”或“自动”时，打印机重新打印被卡的页面。然而，“自动”设置仅在有足够的打印机内存可用时才会重新打印被卡的页面。 卡纸位置和解决方案 区域名称 1 自动文档传送器（ADF） 2 盖门 C 3 盖门 D 4 盖门 F 5 进纸匣 6 盖门 H 7 完成器接纸架 8 盖门 J 9 区域 G 卡纸位置和解决方案 区域名称 控制面板消息 操作 ADF [x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx] 打开 ADF 顶部盖门，然后取出被卡的纸张。 多功能进纸器 [x] 页卡住，从多功能进纸器中清除被卡的纸张。[200.xx] 从进纸器中取出被卡的纸张。 盖门 C，进纸匣 [x] 页卡住，打开盖门 C 并清除所有被卡的纸张。[2yy.xx] 打开盖门 C，然后取出被卡的纸张。 拉出进纸匣，然后取出被卡的纸张。 [x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx] 盖门 D，进纸匣 [x] 页卡住，打开盖门 D 并清除所有被卡的纸张。[24y.xx] 打开盖门 D，然后取出被卡的纸张。 拉出进纸匣，然后取出被卡的纸张。 [x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx] 盖门 C 和 F [x] 页卡住，滑动 3000 页进纸匣并打开盖门 F。[24y.xx] 拉出 3000 页进纸匣，然后从进纸匣侧面取出被卡的纸张。 打开盖门 F，然后取出被卡的纸张。 区域 G，盖门 C、J 和 H，完成器接纸架 [x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。[4yy.xx] 打开盖门 G，然后取出被卡的纸张。 打开盖门 H，然后取出被卡的纸张。 盖门 C 和 G，完成器接纸架 [x] 页卡住，按压盖门 G 旁边的插销并将完成器向左滑动。将纸张留在接纸架中。[40y.xx] 将装订完成器滑到左边，然后取出被卡的纸张。 区域 G，盖门 C、J 和 H，完成器接纸架 [x] 页卡住，打开盖门 H 并顺时针旋转旋钮 SD3。将纸张留在接纸架中。[426.xx–428.xx] 打开盖门 H，然后取出被卡的纸张。 卡纸 定位卡纸区域 卡纸 号码 卡纸 位置"},{"UUID":"09585eae-4019-4e3f-b9af-2bd46aabad39","title":"清除卡纸","link":"message-page-jam-clear-manual-feeder-topic.html","desc":"[x] 页卡住，从多功能进纸器中清除被卡的纸张。[200.xx] 从多功能进纸器中取出所有纸张。 取出被卡的纸张。 打开盖门","descFull":"[x] 页卡住，从多功能进纸器中清除被卡的纸张。[200.xx] 从多功能进纸器中取出所有纸张。 取出被卡的纸张。 打开盖门 C 以取出所有纸张碎片。 确保盖门 C 不触及任何连接到打印机的电缆。 关闭盖门 C。 前后弯曲纸张，使它们松散，然后将它们扇形展开。不要折叠或弄皱纸张。对齐纸张的边缘。 重新加载纸张。 卡纸，清除 在多功能进纸器中 纸张卡住，清除 在多功能进纸器中 打印机消息 [x] 页卡住，清理手动进纸器。[200.xx] [x] 页卡住，清理手动进纸器。[200.xx]"},{"UUID":"ab6056d3-391f-450b-a894-9caed5fcf8b2","title":"清除卡纸","link":"paper-jam-open-door-c-clear-all-jammed-media-topic.html","desc":"[x] 页卡住，打开盖门 C 并清除所有被卡的纸张。[2yy.xx] 打开盖门","descFull":"[x] 页卡住，打开盖门 C 并清除所有被卡的纸张。[2yy.xx] 打开盖门 C。确保它不触及任何连接到打印机的电缆。 从下面的任何位置取出被卡的纸张： 确认已取出所有纸张碎片。 打印机内部可能很烫。为避免被发热组件烫伤的危险，在接触组件之前，请等待表面冷却。 定影器区域 在定影器区域下方 双面打印区域 在双面打印区域上方 打开标准进纸匣，然后找到被卡的纸张。 取出被卡的纸张。 确认已取出所有纸张碎片。 关闭进纸匣和盖门 C。 纸张卡住，清除 盖门 C 盖门 C 纸张卡住，清除 打印机消息 [x] 页卡住，打开盖门 C 并清除所有被卡的介质。[2yy.xx] [x] 页卡住，打开盖门 C 并清除所有被卡的介质。[2yy.xx]"},{"UUID":"f57fb48b-c0f5-415a-b7a0-aed0231eea98","title":"清除卡纸","link":"paper-jam-slide-tray-open-door-c-topic.html","desc":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx]","descFull":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx] 滑动 3000 页进纸匣。 打开盖门 C。确保它不触及任何连接到打印机的电缆。 从下面的任何位置取出被卡的纸张： 确认已取出所有纸张碎片。 打印机内部可能很烫。为避免被发热组件烫伤的危险，在接触组件之前，请等待表面冷却。 定影器区域 在定影器区域下方 双面打印区域 在双面打印区域上方 打开标准进纸匣，然后找到被卡的纸张。 取出被卡的纸张。 确认已取出所有纸张碎片。 关闭进纸匣和盖门 C。 将 3000 页进纸匣滑回原位。 纸张卡住，清除 盖门 C 盖门 C 纸张卡住，清除 打印机消息 [x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx] [x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx]"},{"UUID":"0f6c0ef3-e38f-4fb4-8f0d-311a7ebcd4fc","title":"清除卡纸","link":"paper-jam-open-door-d-clear-all-jammed-media-topic.html","desc":"[x] 页卡住，打开盖门 D 并清除所有被卡的纸张。[24y.xx] 打开盖门","descFull":"[x] 页卡住，打开盖门 D 并清除所有被卡的纸张。[24y.xx] 打开盖门 D，然后取出被卡的纸张。 确认已取出所有纸张碎片。 打开进纸匣选件，然后找到被卡的纸张。 取出被卡的纸张。 确认已取出所有纸张碎片。 关闭进纸匣和盖门 D。 纸张卡住，清除 盖门 D 盖门 D 纸张卡住，清除 打印机消息 [x] 页卡住，打开盖门 D 并清除所有被卡的介质。[24y.xx] [x] 页卡住，打开盖门 D 并清除所有被卡的介质。[24y.xx]"},{"UUID":"157635de-9c93-49a2-b6cb-b66fff318e0b","title":"清除卡纸","link":"paper-jam-slide-tray-open-door-d-topic.html","desc":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx]","descFull":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx] 滑动 3000 页进纸匣。 打开盖门 D，然后取出被卡的纸张。 确认已取出所有纸张碎片。 打开进纸匣选件，然后找到被卡的纸张。 取出被卡的纸张。 确认已取出所有纸张碎片。 关闭进纸匣和盖门 D。 将 3000 页进纸匣滑回原位。 纸张卡住，清除 盖门 D 盖门 D 纸张卡住，清除 打印机消息 [x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx] [x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx]"},{"UUID":"d6cbebfa-1e69-4322-bf9e-6ab709c94525","title":"清除卡纸","link":"message-page-jam-detach-tray-open-door-f-topic.html","desc":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 F。[24y.xx]","descFull":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 F。[24y.xx] 滑动 3000 页进纸匣。 取出被卡的纸张。 确认已取出所有纸张碎片。 打开盖门 F，然后取出被卡的纸张。 确认已取出所有纸张碎片。 关闭盖门 F。 打开盖门 C。确保它不触及任何连接到打印机的电缆。 从下面的任何位置取出被卡的纸张： 确认已取出所有纸张碎片。 打印机内部可能很烫。为避免被发热组件烫伤的危险，在接触组件之前，请等待表面冷却。 定影器区域 在定影器区域下方 双面打印区域 在双面打印区域上方 关闭盖门 C，然后将 3000 页进纸匣滑回原位。 卡纸，清除 在 3000 页进纸匣中 纸张卡住，清除 在 3000 页进纸匣中 纸张卡住，清除 在盖门 F 内 纸张卡住，清除 在盖门 C 内 卡纸，清除 在盖门 F 内 卡纸，清除 在盖门 C 内 打印机消息 [x] 页卡住，分离 3000 页进纸匣并打开盖门 F。[24y.xx] [x] 页卡住，分离 3000 页进纸匣并打开盖门 F。[24y.xx]"},{"UUID":"8ad20a5f-aa50-45ed-9956-5090c56fee65","title":"清除卡纸","link":"message-page-jam-open-doors-g-h-j-clear-jammed-paper-topic.html","desc":"[x] 页卡住，打开盖门 G、H 和 J","descFull":"[x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。将纸张留在接纸架中。[4yy.xx] 打开盖门 G，然后取出被卡的纸张。 确认已取出所有纸张碎片。 打开盖门 J，然后将手柄 J1 抬至其垂直的位置。 打开盖门 H。 从下面的任何位置取出被卡的纸张： 确认已取出所有纸张碎片。 盖门 J 如果在完成器接纸架之间有卡住的纸张，请取出纸张。 区域 H1 和 H2 区域 H3 和 H4 区域 H6 关闭盖门 H。 打开盖门 C，然后取出被卡的纸张。 确保盖门 C 不触及任何连接到打印机的电缆。 确认已取出所有纸张碎片。 如果 3000 页进纸匣已安装，请将进纸匣滑到右边以打开盖门。 关闭盖门 C。 打印机消息 [x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。将纸张留在接纸架中。[400–402] [x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。将纸张留在接纸架中。[400–402]"},{"UUID":"c2b560a9-f17b-4f4e-8271-57d710ed0b8f","title":"清除卡纸","link":"message-page-jam-press-latch-to-access-area-g-leave-paper-in-bin-topic.html","desc":"[x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx] 从装订完成器接纸架中取出所有纸张。 按插销并将装订完成器滑到左边，然后取出被卡的纸张。","descFull":"[x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx] 从装订完成器接纸架中取出所有纸张。 按插销并将装订完成器滑到左边，然后取出被卡的纸张。 确认已取出所有纸张碎片。 如果需要，向下转动转轮 G1 以将被卡的纸张送入完成器接纸架中，然后取出纸张。 将完成器滑回原位。 打开盖门 C，然后取出被卡的纸张。 打印机内部可能很烫。为避免被发热组件烫伤的危险，在接触组件之前，请等待表面冷却。 确保盖门 C 不触及任何连接到打印机的电缆。 确认已取出所有纸张碎片。 如果 3000 页进纸匣已安装，请将进纸匣滑到右边以打开盖门。 关闭盖门 C。 打印机消息 [x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx] [x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx]"},{"UUID":"9123e23c-15b8-4562-a443-bf59f05367af","title":"清除卡纸","link":"message-page-jam-press-latch-to-access-area-g-clear-jammed-staples-leave-paper-in-bin-topic.html","desc":"[x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93] 从装订完成器接纸架中取出所有纸张。","descFull":"[x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93] 从装订完成器接纸架中取出所有纸张。 按装订完成器上的插销，然后将完成器滑到左边。 移除订书钉盒支架。 使用金属凸片来抬起订书钉护板，然后取出所有松散的订书钉。 向下压订书钉护板，直到它发出 咔嗒 一声，卡入到位。 对着金属支架按压订书钉。 如果订书钉在订书钉盒的后部，请朝下晃动订书钉盒，使订书钉靠近金属支架。 将订书钉盒支架推入完成器中，直到支架发出 咔嗒 一声，卡入到位。 将完成器滑回原位。 打印机消息 [x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93] [x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93]"},{"UUID":"0253509c-c4c7-4462-a3e1-e03ff6b91bb3","title":"清除卡纸","link":"message-paper-jam-open-door-h-rotate-knob-h6-clockwise-leave-paper-in-bin-topic.html","desc":"[x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx–428.xx]","descFull":"[x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx–428.xx] 如果被卡的纸张位于盖门 G 下面，请打开盖门并取出纸张。 打开盖门 J，然后抬起手柄 J1。 打开盖门 H。 从下面的任何位置取出被卡的纸张： 确认已取出所有纸张碎片。 盖门 J 如果在完成器接纸架之间有卡住的纸张，请移除纸张。 区域 H1 和 H2 区域 H3 和 H4 区域 H6 使用手柄 H5，拉出小册子制作器。 从下面的任何位置取出被卡的纸张： 确认已取出所有纸张碎片。 区域 H8 区域 H9 区域 H10 将小册子制作器推回原位。 关闭盖门 H。 打开盖门 C，然后取出被卡的纸张。 打印机内部可能很烫。为避免被发热组件烫伤的危险，在接触组件之前，请等待表面冷却。 确保盖门 C 不触及任何连接到打印机的电缆。 确认已取出所有纸张碎片。 如果 3000 页进纸匣已安装，请将进纸匣滑到右边以打开盖门。 关闭盖门 C。 打印机消息 [x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx–428.xx] [x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx–428.xx]"},{"UUID":"8921e4a9-eb40-489d-83f0-f74c270c54f2","title":"清除卡纸","link":"message-page-jam-press-latch-area-e-open-adf-top-cover-topic.html","desc":"[x] 页卡住，按下区域 E 处的插销以打开 ADF","descFull":"[x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx] 从 ADF 进纸匣中取出所有原始文档。 打开顶部的 ADF 顶部盖板。 取出被卡的纸张。 确认已取出所有纸张碎片。 关闭盖板。 打开扫描仪盖板，然后打开底部的 ADF 盖门。 取出被卡的纸张。 确认已取出所有纸张碎片。 关闭盖门。 关闭扫描仪盖板。 卡纸，清除 在顶部 ADF 盖门内 纸张卡住，清除 在底部 ADF 盖门内 打印机消息 [x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx] [x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx] 打印机消息"},{"UUID":"3c316274-f207-484c-9be1-396555eadd9c","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"碳粉不足 [88.xy] 您可能需要订购替换的碳粉盒。如果需要，请在打印机控制面板上触摸 继续 来清除消息并继续打印。","descFull":"碳粉不足 [88.xy] 您可能需要订购替换的碳粉盒。如果需要，请在打印机控制面板上触摸 继续 来清除消息并继续打印。 打印机消息 碳粉不足 [88.xy] 碳粉不足 [88.xy]"},{"UUID":"3250b1e0-1b80-4baa-9a22-cfa2c5bae4c5","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"碳粉即将不足 [88.xy] 如果需要，请在打印机控制面板上触摸 继续 ","descFull":"碳粉即将不足 [88.xy] 如果需要，请在打印机控制面板上触摸 继续  来清除消息并继续打印。 打印机消息 碳粉即将不足 [88.xy] 碳粉即将不足 [88.xy]"},{"UUID":"ff963018-97f2-496a-a829-d2b3bc737c3c","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"碳粉非常不足 [88.xy] 您可能很快就需要更换碳粉盒。如需更多信息，请参阅 。 如果需要，请在控制面板上触摸","descFull":"碳粉非常不足 [88.xy] 您可能很快就需要更换碳粉盒。如需更多信息，请参阅 。 如果需要，请在控制面板上触摸 继续 来清除消息并继续打印。 打印机消息 碳粉非常不足 [88.xy] 碳粉非常不足 [88.xy]"},{"UUID":"02e8c814-79a9-426a-9602-1a0633c1d3e5","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更改 [纸张来源] 为 [自定义字符串] 加载","descFull":"更改 [纸张来源] 为 [自定义字符串] 加载 [方向] 请尝试下列办法中的一个或多个： 在进纸匣中加载正确尺寸和类型的纸张，在控制面板上的“纸张”菜单中指定纸张尺寸和类型，然后触摸 已完成更改纸张 。 触摸 使用当前 [纸张来源]  来使用进纸匣中可用的纸张尺寸和类型。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 更改 [纸张来源] 为 [自定义字符串] 加载 [方向] 更改 [纸张来源] 为 [自定义字符串] 加载 [方向]"},{"UUID":"85e97a12-ff94-4ae6-bd86-7da05474c7ea","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更改 [纸张来源] 为 [自定义类型名称] 加载","descFull":"更改 [纸张来源] 为 [自定义类型名称] 加载 [方向] 请尝试下列办法中的一个或多个： 在进纸匣或进纸器中加载正确尺寸和类型的纸张，在打印机控制面板上的“纸张”菜单中指定纸张尺寸和类型，然后触摸 已完成更改纸张 。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 更改 [纸张来源] 为 [自定义类型名称] 加载 [方向] 更改 [纸张来源] 为 [自定义类型名称] 加载 [方向]"},{"UUID":"8a4113a5-666c-44bb-9cc5-045ef34c5426","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更改 [纸张来源] 为 [纸张尺寸] 加载","descFull":"更改 [纸张来源] 为 [纸张尺寸] 加载 [方向] 请尝试下列办法中的一个或多个： 在进纸匣或进纸器中加载正确尺寸和类型的纸张，在控制面板上的“纸张”菜单中指定纸张尺寸和类型，然后触摸 已完成更改纸张 。 触摸 使用当前 [纸张来源]  来使用当前进纸匣或进纸器中可用的纸张尺寸和类型。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 更改 [纸张来源] 为 [纸张尺寸] 加载 [方向] 更改 [纸张来源] 为 [纸张尺寸] 加载 [方向]"},{"UUID":"526468b4-b352-45f7-b48c-c5cecb435032","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更改 [纸张来源] 为 [纸张类型] [纸张尺寸]","descFull":"更改 [纸张来源] 为 [纸张类型] [纸张尺寸] 加载 [方向] 请尝试下列办法中的一个或多个： 在进纸匣或进纸器中加载正确尺寸和类型的纸张，在控制面板上的“纸张”菜单中指定纸张尺寸和类型，然后触摸 已完成更改纸张 。 触摸 使用当前 [纸张来源]  来使用进纸匣中可用的纸张尺寸和类型。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 更改 [纸张来源] 为 [纸张类型] [纸张尺寸] 加载 [方向] 更改 [纸张来源] 为 [纸张类型] [纸张尺寸] 加载 [方向]"},{"UUID":"d65173d8-71d2-498c-86b1-467dab724b5d","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"关闭盖门 [x] 关闭指定的盖门。 打印机消息 关闭盖门","descFull":"关闭盖门 [x] 关闭指定的盖门。 打印机消息 关闭盖门 [x] 关闭盖门 [x]"},{"UUID":"ad72d719-6a4a-4d05-b7fc-2f3bd79f5999","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"复杂页面，一些数据可能未被打印 [39] 请尝试下列办法中的一个或多个： 从控制面板，触摸 继续","descFull":"复杂页面，一些数据可能未被打印 [39] 请尝试下列办法中的一个或多个： 从控制面板，触摸 继续 来清除消息并继续打印。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消打印作业。 安装额外的打印机内存。 打印机消息 复杂页面，一些数据可能未被打印 [39] 复杂页面，一些数据可能未被打印 [39]"},{"UUID":"6d8e0be6-c639-4192-bc60-a693ed154553","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"配置改变，一些挂起作业未被还原 [57] 由于打印机中下列可能的更改，挂起作业是无效的： 打印机固件已被更新。 用于打印作业的进纸匣已被移除。","descFull":"配置改变，一些挂起作业未被还原 [57] 由于打印机中下列可能的更改，挂起作业是无效的： 打印机固件已被更新。 用于打印作业的进纸匣已被移除。 从不再连接到 USB 端口的闪存驱动器发送打印作业。 打印机硬盘包含的打印作业是硬盘安装在其他打印机型号中时存储的。 从打印机控制面板，触摸 继续 来清除消息。 打印机消息 配置改变，一些挂起作业未被还原 [57] 配置改变，一些挂起作业未被还原 [57]"},{"UUID":"b558d551-19d4-4c98-9660-275cde727ee8","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"检测到有故障的闪存 [51] 请尝试下列办法中的一个或多个： 更换有故障的闪存卡。 从打印机控制面板，触摸","descFull":"检测到有故障的闪存 [51] 请尝试下列办法中的一个或多个： 更换有故障的闪存卡。 从打印机控制面板，触摸 继续 来忽略消息并继续打印。 取消当前的打印作业。 打印机消息 检测到有故障的闪存 [51] 检测到有故障的闪存 [51]"},{"UUID":"f70aff1a-fac5-43eb-8eb0-31fd74b8aeab","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"硬盘已满 [62] 请尝试下列办法中的一个或多个： 从控制面板，触摸 继续","descFull":"硬盘已满 [62] 请尝试下列办法中的一个或多个： 从控制面板，触摸 继续 来清除消息并继续打印。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 删除保存在打印机硬盘中的字体、宏和其他数据。 安装具有更大容量的硬盘。 打印机消息 硬盘已满 [62] 硬盘已满 [62]"},{"UUID":"9e540500-4aa6-44cf-b4eb-41723e1a9b36","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"硬盘已满，扫描作业被取消 请尝试下列办法中的一个或多个： 触摸 继续 来清除消息并继续扫描。","descFull":"硬盘已满，扫描作业被取消 请尝试下列办法中的一个或多个： 触摸 继续 来清除消息并继续扫描。 删除保存在打印机硬盘中的字体、宏和其他数据。 安装具有更大容量的硬盘。 打印机消息 硬盘已满，扫描作业被取消 硬盘已满，扫描作业被取消"},{"UUID":"26129880-c8bd-4c55-a801-a6703841b7e7","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"必须格式化磁盘才能在此设备中使用 从打印机控制面板，触摸 格式化磁盘 来格式化打印机硬盘并清除消息。 格式化会删除保存在打印机硬盘上的所有文件。","descFull":"必须格式化磁盘才能在此设备中使用 从打印机控制面板，触摸 格式化磁盘 来格式化打印机硬盘并清除消息。 格式化会删除保存在打印机硬盘上的所有文件。 打印机消息 必须格式化磁盘才能在此设备中使用 必须格式化磁盘才能在此设备中使用"},{"UUID":"75e8c5ed-908f-43c0-a04e-e224671cb824","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"磁盘接近满。安全清理磁盘空间。 请尝试下列办法中的一个或多个： 触摸 继续 来清除消息并继续打印。","descFull":"磁盘接近满。安全清理磁盘空间。 请尝试下列办法中的一个或多个： 触摸 继续 来清除消息并继续打印。 删除保存在打印机硬盘中的字体、宏和其他数据。 安装具有更大容量的硬盘。 打印机消息 磁盘接近满。安全清理磁盘空间。"},{"UUID":"5ec8f954-1bce-413f-a850-9dc3e0f9de48","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"清空打孔箱 请尝试下列办法中的一个或多个： 清空打孔箱。 在打印机控制面板上选择 继续","descFull":"清空打孔箱 请尝试下列办法中的一个或多个： 清空打孔箱。 在打印机控制面板上选择 继续 来清除消息并继续打印。 取消打印作业。 打印机消息 清空打孔箱 清空打孔箱"},{"UUID":"d52764f1-2d35-4aef-a035-d7e684be8912","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"读取 USB 驱动器时出错。移除 USB。 不支持的","descFull":"读取 USB 驱动器时出错。移除 USB。 不支持的 USB 设备被插入。移除 USB 设备，然后插入一个支持的设备。 打印机消息 读取 USB 驱动器时出错。移除 USB。 读取 USB 驱动器时出错。移除 USB。"},{"UUID":"a3896d75-4fc5-412c-a020-4eb58c0a8f7e","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"读取 USB 集线器时出错。移除集线器。 不支持的 USB","descFull":"读取 USB 集线器时出错。移除集线器。 不支持的 USB 集线器已被插入。移除 USB 集线器，然后安装一个支持的集线器。 打印机消息 不支持的 USB 集线器，请移除 不支持的 USB 集线器，请移除 打印机消息 读取 USB 集线器时出错。移除集线器。 读取 USB 集线器时出错。移除集线器。"},{"UUID":"683ab2d8-4e9f-4d9e-bd04-6039c16c9bab","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"传真内存已满 从打印机控制面板，触摸 继续 来清除消息。 打印机消息","descFull":"传真内存已满 从打印机控制面板，触摸 继续 来清除消息。 打印机消息 传真内存已满 传真内存已满"},{"UUID":"f5c56ffa-4ca7-4930-9f08-5d20a5a197fd","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"传真分区不起作用。请与系统管理员联系。 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。","descFull":"传真分区不起作用。请与系统管理员联系。 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。 关闭打印机电源，然后重新打开。如果消息再次出现，请与您的系统支持人员联系。 打印机消息 传真分区不起作用。请与系统管理员联系。 传真分区不起作用。请与系统管理员联系。"},{"UUID":"15fc0792-3f41-4d69-93f4-f182edadcbdb","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"传真服务器“收件人格式”未设置。请与系统管理员联系。 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。","descFull":"传真服务器“收件人格式”未设置。请与系统管理员联系。 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。 完成“传真服务器”设置。如果消息再次出现，请与您的系统支持人员联系。 打印机消息 传真服务器“收件人格式”未设置。请与系统管理员联系。 传真服务器“收件人格式”未设置。请与系统管理员联系。"},{"UUID":"27a30775-6b00-4116-9b19-8e1d4e926d1a","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"“传真工作站名称”未设置。请与系统管理员联系。 请尝试下面的任一操作： 从打印机控制面板，触摸 继续 来清除消息。","descFull":"“传真工作站名称”未设置。请与系统管理员联系。 请尝试下面的任一操作： 从打印机控制面板，触摸 继续 来清除消息。 完成“模拟传真”设置。如果在完成设置后消息再次出现，请与您的系统支持人员联系。 打印机消息 “传真工作站名称”未设置。请与系统管理员联系。 “传真工作站名称”未设置。请与系统管理员联系。"},{"UUID":"8b4701b1-eb52-4cd3-b3e5-f3b7b3f77749","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"“传真工作站号码”未设置。请与系统管理员联系。 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。","descFull":"“传真工作站号码”未设置。请与系统管理员联系。 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。 完成“模拟传真”设置。如果在完成设置后消息再次出现，请与您的系统支持人员联系。 打印机消息 “传真工作站号码”未设置。请与系统管理员联系。 “传真工作站号码”未设置。请与系统管理员联系。"},{"UUID":"3563b30d-a387-451f-8594-bc59c3423213","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"不正确的纸张尺寸，打开 [纸张来源] [34] 请尝试下列办法中的一个或多个： 在进纸匣或进纸器中加载正确的纸张尺寸和类型，然后在控制面板上的“纸张”菜单中指定纸张尺寸和类型。","descFull":"不正确的纸张尺寸，打开 [纸张来源] [34] 请尝试下列办法中的一个或多个： 在进纸匣或进纸器中加载正确的纸张尺寸和类型，然后在控制面板上的“纸张”菜单中指定纸张尺寸和类型。 确认在“打印属性”或“打印”对话设置中指定了正确的纸张尺寸和类型。 检查长度和宽度导片，并确认纸张被正确加载到进纸匣或进纸器中。 从控制面板，触摸 继续 来清除消息，然后使用其他进纸匣打印。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 不正确的纸张尺寸，打开 [纸张来源] [34] 不正确的纸张尺寸，打开 [纸张来源] [34]"},{"UUID":"52218c39-8147-42fa-8598-acb965cdd0e6","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"插入打孔箱 将打孔箱插入装订完成器中，然后触摸 继续 来清除消息。 打印机消息","descFull":"插入打孔箱 将打孔箱插入装订完成器中，然后触摸 继续 来清除消息。 打印机消息 插入打孔箱 插入打孔箱"},{"UUID":"d3626528-4ca3-4738-bf21-43052e7b804c","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"插入进纸匣 [x] 请尝试下列办法中的一个或多个： 将指定的进纸匣插入打印机中。 取消打印作业。","descFull":"插入进纸匣 [x] 请尝试下列办法中的一个或多个： 将指定的进纸匣插入打印机中。 取消打印作业。 通过在打印机控制面板上选择 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 打印机消息 插入进纸匣 [x] 插入进纸匣 [x]"},{"UUID":"5e2326e0-d0e3-4e20-a635-1aa5ea6047d9","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存不足以进行闪存碎片整理操作 [37] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续","descFull":"内存不足以进行闪存碎片整理操作 [37] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来停止碎片整理操作并继续打印。  删除打印机内存中的字体、宏和其他数据。 安装额外的打印机内存。 打印机消息 内存不足以进行闪存碎片整理操作 [37] 内存不足以进行闪存碎片整理操作 [37]"},{"UUID":"b4e47e4f-ec52-41c4-aca9-9fc80e4f96ae","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存不足以逐份打印作业 [37] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续","descFull":"内存不足以逐份打印作业 [37] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来打印作业的已存储部分并开始逐份打印作业的剩余部分。 取消当前的打印作业。 打印机消息 内存不足以逐份打印作业 [37] 内存不足以逐份打印作业 [37]"},{"UUID":"663bdf48-9fc2-4c12-a514-e621cad5f122","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存不足以支持资源保存特性 [35] 安装额外的打印机内存，或者触摸 继续 来禁用“资源保存”，清除消息，并继续打印。","descFull":"内存不足以支持资源保存特性 [35] 安装额外的打印机内存，或者触摸 继续 来禁用“资源保存”，清除消息，并继续打印。 打印机消息 内存不足以支持资源保存特性 [35] 内存不足以支持资源保存特性 [35]"},{"UUID":"f6decda7-dcc4-48e3-a1f8-cd2cc971780f","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存不足，一些挂起作业已被删除 [37] 从打印机控制面板，触摸 继续 来清除消息。","descFull":"内存不足，一些挂起作业已被删除 [37] 从打印机控制面板，触摸 继续 来清除消息。 打印机消息 内存不足，一些挂起作业已被删除 [37] 内存不足，一些挂起作业已被删除 [37]"},{"UUID":"bf1eab95-f69d-496c-9ae1-74423f60beae","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存不足，一些挂起作业将不被还原 [37] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续","descFull":"内存不足，一些挂起作业将不被还原 [37] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续  来清除消息。 删除其他挂起作业来释放额外的打印机内存。 打印机消息 内存不足，一些挂起作业将不被还原 [37] 内存不足，一些挂起作业将不被还原 [37]"},{"UUID":"f04070ae-c615-4c84-973a-b579d6b82c33","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"进纸匣 3 中的纸堆之间没有足够空间 将纸堆移到一边，然后在控制面板上触摸 继续","descFull":"进纸匣 3 中的纸堆之间没有足够空间 将纸堆移到一边，然后在控制面板上触摸 继续 来清除消息并继续打印。 打印机消息 进纸匣 3 中的纸堆之间没有足够空间 进纸匣 3 中的纸堆之间没有足够空间"},{"UUID":"aade69b2-c4d8-4df3-baf3-2637bf6c1650","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [自定义字符串] [纸张方向] 加载 [纸张来源]","descFull":"用 [自定义字符串] [纸张方向] 加载 [纸张来源] 请尝试下列办法中的一个或多个： 使用正确尺寸和类型的纸张加载进纸匣或进纸器，然后在控制面板上触摸 已完成加载纸张 。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消当前的作业。 打印机消息 用 [自定义字符串] [纸张方向] 加载 [纸张来源] 用 [自定义字符串] [纸张方向] 加载 [纸张来源]"},{"UUID":"42159fb9-45ce-46bd-a058-229e8923866d","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [自定义类型名称]  [纸张方向] 加载","descFull":"用 [自定义类型名称]  [纸张方向] 加载 [纸张来源] 请尝试下列办法中的一个或多个： 使用正确尺寸和类型的纸张加载进纸匣或进纸器，然后在控制面板上触摸 已完成加载纸张 。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 用 [自定义类型名称]  [纸张方向] 加载 [纸张来源] 用 [自定义类型名称]  [纸张方向] 加载 [纸张来源]"},{"UUID":"8558cd20-8dbf-4879-a14d-a2d41460634d","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [纸张尺寸] [纸张方向] 加载 [纸张来源]","descFull":"用 [纸张尺寸] [纸张方向] 加载 [纸张来源] 请尝试下列办法中的一个或多个： 使用正确尺寸的纸张加载进纸匣或进纸器，然后在控制面板上触摸 已完成加载纸张 。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消当前的作业。 打印机消息 用 [纸张尺寸] [纸张方向] 加载 [纸张来源] 用 [纸张尺寸] [纸张方向] 加载 [纸张来源]"},{"UUID":"018c0c5a-7943-4587-a0ab-bbfde2e1b7d1","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [纸张类型] [纸张尺寸] [纸张方向] 加载","descFull":"用 [纸张类型] [纸张尺寸] [纸张方向] 加载 [纸张来源] 请尝试下列办法中的一个或多个： 使用正确尺寸和类型的纸张加载指定的进纸匣或进纸器，然后在控制面板上触摸 已完成加载纸张 。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 取消当前的作业。 打印机消息 用 [纸张类型] [纸张尺寸] [纸张方向] 加载 [纸张来源] 用 [纸张类型] [纸张尺寸] [纸张方向] 加载 [纸张来源]"},{"UUID":"39ca44a4-2243-45db-8c61-82556494261f","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [自定义字符串] [纸张方向] 加载多功能进纸器 请尝试下列办法中的一个或多个：","descFull":"用 [自定义字符串] [纸张方向] 加载多功能进纸器 请尝试下列办法中的一个或多个： 使用正确尺寸和类型的纸张加载进纸器。 从控制面板，触摸下面某一项： 提示每一页，纸张已加载 或 不提示，纸张已加载 —清除消息并继续打印。 自动选择纸张 —使用进纸匣中已加载的纸张。 重置活动接纸架 —为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 用 [自定义字符串] [纸张方向] 加载多功能进纸器 用 [自定义字符串] [纸张方向] 加载多功能进纸器"},{"UUID":"a363f53b-31c6-4287-832d-f7111d598143","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [自定义类型名称] [纸张方向] 加载多功能进纸器 请尝试下列办法中的一个或多个：","descFull":"用 [自定义类型名称] [纸张方向] 加载多功能进纸器 请尝试下列办法中的一个或多个： 使用正确尺寸和类型的纸张加载进纸器。 从控制面板，触摸下面某一项： 提示每一页，纸张已加载 或 不提示，纸张已加载 —清除消息并继续打印。 自动选择纸张 —使用进纸匣中已加载的纸张。 重置活动接纸架 —为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 用 [自定义类型名称] [纸张方向] 加载多功能进纸器 用 [自定义类型名称] [纸张方向] 加载多功能进纸器"},{"UUID":"51b4b8ab-0bd9-4717-a0aa-e5e99b9e2653","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [纸张尺寸] [纸张方向] 加载多功能进纸器 请尝试下列办法中的一个或多个：","descFull":"用 [纸张尺寸] [纸张方向] 加载多功能进纸器 请尝试下列办法中的一个或多个： 使用正确尺寸的纸张加载进纸器。 从控制面板，触摸下面某一项： 提示每一页，纸张已加载 或 不提示，纸张已加载 —清除消息并继续打印。 自动选择纸张 —使用进纸匣中已加载的纸张。 重置活动接纸架 —为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 用 [纸张尺寸] [纸张方向] 加载多功能进纸器 用 [纸张尺寸] [纸张方向] 加载多功能进纸器"},{"UUID":"1f91868c-4af6-4ace-bd73-0b5aa7b0be4a","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"用 [纸张类型] [纸张尺寸] [纸张方向] 加载多功能进纸器","descFull":"用 [纸张类型] [纸张尺寸] [纸张方向] 加载多功能进纸器 请尝试下列办法中的一个或多个： 使用正确尺寸和类型的纸张加载进纸器。 从控制面板，触摸下面某一项： 提示每一页，纸张已加载 或 不提示，纸张已加载 —清除消息并继续打印。 自动选择纸张 —使用进纸匣中已加载的纸张。 重置活动接纸架 —为已连接的接纸架组重置活动接纸架。 取消打印作业。 打印机消息 用 [纸张类型] [纸张尺寸] [纸张方向] 加载多功能进纸器 用 [纸张类型] [纸张尺寸] [纸张方向] 加载多功能进纸器"},{"UUID":"1e053812-10ab-497d-ac67-3383f5efe2d6","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"加载订书钉 请尝试下列办法中的一个或多个： 在装订完成器中更换或插入订书钉盒。  如需有关在装订完成器中插入或更换订书钉盒的指导，请在打印机控制面板上触摸","descFull":"加载订书钉 请尝试下列办法中的一个或多个： 在装订完成器中更换或插入订书钉盒。  如需有关在装订完成器中插入或更换订书钉盒的指导，请在打印机控制面板上触摸 更多信息 。 从打印机控制面板，触摸 继续 来清除消息并继续打印。  从打印机控制面板，触摸 取消作业 来取消打印作业。 打印机消息 加载订书钉 加载订书钉"},{"UUID":"48ac1cd7-cd89-4bd5-a811-570b00b19910","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"加载订书钉 [G11, G12] 请尝试下列办法中的一个或多个： 更换或将订书钉盒插入完成器中。","descFull":"加载订书钉 [G11, G12] 请尝试下列办法中的一个或多个： 更换或将订书钉盒插入完成器中。  如需有关更换或将订书钉盒插入完成器中的说明，请在控制面板上触摸 更多信息 。 从控制面板，触摸 继续 来清除消息并继续打印。  取消打印作业。 打印机消息 加载订书钉 [G11, G12] 加载订书钉 [G11, G12]"},{"UUID":"c94efc46-28b6-4e44-8140-b21bb0a8a2f3","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"[x] 维护组件非常不足 [80.xy] 您可能很快就需要更换维护组件。如需更多信息，请转到 Lexmark","descFull":"[x] 维护组件非常不足 [80.xy] 您可能很快就需要更换维护组件。如需更多信息，请转到 Lexmark 的支持网站： http://support.lexmark.com ，或者与客户支持联系，然后报告消息。 您可能很快就需要更换维护组件。如需更多信息，请联系客户支持或您的服务代表。 您可能很快就需要更换维护组件。如需更多信息，请联系技术支持或您的 Dell 打印机经销商。  如果需要，请触摸 继续 来清除消息并继续打印。 打印机消息 [x] 维护组件非常不足 [80.xy] [x] 维护组件非常不足 [80.xy]"},{"UUID":"96b4de39-cd87-44a1-a9c6-8dd9309a9541","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存已满 [38] 请尝试下列办法中的一个或多个： 从控制面板，触摸 取消作业","descFull":"内存已满 [38] 请尝试下列办法中的一个或多个： 从控制面板，触摸 取消作业 来清除消息。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 安装额外的打印机内存。 打印机消息 内存已满 [38] 内存已满 [38]"},{"UUID":"7e9a143e-0735-491d-af3d-6e4f054007ba","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存已满，不能打印传真 从打印机控制面板，触摸 继续 来清除消息而不打印。挂起的传真试图在打印机重新启动后打印。 打印机消息","descFull":"内存已满，不能打印传真 从打印机控制面板，触摸 继续 来清除消息而不打印。挂起的传真试图在打印机重新启动后打印。 打印机消息 内存已满，不能打印传真 内存已满，不能打印传真"},{"UUID":"fe20ddb9-ac25-4bb0-82d4-37f0a987a90c","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"内存已满，不能发送传真 从打印机控制面板，触摸 继续 来清除消息并取消传真作业。 请尝试下列办法中的一个或多个：","descFull":"内存已满，不能发送传真 从打印机控制面板，触摸 继续 来清除消息并取消传真作业。 请尝试下列办法中的一个或多个： 降低传真分辨率，然后重新发送传真作业。 减少传真的页数，然后重新发送传真作业。 打印机消息 内存已满，不能发送传真 内存已满，不能发送传真"},{"UUID":"5773a2a8-d957-4b73-9b5c-116b37fea0e4","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"","descFull":"没有将模拟电话线连接到调制解调器，传真被禁用。 将打印机连接到模拟电话线路上。 打印机消息 没有将模拟电话线连接到调制解调器，传真被禁用。 没有将模拟电话线连接到调制解调器，传真被禁用。"},{"UUID":"6011b952-4cfc-46eb-9ea8-9a5f108adf63","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"网络 [x] 软件错误 [54] 请尝试下列办法中的一个或多个：","descFull":"网络 [x] 软件错误 [54] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来继续打印。 关闭打印机电源，等待约 10 秒钟，然后再打开打印机电源。 更新打印机或打印服务器中的网络固件。如需更多信息，请访问 Lexmark 的支持网站： http://support.lexmark.com 。 更新打印机或打印服务器中的网络固件。如需更多信息，请联系客户支持或您的服务代表。 更新打印机或打印服务器中的网络固件。如需更多信息，请联系技术支持或您的 Dell 打印机经销商。 打印机消息 网络 [x] 软件错误 [54] 网络 [x] 软件错误 [54]"},{"UUID":"790e9379-d8c7-4110-a66a-dd9798f84b07","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"闪存存储空间不足 [52] 请尝试下列办法中的一个或多个： 从控制面板，触摸 继续","descFull":"闪存存储空间不足 [52] 请尝试下列办法中的一个或多个： 从控制面板，触摸 继续 来清除消息并继续打印。 触摸 重置活动接纸架 来为已连接的接纸架组重置活动接纸架。 删除保存在闪存中的字体、宏和其他数据。 安装具有更大容量的闪存卡。 之前未保存在闪存中的下载字体和宏被删除。 打印机消息 闪存存储空间不足 [52] 闪存存储空间不足 [52]"},{"UUID":"0b8f10e8-fb1a-48b2-9427-30384de4780e","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"打开盖门 H 并从下方区域 H10 取出纸张","descFull":"打开盖门 H 并从下方区域 H10 取出纸张 从指定的区域取出纸张。 打印机消息 打开盖门 H 并从下方区域 H10 取出纸张 打开盖门 H 并从下方区域 H10 取出纸张"},{"UUID":"b86248f4-9657-4b41-adc6-50e78dc7f44b","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"需要更改纸张 请尝试下列办法中的一个或多个：  触摸 使用当前耗材","descFull":"需要更改纸张 请尝试下列办法中的一个或多个：  触摸 使用当前耗材 来清除消息并继续打印。 取消当前的打印作业。 打印机消息 需要更改纸张 需要更改纸张"},{"UUID":"a118418b-156b-46cf-b135-99b51a211522","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"并口 [x] 已禁用 [56] 请尝试下列办法中的一个或多个：","descFull":"并口 [x] 已禁用 [56] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。 启用并口。从打印机控制面板，导览至： 网络/端口 并口 [x] 并口缓冲区 自动 打印机放弃所有通过并口接收到的数据。 打印机消息 并口 [x] 已禁用 [56] 并口 [x] 已禁用 [56]"},{"UUID":"6e0782a0-accb-4fe1-b966-766c1a3c0297","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"感光鼓不足 [84.xy] 您可能需要订购替换的感光鼓。如果需要，请在控制面板上选择 继续 来清除消息并继续打印。","descFull":"感光鼓不足 [84.xy] 您可能需要订购替换的感光鼓。如果需要，请在控制面板上选择 继续 来清除消息并继续打印。 打印机消息 感光鼓不足 [84.xy] 感光鼓不足 [84.xy]"},{"UUID":"7db6fc30-2506-4cde-9c7b-0763eea0e074","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"感光鼓非常不足 [84.xy] 您可能很快就需要更换感光鼓。如需更多信息，请参阅 。 如果需要，请在控制面板上触摸","descFull":"感光鼓非常不足 [84.xy] 您可能很快就需要更换感光鼓。如需更多信息，请参阅 。 如果需要，请在控制面板上触摸 继续 来清除消息并继续打印。 打印机消息 感光鼓非常不足 [84.xy] 感光鼓非常不足 [84.xy]"},{"UUID":"8ff08134-e3c9-43f1-a597-3f515c2b0dcb","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"打印机必须重新启动。上次作业可能是不完整的。 从打印机控制面板，触摸 继续 来清除消息并继续打印。 如需更多信息，请访问","descFull":"打印机必须重新启动。上次作业可能是不完整的。 从打印机控制面板，触摸 继续 来清除消息并继续打印。 如需更多信息，请访问  http://support.lexmark.com ，或者与客户支持联系。 如需更多信息，请访问我们的网站或者与您购买打印机处的销售商联系。 如需更多信息，请访问  http://support.dell.com ，或者与技术支持联系。 打印机消息 打印机必须重新启动。上次作业可能是不完整的。 打印机必须重新启动。上次作业可能是不完整的。"},{"UUID":"d8bf8f79-a256-405f-9b98-7000a37fda0f","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"重新安装缺少或无响应的碳粉盒 [31.xy] 请尝试下列办法中的一个或多个： 检查碳粉盒是否缺少。如果缺少，请安装碳粉盒。 如需有关安装碳粉盒的更多信息，请参阅","descFull":"重新安装缺少或无响应的碳粉盒 [31.xy] 请尝试下列办法中的一个或多个： 检查碳粉盒是否缺少。如果缺少，请安装碳粉盒。 如需有关安装碳粉盒的更多信息，请参阅 用户指南 的“更换耗材”部分。 如果碳粉盒已安装，请移除无响应的碳粉盒，然后重新安装。 如果在重新安装耗材后出现消息，那么碳粉盒有故障。更换碳粉盒。 打印机消息 重新安装缺少或无响应的碳粉盒 [31.xy] 重新安装缺少或无响应的碳粉盒 [31.xy]"},{"UUID":"86d766e9-3f8e-4ae0-bf65-770cf0641619","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"重新安装缺少或无响应的感光鼓 [31.xy] 请尝试下列办法中的一个或多个： 如果缺少感光鼓，请安装它。如需更多信息，请参阅 。","descFull":"重新安装缺少或无响应的感光鼓 [31.xy] 请尝试下列办法中的一个或多个： 如果缺少感光鼓，请安装它。如需更多信息，请参阅 。 如果感光鼓已安装，请移除它然后重新安装。 如果在重新安装耗材后出现消息，请更换有故障的感光鼓。 打印机消息 重新安装缺少或无响应的感光鼓 [31.xy] 重新安装缺少或无响应的感光鼓 [31.xy]"},{"UUID":"8bb3125c-37b2-4902-b7d1-2a03b3c245af","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"移除有故障的硬盘 [61] 移除并更换有故障的打印机硬盘。 打印机消息 移除有故障的硬盘","descFull":"移除有故障的硬盘 [61] 移除并更换有故障的打印机硬盘。 打印机消息 移除有故障的硬盘 [61] 移除有故障的硬盘 [61]"},{"UUID":"705643ae-a173-4228-bc82-a876e2798e1a","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"","descFull":"移除包装材料，[区域名称] 从指定位置移除所有残留的包装材料。 打印机消息 移除包装材料，[区域名称] 移除包装材料，[区域名称]"},{"UUID":"1108ab3a-0317-434b-b66d-a4e2d4878083","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"从扫描仪支架上移除包装材料，打开盖门 C，移除金属卡扣，移除所有螺钉 打开盖门 C 和扫描仪盖板，然后移除所有遗留的包装材料。","descFull":"从扫描仪支架上移除包装材料，打开盖门 C，移除金属卡扣，移除所有螺钉 打开盖门 C 和扫描仪盖板，然后移除所有遗留的包装材料。 确保盖门 C 不触及任何连接到打印机的电缆。 打印机消息 从扫描仪支架上移除包装材料，打开盖门 C，移除金属卡扣，移除所有螺钉 从扫描仪支架上移除包装材料，打开盖门 C，移除金属卡扣，移除所有螺钉"},{"UUID":"446cc3cb-7a43-4b1c-be27-c0d737bc0b02","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"从所有接纸架上取走纸张 从所有接纸架上取走纸张。打印机自动检测纸张移除并恢复打印。 如果移除纸张不能清除消息，则请触摸 继续 。","descFull":"从所有接纸架上取走纸张 从所有接纸架上取走纸张。打印机自动检测纸张移除并恢复打印。 如果移除纸张不能清除消息，则请触摸 继续 。 打印机消息 从所有接纸架上取走纸张 从所有接纸架上取走纸张"},{"UUID":"7014ec8e-410b-4f16-af5c-ec56e760176f","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"从接纸架 [x] 上取走纸张 从指定的接纸架上取走纸张。打印机自动检测纸张移除并恢复打印。 如果移除纸张没有清除消息，请触摸","descFull":"从接纸架 [x] 上取走纸张 从指定的接纸架上取走纸张。打印机自动检测纸张移除并恢复打印。 如果移除纸张没有清除消息，请触摸 继续 。 打印机消息 从接纸架 [x] 上取走纸张 从接纸架 [x] 上取走纸张"},{"UUID":"8bb8a299-2c52-4e28-98cd-9cc6362f5182","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"从 [连接接纸架组名称] 上取走纸张 从指定的接纸架上取走纸张。打印机自动检测纸张移除并恢复打印。 如果移除纸张没有清除消息，请触摸","descFull":"从 [连接接纸架组名称] 上取走纸张 从指定的接纸架上取走纸张。打印机自动检测纸张移除并恢复打印。 如果移除纸张没有清除消息，请触摸 继续 。 打印机消息 从 [连接接纸架组名称] 上取走纸张 从 [连接接纸架组名称] 上取走纸张"},{"UUID":"a4f0c304-5e72-40ce-8fec-7739c6232aed","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"","descFull":"从标准接纸架上取走纸张 从标准接纸架上取走纸堆。 打印机消息 从标准接纸架上取走纸张 从标准接纸架上取走纸张"},{"UUID":"15b53672-e645-4805-8cf4-c7876211632f","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"如果重新启动作业，请放回所有原件。 请尝试下列办法中的一个或多个： 触摸 取消作业 来清除消息并取消扫描作业。","descFull":"如果重新启动作业，请放回所有原件。 请尝试下列办法中的一个或多个： 触摸 取消作业 来清除消息并取消扫描作业。 触摸 从自动文档传送器扫描 ，在上一次成功扫描作业之后立即从 ADF 继续扫描。 触摸 从平板扫描 ，在上一次成功扫描作业之后立即从扫描仪继续扫描。 触摸 完成作业而不再扫描  来结束最后一次成功扫描作业。 触摸 重新启动作业 来使用与之前扫描作业相同的设置重新启动扫描作业。 打印机消息 如果重新启动作业，请放回所有原件。 如果重新启动作业，请放回所有原件。"},{"UUID":"ece7c310-70f8-4c29-89a5-8e8bec15053b","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换碳粉盒，估计剩余 0 页 [88.xy] 更换碳粉盒来清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页，或者参阅","descFull":"更换碳粉盒，估计剩余 0 页 [88.xy] 更换碳粉盒来清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页，或者参阅 用户指南 的“更换耗材”部分。 如果您没有替换的碳粉盒，请参阅 用户指南 的“订购耗材”部分，或者访问  www.lexmark.com 。 如果您没有替换的碳粉盒，请访问我们的网站或者与您购买打印机处的销售商联系。 打印机消息 更换碳粉盒，估计剩余 0 页 [88.xy] 更换碳粉盒，估计剩余 0 页 [88.xy]"},{"UUID":"021f69be-49a4-4721-bff8-9e9aae10c8df","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换碳粉盒，打印机使用地区不匹配 [42.xy] 请安装与打印机的使用地区号码相匹配的碳粉盒。  x","descFull":"更换碳粉盒，打印机使用地区不匹配 [42.xy] 请安装与打印机的使用地区号码相匹配的碳粉盒。  x  表示打印机使用地区的值。  y  表示碳粉盒使用地区的值。x 和 y 可能有下列值： 安装合适的碳粉盒。 打印机和碳粉盒使用地区 地区编号 地区 0 全球 1 美国、加拿大 2 欧洲经济区（EEA）、瑞士 3 亚太地区、澳大利亚、新西兰 4 拉丁美洲 5 非洲、中东、欧洲其他国家 9 无效 x 和 y 值代表出现在打印机控制面板上的代码中的  xy 。 x 和 y 值必须匹配才能继续打印。 打印机消息 更换碳粉盒，打印机使用地区不匹配 [42.xy] 更换碳粉盒，打印机使用地区不匹配 [42.xy]"},{"UUID":"3426e409-80d8-40f5-9202-c1f21ba168f3","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"如果重新启动作业，请放回被卡的原件。 请尝试下列办法中的一个或多个： 触摸 取消作业 来清除消息并取消扫描作业。","descFull":"如果重新启动作业，请放回被卡的原件。 请尝试下列办法中的一个或多个： 触摸 取消作业 来清除消息并取消扫描作业。 触摸 从自动文档传送器扫描 ，在上一次成功扫描作业之后立即从 ADF 继续扫描。 触摸 从平板扫描 ，在上一次成功扫描作业之后立即从扫描仪继续扫描。 触摸 完成作业而不再扫描  来结束最后一次成功扫描作业。 触摸 重新启动作业 来使用与之前扫描作业相同的设置重新启动扫描作业。 打印机消息 如果重新启动作业，请放回被卡的原件。 如果重新启动作业，请放回被卡的原件。"},{"UUID":"27cd67fc-81fe-4562-be63-95a6740886f9","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换 [x] 维护组件，估计剩余 0 页","descFull":"更换 [x] 维护组件，估计剩余 0 页 [80.xy]  打印机已预定维护。如需更多信息，请转到 Lexmark 的支持网站： http://support.lexmark.com ，或者与您的服务代表联系，然后报告消息。  打印机已预定维护。联系客户支持或您的服务代表，然后报告消息。  打印机已预定维护。联系技术支持或您的 Dell 打印机经销商，然后报告消息。 打印机消息 更换 [x] 维护组件，估计剩余 0 页 [80.xy] 更换 [x] 维护组件，估计剩余 0 页 [80.xy]"},{"UUID":"517b6f33-87ce-4085-8ba4-ef958dd6a09c","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换缺少的感光鼓 [31.xy] 安装缺少的感光鼓以清除消息。如需更多信息，请参阅 。 打印机消息","descFull":"更换缺少的感光鼓 [31.xy] 安装缺少的感光鼓以清除消息。如需更多信息，请参阅 。 打印机消息 更换缺少的感光鼓 [31.xy] 更换缺少的感光鼓 [31.xy]"},{"UUID":"2ef7baa9-147f-4b09-aad3-9e26d2b78e97","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换缺少的废碳粉瓶 [82.xy] 安装缺少的废碳粉瓶来清除消息。如需更多信息，请参阅随耗材附带的说明页。 打印机消息 更换缺少的废碳粉瓶","descFull":"更换缺少的废碳粉瓶 [82.xy] 安装缺少的废碳粉瓶来清除消息。如需更多信息，请参阅随耗材附带的说明页。 打印机消息 更换缺少的废碳粉瓶 [82.xy] 更换缺少的废碳粉瓶 [82.xy]"},{"UUID":"9687dd97-4437-4f3e-a3b7-ee9a08aa0a1d","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换缺少的碳粉盒 [31.xy] 安装缺少的碳粉盒来清除消息。如需更多信息，请参阅 。 打印机消息","descFull":"更换缺少的碳粉盒 [31.xy] 安装缺少的碳粉盒来清除消息。如需更多信息，请参阅 。 打印机消息 更换缺少的碳粉盒 [31.xy] 更换缺少的碳粉盒 [31.xy]"},{"UUID":"5db7f7db-200b-40b5-953e-cbfcbdf4b12c","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"使用进纸匣 1 或进纸匣 2 隔间中的部件和说明更换","descFull":"使用进纸匣 1 或进纸匣 2 隔间中的部件和说明更换 [纸张来源] 中的拾纸辊 [80] 请尝试下列办法中的一个或多个： 更换拾纸辊，然后在控制面板上触摸 辊已更换 来清除消息并继续打印。 触摸 继续并稍后更换（卡纸可能继续发生） 来忽略消息并继续打印。 打印机消息 使用进纸匣 1 或进纸匣 2 隔间中的部件和说明更换 [纸张来源] 中的拾纸辊 [80] 使用进纸匣 1 或进纸匣 2 隔间中的部件和说明更换 [纸张来源] 中的拾纸辊 [80]"},{"UUID":"e8c6b877-5875-4367-838b-7fa754456635","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换感光鼓，剩余 0 页 [84.xy] 更换感光鼓以清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页或参阅","descFull":"更换感光鼓，剩余 0 页 [84.xy] 更换感光鼓以清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页或参阅 。 如果您没有替换的感光鼓，请参阅 ，或者转到  www.lexmark.com 。 如果您没有替换的感光鼓，请转到我们的网站或者与您购买打印机处的销售商联系。 打印机消息 更换感光鼓，剩余 0 页 [84.xy] 更换感光鼓，剩余 0 页 [84.xy]"},{"UUID":"07051863-6885-473a-b62b-5c3b1777d08c","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换不支持的碳粉盒 [32.xy] 移除碳粉盒，然后安装一个支持的碳粉盒来清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页，或者参阅 用户指南 的“更换耗材”部分。","descFull":"更换不支持的碳粉盒 [32.xy] 移除碳粉盒，然后安装一个支持的碳粉盒来清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页，或者参阅 用户指南 的“更换耗材”部分。 如果您没有替换的碳粉盒，请参阅 用户指南 的“订购耗材”部分，或者访问  www.lexmark.com 。 如果您没有替换的碳粉盒，请访问我们的网站或者与您购买打印机处的销售商联系。 打印机消息 更换不支持的碳粉盒 [32.xy] 更换不支持的碳粉盒 [32.xy]"},{"UUID":"2669460e-ba5a-409b-9502-5eb5c3108fe0","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换不支持的感光鼓 [32.xy] 移除感光鼓，然后安装一个支持的感光鼓来清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页或参阅 。 如果您没有替换的感光鼓，请参阅","descFull":"更换不支持的感光鼓 [32.xy] 移除感光鼓，然后安装一个支持的感光鼓来清除消息并继续打印。如需更多信息，请参阅随耗材附带的说明页或参阅 。 如果您没有替换的感光鼓，请参阅 ，或者转到  www.lexmark.com 。 如果您没有替换的感光鼓，请转到我们的网站或者与您购买打印机处的销售商联系，然后报告消息。 打印机消息 更换不支持的感光鼓 [32.xy] 更换不支持的感光鼓 [32.xy]"},{"UUID":"50e0ea34-5595-4458-b2b7-f61a21ebb1de","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"更换废碳粉瓶 [82.xy] 更换废碳粉瓶来清除消息。 打印机消息 更换废碳粉瓶","descFull":"更换废碳粉瓶 [82.xy] 更换废碳粉瓶来清除消息。 打印机消息 更换废碳粉瓶 [82.xy] 更换废碳粉瓶 [82.xy]"},{"UUID":"4340a695-44c1-49fe-badd-76ba7e4b01c8","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"还原挂起作业？ 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 还原 来还原存储在打印机硬盘上的所有挂起作业。","descFull":"还原挂起作业？ 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 还原 来还原存储在打印机硬盘上的所有挂起作业。 如果您不希望还原任何打印作业，请从打印机控制面板，触摸 不还原 。 打印机消息 还原挂起作业？ 还原挂起作业？"},{"UUID":"6380b792-df9e-41c1-a11a-231931426fd4","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"扫描仪已被管理员禁用 [840.01] 不使用扫描仪打印，或者与系统支持人员联系。 打印机消息 扫描仪已被管理员禁用","descFull":"扫描仪已被管理员禁用 [840.01] 不使用扫描仪打印，或者与系统支持人员联系。 打印机消息 扫描仪已被管理员禁用 [840.01] 扫描仪已被管理员禁用 [840.01]"},{"UUID":"a2ba6a56-c8ae-4b82-bb67-1293f44b7632","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"扫描仪已禁用。如果问题继续存在，请与系统管理员联系。[840.02] 请尝试下列办法中的一个或多个： 触摸 继续并禁用扫描仪 来返回到主屏幕，然后与您的系统支持人员联系。","descFull":"扫描仪已禁用。如果问题继续存在，请与系统管理员联系。[840.02] 请尝试下列办法中的一个或多个： 触摸 继续并禁用扫描仪 来返回到主屏幕，然后与您的系统支持人员联系。 触摸 重启并自动启用扫描仪 来取消作业。 这试图启用扫描仪。 打印机消息 扫描仪已禁用。如果问题继续存在，请与系统管理员联系。[840.02] 扫描仪已禁用。如果问题继续存在，请与系统管理员联系。[840.02]"},{"UUID":"71fbd790-c0a0-438e-8dfd-d4b902483d03","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"扫描仪卡纸，从扫描仪中取出被卡的原件 [2yy.xx] 从扫描仪中取出被卡的纸张。 打印机消息 扫描仪卡纸，从扫描仪中取出被卡的原件","descFull":"扫描仪卡纸，从扫描仪中取出被卡的原件 [2yy.xx] 从扫描仪中取出被卡的纸张。 打印机消息 扫描仪卡纸，从扫描仪中取出被卡的原件 [2yy.xx] 扫描仪卡纸，从扫描仪中取出被卡的原件 [2yy.xx]"},{"UUID":"a176fc72-dd1d-45f1-ae32-394c7e47b182","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"需要扫描仪维护，请使用 ADF 组件 [80] 打印机已预定维护。如需更多信息，请转到","descFull":"需要扫描仪维护，请使用 ADF 组件 [80] 打印机已预定维护。如需更多信息，请转到 Lexmark 的支持网站： http://support.lexmark.com ，或者与您的服务代表联系，然后报告消息。 打印机已预定维护。联系客户支持或您的服务代表，然后报告消息。 打印机已预定维护。联系技术支持或您的 Dell 打印机经销商，然后报告消息。 打印机消息 需要扫描仪维护，请使用 ADF 组件 [80] 需要扫描仪维护，请使用 ADF 组件 [80]"},{"UUID":"ef106164-7ecf-44bc-ae80-4b0fcfb35a1f","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"即将需要扫描仪维护，请使用 ADF 工具包 [80] 请与客户支持联系，然后报告消息。打印机已预定维护。","descFull":"即将需要扫描仪维护，请使用 ADF 工具包 [80] 请与客户支持联系，然后报告消息。打印机已预定维护。 联系技术支持或您的 Dell 打印机经销商，然后报告消息。打印机已预定维护。 打印机消息 即将需要扫描仪维护，请使用 ADF 工具包 [80] 即将需要扫描仪维护，请使用 ADF 工具包 [80]"},{"UUID":"08778a3f-a157-4dfe-94f3-f5376a52a606","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"串口 [x] 已禁用 [56] 请尝试下列办法中的一个或多个：","descFull":"串口 [x] 已禁用 [56] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。 打印机放弃所有通过指定的串口接收到的数据。 确认“串口缓冲区”没有被设置为“禁用”。 从打印机控制面板，将“串口 [x]”菜单中的“串口缓冲区”设置为“自动”。 打印机消息 串口 [x] 已禁用 [56] 串口 [x] 已禁用 [56]"},{"UUID":"6d451778-df60-40ef-a015-6fd448d65dc2","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"一些挂起作业未被还原 从打印机控制面板，触摸 继续 来删除指示的作业。 未被还原的挂起作业仍然留在打印机硬盘上并且不可访问。","descFull":"一些挂起作业未被还原 从打印机控制面板，触摸 继续 来删除指示的作业。 未被还原的挂起作业仍然留在打印机硬盘上并且不可访问。 打印机消息 一些挂起作业未被还原 一些挂起作业未被还原"},{"UUID":"91a5aaed-bca9-4faf-8427-b1f88b6e757f","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"SMTP 服务器未设置。请与系统管理员联系。 从打印机控制面板，触摸 继续 来清除消息。","descFull":"SMTP 服务器未设置。请与系统管理员联系。 从打印机控制面板，触摸 继续 来清除消息。  如果消息再次出现，请与您的系统支持人员联系。 打印机消息 SMTP 服务器未设置。请与系统管理员联系。 SMTP 服务器未设置。请与系统管理员联系。"},{"UUID":"7c528785-4cfc-4d53-a8d4-5e51886a02f1","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"标准网络软件错误 [54] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续","descFull":"标准网络软件错误 [54] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来继续打印。 关闭打印机电源，然后重新打开。 更新打印机或打印服务器中的网络固件。如需更多信息，请访问 Lexmark 的支持网站： http://support.lexmark.com ，或者与客户支持联系，然后报告消息。 更新打印机或打印服务器中的网络固件。如需更多信息，请联系客户支持或您的服务代表。 更新打印机或打印服务器中的网络固件。如需更多信息，请联系技术支持或您的 Dell 打印机经销商。 打印机消息 标准网络软件错误 [54] 标准网络软件错误 [54]"},{"UUID":"a3712658-3d04-4ae1-8916-0ee6ea02de76","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"标准 USB 端口已禁用 [56] 请尝试下列办法中的一个或多个：","descFull":"标准 USB 端口已禁用 [56] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来清除消息。  启用 USB 端口。从打印机控制面板，导览至： 网络/端口 USB 缓冲区 自动 打印机放弃所有通过 USB 端口接收到的数据。 打印机消息 标准 USB 端口已禁用 [56] 标准 USB 端口已禁用 [56]"},{"UUID":"74b5646f-dfdf-4aac-94e6-1ddd1b8b81bf","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"完成作业需要耗材 请执行下面的任一操作： 安装缺少的耗材以完成作业。 取消当前的作业。 打印机消息","descFull":"完成作业需要耗材 请执行下面的任一操作： 安装缺少的耗材以完成作业。 取消当前的作业。 打印机消息 完成作业需要耗材 完成作业需要耗材"},{"UUID":"6fcfa68d-f415-4a1a-8e2c-8ba67fb98010","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"设备以“安全模式”运行。一些打印选项可能被禁用，或者提供意外结果。 在控制面板上触摸 继续  来清除消息并继续打印。","descFull":"设备以“安全模式”运行。一些打印选项可能被禁用，或者提供意外结果。 在控制面板上触摸 继续  来清除消息并继续打印。 打印机消息 设备以安全模式运行。一些打印选项可能被禁用，或者提供意外结果。 设备以安全模式运行。一些打印选项可能被禁用，或者提供意外结果。"},{"UUID":"5192ed63-1db5-4af6-b886-74b5aa96269e","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"安装的闪存选件太多 [58] 请尝试下列办法中的一个或多个： 在控制面板上触摸 继续","descFull":"安装的闪存选件太多 [58] 请尝试下列办法中的一个或多个： 在控制面板上触摸 继续 来继续打印。 移除额外的闪存。 关闭打印机电源。 从电源插座中拔掉电源线。 移除额外的闪存。 将电源线连接到正确接地的电源插座上。 重新打开打印机电源。 打印机消息 安装的闪存选件太多 [58] 安装的闪存选件太多 [58]"},{"UUID":"b1070a0d-e8c1-4e1e-9009-f4531cfa6f75","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"安装的进纸匣太多 [58] 关闭打印机电源。 从电源插座中拔掉电源线。 移除额外的进纸匣。","descFull":"安装的进纸匣太多 [58] 关闭打印机电源。 从电源插座中拔掉电源线。 移除额外的进纸匣。 将电源线连接到正确接地的电源插座上。 重新打开打印机电源。 打印机消息 安装的进纸匣太多 [58] 安装的进纸匣太多 [58]"},{"UUID":"9d45ac9b-39d8-45e5-8344-616d91bbae1a","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"进纸匣 [x] 纸张尺寸不被支持 使用支持的纸张尺寸更换。 打印机消息","descFull":"进纸匣 [x] 纸张尺寸不被支持 使用支持的纸张尺寸更换。 打印机消息 进纸匣 [x] 纸张尺寸不被支持 进纸匣 [x] 纸张尺寸不被支持"},{"UUID":"e373e3c3-75a4-4a8f-9f8d-cf1e2a452e7e","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"检测到未格式化的闪存 [53] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续","descFull":"检测到未格式化的闪存 [53] 请尝试下列办法中的一个或多个： 从打印机控制面板，触摸 继续 来停止碎片整理操作并继续打印。 格式化闪存。 如果错误消息仍然存在，则可能是闪存有故障并需要更换。 打印机消息 检测到未格式化的闪存 [53] 检测到未格式化的闪存 [53]"},{"UUID":"1ee6cde2-4716-4ad5-9af6-bcd8314c5c62","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"","descFull":"不支持的硬盘 移除不支持的打印机硬盘，然后插入一个支持的硬盘。 打印机消息 不支持的硬盘"},{"UUID":"cabb71ab-90e2-4ad3-b5e2-1aa4fe3659e2","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"插槽 [x] 中有不支持的选件 [55] 关闭打印机电源。","descFull":"插槽 [x] 中有不支持的选件 [55] 关闭打印机电源。 从电源插座中拔掉电源线。 从打印机控制系统板上移除不支持的选件卡，然后更换一块支持的卡。 将电源线连接到正确接地的电源插座上。 重新打开打印机电源。 打印机消息 插槽 [x] 中有不支持的选件 [55] 插槽 [x] 中有不支持的选件 [55]"},{"UUID":"6475a787-fbf1-4b0f-8222-32f526df0261","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"废碳粉瓶即将满 [82.xy] 您可能需要订购废碳粉瓶。如果需要，请在打印机控制面板上触摸 继续 来清除消息并继续打印。","descFull":"废碳粉瓶即将满 [82.xy] 您可能需要订购废碳粉瓶。如果需要，请在打印机控制面板上触摸 继续 来清除消息并继续打印。 打印机消息 废碳粉瓶即将满 [82.xy] 废碳粉瓶即将满 [82.xy]"},{"UUID":"9a52ed7b-9c3e-4082-9d65-b4dba674f695","title":"理解打印机消息","link":"message-cartridge-low-88.xy-topic.html","desc":"Weblink 服务器未设置。请与系统管理员联系。 从打印机控制面板，触摸 继续 来清除消息。","descFull":"Weblink 服务器未设置。请与系统管理员联系。 从打印机控制面板，触摸 继续 来清除消息。 如果消息再次出现，请与您的系统支持人员联系。 打印机消息 Weblink 服务器未设置。请与系统管理员联系。 Weblink 服务器未设置。请与系统管理员联系。"},{"UUID":"0aca4fcc-b155-4b1b-bd15-ad7f9b842da2","title":"基本打印机问题","link":"trb-printer-not-responding-topic.html","desc":"打印机不响应 解决问题的步骤 操作 是 否","descFull":"打印机不响应 解决问题的步骤 操作 是 否 确认打印机的电源已经打开。 打印机电源打开了吗？ 打开打印机电源。 检查打印机是否处于“睡眠”模式或“休眠”模式。 打印机处于“睡眠”模式或“休眠”模式吗？ 按“睡眠”按钮，将打印机从“睡眠”模式或“休眠”模式唤醒。 检查电源线的一端是否被插入打印机，并且另一端插入正确接地的电源插座中。 电源线已被插入打印机和正确接地的电源插座中吗？ 将电源线的一端插入打印机，并且另一端插入正确接地的电源插座中。 检查其他插在电源插座中的电子设备。 其他电子设备工作吗？ 拔掉其他电子设备的电源线，然后打开打印机电源。如果打印机不工作，请重新连接其他电子设备。 检查连接打印机和计算机的电缆是否被插入正确的端口中。 电缆被插入正确的端口中吗？ 请确认下列匹配项： 电缆上的 USB 符号与打印机上的 USB 符号 适当的以太网电缆与以太网端口 确认电源插座没有被开关或断路器关闭。 电源插座被开关或断路器关闭吗？ 打开开关或重置断路器。 检查打印机是否被插入任何浪涌电压保护器、不间断电源或延长线路中。 打印机被插入任何浪涌电压保护器、不间断电源或延长线路中吗？ 将打印机电源线直接连接到正确接地的电源插座上。 检查打印机电缆的一端是否被插入打印机上的端口，并且另一端插入计算机、打印服务器、选件或其他网络设备中。 打印机电缆被牢固地连接在打印机和计算机、打印服务器、选件或其他网络设备上吗？ 将打印机电缆牢固地连接在打印机和计算机、打印服务器、选件或其他网络设备上。 确认正确安装所有的硬件选件，并且移除任何包装材料。 所有的硬件选件都安装正确，并且所有的包装材料都被移除了吗？ 关闭打印机电源，移除所有包装材料，接着重新安装硬件选件，然后打开打印机电源。 检查您是否已经在打印机驱动程序中选择了正确的端口设置。 端口设置正确吗？ 使用正确的打印机驱动程序设置。 检查已安装的打印机驱动程序。 安装了正确的打印机驱动程序吗？ 安装正确的打印机驱动程序。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 打印机正在工作吗？ 问题得以解决。 请联系 客户支持 。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 打印机正在工作吗？ 问题得以解决。 请联系 技术支持 。 疑难解答 解决基本打印机问题 疑难解答 检查无响应的打印机 检查无响应的打印机 打印机问题，解决基本"},{"UUID":"882e2fc5-a985-4113-b36b-1739a4db781e","title":"基本打印机问题","link":"trb-printer-not-responding-topic.html","desc":"打印机显示屏为空白 解决问题的步骤 操作 是 否","descFull":"打印机显示屏为空白 解决问题的步骤 操作 是 否 在打印机控制面板上按“睡眠”按钮。 打印机显示屏上出现 就绪 吗？ 问题得以解决。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 打印机显示屏上出现 请等待 和 就绪 吗？ 问题得以解决。 关闭打印机电源，然后联系 客户支持 。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 打印机显示屏上出现 请等待 和 就绪 吗？ 问题得以解决。 关闭打印机电源，然后联系 技术支持 。 显示屏疑难解答 打印机显示屏为空白 疑难解答，显示屏 打印机显示屏为空白"},{"UUID":"7c1c0300-44c1-4101-9ce0-07dc391c751d","title":"硬件和内置式选件问题","link":"trb-printer-not-responding-topic.html","desc":"无法检测内置式选件 解决问题的步骤 操作 是 否","descFull":"无法检测内置式选件 解决问题的步骤 操作 是 否 关闭打印机电源，接着等待约 10 秒钟，然后打开打印机电源。 内置式选件操作正确吗？ 问题得以解决。 检查内置式选件是否正确地安装在控制器板上。 使用电源开关关闭打印机，然后从电源插座中拔掉电源线。 确认内置式选件安装在控制器板上的适当连接器中。 将电源线连接到打印机上，并插入正确接地的电源插座中，然后打开打印机电源。 内置式选件被正确地安装在控制器板上吗？ 将内置式选件连接到控制器板上。 打印菜单设置页，然后检查内置式选件是否被列在 Installed Features（已安装特性）列表中。 内置式选件被列在菜单设置页上吗？ 重新安装内置式选件。 检查内置式选件是否已被选定。 可能需要在打印机驱动程序中手动添加内置式选件才能使它对打印作业可用。如需更多信息，请参阅 。 重新发送打印作业。 内置式选件操作正确吗？ 问题得以解决。 请联系 客户支持 。 检查内置式选件是否已被选定。 可能需要在打印机驱动程序中手动添加内置式选件才能使它对打印作业可用。如需更多信息，请参阅 。 重新发送打印作业。 内置式选件操作正确吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印机选件 没有检测到内置式选件 打印机选件疑难解答 没有检测到内置式选件"},{"UUID":"5774d1c3-c147-4cb7-bde1-4dd5074a27d9","title":"硬件和内置式选件问题","link":"trb-printer-not-responding-topic.html","desc":"内置式打印服务器操作不正确 解决问题的步骤 操作 是 否","descFull":"内置式打印服务器操作不正确 解决问题的步骤 操作 是 否 重新安装内置式打印服务器。 移除，然后安装内置式打印服务器。如需更多信息，请参阅 。 打印菜单设置页，然后检查内置式打印服务器是否被列在 Installed Features（已安装特性）列表中。 内置式打印服务器被列在 Installed Features（已安装特性）列表中吗？ 检查内置式打印服务器是否被打印机支持。 来自另一台打印机的内置式打印服务器可能无法用于此打印机。 检查电缆和内置式打印服务器的连接。 使用正确的电缆，然后检查它是否牢固地连接到内置式打印服务器。 内置式打印服务器操作正确吗？ 问题得以解决。 请联系 客户支持 。 检查电缆和内置式打印服务器的连接。 使用正确的电缆，然后检查它是否牢固地连接到内置式打印服务器。 内置式打印服务器操作正确吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印机选件 内置式打印服务器 打印机选件疑难解答 内置式打印服务器 内置式打印服务器 疑难解答"},{"UUID":"82c97572-a460-4d0a-9792-daa30c1fd7ca","title":"硬件和内置式选件问题","link":"trb-printer-not-responding-topic.html","desc":"内置方案端口操作不正确 解决问题的步骤 操作 是 否","descFull":"内置方案端口操作不正确 解决问题的步骤 操作 是 否 确认内置方案端口（ISP）已安装。 安装 ISP。如需更多信息，请参阅 。 打印菜单设置页，然后检查 ISP 是否被列在 Installed Features（已安装特性）列表中。 ISP 被列在 Installed Features（已安装特性）列表中吗？ 检查您是否有支持的 ISP。 来自另一台打印机的 ISP 可能无法在此打印机上工作。 检查电缆和 ISP 连接。 使用正确的电缆，然后确认它被牢固地连接到 ISP。 检查 ISP 解决方案接口电缆是否牢固地连接到控制器板的插座中。 ISP 解决方案接口电缆和控制器板上的插座都有颜色编码。 内置方案端口操作正确吗？ 问题得以解决。 请联系 客户支持 。 检查电缆和 ISP 连接。 使用正确的电缆，然后确认它被牢固地连接到 ISP。 检查 ISP 解决方案接口电缆是否牢固地连接到控制器板的插座中。 ISP 解决方案接口电缆和控制器板上的插座都有颜色编码。 内置方案端口操作正确吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印机选件 内置方案端口 打印机选件疑难解答 内置方案端口 内置方案端口 疑难解答"},{"UUID":"633aaec1-b071-49e1-83a3-a107bf7d3809","title":"硬件和内置式选件问题","link":"trb-printer-not-responding-topic.html","desc":"进纸匣问题 解决问题的步骤 操作 是 否","descFull":"进纸匣问题 解决问题的步骤 操作 是 否 拉出进纸匣，然后执行下列操作中的一项或多项： 检查是否有卡纸或误进纸。 检查纸张导片上的纸张尺寸指示器是否与进纸匣上的纸张尺寸指示器对齐。 如果您使用自定义尺寸的纸张打印，请确认纸张导片靠着纸张的边缘。 确认纸张低于最大纸张加载指示线。 确认纸张平整地放在进纸匣中。 检查进纸匣是否正确关闭。 进纸匣正在工作吗？ 问题得以解决。 关闭打印机电源，等待大约 10 秒钟，然后重新打开打印机电源。 重新发送打印作业。 进纸匣正在工作吗？ 问题得以解决。 检查进纸匣是否已安装并被打印机识别。 打印菜单设置页，然后检查进纸匣是否被列在 Installed Features（已安装特性）列表中。 进纸匣被列在菜单设置页上吗？ 重新安装进纸匣。如需更多信息，请参阅随进纸匣附带的设置文档。 检查进纸匣是否在打印机驱动程序中可用。 如果需要，请在打印机驱动程序中手动添加进纸匣以使它对打印作业可用。如需更多信息，请参阅 。 进纸匣在打印机驱动程序中可用吗？ 问题得以解决。 请联系 客户支持 。 检查进纸匣是否在打印机驱动程序中可用。 如果需要，请在打印机驱动程序中手动添加进纸匣以使它对打印作业可用。如需更多信息，请参阅 。 进纸匣在打印机驱动程序中可用吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印机选件 进纸匣问题 打印机选件疑难解答 进纸匣问题"},{"UUID":"abb7316f-9c09-458c-8391-aec52f53489d","title":"硬件和内置式选件问题","link":"trb-printer-not-responding-topic.html","desc":"USB/并行接口卡操作不正确 解决问题的步骤 操作 是 否","descFull":"USB/并行接口卡操作不正确 解决问题的步骤 操作 是 否 确认 USB 或并行接口卡已安装。 安装 USB 或并行接口卡。如需更多信息，请参阅 。 打印菜单设置页，然后检查 USB 或并行接口卡是否被列在 Installed Features（已安装特性）列表中。 USB 或并行接口卡被列在 Installed Features（已安装特性）列表中吗？ 检查您是否有支持的 USB 或并行接口卡。 来自另一台打印机的 USB 或并行接口卡可能无法用于此打印机。 检查电缆和 USB 或并行接口卡的连接。 使用正确的电缆，然后确认它被牢固地连接到 USB 或并行接口卡。 USB 或并行接口卡操作正确吗？ 问题得以解决。 请联系 客户支持 。 检查电缆和 USB 或并行接口卡的连接。 使用正确的电缆，然后确认它被牢固地连接到 USB 或并行接口卡。 USB 或并行接口卡操作正确吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印机选件 USB/并行接口卡 打印机选件疑难解答 USB/并行接口卡 USB/并行接口卡 疑难解答"},{"UUID":"47c8dfcd-831c-4305-adb8-a702b818885b","title":"进纸问题","link":"trb-printer-not-responding-topic.html","desc":"被卡的页面不重新打印 解决问题的步骤 操作 是 否","descFull":"被卡的页面不重新打印 解决问题的步骤 操作 是 否 打开“卡纸恢复”。 从主屏幕，导览至： 设置 常规设置 打印恢复 从“卡纸恢复”菜单，选择 开 或 自动 。 保存更改。 卡纸后页面重新打印吗？ 问题得以解决。 请联系 客户支持 。 请联系 技术支持 。 疑难解答，打印 被卡的页面不重新打印 打印疑难解答 被卡的页面不重新打印"},{"UUID":"4668f30f-7abe-4d32-aa23-bea197350814","title":"进纸问题","link":"trb-printer-not-responding-topic.html","desc":"频繁出现卡纸 解决问题的步骤 操作 是 否","descFull":"频繁出现卡纸 解决问题的步骤 操作 是 否 拉出进纸匣，然后执行下列操作中的一项或多项： 确认纸张平整地放在进纸匣中。 检查纸张导片上的纸张尺寸指示器是否与进纸匣上的纸张尺寸指示器对齐。 检查纸张导片是否与纸张边缘对齐。 确认纸张低于最大纸张加载指示线。 检查您是否使用推荐的纸张尺寸和类型进行打印。 正确插入进纸匣。 如果卡纸恢复已启用，那么打印作业将自动重新打印。 卡纸仍然频繁出现吗？ 问题得以解决。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 卡纸仍然频繁出现吗？ 问题得以解决。 查看有关避免卡纸的提示。如需更多信息，请参阅 。 按照建议执行，然后重新发送打印作业。 卡纸仍然频繁出现吗？ 请联系 客户支持 。 问题得以解决。 查看有关避免卡纸的提示。如需更多信息，请参阅 。 按照建议执行，然后重新发送打印作业。 卡纸仍然频繁出现吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印 频繁出现卡纸 打印疑难解答 频繁出现卡纸"},{"UUID":"8f95062b-5c0f-4f0f-a015-13a3635df0af","title":"进纸问题","link":"trb-printer-not-responding-topic.html","desc":"清除卡纸后，卡纸消息仍然显示 解决问题的步骤 操作 是 否","descFull":"清除卡纸后，卡纸消息仍然显示 解决问题的步骤 操作 是 否 检查整个纸张通道内被卡的纸张。 取出被卡的纸张。 从打印机控制面板，触摸 继续 来清除消息。 卡纸消息仍然存在吗？ 请联系 客户支持 。 问题得以解决。 检查整个纸张通道内被卡的纸张。 取出被卡的纸张。 从打印机控制面板，触摸 继续 来清除消息。 卡纸消息仍然存在吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，进纸 清除卡纸后消息仍然显示 进纸疑难解答 清除卡纸后消息仍然显示"},{"UUID":"89a5758e-7807-46aa-b29a-b3e8b93f34c3","title":"打印问题","link":"solving-print-problems-group.html","desc":"不打印保密和其他挂起作业 如果打印机需要额外内存来处理其他挂起作业，“保密”、“校验”、“保留”和“重复”打印作业可能被删除。 解决问题的步骤 操作 是","descFull":"不打印保密和其他挂起作业 如果打印机需要额外内存来处理其他挂起作业，“保密”、“校验”、“保留”和“重复”打印作业可能被删除。 解决问题的步骤 操作 是 否 在打印机显示屏上，打开挂起作业文件夹，然后检验您的打印作业是否已列出。 您的打印作业被列在挂起作业文件夹中吗？ 选择一个“打印并挂起”选项，然后重新发送打印作业。如需更多信息，请参阅 。 打印作业可能包含格式错误或无效数据。 删除打印作业，然后再次发送它。 对于 PDF 文件，请生成新的 PDF，然后再次打印。 如果您正在从 Internet 打印，那么打印机可能读取多个作业标题作为副本并删除除第一个作业之外的所有作业。 对于 Windows 用户 打开“打印属性”文件夹。 从“打印并挂起”对话，选择“保留重复的文档”复选框。 输入 PIN 码。 对于 Macintosh 用户 保存每一个打印作业，使用不同名称命名每一个作业，然后将单独的作业发送给打印机。 作业打印了吗？ 问题得以解决。 通过删除一些挂起作业来释放额外的打印机内存。 作业打印了吗？ 问题得以解决。 添加额外的打印机内存。 疑难解答，打印 不打印挂起作业 打印疑难解答 不打印挂起作业"},{"UUID":"ad385990-75a6-4c47-af30-55516a803a8d","title":"打印问题","link":"solving-print-problems-group.html","desc":"当打印时信封封口 解决问题的步骤 操作 是 否","descFull":"当打印时信封封口 解决问题的步骤 操作 是 否 使用已存储在干燥环境中的信封。 使用水分含量高的信封打印会封住封舌。 重新发送打印作业。 当打印时，信封封口了吗？ 请联系 客户支持 。 问题得以解决。 使用已存储在干燥环境中的信封。 使用水分含量高的信封打印会封住封舌。 重新发送打印作业。 当打印时，信封封口了吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印 当打印时信封封口 打印疑难解答 当打印时信封封口"},{"UUID":"5174331b-02d6-4b53-9dfe-f9f2cc2bfd9e","title":"打印问题","link":"solving-print-problems-group.html","desc":"出现有关读取闪存驱动器的错误消息 解决问题的步骤 操作 是 否","descFull":"出现有关读取闪存驱动器的错误消息 解决问题的步骤 操作 是 否 检查闪存驱动器是否插入前部 USB 端口中。 如果闪存驱动器被插入后部 USB 端口中，它将不工作。 闪存驱动器被插入前部 USB 端口中吗？ 将闪存驱动器插入前部 USB 端口中。 检查打印机控制面板上的指示灯是否闪烁绿光。 闪烁绿光的指示灯表示打印机正忙。 指示灯正在闪烁绿光吗？ 等待打印机变为就绪，接着查看挂起作业列表，然后打印文档。 检查显示屏上的错误消息。 清除消息。 错误消息仍然出现吗？ 问题得以解决。 检查闪存驱动器是否被支持。 如需有关已经测试和验证的 USB 闪存驱动器的更多信息，请参阅 。 错误消息仍然出现吗？ 问题得以解决。 检查 USB 端口是否被系统支持人员禁用。 错误消息仍然出现吗？ 请联系 客户支持 。 问题得以解决。 检查 USB 端口是否被系统支持人员禁用。 错误消息仍然出现吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印 读取闪存驱动器时出错 打印疑难解答 读取闪存驱动器时出错"},{"UUID":"e9dedf4e-5574-410f-b31a-b06f587badfb","title":"打印问题","link":"solving-print-problems-group.html","desc":"打印不正确的字符 解决问题的步骤 操作 是 否","descFull":"打印不正确的字符 解决问题的步骤 操作 是 否 确认打印机没有处于“十六进制打印”模式。 如果显示屏上出现 就绪 十六进制 ，请关闭打印机电源，然后重新打开以停用“十六进制打印”模式。 打印机处于“十六进制打印”模式吗？ 停用“十六进制打印”模式。 从控制面板，选择 标准网络 或 网络 [x] ，然后将“PCL 智能切换”或“PS 智能切换”设置为“开”。 重新发送打印作业。 打印不正确的字符吗？ 请联系 客户支持 。 请联系 技术支持 。 问题得以解决。 疑难解答，打印 打印不正确的字符 打印疑难解答 打印不正确的字符"},{"UUID":"24b36a4b-9532-4fd5-bc18-2ed4a56e5985","title":"打印问题","link":"solving-print-problems-group.html","desc":"作业从错误的进纸匣打印或打印在错误的纸张上 解决问题的步骤 操作 是 否","descFull":"作业从错误的进纸匣打印或打印在错误的纸张上 解决问题的步骤 操作 是 否 检查您是否使用进纸匣支持的纸张打印。 重新发送打印作业。 作业从正确的进纸匣或者在正确的纸张上打印吗？ 问题得以解决。 从打印机控制面板上的“纸张”菜单，设置纸张尺寸和类型以匹配进纸匣中加载的纸张。 重新发送打印作业。 作业从正确的进纸匣或者在正确的纸张上打印吗？ 问题得以解决。 根据您的操作系统，打开“打印首选项”或“打印”对话，然后指定纸张类型。 重新发送打印作业。 作业从正确的进纸匣或者在正确的纸张上打印吗？ 问题得以解决。 检查进纸匣是否未连接。 重新发送打印作业。 作业从正确的进纸匣或者在正确的纸张上打印吗？ 问题得以解决。 请联系 客户支持 。 检查进纸匣是否未连接。 重新发送打印作业。 作业从正确的进纸匣或者在正确的纸张上打印吗？ 问题得以解决。 请联系 技术支持 。 打印疑难解答 作业从错误的进纸匣打印 打印疑难解答 作业打印在错误的纸张上 疑难解答，打印 作业从错误的进纸匣打印 疑难解答，打印 作业打印在错误的纸张上"},{"UUID":"52fca665-3021-4697-a7d6-3329d40c98ac","title":"打印问题","link":"solving-print-problems-group.html","desc":"不逐份打印大的作业 解决问题的步骤 操作 是 否","descFull":"不逐份打印大的作业 解决问题的步骤 操作 是 否 从打印机控制面板上的“输出”菜单，将“逐份打印”设置为 (1,2,3) (1,2,3)。 重新发送打印作业。 作业逐份打印正确吗？ 问题得以解决。 从打印机软件，将“逐份打印”设置为 (1,2,3) (1,2,3)。 在软件中将“逐份打印”设置为 (1,1,1) (2,2,2) 会覆盖“输出”菜单中的设置。 重新发送打印作业。 作业逐份打印正确吗？ 问题得以解决。 通过减少字体的数量和大小、图像的数量和复杂程度，以及作业的页数来降低打印作业的复杂程度。 作业逐份打印正确吗？ 问题得以解决。 请联系 客户支持 。 通过减少字体的数量和大小、图像的数量和复杂程度，以及作业的页数来降低打印作业的复杂程度。 作业逐份打印正确吗？ 问题得以解决。 请联系 技术支持 。 打印疑难解答 不逐份打印大的作业 疑难解答，打印 不逐份打印大的作业"},{"UUID":"ee1de0c7-0b9d-4ecc-a953-ce762b9d8bbc","title":"打印问题","link":"solving-print-problems-group.html","desc":"多语言 PDF 文件不打印 解决问题的步骤 操作","descFull":"多语言 PDF 文件不打印 解决问题的步骤 操作 是 否 检查 PDF 输出的打印选项是否被设置为嵌入所有字体。 如需更多信息，请参阅随 Adobe Acrobat 附带的文档。 生成新的 PDF 文件，然后重新发送打印作业。 文件打印了吗？ 问题得以解决。 在 Adobe Acrobat 中打开您要打印的文档。 单击 文件 打印 高级 作为图像打印 确定 确定 。 文件打印了吗？ 问题得以解决。 请联系 客户支持 。 在 Adobe Acrobat 中打开您要打印的文档。 单击 文件 打印 高级 作为图像打印 确定 确定 。 文件打印了吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印 多语言 PDF 文件不打印 打印疑难解答 多语言 PDF 文件不打印"},{"UUID":"839a9067-c184-41be-8a06-d1afa800c195","title":"打印问题","link":"solving-print-problems-group.html","desc":"打印作业的时间超过预期 解决问题的步骤 操作 是 否","descFull":"打印作业的时间超过预期 解决问题的步骤 操作 是 否 禁用 Eco 模式。 从控制面板，导览至： 设置 常规设置 Eco 模式 关 禁用“Eco 模式”可能增加能源或纸张，或两者的消耗。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 减少打印作业中字体的数量和大小，图像的数量和复杂程度，以及页数，然后重新发送作业。 作业打印了吗？ 问题得以解决。 删除存储在打印机内存中的挂起作业。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 禁用“页面保护”特性。 从控制面板，导览至： 设置 常规设置 打印恢复 页面保护 关  重新发送打印作业。 作业打印了吗？ 问题得以解决。 检查连接到打印机和打印服务器的电缆是否牢固。如需更多信息，请参阅随打印机附带的设置文档。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 安装额外的打印机内存，然后重新发送打印作业。 作业打印了吗？ 问题得以解决。 请联系 客户支持 。 请联系 技术支持 。 打印疑难解答 打印作业的时间超过预期 疑难解答，打印 打印作业的时间超过预期"},{"UUID":"ceed6b19-3f8c-4ba7-a1b1-b6b55b10c5f1","title":"打印问题","link":"solving-print-problems-group.html","desc":"不打印作业 解决问题的步骤 操作 是 否","descFull":"不打印作业 解决问题的步骤 操作 是 否 从您正在尝试打印的文档，打开“打印”对话并检查您是否选择了正确的打印机。 如果该打印机不是默认打印机，那么您必须为您要打印的每一个文档选择打印机。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 检查打印机是否已插上电源并打开，并且打印机显示屏上是否出现 就绪 。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 如果打印机显示屏上出现错误消息，请清除该消息。 清除消息之后，打印机继续打印。 作业打印了吗？ 问题得以解决。 检查端口（USB、串口或以太网）是否正在工作，并且电缆是否牢固地连接到计算机和打印机。 如需更多信息，请参阅随打印机附带的设置文档。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 移除打印机软件，然后重新安装。如需更多信息，请参阅 。 打印机软件可在  http://support.lexmark.com  上获得。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 请联系 客户支持 。 移除打印机软件，然后重新安装。如需更多信息，请参阅 。 如需更多信息，请访问  www.dell.com/support/printers 。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 请联系 技术支持 。 移除打印机软件，然后重新安装。如需更多信息，请参阅 。 重新发送打印作业。 作业打印了吗？ 问题得以解决。 请联系 客户支持 。 疑难解答，打印 不打印作业 打印疑难解答 不打印作业"},{"UUID":"1b2e8bb2-c456-4ef9-8aa3-b97c8588afb4","title":"打印问题","link":"solving-print-problems-group.html","desc":"进纸匣连接不工作 进纸匣能够检测纸张长度。 多功能进纸器不会自动检测纸张尺寸。您必须从“纸张尺寸/类型”菜单设置尺寸。 解决问题的步骤 操作","descFull":"进纸匣连接不工作 进纸匣能够检测纸张长度。 多功能进纸器不会自动检测纸张尺寸。您必须从“纸张尺寸/类型”菜单设置尺寸。 解决问题的步骤 操作 是 否 打开进纸匣，然后检查它们是否装有相同尺寸和类型的纸张。 检查纸张导片是否放在与每个进纸匣中加载的纸张尺寸相符的正确位置上。 检查纸张导片上的纸张尺寸指示器是否与进纸匣上的纸张尺寸指示器对齐。 重新发送打印作业。 进纸匣连接正确吗？ 问题得以解决。 从打印机控制面板，在“纸张”菜单中设置纸张尺寸和类型以匹配要连接的进纸匣中加载的纸张。 纸张尺寸和类型必须匹配才能使进纸匣连接。 重新发送打印作业。 进纸匣连接正确吗？ 问题得以解决。 请联系 客户支持 。 从打印机控制面板，在“纸张”菜单中设置纸张尺寸和类型以匹配要连接的进纸匣中加载的纸张。 纸张尺寸和类型必须匹配才能使进纸匣连接。 重新发送打印作业。 进纸匣连接正确吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印 进纸匣连接不工作 打印疑难解答 进纸匣连接不工作"},{"UUID":"f38a98f3-1c6b-4abb-9bc9-760d246c8bda","title":"打印问题","link":"solving-print-problems-group.html","desc":"出现意想不到的页中断 解决问题的步骤 操作 是 否","descFull":"出现意想不到的页中断 解决问题的步骤 操作 是 否 增加打印超时。 从主屏幕，导览至： 设置 常规设置 超时 增加“打印超时”设置，然后触摸 提交 。 重新发送打印作业。 文件打印正确吗？ 问题得以解决。 检查原始文件中的手动页中断。 疑难解答，打印 出现意想不到的页中断 打印疑难解答 出现意想不到的页中断"},{"UUID":"28a0b910-b358-4d43-94fe-221e3e374f79","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"字符有锯齿或不平滑的边缘 解决问题的步骤 操作 是 否","descFull":"字符有锯齿或不平滑的边缘 解决问题的步骤 操作 是 否 打印字体样本列表来检查您正在使用的字体是否被打印机支持。 从打印机控制面板，导览至： 报告 打印字体 触摸  PCL 字体 或  PostScript 字体 。 使用打印机支持的字体，或者安装您要使用的字体。如需更多信息，请与系统支持人员联系。 重新发送打印作业。 打印结果仍然包含有锯齿或不平滑边缘的字符吗？ 问题得以解决。 使用打印机支持的字体，或者在计算机上安装您要使用的字体。如需更多信息，请与系统支持人员联系。 重新发送打印作业。 打印结果仍然包含有锯齿或不平滑边缘的字符吗？ 请联系 客户支持 。 问题得以解决。 使用打印机支持的字体，或者在计算机上安装您要使用的字体。如需更多信息，请与系统支持人员联系。 重新发送打印作业。 打印结果仍然包含有锯齿或不平滑边缘的字符吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 字符有锯齿边 打印质量疑难解答 字符有锯齿边"},{"UUID":"51ff4667-9bdf-4f4d-8174-3604262f16b2","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"页面或图像被剪切 解决问题的步骤 操作 是 否","descFull":"页面或图像被剪切 解决问题的步骤 操作 是 否 将进纸匣中的纸张导片移动到与加载的纸张相符的正确位置上。 重新发送打印作业。 页面或图像被剪切吗？ 问题得以解决。 从控制面板，在“纸张”菜单中设置纸张尺寸和类型以匹配进纸匣中加载的纸张。 纸张尺寸和类型与进纸匣中加载的纸张相符吗？ 请执行下列操作中的一项或多项： 从进纸匣设置指定纸张尺寸以匹配进纸匣中加载的纸张。 更改进纸匣中加载的纸张以匹配进纸匣设置中指定的纸张尺寸。 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张尺寸。 重新发送打印作业。 页面或图像被剪切吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 页面或图像被剪切吗？ 问题得以解决。 移除，然后重新安装感光鼓。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 页面或图像被剪切吗？ 请联系 客户支持 。 问题得以解决。 移除，然后重新安装感光鼓。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 页面或图像被剪切吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 页面或图像被剪切 打印质量疑难解答 页面或图像被剪切"},{"UUID":"991162e5-ddd8-44ab-ac6c-196341e30d0a","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现灰色背景 解决问题的步骤 操作 是 否","descFull":"打印页面上出现灰色背景 解决问题的步骤 操作 是 否 从控制面板上的“质量菜单”，降低碳粉浓度。 重新发送打印作业。 灰色背景从打印页面上消失了吗？ 问题得以解决。 移除，然后重新安装感光鼓和碳粉盒。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 灰色背景从打印页面上消失了吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 灰色背景从打印页面上消失了吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 灰色背景从打印页面上消失了吗？ 问题得以解决。 请联系 客户支持 。 请联系 技术支持 。 疑难解答，打印质量 打印页面上出现灰色背景 打印质量疑难解答 打印页面上出现灰色背景"},{"UUID":"b8e17a3c-f2fc-4984-b47f-3aa170a5ee51","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现水平空白 解决问题的步骤 操作 是 否","descFull":"打印页面上出现水平空白 解决问题的步骤 操作 是 否 确认您的软件程序使用正确的填充方式。 重新发送打印作业。 打印页面上出现水平空白吗？ 问题得以解决。 使用推荐类型的纸张加载指定的进纸匣或进纸器。 重新发送打印作业。 打印页面上出现水平空白吗？ 问题得以解决。 移除，然后重新安装感光鼓。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 打印页面上出现水平空白吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印页面上出现水平空白吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现水平空白吗？ 请联系 客户支持 。 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印页面上出现水平空白 打印质量疑难解答 打印页面上出现水平空白"},{"UUID":"d95a6dcf-8a41-4734-9d70-e50ca6ef1230","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上页边距不正确 解决问题的步骤 操作 是 否","descFull":"打印页面上页边距不正确 解决问题的步骤 操作 是 否 将进纸匣中的宽度和长度导片移动到与加载的纸张尺寸相符的正确位置上。 重新发送打印作业。 页边距正确吗？ 问题得以解决。 从打印机控制面板，在“纸张”菜单中设置纸张尺寸以匹配进纸匣中加载的纸张。 纸张尺寸与进纸匣中加载的纸张相符吗？ 请执行下列操作中的一项或多项： 从进纸匣设置指定纸张尺寸以匹配进纸匣中加载的纸张。 更改进纸匣中加载的纸张以匹配进纸匣设置中指定的纸张尺寸。 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张尺寸。 重新发送打印作业。 页边距正确吗？ 问题得以解决。 请联系 客户支持 。 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张尺寸。 重新发送打印作业。 页边距正确吗？ 问题得以解决。 请联系 技术支持 。 打印疑难解答 打印页面上页边距不正确 疑难解答，打印 打印页面上页边距不正确"},{"UUID":"beae94f7-fc5d-4990-862e-7f173fa4c2d9","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"纸张卷曲 解决问题的步骤 操作 是 否","descFull":"纸张卷曲 解决问题的步骤 操作 是 否 将进纸匣中的宽度和长度导片移动到与加载的纸张尺寸相符的正确位置上。 宽度和长度导片放置正确吗？ 调整宽度和长度导片。 从打印机控制面板，在“纸张”菜单中设置纸张类型和重量以匹配进纸匣中加载的纸张。 纸张类型和重量与进纸匣中的纸张的类型和重量相符吗？ 从进纸匣设置指定纸张类型和重量以匹配进纸匣中加载的纸张。 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张类型和重量。 重新发送打印作业。 纸张仍然卷曲吗？ 问题得以解决。 从进纸匣中取出纸张，然后翻转过来。 重新发送打印作业。 纸张仍然卷曲吗？ 问题得以解决。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 纸张仍然卷曲吗？ 请联系 客户支持 。 问题得以解决。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 纸张仍然卷曲吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印 纸张卷曲 打印疑难解答 纸张卷曲"},{"UUID":"d90134b2-06a3-4897-97b1-1109c48f8457","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印机打印空白页 解决问题的步骤 操作 是 否","descFull":"打印机打印空白页 解决问题的步骤 操作 是 否 检查是否有包装材料留在感光鼓上。 移除感光鼓。 检查是否从感光鼓上正确移除包装材料。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新安装感光鼓。 重新发送打印作业。 打印机仍然打印空白页吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印机仍然打印空白页吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印机仍然打印空白页吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印机仍然打印空白页吗？ 请联系 技术支持 。 疑难解答，打印质量 空白页 打印质量疑难解答 空白页 打印机打印空白页"},{"UUID":"76d47465-ac74-455b-baa8-72bc40c7f0f9","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印机正在打印纯黑色页面 解决问题的步骤 操作 是 否","descFull":"打印机正在打印纯黑色页面 解决问题的步骤 操作 是 否 重新安装感光鼓。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 打印机正在打印纯黑色页面吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印机正在打印纯黑色页面吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印机正在打印纯黑色页面吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印机正在打印纯黑色页面吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印机正在打印纯黑色页面 打印质量疑难解答 打印机正在打印纯黑色页面"},{"UUID":"5e415db3-a208-46f1-9944-19e78eccba1e","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印不规则 解决问题的步骤 操作 是 否","descFull":"打印不规则 解决问题的步骤 操作 是 否 将进纸匣中的纸张导片移动到与进纸匣中加载的纸张尺寸相符的正确位置上。 重新发送打印作业。 仍然出现打印不规则吗？ 问题得以解决。 从控制面板，在“纸张”菜单中设置纸张尺寸和类型以匹配进纸匣中加载的纸张。 打印机设置与进纸匣中加载的纸张的尺寸和类型相符吗？ 在进纸匣设置中指定纸张尺寸和类型以匹配进纸匣中加载的纸张。 根据您的操作系统，在“打印首选项”或“打印”对话中指定纸张类型和重量。 重新发送打印作业。 仍然出现打印不规则吗？ 问题得以解决。 检查进纸匣中加载的纸张是否有纹理或表面粗糙。 您正在使用有纹理或粗糙的纸张进行打印吗？ 从控制面板，在“纸张”菜单中设置纸张纹理以匹配进纸匣中加载的纸张。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 仍然出现打印不规则吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 仍然出现打印不规则吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 仍然出现打印不规则吗？ 请联系 客户支持 ，或您的服务代表。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 仍然出现打印不规则吗？ 请联系 技术支持 ，或您的 Dell 打印机经销商。 问题得以解决。 疑难解答，打印质量 打印不规则 打印质量疑难解答 打印不规则 打印不规则"},{"UUID":"88520421-5283-4867-825e-059a7357f410","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印浓度太深 解决问题的步骤 操作 是 否","descFull":"打印浓度太深 解决问题的步骤 操作 是 否 从控制面板上的“质量菜单”，降低碳粉浓度。 8 是出厂默认设置。 重新发送打印作业。 打印浓度仍然太深吗？ 问题得以解决。 从控制面板，在“纸张”菜单中设置纸张类型、纹理和重量以匹配进纸匣中加载的纸张。 重新发送打印作业。 进纸匣设置为已加载纸张的类型、纹理和重量吗？ 请执行下列操作中的一项或多项： 从进纸匣设置指定纸张类型、纹理和重量以匹配进纸匣中加载的纸张。 更改进纸匣中加载的纸张以匹配进纸匣设置中指定的纸张类型、纹理和重量。 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张类型、纹理和重量。 重新发送打印作业。 打印浓度仍然太深吗？ 问题得以解决。 检查进纸匣中加载的纸张是否有纹理或表面粗糙。 您正在使用有纹理或粗糙的纸张进行打印吗？ 从控制面板，更改“纸张纹理”菜单中的纹理设置以匹配您正在用于打印的纸张。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 打印浓度仍然太深吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印浓度仍然太深吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 打印浓度仍然太深吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 打印浓度仍然太深吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印浓度太深 打印质量疑难解答 打印浓度太深"},{"UUID":"b1ead1ea-b68f-4388-8c3e-5ecfb4d37496","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印浓度太浅 解决问题的步骤 操作 是 否","descFull":"打印浓度太浅 解决问题的步骤 操作 是 否 从控制面板上的“质量菜单”，提高碳粉浓度。 8 是出厂默认设置。 重新发送打印作业。 打印浓度仍然太浅吗？ 问题得以解决。 从控制面板，在“纸张”菜单中设置纸张类型、纹理和重量以匹配进纸匣中加载的纸张。 进纸匣设置为已加载纸张的类型、纹理和重量吗？ 更改纸张类型、纹理和重量以匹配进纸匣中加载的纸张。 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张类型、纹理和重量。 重新发送打印作业。 打印浓度仍然太浅吗？ 问题得以解决。 确认纸张没有纹理或粗糙表面。 您正在使用有纹理或粗糙的纸张进行打印吗？ 从控制面板，更改“纸张纹理”菜单中的纹理设置以匹配您正在用于打印的纸张。 请转到第 5 步。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 打印浓度仍然太浅吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印浓度仍然太浅吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 打印浓度仍然太浅吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 打印浓度仍然太浅吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印浓度太浅 打印质量疑难解答 打印浓度太浅"},{"UUID":"20a14801-2456-4ced-995c-3a73a828641b","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现重复的缺陷 解决问题的步骤 操作 是 否","descFull":"打印页面上出现重复的缺陷 解决问题的步骤 操作 是 否 清洁充电辊和打印头镜片。 重新发送打印作业。 打印页面上仍然出现重复的缺陷吗？ 问题得以解决。 如果缺陷之间的距离等于 95.8 毫米（3.77 英寸），请更换感光鼓。 重新发送打印作业。 打印页面上仍然出现重复的缺陷吗？ 问题得以解决。 如果缺陷之间的距离等于下面任一值，请更换 300K 维护组件： 62.65 毫米（2.47 英寸） 75.85 毫米（2.99 英寸） 重新发送打印作业。 打印页面上仍然出现重复的缺陷吗？ 请联系 客户支持 。 请联系 技术支持 。 问题得以解决。 打印质量疑难解答 打印页面上出现重复的缺陷 疑难解答，打印质量 打印页面上出现重复的缺陷 打印页面上出现重复的缺陷"},{"UUID":"1ba1f513-d1f5-4028-9677-f973350e1f5e","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现阴影图像 解决问题的步骤 操作 是 否","descFull":"打印页面上出现阴影图像 解决问题的步骤 操作 是 否 使用正确纸张类型和重量的纸张加载进纸匣。 使用正确纸张类型和重量的纸张加载进纸匣吗？ 使用正确纸张类型和重量的纸张加载进纸匣。 从控制面板，在“纸张”菜单中设置纸张类型和重量以匹配进纸匣中加载的纸张。 进纸匣设置为已加载纸张的类型和重量吗？ 更改进纸匣中加载的纸张以匹配进纸匣设置中指定的纸张类型和重量。 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张类型和重量。 重新发送打印作业。 打印页面上仍然出现阴影图像吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印页面上仍然出现阴影图像吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 打印页面上仍然出现阴影图像吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 打印页面上仍然出现阴影图像吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印页面上出现阴影图像 打印质量疑难解答 打印页面上出现阴影图像"},{"UUID":"0e250129-1dc6-4aa1-899b-17210bd9f54c","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印歪斜 解决问题的步骤 操作 是 否","descFull":"打印歪斜 解决问题的步骤 操作 是 否 将进纸匣中的宽度和长度导片移动到与加载的纸张尺寸相符的正确位置上。 重新发送打印作业。 打印仍然歪斜吗？ 问题得以解决。 检查您是否使用进纸匣支持的纸张打印。 重新发送打印作业。 打印仍然歪斜吗？ 请联系 客户支持 。 问题得以解决。 检查您是否使用进纸匣支持的纸张打印。 重新发送打印作业。 打印仍然歪斜吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印歪斜 打印质量疑难解答 打印歪斜"},{"UUID":"84a77d78-ee24-4725-a253-5871d51f3245","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现水平条纹 解决问题的步骤 操作 是 否","descFull":"打印页面上出现水平条纹 解决问题的步骤 操作 是 否 根据您的操作系统，从“打印首选项”或“打印”对话指定进纸匣或进纸器。 重新发送打印作业。  打印页面上出现水平条纹吗？ 问题得以解决。 从控制面板，在“纸张”菜单中设置纸张类型和重量以匹配进纸匣中加载的纸张。 纸张类型和重量与进纸匣中的纸张的类型和重量相符吗？ 更改纸张类型和重量以匹配进纸匣中加载的纸张。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 打印页面上出现水平条纹吗？ 问题得以解决。 移除，然后重新安装感光鼓。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 打印页面上出现水平条纹吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印页面上出现水平条纹吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现水平条纹吗？ 请联系 客户支持 。 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印页面上出现水平条纹 打印质量疑难解答 打印页面上出现水平条纹 打印页面上出现水平条纹"},{"UUID":"41caba11-6de0-42f1-9ee1-138211d7ca78","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现垂直条纹 解决问题的步骤 操作 是 否","descFull":"打印页面上出现垂直条纹 解决问题的步骤 操作 是 否 根据您的操作系统，从“打印首选项”或“打印”对话指定纸张类型、纹理和重量。 重新发送打印作业。 打印页面上出现垂直条纹吗？ 问题得以解决。 从控制面板，在“纸张”菜单中设置纸张纹理、类型和重量以匹配进纸匣中加载的纸张。 纸张纹理、尺寸和类型与进纸匣中的纸张相符吗？ 请执行下列操作中的一项或多项： 从进纸匣设置指定纸张纹理、类型和重量以匹配进纸匣中加载的纸张。 更改进纸匣中加载的纸张以匹配进纸匣设置中指定的纸张纹理、类型和重量。 加载新包装中的纸张。 由于空气湿度大，纸张吸收了水分。在使用之前将纸张保存在其原始包装中。 重新发送打印作业。 打印页面上出现垂直条纹吗？ 问题得以解决。 移除，然后重新安装感光鼓。 移除感光鼓。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 安装感光鼓。 重新发送打印作业。 打印页面上出现垂直条纹吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印页面上出现垂直条纹吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现垂直条纹吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现垂直条纹吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现垂直条纹吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 垂直条纹 打印质量疑难解答 垂直条纹 打印页面上出现垂直条纹"},{"UUID":"873502f4-3705-4a7c-a116-5ae47201e112","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现碳粉模糊或背景阴影 解决问题的步骤 操作 是 否","descFull":"打印页面上出现碳粉模糊或背景阴影 解决问题的步骤 操作 是 否 清洁充电辊和打印头镜片。 重新发送打印作业。 碳粉模糊或背景阴影从打印页面上消失了吗？ 问题得以解决。 重新安装感光鼓。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 碳粉模糊或背景阴影从打印页面上消失了吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 碳粉模糊或背景阴影从打印页面上消失了吗？ 问题得以解决。 请联系 客户支持 。 更换感光鼓，然后重新发送打印作业。 碳粉模糊或背景阴影从打印页面上消失了吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，打印质量 打印页面上出现碳粉模糊或背景阴影 打印质量疑难解答 打印页面上出现碳粉模糊或背景阴影"},{"UUID":"30fe04cb-5b5d-411d-b1a2-0783932772b2","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"碳粉脱落 解决问题的步骤 操作 是 否","descFull":"碳粉脱落 解决问题的步骤 操作 是 否 从打印机控制面板上的“纸张”菜单，检查纸张类型、纹理和重量。 纸张类型、纹理和重量与进纸匣中加载的纸张相符吗？ 从进纸匣设置指定纸张类型、纹理和重量以匹配进纸匣中加载的纸张。 重新发送打印作业。 碳粉仍然脱落吗？ 请联系 客户支持 。 问题得以解决。 重新发送打印作业。 碳粉仍然脱落吗？ 请联系 技术支持 ，或您的 Dell 打印机经销商。 问题得以解决。 重新发送打印作业。 碳粉仍然脱落吗？ 请联系客户支持或您的服务代表。 问题得以解决。 疑难解答，打印质量 碳粉脱落 打印质量疑难解答 碳粉脱落"},{"UUID":"ae7ebd21-822e-4d4e-9c95-c330b196e193","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现碳粉斑点 解决问题的步骤 操作 是 否","descFull":"打印页面上出现碳粉斑点 解决问题的步骤 操作 是 否 清洁充电辊和打印头镜片。 重新发送打印作业。 打印页面上出现碳粉斑点吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现碳粉斑点吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现碳粉斑点吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印页面上出现碳粉斑点 打印质量疑难解答 打印页面上出现碳粉斑点"},{"UUID":"3d4586b1-2bd0-43ac-b15d-57c273eddfe0","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"透明胶片的打印质量很差 解决问题的步骤 操作 是 否","descFull":"透明胶片的打印质量很差 解决问题的步骤 操作 是 否 从打印机控制面板，在“纸张”菜单中设置纸张类型以匹配进纸匣中加载的纸张。 进纸匣的纸张类型设置为“透明胶片”吗？ 将纸张类型设置为“透明胶片”。 检查您是否使用推荐类型的透明胶片。 重新发送打印作业。 打印质量仍然很差吗？ 请联系 客户支持 。 问题得以解决。 检查您是否使用推荐类型的透明胶片。 重新发送打印作业。 打印质量仍然很差吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 透明胶片的打印质量很差 打印质量疑难解答 透明胶片的打印质量很差"},{"UUID":"60e29a6c-a902-4f84-901f-fb870b7414f9","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印密度不均匀 解决问题的步骤 操作 是 否","descFull":"打印密度不均匀 解决问题的步骤 操作 是 否 清洁充电辊和打印头镜片。 重新发送打印作业。 打印密度不均匀吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印密度不均匀吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印密度不均匀吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 打印密度不均匀 打印质量疑难解答 打印密度不均匀 打印密度不均匀"},{"UUID":"f4c58add-70a3-485b-8101-89f6e2a819bd","title":"打印质量问题","link":"solving-print-problems-group.html","desc":"打印页面上出现垂直空白 解决问题的步骤 操作 是 否","descFull":"打印页面上出现垂直空白 解决问题的步骤 操作 是 否 确认您的软件程序使用正确的填充方式。 重新发送打印作业。 打印页面上出现垂直空白吗？ 问题得以解决。 从控制面板，在“纸张”菜单中设置纸张类型和重量以匹配进纸匣中加载的纸张。 重新发送打印作业。 打印页面上出现垂直空白吗？ 问题得以解决。 检查您是否使用推荐类型的纸张。 使用推荐类型的纸张加载指定的进纸匣或进纸器。 重新发送打印作业。 打印页面上出现垂直空白吗？ 问题得以解决。 移除感光鼓，然后重新安装它。 不要让感光鼓暴露在直射光线下超过 10 分钟。长时间暴露在光线下可能导致打印质量问题。 重新发送打印作业。 打印页面上出现垂直空白吗？ 问题得以解决。 清洁充电辊和打印头镜片。 重新发送打印作业。 打印页面上出现垂直空白吗？ 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现垂直空白吗？ 请联系 客户支持 。 问题得以解决。 更换感光鼓，然后重新发送打印作业。 打印页面上出现垂直空白吗？ 请联系 技术支持 。 问题得以解决。 疑难解答，打印质量 页面上出现白色条纹 打印质量疑难解答 白色条纹 出现条纹 出现空白 出现垂直空白"},{"UUID":"758f292c-93ea-4035-b6f3-51bb0e1b1baa","title":"解决复印问题","link":"trb-copier-does-not-respond-topic.html","desc":"复印机不响应 解决问题的步骤 操作 是 否","descFull":"复印机不响应 解决问题的步骤 操作 是 否 检查显示屏上是否出现错误或状态消息。 出现错误或状态消息吗？ 清除错误或状态消息。 检查电源线是否已被插入打印机和正确接地的电源插座中。 电源线已被插入打印机和正确接地的电源插座中吗？ 将电源线连接到打印机和正确接地的电源插座中。 关闭打印机电源，等待大约 10 秒钟，然后重新打开打印机电源。 出现 正在执行自检 和 就绪 吗？ 问题得以解决。 请联系 客户支持 。 关闭打印机电源，等待大约 10 秒钟，然后重新打开打印机电源。 出现 正在执行自检 和 就绪 吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，复印 复印机不响应 复印疑难解答 复印机不响应"},{"UUID":"04f9f6e6-317a-4de6-bba3-f452360e71b2","title":"解决复印问题","link":"trb-copier-does-not-respond-topic.html","desc":"复印部分文档或照片 解决问题的步骤 操作 是 否","descFull":"复印部分文档或照片 解决问题的步骤 操作 是 否 检查文档或照片的放置。 确认将文档或照片面朝下放在扫描仪玻璃的左上角上。 文档或照片加载正确吗？ 将文档或照片面朝下放在扫描仪玻璃的左上角上。 检查纸张尺寸设置与进纸匣中加载的纸张尺寸是否相匹配。 从打印机控制面板上的“纸张”菜单，检查“纸张尺寸”设置。 纸张尺寸设置与进纸匣中加载的纸张尺寸相匹配吗？ 更改纸张尺寸设置以匹配进纸匣中加载的纸张，或者用匹配纸张尺寸设置的纸张加载进纸匣。 指定纸张尺寸。根据您的操作系统，在“打印首选项”或“打印”对话中指定纸张尺寸。 重新发送打印作业。 副本打印正确吗？ 问题得以解决。 请联系 客户支持 。 指定纸张尺寸。根据您的操作系统，在“打印首选项”或“打印”对话中指定纸张尺寸。 重新发送打印作业。 副本打印正确吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，复印 复印部分文档或照片 复印疑难解答 复印部分文档或照片"},{"UUID":"e0777bfa-0a01-44f7-91ba-c2ba68515a17","title":"解决复印问题","link":"trb-copier-does-not-respond-topic.html","desc":"复印质量很差 解决问题的步骤 操作 是 否","descFull":"复印质量很差 解决问题的步骤 操作 是 否 检查显示屏上是否出现错误或状态消息。 出现错误或状态消息吗？ 清除错误或状态消息。 检查原始文档的质量。 原始文档的质量令人满意吗？ 增加扫描分辨率设置，以获得更高质量的输出。 如果打印页面上出现暗痕，请用水润湿一块干净、不起毛的布，然后清洁扫描仪玻璃和 ADF 玻璃。 扫描仪玻璃干净吗？ 请参阅 。 发送打印作业，检查打印质量问题。 从“复印”菜单，调整碳粉浓度。 如果打印效果仍然变浅，请更换碳粉盒。 打印质量令人满意吗？ 请参阅 。 检查文档或照片的放置。 确认将文档或照片面朝下放在扫描仪玻璃的左上角上。 文档或照片加载正确吗？ 将文档或照片面朝下放在扫描仪玻璃的左上角上。 检查复印设置。 从“复印”屏幕，检查“内容类型”和“内容来源”设置对正在扫描的文档是否正确。 “内容类型”和“内容来源”设置对正在扫描的文档正确吗？ 更改“内容类型”和“内容来源”设置以匹配正在扫描的文档。 检查打印页面上的图案。 从“复印”屏幕，导览至： 高级选项 高级图像 清晰度  选择较低的设置 确认没有选择缩放。 重新发送复印作业。 打印页面上出现图案吗？ 问题得以解决。 检查打印页面上缺少或浅色的文本。 从“复印”屏幕，导览至： 高级选项 高级图像 调整设置： 清晰度 —增加当前设置。 对比度 —增加当前设置。 重新发送复印作业。 打印页面上有缺少或浅色的文本吗？ 问题得以解决。 检查褪色或过度曝光的输出。 从“复印”屏幕，导览至： 高级选项 高级图像 调整下列设置： 背景消除 —减少当前设置。 阴影细节 —减少当前设置。 重新发送复印作业。 页面显示褪色或过度曝光的打印效果吗？ 请联系 客户支持 。 问题得以解决。 检查褪色或过度曝光的输出。 从“复印”屏幕，导览至： 高级选项 高级图像 调整下列设置： 背景消除 —减少当前设置。 阴影细节 —减少当前设置。 重新发送复印作业。 页面显示褪色或过度曝光的打印效果吗？ 请联系 技术支持 。 问题得以解决。 复印疑难解答 复印质量很差 疑难解答，复印 复印质量很差"},{"UUID":"1a437854-b383-498b-998b-4c5b688ecb73","title":"解决传真问题","link":"trb-caller-id-not-shown-topic.html","desc":"不显示来电号码 解决问题的步骤 操作 是 否","descFull":"不显示来电号码 解决问题的步骤 操作 是 否 请联系您的电话公司，检查您的电话线是否已申请来电显示服务。 如果您所在的地区支持多种来电显示模式，您可能要更改默认的设置。有两种设置可供选择：FSK（模式 1）和 DTMF（模式 2）。 “传真”菜单中这些设置的可用性取决于您所在的国家或地区是否支持多种来电显示模式。 请与您的电话公司联系以确定使用哪种模式或切换设置。 显示来电号码了吗？ 问题得以解决。 请联系 客户支持 。 请联系您的电话公司，检查您的电话线是否已申请来电显示服务。 如果您所在的地区支持多种来电显示模式，您可能要更改默认的设置。有两种设置可供选择：FSK（模式 1）和 DTMF（模式 2）。 “传真”菜单中这些设置的可用性取决于您所在的国家或地区是否支持多种来电显示模式。 请与您的电话公司联系以确定使用哪种模式或切换设置。 显示来电号码了吗？ 问题得以解决。 请联系 技术支持 。 疑难解答，传真 不显示来电号码 传真疑难解答 不显示来电号码"},{"UUID":"95019394-b3a3-4ad3-b1d3-059e559e2a8d","title":"解决传真问题","link":"trb-caller-id-not-shown-topic.html","desc":"不能发送或接收传真 解决问题的步骤 操作 是 否","descFull":"不能发送或接收传真 解决问题的步骤 操作 是 否 检查显示屏上是否出现错误或状态消息。 显示屏上有错误或状态消息吗？ 清除错误或状态消息。 检查电源线是否已被插入打印机和正确接地的电源插座中。 电源线已被插入打印机和正确接地的电源插座中吗？ 将电源线连接到打印机和正确接地的电源插座中。 检查电源。 检查打印机是否已插上电源并打开，并且显示屏上是否出现 就绪 。 打印机电源打开，并且显示屏上出现 就绪 了吗？ 打开打印机电源，然后等待显示屏上出现 就绪 。 检查打印机连接。 如果适用，请检查下列装置的电缆连接是否牢固： 电话 电话听筒 应答机 电缆连接牢固吗？ 牢固地连接电缆。 检查电话墙壁插孔。 将电话线插入墙壁插孔中。 聆听拨号音。 如果听不到拨号音，请将另一根电话线插入墙壁插孔中。 如果您仍然听不到拨号音，请将电话线插入另一个墙壁插孔中。 如果您听到拨号音，请将打印机连接到该墙壁插孔中。 尝试发送或接收传真。 能够发送或接收传真吗？ 问题得以解决。 检查打印机是否连接到模拟电话服务或正确的数字连接器上。 传真调制解调器是模拟设备。某些设备能够被连接到打印机上以便能够使用数字电话服务。 如果您使用 ISDN 电话服务，请将打印机连接到 ISDN 终端适配器上的模拟电话端口（R 接口端口）。如需更多信息和请求 R 接口端口，请与您的 ISDN 供应商联系。 如果您使用 DSL，请连接到支持模拟应用的 DSL 过滤器或路由器上。如需更多信息，请与您的 DSL 供应商联系。 如果您使用 PBX 电话服务，请确认您连接到 PBX 上的模拟连接。如果不存在模拟连接，则考虑为传真机安装一条模拟电话线。 打印机连接到模拟电话服务或正确的数字连接器上吗？ 将打印机连接到模拟电话服务或正确的数字连接器上。 检查拨号音。 您听到拨号音吗？ 尝试呼叫传真号码以确认它工作正常。 如果电话线路正被其他设备使用，请在发送传真之前等待其他设备结束使用。 如果您使用“免提拨号”功能，请调高音量以检查您是否听到拨号音。 暂时断开打印机和电话线之间的其他装置（如应答机、带调制解调器的计算机或电话分线器），然后尝试发送或接收传真。 能够发送或接收传真吗？ 问题得以解决。 暂时禁用呼叫等待。请与您的电话公司联系以获得暂时禁用呼叫等待的键区序列。 尝试发送或接收传真。 能够发送或接收传真吗？ 问题得以解决。 暂时禁用语音信箱服务。如需更多信息，请与您的电话公司联系。 如果您要同时使用语音信箱和打印机，请考虑为打印机添加第二条电话线。 尝试发送或接收传真。 能够发送或接收传真吗？ 问题得以解决。 每次扫描一页原始文档。 拨传真号码。 每次扫描一页文档。 能够发送或接收传真吗？ 问题得以解决。 请联系 客户支持 。 每次扫描一页原始文档。 拨传真号码。 每次扫描一页文档。 能够发送或接收传真吗？ 问题得以解决。 请联系 技术支持 。 传真疑难解答 不能发送或接收传真 疑难解答，传真 不能发送或接收传真"},{"UUID":"cb2ff77e-3eb9-4cc0-9ae6-b8813a68cb11","title":"解决传真问题","link":"trb-caller-id-not-shown-topic.html","desc":"能接收但不能发送传真 解决问题的步骤 操作 是 否","descFull":"能接收但不能发送传真 解决问题的步骤 操作 是 否 检查打印机是否处于“传真”模式。 从主屏幕，触摸 传真 来将打印机置于“传真”模式，然后发送传真。 能够发送传真吗？ 问题得以解决。 将原始文档正确放入 ADF 进纸匣中，或放在扫描仪玻璃上。 能够发送传真吗？ 问题得以解决。 正确设置快捷方式号码。 检查是否已为您要拨出的电话号码设置快捷方式号码。 手动拨出电话号码。 能够发送传真吗？ 问题得以解决。 请联系 客户支持 。 正确设置快捷方式号码。 检查是否已为您要拨出的电话号码设置快捷方式号码。 手动拨出电话号码。 能够发送传真吗？ 问题得以解决。 请联系 技术支持 。 传真疑难解答 能接收但不能发送传真 疑难解答，传真 能接收但不能发送传真"},{"UUID":"d49fd666-2012-4848-b57b-4baade60f322","title":"解决传真问题","link":"trb-caller-id-not-shown-topic.html","desc":"能发送但不能接收传真 解决问题的步骤 操作 是 否","descFull":"能发送但不能接收传真 解决问题的步骤 操作 是 否 检查进纸匣或进纸器。 如果为空，请将纸张加载到进纸匣或进纸器中。 能够接收传真吗？ 问题得以解决。 检查“振铃计数延迟”设置。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 单击 设置 传真设置 模拟传真设置 。 在“应答振铃”字段中，输入您要让电话在打印机应答之前振铃的次数。 单击 提交 。 能够接收传真吗？ 问题得以解决。 更换碳粉盒。如需更多信息，请参阅随耗材附带的说明页。 能够接收传真吗？ 问题得以解决。 请联系 客户支持 。 更换碳粉盒。如需更多信息，请参阅随耗材附带的说明页。 能够接收传真吗？ 问题得以解决。 请联系 技术支持 。 传真疑难解答 能发送但不能接收传真 疑难解答，传真 能发送但不能接收传真"},{"UUID":"da400abb-4ef9-45e6-bba2-fe8a16473d8a","title":"解决传真问题","link":"trb-caller-id-not-shown-topic.html","desc":"传真和电子邮件功能未设置 在您解决问题之前，请检查传真电缆是否已连接。 指示灯闪烁红光，直到您设置好传真和电子邮件。 解决问题的步骤 操作","descFull":"传真和电子邮件功能未设置 在您解决问题之前，请检查传真电缆是否已连接。 指示灯闪烁红光，直到您设置好传真和电子邮件。 解决问题的步骤 操作 是 否 从主屏幕，导览至： 设置 常规设置 运行初始设置 是 提交 关闭打印机电源，然后重新打开。 打印机显示屏上出现“选择您的语言”屏幕。 选择一种语言，然后触摸  。 选择一个国家或地区，然后触摸 下一步 。 选择一个时区，然后触摸 下一步 。 选择 传真 和 电子邮件 ，然后触摸 下一步 。 传真和电子邮件功能设置了吗？ 问题得以解决。 请联系 客户支持 。 从主屏幕，导览至： 设置 常规设置 运行初始设置 是 提交 关闭打印机电源，然后重新打开。 打印机显示屏上出现“选择您的语言”屏幕。 选择一种语言，然后触摸  。 选择一个国家或地区，然后触摸 下一步 。 选择一个时区，然后触摸 下一步 。 选择 传真 和  电子邮件 ，然后触摸 下一步 。 传真和电子邮件功能设置了吗？ 问题得以解决。 请联系 技术支持 。 疑难解答 传真和电子邮件功能未设置 传真和电子邮件功能未设置 传真和电子邮件功能 设置 设置传真和电子邮件功能"},{"UUID":"275c9feb-6200-4073-86ce-193dd7255252","title":"解决传真问题","link":"trb-caller-id-not-shown-topic.html","desc":"接收的传真打印质量很差 解决问题的步骤 操作 是 否","descFull":"接收的传真打印质量很差 解决问题的步骤 操作 是 否 请发送传真给您的人： 检查原始文档的质量是否令人满意。 如果可能，增加传真扫描分辨率。 重新发送传真。 传真打印质量令人满意吗？ 问题得以解决。 降低发来传真的传输速度。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 在打印机主屏幕上查看打印机 IP 地址。IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 如果您正在使用代理服务器，请临时禁用它以便正确加载 Web 页。 打印网络设置页或菜单设置页，然后在 TCP/IP 部分中找到 IP 地址。 单击  设置 传真设置 模拟传真设置 。 在“最大速度”菜单中，单击下列选项之一： 2400 4800 9600 14400 33600 单击 提交 ，然后重新发送传真。 传真打印质量令人满意吗？ 问题得以解决。 更换碳粉盒。 当出现 碳粉不足 [88.xy]  时，更换碳粉盒，然后重新发送传真。 传真打印质量令人满意吗？ 问题得以解决。 请联系 客户支持 。 更换碳粉盒。 当出现 碳粉不足 [88.xy]  时，更换碳粉盒，然后重新发送传真。 传真打印质量令人满意吗？ 问题得以解决。 请联系 技术支持 。 传真疑难解答 接收的传真打印质量很差 疑难解答，传真 接收的传真打印质量很差"},{"UUID":"819b041d-da29-4b27-90bb-a41a0ca0f0d2","title":"解决扫描仪问题","link":"trb-cannot-scan-from-a-computer-topic.html","desc":"不能从计算机扫描 解决问题的步骤 操作 是 否","descFull":"不能从计算机扫描 解决问题的步骤 操作 是 否 在扫描作业之前，确认打印机的电源已经打开，并且打印机显示屏上出现 就绪 。 在扫描作业之前出现 就绪 吗？ 请转到第 3 步。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 打印机显示屏上有错误消息吗？ 清除错误消息。 检查连接在打印机和打印服务器之间的电缆以确认它们牢固。 如需更多信息，请参阅随打印机附带的设置文档。 连接在打印机和打印服务器之间的电缆牢固吗？ 请联系 客户支持 。 固定电缆连接。 检查连接在打印机和打印服务器之间的电缆以确认它们牢固。 如需更多信息，请参阅随打印机附带的设置文档。 连接在打印机和打印服务器之间的电缆牢固吗？ 请联系 技术支持 。 固定电缆连接。 扫描疑难解答 不能从计算机扫描 疑难解答，扫描 不能从计算机扫描"},{"UUID":"5439219d-457b-44a4-b454-65a8252f3714","title":"解决扫描仪问题","link":"trb-cannot-scan-from-a-computer-topic.html","desc":"扫描部分文档或照片 解决问题的步骤 操作 是 否","descFull":"扫描部分文档或照片 解决问题的步骤 操作 是 否 检查文档或照片的放置。 确认将文档或照片面朝下放在扫描仪玻璃的左上角上。 文档或照片加载正确吗？ 请联系 客户支持 。 将文档或照片面朝下放在扫描仪玻璃的左上角上。 检查文档或照片的放置。 确认将文档或照片面朝下放在扫描仪玻璃的左上角上。 文档或照片加载正确吗？ 请联系 技术支持 。 将文档或照片面朝下放在扫描仪玻璃的左上角上。 疑难解答，扫描 扫描部分文档或照片 扫描疑难解答 扫描部分文档或照片"},{"UUID":"e0922e62-c05b-4e82-aa6a-4f74c4b68a0b","title":"解决扫描仪问题","link":"trb-cannot-scan-from-a-computer-topic.html","desc":"扫描图像质量很差 解决问题的步骤 操作 是 否","descFull":"扫描图像质量很差 解决问题的步骤 操作 是 否 检查显示屏上是否出现错误消息。 打印机显示屏上有错误消息吗？ 清除错误消息。 检查原始文档的质量。 原始文档的质量令人满意吗？ 增加扫描分辨率设置，以获得更高质量的输出。 用水润湿一块干净、不起毛的布，然后清洁扫描仪玻璃和 ADF 玻璃。 扫描仪玻璃干净吗？ 请参阅 。 检查文档或照片的放置。 确认将文档或照片面朝下放在扫描仪玻璃的左上角上。 文档或照片加载正确吗？ 将文档或照片面朝下放在扫描仪玻璃的左上角上。 发送打印作业，检查打印质量问题。 从“复印”菜单，调整碳粉浓度。 当打印颜色变浅时，请更换碳粉盒。 打印质量令人满意吗？ 请参阅 。 检查扫描设置。 从“扫描”屏幕，确认“内容类型”和“内容来源”设置对正在扫描的文档是正确的。 “内容类型”和“内容来源”设置对正在扫描的文档正确吗？ 更改“内容类型”和“内容来源”设置以匹配正在扫描的文档。 增加扫描分辨率设置，以获得更高质量的输出。 增加分辨率产生更高质量的输出了吗？ 问题得以解决。 请联系 客户支持 。 增加扫描分辨率设置，以获得更高质量的输出。 增加分辨率产生更高质量的输出了吗？ 问题得以解决。 请联系 技术支持 。 复印疑难解答 扫描图像质量很差 疑难解答，复印 扫描图像质量很差"},{"UUID":"ad73b2d6-a330-4a53-9e8f-280b585ca149","title":"解决扫描仪问题","link":"trb-cannot-scan-from-a-computer-topic.html","desc":"扫描作业不成功 解决问题的步骤 操作 是 否","descFull":"扫描作业不成功 解决问题的步骤 操作 是 否 检查电缆连接。 确认以太网或 USB 电缆牢固地连接在计算机和打印机上。 电缆连接牢固吗？ 正确连接电缆。 检查文件名是否已被使用。 文件名已被使用吗？ 更改文件名。 检查您要扫描的文档或照片是否在另一个应用程序中打开，或者正被另一个用户使用。 您要扫描的文件被另一个应用程序或用户打开吗？ 关闭您正在扫描的文件。 检查在目标配置设置中， 附加时间戳 或 改写现有文件 复选框是否被选定。 在目标配置设置中， 附加时间戳 或 改写现有文件 复选框被选定吗？ 请联系 客户支持 。 在目标配置设置中，选择 附加时间戳 或 改写现有文件 复选框。 检查在目标配置设置中， 附加时间戳 或 改写现有文件 复选框是否被选定。 在目标配置设置中， 附加时间戳 或 改写现有文件 复选框被选定吗？ 请联系 技术支持 。 在目标配置设置中，选择 附加时间戳 或 改写现有文件 复选框。 扫描疑难解答 扫描作业不成功 疑难解答，扫描 扫描作业不成功"},{"UUID":"21074bd8-7ad9-418a-a433-ddb42a70c23b","title":"解决扫描仪问题","link":"trb-cannot-scan-from-a-computer-topic.html","desc":"扫描仪部件未关闭 解决问题的步骤 操作 是 否","descFull":"扫描仪部件未关闭 解决问题的步骤 操作 是 否 检查扫描仪部件中是否有阻碍物。 抬起扫描仪部件。 移除任何使扫描仪部件打开的阻碍物。 放下扫描仪部件。 扫描仪部件正确关闭了吗？ 问题得以解决。 请联系 客户支持 。 检查扫描仪部件中是否有阻碍物。 抬起扫描仪部件。 移除任何使扫描仪部件打开的阻碍物。 放下扫描仪部件。 扫描仪部件正确关闭了吗？ 问题得以解决。 请联系 技术支持 。 复印疑难解答 扫描仪部件未关闭 疑难解答，复印 扫描仪部件未关闭 扫描疑难解答 扫描仪部件未关闭 疑难解答，扫描 扫描仪部件未关闭"},{"UUID":"7737806f-c06a-493c-aec6-9a98f31cafb4","title":"解决扫描仪问题","link":"trb-cannot-scan-from-a-computer-topic.html","desc":"扫描时间太长或令计算机冻结 解决问题的步骤 操作 是 否","descFull":"扫描时间太长或令计算机冻结 解决问题的步骤 操作 是 否 检查其他应用程序是否干扰扫描。 关闭所有未被使用的应用程序。 扫描时间仍然太长或令计算机冻结吗？ 问题得以解决。 选择较低的扫描分辨率。 扫描时间仍然太长或令计算机冻结吗？ 请联系 客户支持 。 问题得以解决。 选择较低的扫描分辨率。 扫描时间仍然太长或令计算机冻结吗？ 请联系 技术支持 。 问题得以解决。 扫描疑难解答 扫描时间太长或令计算机冻结 疑难解答，扫描 扫描时间太长或令计算机冻结"},{"UUID":"76258aac-ae6a-407c-968f-51c4570c7e69","title":"解决扫描仪问题","link":"trb-cannot-scan-from-a-computer-topic.html","desc":"扫描仪不响应 解决问题的步骤 操作 是 否","descFull":"扫描仪不响应 解决问题的步骤 操作 是 否 检查打印机的电源是否已经打开。 打印机电源打开了吗？ 打开打印机电源。 检查打印机电缆是否被牢固地连接在打印机和计算机、打印服务器、选件或其他网络设备上。 打印机电缆被牢固地连接在打印机和计算机、打印服务器、选件或其他网络设备上吗？ 将打印机电缆牢固地连接在打印机和计算机、打印服务器、选件或其他网络设备上。 检查电源线是否已被插入打印机和正确接地的电源插座中。 电源线已被插入打印机和正确接地的电源插座中吗？ 将电源线连接到打印机和正确接地的电源插座中。 检查电源插座是否被开关或断路器关闭。 电源插座被开关或断路器关闭吗？ 打开开关或重置断路器。 检查打印机是否被插入任何浪涌电压保护器、不间断电源或延长线路中。 打印机被插入任何浪涌电压保护器、不间断电源或延长线路中吗？ 将打印机电源线直接连接到正确接地的电源插座上。 检查其他插在插座中的电子设备。 其他电子设备正在工作吗？ 拔掉其他电子设备的电源线，并打开打印机电源。如果打印机不工作，请重新连接其他电子设备，然后转到第 6 步。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 打印机和扫描仪正在工作吗？ 问题得以解决。 请联系 客户支持 。 关闭打印机电源，接着等待约 10 秒钟，然后重新打开打印机电源。 打印机和扫描仪正在工作吗？ 问题得以解决。 请联系 技术支持 。 疑难解答 扫描仪不响应 扫描仪不响应"},{"UUID":"47f7ee4c-ced6-401a-9032-eec939bee8ef","title":"解决主屏幕应用程序问题","link":"application-error-has-occurred-topic.html","desc":"出现应用程序错误 解决问题的步骤 操作 是 否","descFull":"出现应用程序错误 解决问题的步骤 操作 是 否 检查系统日志中的相关详细信息。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 如果您不知道打印机的 IP 地址，您可以： 在打印机主屏幕上查看 IP 地址。 打印网络设置页或菜单设置页，然后在 TCP/IP 部分中找到 IP 地址。 IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 单击 设置 应用程序 应用程序管理 系统 选项卡 日志 。 从“过滤器”菜单，选择应用程序状态。 从“应用程序”菜单，选择应用程序，然后单击 提交 。 日志中出现错误消息吗？ 请联系 客户支持 。 检查系统日志中的相关详细信息。 打开 Web 浏览器，然后在地址字段中键入打印机 IP 地址。 如果您不知道打印机的 IP 地址，您可以： 在打印机主屏幕上查看 IP 地址。 打印网络设置页或菜单设置页，然后在 TCP/IP 部分中找到 IP 地址。 IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 单击 设置 应用程序 应用程序管理 系统 选项卡 日志 。 从“过滤器”菜单，选择应用程序状态。 从“应用程序”菜单，选择应用程序，然后单击 提交 。 日志中出现错误消息吗？ 请联系 技术支持 。 解决错误。 应用程序现在工作了吗？ 问题得以解决。 请联系 客户支持 。 解决错误。 应用程序现在工作了吗？ 问题得以解决。 请联系 技术支持 。 疑难解答 出现应用程序错误"},{"UUID":"6ef3f2d0-da07-473a-a53c-ccda711ce8e2","title":"疑难解答","link":"trb-embedded-web-server-does-not-open-topic.html","desc":"Embedded Web Server 没有打开 解决问题的步骤","descFull":"Embedded Web Server 没有打开 解决问题的步骤 操作 是 否 确认打印机 IP 地址是正确的。 查看打印机 IP 地址： 从打印机主屏幕 从“网络/端口”菜单中的 TCP/IP 部分 通过打印网络设置页或菜单设置页，然后查找 TCP/IP 部分 IP 地址显示为用小数点分隔的四组数字，例如 123.123.123.123。 打印机 IP 地址正确吗？ 在 Web 浏览器的地址字段中键入正确的打印机 IP 地址。 根据网络设置，您可能需要在打印机 IP 地址之前键入“ https ://”而不是“ http ://”才能访问 Embedded Web Server。 检查打印机的电源是否已经打开。 打印机电源打开了吗？ 打开打印机电源。 检查网络连接是否正在工作。 网络连接正在工作吗？ 请与系统支持人员联系。 确认连接到打印机和打印服务器的电缆是牢固的。 如需更多信息，请参阅随打印机附带的设置文档。 连接到打印机和打印服务器的电缆牢固吗？ 固定电缆连接。 临时禁用 Web 代理服务器。 代理服务器可能阻止或限制您访问某些 Web 站点，包括 Embedded Web Server。  Web 代理服务器被禁用了吗？ 请与系统支持人员联系。 通过在地址字段中键入正确的 IP 地址来再次访问 Embedded Web Server。 Embedded Web Server 打开了吗？ 问题得以解决。 请联系 客户支持 。 通过在地址字段中键入正确的 IP 地址来再次访问 Embedded Web Server。 Embedded Web Server 打开了吗？ 问题得以解决。 请联系 技术支持 。 无法打开 Embedded Web Server 疑难解答 无法打开 Embedded Web Server Embedded Web Server 访问问题"},{"UUID":"95b0153e-c6fc-4fbd-a0ac-4384a6539c85","title":"疑难解答","link":"trb-contacting-customer-support-topic.html","desc":"联系客户支持 当您与客户支持联系时，您将需要能够描述您遇到的问题，打印机显示屏上的消息，以及您为找到解决方案所采取的故障排除步骤。 您需要知道打印机的型号和序列号。如需更多信息，请参阅打印机背后的标签。序列号也在菜单设置页上列出。 Lexmark 有各种方法帮助您解决打印问题。请访问","descFull":"联系客户支持 当您与客户支持联系时，您将需要能够描述您遇到的问题，打印机显示屏上的消息，以及您为找到解决方案所采取的故障排除步骤。 您需要知道打印机的型号和序列号。如需更多信息，请参阅打印机背后的标签。序列号也在菜单设置页上列出。 Lexmark 有各种方法帮助您解决打印问题。请访问 Lexmark 的网站： http://support.lexmark.com ，然后选择下列选项之一： 联系客户支持的方法 技术库 您可以浏览我们的手册库、支持文档、驱动程序和其他下载资源来帮助您解决常见问题。 电子邮件 您可以发送电子邮件给 Lexmark 团队，描述您的问题。服务代表将作出响应并向您提供解决问题的信息。 在线聊天 您可以直接与服务代表交谈。他们可以与您一起解决您的打印机问题或通过“辅助服务”提供援助，服务代表可以通过互联网远程连接到您的计算机来解决问题、安装更新，或完成其他任务，以帮助您成功使用您的 Lexmark 产品。 电话支持也有提供。在美国或加拿大，请拨打 1-800-539-6275。对于其他国家或地区，请访问  http://support.lexmark.com 。 如需客户支持，请与您购买打印机处的销售商联系。 疑难解答 联系客户支持 联系客户支持 客户支持 联系"},{"UUID":"37439c9b-d11e-49ad-b6a7-7d0c25a3fb6e","title":"疑难解答","link":"troubleshooting-chapter.html","desc":"联系技术支持 当您致电技术支持时，请描述您所遇到的问题，打印机显示屏上的消息，以及您已采取的寻求解决办法的步骤。 您需要知道打印机的型号和服务标签号码或快速服务代码。如需更多信息，请参阅打印机顶部前盖板内或打印机背后的标签。“服务标签”号码也在菜单设置页上列出。 如需更多信息，请查看 Dell","descFull":"联系技术支持 当您致电技术支持时，请描述您所遇到的问题，打印机显示屏上的消息，以及您已采取的寻求解决办法的步骤。 您需要知道打印机的型号和服务标签号码或快速服务代码。如需更多信息，请参阅打印机顶部前盖板内或打印机背后的标签。“服务标签”号码也在菜单设置页上列出。 如需更多信息，请查看 Dell 的支持网站： www.dell.com/support/printers 。 疑难解答 联系技术支持 联系技术支持"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"divd0e18"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"MX910 系列"}},[_vm._v("\n    MX910 系列\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_sc","title":"安全信息"}},[_vm._v("\n    安全信息\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_sc","title":"了解打印机"}},[_vm._v("\n    了解打印机\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e154"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_sc","title":"查找有关打印机的信息"}},[_vm._v("\n     查找有关打印机的信息\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-the-printer-to-outlet-topic.html#connecting-the-printer-to-outlet_sc","title":"将打印机连接到电源插座"}},[_vm._v("\n     将打印机连接到电源插座\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-m-topic.html#selecting-location-printer-m_sc","title":"为打印机选择位置"}},[_vm._v("\n     为打印机选择位置\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_sc","title":"打印机配置"}},[_vm._v("\n     打印机配置\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-basic-functions-scanner-topic.html#understanding-basic-functions-scanner_sc","title":"理解扫描仪的基本功能"}},[_vm._v("\n     理解扫描仪的基本功能\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-topic.html#using-ADF-and-scanner-glass_sc","title":"使用 ADF 和扫描仪玻璃"}},[_vm._v("\n     使用 ADF 和扫描仪玻璃\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-home-screen-chapter.html#understanding-home-screen-chapter_sc","title":"理解打印机控制面板"}},[_vm._v("\n    理解打印机控制面板\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e597"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-printer-control-panel-topic.html#using-printer-control-panel_sc","title":"使用控制面板"}},[_vm._v("\n     使用控制面板\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-colors-sleep-button-indicator-lights-h-topic.html#understanding-colors-sleep-button-indicator-lights-h_sc","title":"理解&ldquo;睡眠&rdquo;按钮和指示灯的颜色"}},[_vm._v("\n     理解“睡眠”按钮和指示灯的颜色\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-home-screen-topic.html#understanding-home-screen_sc","title":"理解主屏幕"}},[_vm._v("\n     理解主屏幕\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-touch-screen-buttons-topic.html#using-touch-screen-buttons_sc","title":"使用触摸屏按钮"}},[_vm._v("\n     使用触摸屏按钮\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sc","title":"设置和使用主屏幕应用程序"}},[_vm._v("\n    设置和使用主屏幕应用程序\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1129"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-ip-address-of-printer-topic.html#finding-ip-address-of-printer_sc","title":"查找打印机的 IP 地址"}},[_vm._v("\n     查找打印机的 IP 地址\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-ip-address-of-computer-topic.html#finding-ip-address-of-computer_sc","title":"查找计算机的 IP 地址"}},[_vm._v("\n     查找计算机的 IP 地址\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-embedded-web-server-topic.html#accessing-embedded-web-server_sc","title":"访问 Embedded Web Server"}},[_vm._v("\n     访问 Embedded Web Server\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"customizing-home-screen-topic.html#customizing-home-screen_sc","title":"定制主屏幕"}},[_vm._v("\n     定制主屏幕\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-different-apps-topic.html#understanding-different-apps_sc","title":"理解不同的应用程序"}},[_vm._v("\n     理解不同的应用程序\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-home-screen-apps-group.html#activating-home-screen-apps-title_sc","title":"激活主屏幕应用程序"}},[_vm._v("\n     激活主屏幕应用程序\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-remote-operator-panel-topic.html#setting-up-remote-operator-panel_sc","title":"设置&ldquo;远程操作面板&rdquo;"}},[_vm._v("\n     设置“远程操作面板”\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-importing-configuration-using-ews-winners-circle-topic.html#exporting-importing-configuration-using-ews-winners-circle_sc","title":"导出和导入配置"}},[_vm._v("\n     导出和导入配置\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"installing-options-chapter.html#installing-options-chapter_sc","title":"其他打印机设置"}},[_vm._v("\n    其他打印机设置\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"internal-options.html#internal-options_sc","title":"安装内置式选件"}},[_vm._v("\n     安装内置式选件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"order-installation-topic.html#d0e2058","title":"安装硬件选件"}},[_vm._v("\n     安装硬件选件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_sc","title":"连接电缆"}},[_vm._v("\n     连接电缆\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e2314","title":"设置打印机软件"}},[_vm._v("\n     设置打印机软件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preparing-set-up-printer-ethernet-network-topic.html#d0e2383","title":"网络连接"}},[_vm._v("\n     网络连接\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-h2-topic.html#d0e2748","title":"检验打印机设置"}},[_vm._v("\n     检验打印机设置\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_sc","title":"加载纸张和特殊介质"}},[_vm._v("\n    加载纸张和特殊介质\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2794"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-paper-size-and-type-topic.html#setting-paper-size-and-type_sc","title":"设置纸张尺寸和类型"}},[_vm._v("\n     设置纸张尺寸和类型\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-universal-paper-settings-topic.html#configuring-universal-paper-settings_sc","title":"配置 Universal 纸张设置"}},[_vm._v("\n     配置 Universal 纸张设置\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-topic.html#loading-trays_sc","title":"加载进纸匣"}},[_vm._v("\n     加载进纸匣\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-multipurpose-feeder-h-topic.html#loading-multipurpose-feeder-h_sc","title":"加载多功能进纸器"}},[_vm._v("\n     加载多功能进纸器\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"linking-and-unlinking-trays-h2-topic.html#d0e2974","title":"进纸匣连接和解除连接"}},[_vm._v("\n     进纸匣连接和解除连接\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"paper-and-specialty-media-guide-chapter.html#paper-and-specialty-media-guide-chapter_sc","title":"纸张和特殊介质指南"}},[_vm._v("\n    纸张和特殊介质指南\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e3093"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-specialty-media.html#d0e3104","title":"使用特殊介质"}},[_vm._v("\n     使用特殊介质\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-group-title.html#paper-guidelines-group-title_sc","title":"纸张使用指南"}},[_vm._v("\n     纸张使用指南\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-media-sizes-types-weights-supported.html#paper-media-sizes-types-weights-supported_sc","title":"支持的纸张尺寸、类型和重量"}},[_vm._v("\n     支持的纸张尺寸、类型和重量\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_sc","title":"打印"}},[_vm._v("\n    打印\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5746"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-forms-topic.html#d0e5749","title":"打印表单和文档"}},[_vm._v("\n     打印表单和文档\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-h2-topic.html#d0e5823","title":"从闪存驱动器或移动设备打印"}},[_vm._v("\n     从闪存驱动器或移动设备打印\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-confidential-other-jobs.html#holding-confidential-other-jobs_sc","title":"打印保密和其他挂起作业"}},[_vm._v("\n     打印保密和其他挂起作业\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#d0e6122","title":"打印信息页"}},[_vm._v("\n     打印信息页\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-from-printer-control-panel-h2-topic.html#d0e6167","title":"取消打印作业"}},[_vm._v("\n     取消打印作业\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_sc","title":"复印"}},[_vm._v("\n    复印\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6211"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-using-adf-or-scanner-glass-topic.html#d0e6241","title":"制作副本"}},[_vm._v("\n     制作副本\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-using-printer-control-panel-topic.html#d0e6343","title":"创建复印快捷方式"}},[_vm._v("\n     创建复印快捷方式\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-to-different-size-topic.html#d0e6400","title":"定制复印设置"}},[_vm._v("\n     定制复印设置\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-header-or-footer-on-pages-topic.html#placing-header-or-footer-on-pages_sc","title":"在页面上放置页眉或页脚"}},[_vm._v("\n     在页面上放置页眉或页脚\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-copy-job-while-pages-are-being-printed-topic.html#canceling-copy-job-while-pages-are-being-printed_sc","title":"当正在打印页面时取消复印作业"}},[_vm._v("\n     当正在打印页面时取消复印作业\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-from-topic.html#d0e6797","title":"理解复印选项"}},[_vm._v("\n     理解复印选项\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_sc","title":"电子邮件"}},[_vm._v("\n    电子邮件\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7002"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-email-settings-topic.html#d0e7032","title":"设置打印机发送电子邮件"}},[_vm._v("\n     设置打印机发送电子邮件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-using-ews-topic.html#d0e7060","title":"创建电子邮件快捷方式"}},[_vm._v("\n     创建电子邮件快捷方式\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-using-control-panel-topic.html#d0e7154","title":"用电子邮件发送文档"}},[_vm._v("\n     用电子邮件发送文档\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-changing-output-file-type-topic.html#d0e7225","title":"定制电子邮件设置"}},[_vm._v("\n     定制电子邮件设置\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-an-email-topic.html#canceling-an-email_sc","title":"取消电子邮件"}},[_vm._v("\n     取消电子邮件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-recipients-topic.html#d0e7281","title":"理解电子邮件选项"}},[_vm._v("\n     理解电子邮件选项\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_sc","title":"传真"}},[_vm._v("\n    传真\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7484"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"initial-fax-setup-topic.html#d0e7514","title":"设置打印机发送传真"}},[_vm._v("\n     设置打印机发送传真\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_sc","title":"发送传真"}},[_vm._v("\n     发送传真\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-at-scheduled-time-topic.html#sending-fax-at-scheduled-time_sc","title":"在预定时间发送传真"}},[_vm._v("\n     在预定时间发送传真\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-using-embedded-web-server-topic.html#d0e8075","title":"创建快捷方式"}},[_vm._v("\n     创建快捷方式\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#d0e8174","title":"定制传真设置"}},[_vm._v("\n     定制传真设置\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-fax-job-topic.html#canceling-fax-job_sc","title":"取消传真作业"}},[_vm._v("\n     取消传真作业\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#d0e8302","title":"挂起和转发传真"}},[_vm._v("\n     挂起和转发传真\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"faxing-resolution-topic.html#d0e8403","title":"理解传真选项"}},[_vm._v("\n     理解传真选项\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Scanning.html#Scanning_sc","title":"扫描"}},[_vm._v("\n    扫描\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8549"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-scan-to-network-topic.html#using-scan-to-network_sc","title":"使用&ldquo;扫描到网络&rdquo;"}},[_vm._v("\n     使用“扫描到网络”\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-ftp-shortcuts-using-ews-topic.html#d0e8564","title":"扫描到 FTP 地址"}},[_vm._v("\n     扫描到 FTP 地址\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-scan-to-computer-topic.html#d0e8726","title":"扫描到计算机或闪存驱动器"}},[_vm._v("\n     扫描到计算机或闪存驱动器\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-destination-topic.html#d0e8801","title":"理解扫描选项"}},[_vm._v("\n     理解扫描选项\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sc","title":"理解打印机菜单"}},[_vm._v("\n    理解打印机菜单\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8984"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menus-list-topic.html#menus-list_sc","title":"菜单列表"}},[_vm._v("\n     菜单列表\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-menu-group.html#paper-menu-group_sc","title":"纸张菜单"}},[_vm._v("\n     纸张菜单\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reports-group.html#reports-group_sc","title":"报告菜单"}},[_vm._v("\n     报告菜单\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-ports-group.html#network-ports-group_sc","title":"网络/端口菜单"}},[_vm._v("\n     网络/端口菜单\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"security-menus-group.html#d0e11888","title":"安全菜单"}},[_vm._v("\n     安全菜单\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"settings-group.html#settings-group_sc","title":"设置菜单"}},[_vm._v("\n     设置菜单\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"conserving-printer-energy-materials.html#conserving-printer-energy-materials_sc","title":"节省费用和环境资源"}},[_vm._v("\n    节省费用和环境资源\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18100"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"conserving-printer-energy-materials.html#d0e18118","title":"节省纸张和碳粉"}},[_vm._v("\n     节省纸张和碳粉\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"conserving-printer-energy-materials.html#d0e18179","title":"节省能源"}},[_vm._v("\n     节省能源\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"conserving-printer-energy-materials.html#d0e18367","title":"循环再生"}},[_vm._v("\n     循环再生\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_sc","title":"保护打印机"}},[_vm._v("\n    保护打印机\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18435"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-security-lock-feature-m-topic.html#using-security-lock-feature-m_sc","title":"使用安全锁特性"}},[_vm._v("\n     使用安全锁特性\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-h-topic.html#statement-of-volatility-h_sc","title":"易失性声明"}},[_vm._v("\n     易失性声明\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-volatile-memory-h-topic.html#erasing-volatile-memory-h_sc","title":"清除易失性内存"}},[_vm._v("\n     清除易失性内存\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-non-volatile-memory-h-topic.html#erasing-non-volatile-memory-h_sc","title":"清除非易失性内存"}},[_vm._v("\n     清除非易失性内存\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-hard-disk-memory-h1-topic.html#erasing-printer-hard-disk-memory-h1_sc","title":"清除打印机硬盘内存"}},[_vm._v("\n     清除打印机硬盘内存\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_sc","title":"配置打印机硬盘加密"}},[_vm._v("\n     配置打印机硬盘加密\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-security-information-b-topic.html#finding-printer-security-information-b_sc","title":"查找打印机安全信息"}},[_vm._v("\n     查找打印机安全信息\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_sc","title":"维护打印机"}},[_vm._v("\n    维护打印机\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18672"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e18677","title":"清洁打印机部件"}},[_vm._v("\n     清洁打印机部件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-on-printer-control-panel-topic.html#d0e18830","title":"检查部件和耗材的状态"}},[_vm._v("\n     检查部件和耗材的状态\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"estimated-number-remaining-pages-topic.html#estimated-number-remaining-pages_sc","title":"估算的剩余页数"}},[_vm._v("\n     估算的剩余页数\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-supplies.html#ordering-supplies_sc","title":"订购耗材"}},[_vm._v("\n     订购耗材\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-maintenance-kit-topic.html#ordering-maintenance-kit_sc","title":"订购 300K 维护组件"}},[_vm._v("\n     订购 300K 维护组件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"storing-supplies-topic.html#d0e19083","title":"存储部件和耗材"}},[_vm._v("\n     存储部件和耗材\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-supplies.html#d0e19127","title":"更换耗材"}},[_vm._v("\n     更换耗材\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-exhaust-ozone-filters-topic.html#d0e19335","title":"更换 300K 维护组件"}},[_vm._v("\n     更换 300K 维护组件\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-adf-scan-pad-topic.html#replacing-adf-scan-pad_sc","title":"更换 ADF 扫描垫"}},[_vm._v("\n     更换 ADF 扫描垫\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-the-printer.html#moving-the-printer_sc","title":"移动打印机"}},[_vm._v("\n     移动打印机\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"administrative-support-chapter.html#administrative-support-chapter_sc","title":"管理打印机"}},[_vm._v("\n    管理打印机\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e19678"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-virtual-display-h-topic.html#checking-virtual-display-h_sc","title":"检查虚拟显示屏"}},[_vm._v("\n     检查虚拟显示屏\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sc","title":"设置电子邮件警报"}},[_vm._v("\n     设置电子邮件警报\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_sc","title":"查看报告"}},[_vm._v("\n     查看报告\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-printer-settings-to-other-printers-topic.html#copying-printer-settings-to-other-printers_sc","title":"将打印机设置复制到其他打印机"}},[_vm._v("\n     将打印机设置复制到其他打印机\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-h2-topic.html#configuring-supply-notifications-h2_sc","title":"从 Embedded Web Server 配置耗材通知"}},[_vm._v("\n     从 Embedded Web Server 配置耗材通知\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-h-topic.html#restoring-factory-default-settings-h_sc","title":"还原出厂默认设置"}},[_vm._v("\n     还原出厂默认设置\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"clearing-jams-chapter.html#clearing-jams-chapter_sc","title":"清除卡纸"}},[_vm._v("\n    清除卡纸\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e19914"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"avoiding-jams-topic.html#avoiding-jams_sc","title":"避免卡纸"}},[_vm._v("\n     避免卡纸\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-jam-messages-topic.html#understanding-jam-messages_sc","title":"理解卡纸消息和位置"}},[_vm._v("\n     理解卡纸消息和位置\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-page-jam-clear-manual-feeder-topic.html#message-page-jam-clear-manual-feeder_sc","title":"[x] 页卡住，从多功能进纸器中清除被卡的纸张。[200.xx]"}},[_vm._v("\n     [x] 页卡住，从多功能进纸器中清除被卡的纸张。[200.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-jam-open-door-c-clear-all-jammed-media-topic.html#paper-jam-open-door-c-clear-all-jammed-media_sc","title":"[x] 页卡住，打开盖门 C 并清除所有被卡的纸张。[2yy.xx]"}},[_vm._v("\n     [x] 页卡住，打开盖门 C 并清除所有被卡的纸张。[2yy.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-jam-slide-tray-open-door-c-topic.html#paper-jam-slide-tray-open-door-c_sc","title":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx]"}},[_vm._v("\n     [x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-jam-open-door-d-clear-all-jammed-media-topic.html#paper-jam-open-door-d-clear-all-jammed-media_sc","title":"[x] 页卡住，打开盖门 D 并清除所有被卡的纸张。[24y.xx]"}},[_vm._v("\n     [x] 页卡住，打开盖门 D 并清除所有被卡的纸张。[24y.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-jam-slide-tray-open-door-d-topic.html#paper-jam-slide-tray-open-door-d_sc","title":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx]"}},[_vm._v("\n     [x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-page-jam-detach-tray-open-door-f-topic.html#message-page-jam-detach-tray-open-door-f_sc","title":"[x] 页卡住，滑动 3000 页进纸匣并打开盖门 F。[24y.xx]"}},[_vm._v("\n     [x] 页卡住，滑动 3000 页进纸匣并打开盖门 F。[24y.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-page-jam-open-doors-g-h-j-clear-jammed-paper-topic.html#message-page-jam-open-doors-g-h-j-clear-jammed-paper_sc","title":"[x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。将纸张留在接纸架中。[4yy.xx]"}},[_vm._v("\n     [x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。将纸张留在接纸架中。[4yy.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-page-jam-press-latch-to-access-area-g-leave-paper-in-bin-topic.html#message-page-jam-press-latch-to-access-area-g-leave-paper-in-bin_sc","title":"[x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx]"}},[_vm._v("\n     [x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-page-jam-press-latch-to-access-area-g-clear-jammed-staples-leave-paper-in-bin-topic.html#message-page-jam-press-latch-to-access-area-g-clear-jammed-staples-leave-paper-in-bin_sc","title":"[x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93]"}},[_vm._v("\n     [x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-paper-jam-open-door-h-rotate-knob-h6-clockwise-leave-paper-in-bin-topic.html#message-paper-jam-open-door-h-rotate-knob-h6-clockwise-leave-paper-in-bin_sc","title":"[x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx-428.xx]"}},[_vm._v("\n     [x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx-428.xx]\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-page-jam-press-latch-area-e-open-adf-top-cover-topic.html#message-page-jam-press-latch-area-e-open-adf-top-cover_sc","title":"[x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx]"}},[_vm._v("\n     [x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx]\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_sc","title":"疑难解答"}},[_vm._v("\n    疑难解答\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e20638"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-cartridge-low-88.xy-topic.html#d0e20641","title":"理解打印机消息"}},[_vm._v("\n     理解打印机消息\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#d0e22397","title":"解决打印机问题"}},[_vm._v("\n     解决打印机问题\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-print-problems-group.html#d0e23117","title":"解决打印问题"}},[_vm._v("\n     解决打印问题\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-copier-does-not-respond-topic.html#d0e25705","title":"解决复印问题"}},[_vm._v("\n     解决复印问题\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e25997","title":"解决传真问题"}},[_vm._v("\n     解决传真问题\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-from-a-computer-topic.html#d0e26535","title":"解决扫描仪问题"}},[_vm._v("\n     解决扫描仪问题\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"application-error-has-occurred-topic.html#d0e26997","title":"解决主屏幕应用程序问题"}},[_vm._v("\n     解决主屏幕应用程序问题\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-embedded-web-server-does-not-open-topic.html#trb-embedded-web-server-does-not-open_sc","title":"Embedded Web Server 没有打开"}},[_vm._v("\n     Embedded Web Server 没有打开\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sc","title":"联系客户支持"}},[_vm._v("\n     联系客户支持\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_sc","title":"注意事项"}},[_vm._v("\n    注意事项\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e27214"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e27217","title":"产品信息"}},[_vm._v("\n     产品信息\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e27234","title":"版本注意事项"}},[_vm._v("\n     版本注意事项\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_sc","title":"商标"}},[_vm._v("\n     商标\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_sc","title":"许可注意事项"}},[_vm._v("\n     许可注意事项\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_sc","title":"噪音水平"}},[_vm._v("\n     噪音水平\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_sc","title":"产品处理"}},[_vm._v("\n     产品处理\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_sc","title":"静电灵敏度注意事项"}},[_vm._v("\n     静电灵敏度注意事项\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_sc","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e27491","title":"中国 RoHS 计划的信息"}},[_vm._v("\n     中国 RoHS 计划的信息\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_sc","title":"温度信息"}},[_vm._v("\n     温度信息\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e27695","title":"激光注意事项"}},[_vm._v("\n     激光注意事项\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-advisory-label_sc","title":"激光忠告标签"}},[_vm._v("\n     激光忠告标签\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_sc","title":"能量消耗"}},[_vm._v("\n     能量消耗\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#ccc-emc-notice_sc","title":"CCC EMC 注意事项"}},[_vm._v("\n     CCC EMC 注意事项\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_sc","title":"通信终端设备管制通告"}},[_vm._v("\n     通信终端设备管制通告\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-wireless-products_sc","title":"无线产品管制通告"}},[_vm._v("\n     无线产品管制通告\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_sc","title":"模块组件注意事项"}},[_vm._v("\n     模块组件注意事项\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_sc","title":"无线频率辐射暴露通告"}},[_vm._v("\n     无线频率辐射暴露通告\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#patent-acknowledgment_sc","title":"Patent acknowledgment"}},[_vm._v("\n     Patent acknowledgment\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js